"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[416],{

/***/ 1130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CategoryTag; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 24 modules
var withStyles = __webpack_require__(9438);
;// CONCATENATED MODULE: ./components/CategoryTag/style.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var styles = function(theme) {
    var _obj;
    return {
        CategoryTag: (_obj = {
            cursor: "pointer",
            borderRadius: 6,
            backgroundColor: "#f5faff",
            padding: theme.spacing(2),
            fontFamily: "Raleway,Assistant",
            fontSize: 16,
            fontWeight: 700,
            color: "#4c4c78",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }, _defineProperty(_obj, theme.breakpoints.down("sm"), {
            margin: theme.spacing(0),
            fontSize: 15
        }), _defineProperty(_obj, theme.breakpoints.down("xs"), {
            width: "100%",
            fontSize: 16
        }), _defineProperty(_obj, "&:hover", {
            backgroundColor: "#4a92cf",
            color: "#fff"
        }), _defineProperty(_obj, "& .activeTag", {
            backgroundColor: "#4a92cf",
            color: "#fff"
        }), _defineProperty(_obj, "& img", {
            marginLeft: theme.direction === "ltr" ? 0 : 8,
            marginRight: theme.direction === "ltr" ? 8 : 0,
            width: 14
        }), _obj)
    };
};
/* harmony default export */ var style = (styles);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
;// CONCATENATED MODULE: ./components/CategoryTag/index.js






var CategoryTag = function(param) {
    var classes = param.classes, CategoryTagIconSrc = param.CategoryTagIconSrc, CategoryTagIconAlt = param.CategoryTagIconAlt, CategoryTagTitle = param.CategoryTagTitle, showIcon = param.showIcon, selected = param.selected;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.CategoryTag,
        children: [
            showIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: CategoryTagIconSrc,
                alt: CategoryTagIconAlt
            }),
            CategoryTagTitle
        ]
    });
};
CategoryTag.defaultProps = {
    showIcon: false
};
CategoryTag.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    CategoryTagIconSrc: (prop_types_default()).string,
    CategoryTagIconAlt: (prop_types_default()).string,
    CategoryTagTitle: (prop_types_default()).string,
    showIcon: (prop_types_default()).bool
};
/* harmony default export */ var components_CategoryTag = ((0,withStyles/* default */.Z)(style)(CategoryTag));


/***/ }),

/***/ 4394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5833);
/* harmony import */ var prismic_reactjs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1752);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);







var Head = function(param) {
    var data = param.data, canonical = param.canonical;
    var siteUrl = (0,next_config__WEBPACK_IMPORTED_MODULE_5__["default"])().publicRuntimeConfig.siteUrl;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var canonicalUrl = canonical === "/homepage" ? "".concat(siteUrl, "/").concat(router.locale) : "".concat(siteUrl, "/").concat(router.locale).concat(canonical);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "/favicon-32x32.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "/favicon-16x16.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "manifest",
                href: "/site.webmanifest"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "mask-icon",
                href: "/safari-pinned-tab.svg",
                color: "#d6a560"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "msapplication-TileColor",
                content: "#ffffff"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "theme-color",
                content: "#ffffff"
            }),
            data.meta_title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__.RichText.asText(data.meta_title)
            }),
            !data.meta_title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: "VFI"
            }),
            data.meta_description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__.RichText.asText(data.meta_description)
            }),
            data.meta_title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__.RichText.asText(data.meta_title)
            }),
            data.meta_description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__.RichText.asText(data.meta_description)
            }),
            data.og_image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: data.og_image.url
            }),
            data.robots_index && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: data.robots_index ? "all" : "noindex"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            })
        ]
    });
};
Head.propTypes = {
    data: prop_types__WEBPACK_IMPORTED_MODULE_2___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_2___default().any))
};
/* harmony default export */ __webpack_exports__["Z"] = (Head);


/***/ }),

/***/ 5568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PersonItem; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 24 modules
var withStyles = __webpack_require__(9438);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(2318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
;// CONCATENATED MODULE: ./components/PersonItem/style.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var styles = function(theme) {
    var _obj, _obj1;
    return {
        speaker: {
            boxShadow: "0 22px 57px 0 rgba(37, 44, 80, 0.5)",
            backgroundColor: "#ffffff",
            cursor: "pointer",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            "&>a": {
                display: "flex",
                flexDirection: "column",
                height: "100%"
            },
            "& .itemImage": {
                verticalAlign: "bottom"
            },
            "& .speakerInfo": (_obj1 = {
                display: "flex",
                flexDirection: "column",
                padding: theme.spacing(4)
            }, _defineProperty(_obj1, theme.breakpoints.down("sm"), {
                padding: theme.spacing(3)
            }), _defineProperty(_obj1, theme.breakpoints.down("xs"), {
                padding: theme.spacing(2)
            }), _defineProperty(_obj1, "flex", 1), _defineProperty(_obj1, "& .tag", (_obj = {
                display: "inline-block",
                borderRadius: 2,
                width: "fit-content",
                backgroundColor: "#4a92cf",
                padding: theme.spacing(0.5),
                paddingLeft: theme.spacing(1.5),
                paddingRight: theme.spacing(1.5),
                marginBottom: theme.spacing(2),
                fontSize: 12,
                color: "#ffffff",
                fontWeight: 700,
                textTransform: "uppercase"
            }, _defineProperty(_obj, theme.breakpoints.down("sm"), {
                fontSize: 11
            }), _defineProperty(_obj, theme.breakpoints.down("xs"), {
                fontSize: 10
            }), _defineProperty(_obj, "& a", {
                color: "#fff"
            }), _obj)), _defineProperty(_obj1, "& .name", {
                color: "#4c4c78",
                lineHeight: 1.19,
                fontWeight: 700,
                flex: 1
            }), _defineProperty(_obj1, "& .title", _defineProperty({
                lineHeight: 1.67,
                color: "#4c4c78",
                fontWeight: 500,
                fontFamily: "Raleway,Assistant,sans-serif",
                marginTop: theme.spacing(2),
                display: "block"
            }, theme.breakpoints.down("sm"), {
                marginTop: theme.spacing(1)
            })), _defineProperty(_obj1, "& button", _defineProperty({
                width: "100%",
                marginTop: theme.spacing(2)
            }, theme.breakpoints.down("sm"), {
                marginTop: theme.spacing(1)
            })), _obj1)
        }
    };
};
/* harmony default export */ var style = (styles);

// EXTERNAL MODULE: ./components/CustomLink/index.js + 1 modules
var CustomLink = __webpack_require__(6833);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/PersonItem/index.js









var PersonItem = function(param) {
    var classes = param.classes, tag = param.tag, name = param.name, title = param.title, bannerImageSrc = param.bannerImageSrc, bannerImageAlt = param.bannerImageAlt, btnLabel = param.btnLabel, showTag = param.showTag, showBtn = param.showBtn, link = param.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.speaker,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomLink/* default */.Z, {
            link: link ? link : {},
            class: "custLinkItem",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        position: "relative",
                        height: 273,
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        objectFit: "cover",
                        layout: "fill",
                        src: bannerImageSrc,
                        alt: bannerImageAlt,
                        className: "itemImage"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "speakerInfo",
                    children: [
                        showTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tag",
                            children: tag
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h5",
                            className: "name",
                            children: name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h6",
                            className: "title",
                            children: title
                        }),
                        showBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "outlined",
                            color: "primary",
                            children: btnLabel
                        })
                    ]
                })
            ]
        })
    });
};
PersonItem.defaultProps = {
    tag: "",
    btnLabel: "",
    showTag: false,
    showBtn: false
};
PersonItem.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    tag: (prop_types_default()).any,
    name: (prop_types_default()).string,
    title: (prop_types_default()).string,
    bannerImageSrc: (prop_types_default()).string,
    bannerImageAlt: (prop_types_default()).string,
    btnLabel: (prop_types_default()).string,
    showTag: (prop_types_default()).bool,
    showBtn: (prop_types_default()).bool
};
/* harmony default export */ var components_PersonItem = ((0,withStyles/* default */.Z)(style)(PersonItem));


/***/ }),

/***/ 8785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_TitleSubtitle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 24 modules
var withStyles = __webpack_require__(9438);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(2318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(1749);
;// CONCATENATED MODULE: ./components/TitleSubtitle/style.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3;
    return {
        whiteTxt: {
            "& .title": {
                color: "#fff",
                textTransform: "uppercase",
                textAlign: "center"
            },
            "& .subtitle": (_obj1 = {
                color: "#fff",
                textAlign: "center",
                fontWeight: 700,
                marginTop: theme.spacing(3),
                letterSpacing: 1.1,
                fontSize: 18,
                lineHeight: 1.5
            }, _defineProperty(_obj1, theme.breakpoints.down("sm"), {
                marginTop: theme.spacing(2),
                fontSize: 17
            }), _defineProperty(_obj1, theme.breakpoints.down("xs"), {
                marginTop: theme.spacing(1),
                fontSize: 16
            }), _defineProperty(_obj1, "& p", (_obj = {
                color: "#4c4c78",
                textAlign: "center",
                letterSpacing: 1.1,
                fontWeight: 700,
                marginTop: theme.spacing(3),
                fontSize: 18,
                lineHeight: 1.5
            }, _defineProperty(_obj, theme.breakpoints.down("sm"), {
                marginTop: theme.spacing(2),
                fontSize: 17
            }), _defineProperty(_obj, theme.breakpoints.down("xs"), {
                marginTop: theme.spacing(1),
                fontSize: 16
            }), _defineProperty(_obj, "& strong", {
                fontWeight: 900
            }), _obj)), _obj1)
        },
        blueTxt: {
            "& .title": {
                color: "#4c4c78",
                textTransform: "uppercase",
                textAlign: "center"
            },
            "& .subtitle": (_obj3 = {
                color: "#4c4c78",
                textAlign: "center",
                letterSpacing: 1.1,
                fontWeight: 700,
                marginTop: theme.spacing(3),
                fontSize: 18,
                lineHeight: 1.5
            }, _defineProperty(_obj3, theme.breakpoints.down("sm"), {
                marginTop: theme.spacing(2),
                fontSize: 17
            }), _defineProperty(_obj3, theme.breakpoints.down("xs"), {
                marginTop: theme.spacing(1),
                fontSize: 16
            }), _defineProperty(_obj3, "& p", (_obj2 = {
                color: "#4c4c78",
                textAlign: "center",
                letterSpacing: 1.1,
                fontWeight: 700,
                marginTop: theme.spacing(3),
                fontSize: 18,
                lineHeight: 1.5
            }, _defineProperty(_obj2, theme.breakpoints.down("sm"), {
                marginTop: theme.spacing(2),
                fontSize: 17
            }), _defineProperty(_obj2, theme.breakpoints.down("xs"), {
                marginTop: theme.spacing(1),
                fontSize: 16
            }), _defineProperty(_obj2, "& strong", {
                fontWeight: 900
            }), _obj2)), _obj3)
        }
    };
};
/* harmony default export */ var style = (styles);

;// CONCATENATED MODULE: ./components/TitleSubtitle/index.js







var TitleSubtitle = function(param) {
    var classes = param.classes, title = param.title, subtitle = param.subtitle, showClass = param.showClass;
    subtitle = subtitle || "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
        container: true,
        className: showClass ? classes.whiteTxt : classes.blueTxt,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
            item: true,
            xs: 12,
            container: true,
            alignItems: "center",
            justify: "center",
            direction: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h1",
                    component: "h2",
                    className: "title",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "subtitle",
                    children: subtitle
                })
            ]
        })
    });
};
TitleSubtitle.defaultProps = {
    showClass: false
};
TitleSubtitle.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    title: (prop_types_default()).string,
    subtitle: (prop_types_default()).any,
    showClass: (prop_types_default()).bool
};
/* harmony default export */ var components_TitleSubtitle = ((0,withStyles/* default */.Z)(style)(TitleSubtitle));


/***/ }),

/***/ 202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_VideoModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 24 modules
var withStyles = __webpack_require__(9438);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(2663);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(6083);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/DialogContent/DialogContent.js
var DialogContent = __webpack_require__(9525);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(7812);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(366);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(5477);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(2318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(1749);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(2004);
;// CONCATENATED MODULE: ./components/VideoModal/style.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var styles = function(theme) {
    return {
        root: {
            margin: 0,
            padding: theme.spacing(2),
            "& h6": _defineProperty({}, theme.breakpoints.down("sm"), {
                display: "none"
            })
        },
        videoModalPaper: {
            overflow: "hidden"
        },
        closeButton: _defineProperty({
            position: "absolute",
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
            "&:hover": {
                backgroundColor: "transparent"
            }
        }, theme.breakpoints.down("sm"), {
            right: theme.spacing(-1),
            top: theme.spacing(-1)
        }),
        content: {
            padding: 0,
            position: "relative",
            overflow: "hidden"
        },
        reactWrapper: {
            position: "relative",
            paddingTop: "56.25%",
            marginBottom: "-1px",
            "& iframe": {
                borderBottomRightRadius: 4,
                borderBottomLeftRadius: 4
            }
        },
        reactPlayer: {
            zIndex: 10,
            position: "absolute",
            top: 0,
            left: 0
        },
        loading: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        }
    };
};
/* harmony default export */ var style = (styles);

;// CONCATENATED MODULE: ./components/VideoModal/index.js
function VideoModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            VideoModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}














var VideoModal_DialogTitle = (0,withStyles/* default */.Z)(style)(function(props) {
    var children = props.children, classes = props.classes, onClose = props.onClose, other = _objectWithoutProperties(props, [
        "children",
        "classes",
        "onClose"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogTitle/* default */.Z, _objectSpread({
        disableTypography: true,
        className: classes.root
    }, other, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                children: children
            }),
            onClose ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                "aria-label": "close",
                className: classes.closeButton,
                onClick: onClose,
                disableFocusRipple: true,
                disableRipple: true,
                disableTouchRipple: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
            }) : null
        ]
    }));
});
var VideoModal = function(param) {
    var classes = param.classes, open = param.open, handleClose = param.handleClose, video = param.video;
    var ref = (0,react.useState)(true), playing = ref[0], setPlaying = ref[1];
    (0,react.useEffect)(function() {
        if (open) {
            setPlaying(true);
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
            fullWidth: true,
            maxWidth: "md",
            onClose: handleClose,
            "aria-labelledby": "customized-dialog-title",
            open: open,
            classes: {
                paper: classes.videoModalPaper
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModal_DialogTitle, {
                    id: "customized-dialog-title",
                    onClose: handleClose,
                    children: video.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                    className: classes.content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.reactWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                className: classes.reactPlayer,
                                url: video.embed_url,
                                width: "100%",
                                height: "100%",
                                playing: playing,
                                controls: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            container: true,
                            alignItems: "center",
                            justify: "center",
                            className: classes.loading,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                    size: 80
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
VideoModal.propTypes = {
    handleClose: (prop_types_default()).func,
    open: (prop_types_default()).bool,
    video: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var components_VideoModal = ((0,withStyles/* default */.Z)(style)(VideoModal));


/***/ }),

/***/ 3438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_WorkItem; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(5833);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 24 modules
var withStyles = __webpack_require__(9438);
// EXTERNAL MODULE: ./utils/prop-types.js
var utils_prop_types = __webpack_require__(9725);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(5154);
;// CONCATENATED MODULE: ./components/WorkItem/style.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var style = function(theme) {
    var _obj, _obj1, _obj2;
    return (0,createStyles/* default */.Z)({
        workItem: {
            boxShadow: "0 22px 57px 0 rgba(79, 89, 138, 0.16)",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            "& img": {
                width: "100%",
                height: 273,
                objectFit: "cover",
                verticalAlign: "bottom"
            },
            "& a": {
                textDecoration: "none"
            },
            "& .featureWorkItemData": (_obj2 = {
                padding: theme.spacing(4),
                display: "flex",
                flexDirection: "column",
                height: "100%"
            }, _defineProperty(_obj2, theme.breakpoints.down("sm"), {
                padding: theme.spacing(4)
            }), _defineProperty(_obj2, theme.breakpoints.down("xs"), {
                padding: theme.spacing(2),
                height: "unset"
            }), _defineProperty(_obj2, "& .featuredInfo", {
                flex: 1,
                "& .featuredProjectTitle": (_obj = {
                    fontFamily: "Raleway,Assistant",
                    fontSize: 21,
                    color: "#4c4c78",
                    marginBottom: theme.spacing(1),
                    fontWeight: 700
                }, _defineProperty(_obj, theme.breakpoints.down("sm"), {
                    fontSize: 20
                }), _defineProperty(_obj, theme.breakpoints.down("xs"), {
                    fontSize: 19
                }), _obj),
                "& .projectCategoryTitle": (_obj1 = {
                    fontFamily: "Raleway,Assistant",
                    fontSize: 18,
                    color: "#4c4c78"
                }, _defineProperty(_obj1, theme.breakpoints.down("sm"), {
                    fontSize: 17
                }), _defineProperty(_obj1, theme.breakpoints.down("xs"), {
                    fontSize: 16
                }), _obj1)
            }), _obj2),
            "& .button": {
                marginTop: theme.spacing(2)
            }
        }
    });
};
/* harmony default export */ var WorkItem_style = (style);

// EXTERNAL MODULE: ./utils/layout-context.tsx
var layout_context = __webpack_require__(5385);
// EXTERNAL MODULE: ./components/CustomLink/index.js + 1 modules
var CustomLink = __webpack_require__(6833);
;// CONCATENATED MODULE: ./components/WorkItem/index.js










function WorkItem(param) {
    var classes = param.classes, work = param.work;
    var data = work.data;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
        link: work,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.workItem,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: data.featured_image.url,
                    alt: data.featured_image.alt
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "featureWorkItemData",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "featuredInfo",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "featuredProjectTitle",
                                    children: prismic_reactjs.RichText.asText(data.title)
                                }),
                                data.project_category && data.project_category.data && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "projectCategoryTitle",
                                    children: prismic_reactjs.RichText.asText(data.project_category.data.title)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                            link: work,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "button",
                                variant: "outlined",
                                color: "primary",
                                fullWidth: true,
                                children: prismic_reactjs.RichText.asText(layout.project_learn_more_button_text)
                            })
                        })
                    ]
                })
            ]
        })
    });
}
WorkItem.propTypes = {
    work: prop_types_default().shape({
        title: utils_prop_types/* structuredTextPropTypes */.h,
        featuredImage: utils_prop_types/* imagePropTypes */.R,
        projectCategory: prop_types_default().objectOf((prop_types_default()).any)
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var components_WorkItem = ((0,withStyles/* default */.Z)(WorkItem_style)(WorkItem));


/***/ }),

/***/ 9830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ share_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/share-component/style.js
var styles = function(theme) {
    return {
        customShare: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: theme.direction === "ltr" ? "row" : "row-reverse"
        },
        socialButton: {
            color: "#9ad455 !important",
            margin: "0px 4px",
            outline: "none",
            cursor: "pointer",
            borderRadius: 4,
            backgroundColor: "#fff !important",
            padding: "4px 4px 0px !important",
            "&:hover": {
                color: "#9ad455 !important"
            }
        },
        shareButton: {
            width: 40,
            height: 40,
            padding: 10,
            boxShadow: " 0 8px 18px 0 rgba(121, 125, 176, 0.28)",
            backgroundColor: "#9ad455",
            borderRadius: 4,
            cursor: "pointer"
        }
    };
};
/* harmony default export */ var style = (styles);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(1749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 24 modules
var withStyles = __webpack_require__(9438);
// EXTERNAL MODULE: ./node_modules/react-share/es/EmailShareButton.js
var EmailShareButton = __webpack_require__(8137);
// EXTERNAL MODULE: ./node_modules/react-share/es/FacebookShareButton.js
var FacebookShareButton = __webpack_require__(6573);
// EXTERNAL MODULE: ./node_modules/react-share/es/TwitterShareButton.js
var TwitterShareButton = __webpack_require__(6616);
// EXTERNAL MODULE: ./node_modules/react-share/es/LinkedinShareButton.js
var LinkedinShareButton = __webpack_require__(3597);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/mdi-react/FacebookIcon.js
var FacebookIcon = __webpack_require__(6892);
var FacebookIcon_default = /*#__PURE__*/__webpack_require__.n(FacebookIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/TwitterIcon.js
var TwitterIcon = __webpack_require__(978);
var TwitterIcon_default = /*#__PURE__*/__webpack_require__.n(TwitterIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/LinkedinIcon.js
var LinkedinIcon = __webpack_require__(3745);
var LinkedinIcon_default = /*#__PURE__*/__webpack_require__.n(LinkedinIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/MailOutlineIcon.js
var MailOutlineIcon = __webpack_require__(4075);
var MailOutlineIcon_default = /*#__PURE__*/__webpack_require__.n(MailOutlineIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/ShareVariantIcon.js
var ShareVariantIcon = __webpack_require__(1202);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(5833);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/framer-motion.es.js
var framer_motion_es = __webpack_require__(6805);
;// CONCATENATED MODULE: ./components/share-button/style.js
var style_styles = function(theme) {
    return {
        shareIcon: {
            backgroundColor: "#fff"
        }
    };
};
/* harmony default export */ var share_button_style = (style_styles);

;// CONCATENATED MODULE: ./components/share-button/index.js







var CustomShareButton = function(props) {
    var classes = props.classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.shareIcon,
        style: {
            mask: "url(/share-alt-solid.svg) no-repeat center",
            WebkitMask: "url(/share-alt-solid.svg) no-repeat center",
            height: 20
        }
    });
};
/* harmony default export */ var share_button = ((0,withStyles/* default */.Z)(share_button_style)(CustomShareButton));

;// CONCATENATED MODULE: ./components/share-component/index.js
















var NewGrid = framer_motion_es/* motion.custom */.ww.custom(Grid/* default */.Z);
var CustomShareComponent = function(props) {
    var classes = props.classes, onClick = props.onClick;
    var ref = (0,react.useState)(false), share = ref[0], setShare = ref[1];
    var openShare = function() {
        setShare(true);
    };
    var closeShare = function() {
        setShare(false);
    };
    var router = (0,next_router.useRouter)();
    var sharingVariants = {
        open: {
            transition: {
                staggerDirection: -1,
                staggerChildren: 0.1
            }
        },
        closed: {
            transition: {
                staggerChildren: 0.1
            }
        }
    };
    var item = {
        closed: {
            opacity: 0,
            transition: {
                y: {
                    stiffness: 1000
                }
            }
        },
        open: {
            opacity: 1,
            transition: {
                y: {
                    stiffness: 1000,
                    velocity: -100
                }
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.customShare,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewGrid, {
                container: true,
                variants: sharingVariants,
                animate: share ? "open" : "closed",
                initial: "closed",
                onMouseEnter: function() {
                    return openShare();
                },
                onMouseLeave: function() {
                    return closeShare();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewGrid, {
                        item: true,
                        variants: item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailShareButton/* default */.Z, {
                            className: classes.socialButton,
                            url: "https://vfi-website.vercel.app/".concat(router.asPath),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((MailOutlineIcon_default()), {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewGrid, {
                        item: true,
                        variants: item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookShareButton/* default */.Z, {
                            className: classes.socialButton,
                            url: "https://vfi-website.vercel.app/".concat(router.asPath),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((FacebookIcon_default()), {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewGrid, {
                        item: true,
                        variants: item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterShareButton/* default */.Z, {
                            className: classes.socialButton,
                            url: "https://vfi-website.vercel.app/".concat(router.asPath),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((TwitterIcon_default()), {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewGrid, {
                        item: true,
                        variants: item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedinShareButton/* default */.Z, {
                            className: classes.socialButton,
                            url: "https://vfi-website.vercel.app/".concat(router.asPath),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((LinkedinIcon_default()), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.shareButton,
                onMouseEnter: function() {
                    return openShare();
                },
                onMouseLeave: function() {
                    return closeShare();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(share_button, {})
            })
        ]
    });
};
/* harmony default export */ var share_component = ((0,withStyles/* default */.Z)(style)(CustomShareComponent));


/***/ }),

/***/ 7982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sm_resolver; }
});

// NAMESPACE OBJECT: ./slices/index.js
var slices_namespaceObject = {};
__webpack_require__.r(slices_namespaceObject);
__webpack_require__.d(slices_namespaceObject, {
  "AboutHero": function() { return slices_AboutHero; },
  "AboutIntro": function() { return slices_AboutIntro; },
  "AboutQuote": function() { return slices_AboutQuote; },
  "AllBlogs": function() { return slices_AllBlogs; },
  "AllEndorsements": function() { return AllEndorsements; },
  "AllEvents": function() { return AllEvents; },
  "AllMembers": function() { return AllMembers; },
  "AllPastEvents": function() { return AllPastEvents; },
  "BigImage": function() { return slices_BigImage; },
  "BlogPostHero": function() { return slices_BlogPostHero; },
  "BlogPostRichText": function() { return slices_BlogPostRichText; },
  "BlogPostVideo": function() { return slices_BlogPostVideo; },
  "BlogTestimonial": function() { return BlogTestimonial; },
  "BlogsCategory": function() { return BlogsCategory; },
  "CallToAction": function() { return slices_CallToAction; },
  "CompletePayment": function() { return slices_CompletePayment; },
  "ContactForm": function() { return slices_ContactForm; },
  "ContactOurBranches": function() { return slices_ContactOurBranches; },
  "DonateNow": function() { return slices_DonateNow; },
  "DonateOtherModes": function() { return slices_DonateOtherModes; },
  "DonatePayNow": function() { return slices_DonatePayNow; },
  "DonationThankyou": function() { return slices_DonationThankyou; },
  "EndorsementsComponent": function() { return EndorsementsComponent; },
  "EventDetailAbpout": function() { return EventDetailAbpout; },
  "EventDetailsCta": function() { return slices_EventDetailsCta; },
  "EventDetailsHero": function() { return slices_EventDetailsHero; },
  "EventDetailsVideo": function() { return slices_EventDetailsVideo; },
  "EventVideos": function() { return slices_EventVideos; },
  "EventsDetailPastEvents": function() { return EventsDetailPastEvents; },
  "FeaturedBlogs": function() { return slices_FeaturedBlogs; },
  "FeaturedBlogsInProject": function() { return FeaturedBlogsInProject; },
  "FeaturedMembers": function() { return slices_FeaturedMembers; },
  "FeaturedWork": function() { return slices_FeaturedWork; },
  "HeroBackgroundImage": function() { return slices_HeroBackgroundImage; },
  "HomepageHero": function() { return slices_HomepageHero; },
  "ImageGallery": function() { return ImageGallery; },
  "ImapctStatement": function() { return ImapctStatement; },
  "OurPartners": function() { return OurPartners; },
  "PastEvent": function() { return PastEvent; },
  "ProjectGallery": function() { return ProjectGallery; },
  "QuoteTestimonials": function() { return slices_QuoteTestimonials; },
  "ShortHero": function() { return slices_ShortHero; },
  "SubscribeEbook": function() { return SubscribeEbook; },
  "TestimonialBackgroundImage": function() { return slices_TestimonialBackgroundImage; },
  "TextBlueBackground": function() { return slices_TextBlueBackground; },
  "TextWithImage": function() { return slices_TextWithImage; },
  "TextWithVideo": function() { return slices_TextWithVideo; },
  "VideoDetails": function() { return slices_VideoDetails; },
  "WhoWeAre": function() { return slices_WhoWeAre; },
  "components": function() { return components; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(5833);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 24 modules
var withStyles = __webpack_require__(9438);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(2318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(3832);
// EXTERNAL MODULE: ./components/CustomLink/index.js + 1 modules
var CustomLink = __webpack_require__(6833);
// EXTERNAL MODULE: ./components/VideoModal/index.js + 1 modules
var VideoModal = __webpack_require__(202);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
;// CONCATENATED MODULE: ./slices/AboutHero/style.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5, _obj6, _obj7, _obj8, _obj9;
    return {
        outer: {
            position: "relative",
            "& .homehero1": _defineProperty({
                position: "absolute",
                right: 0,
                top: "15%"
            }, theme.breakpoints.down("700"), {
                right: "0px"
            }),
            "& .homehero2": (_obj = {
                position: "absolute",
                right: "10%",
                bottom: "10%"
            }, _defineProperty(_obj, theme.breakpoints.down("1250"), {
                right: "0%",
                bottom: "-20%"
            }), _defineProperty(_obj, theme.breakpoints.down("700"), {
                right: "0px",
                bottom: "-28%"
            }), _obj),
            "& .homehero3": (_obj1 = {
                position: "absolute",
                right: "20%",
                bottom: "5%",
                width: 200,
                height: 200,
                borderRadius: "50%",
                border: "2px solid #fff",
                objectFit: "cover",
                boxShadow: "0 30px 60px 0 rgba(119, 133, 169, 0.28)"
            }, _defineProperty(_obj1, theme.breakpoints.down("980"), {
                width: 160,
                height: 160,
                right: "5%"
            }), _defineProperty(_obj1, theme.breakpoints.down("700"), {
                width: 80,
                height: 80,
                right: "0",
                bottom: 0
            }), _obj1),
            "& .homehero4": (_obj2 = {
                right: "20%",
                width: 150,
                border: "2px solid #fff",
                top: "5%",
                height: 150,
                position: "absolute",
                objectFit: "cover",
                borderRadius: "50%",
                boxShadow: "0 30px 60px 0 rgba(119, 133, 169, 0.28)"
            }, _defineProperty(_obj2, theme.breakpoints.down("980"), {
                width: 120,
                height: 120
            }), _defineProperty(_obj2, theme.breakpoints.down("610"), {
                width: 80,
                height: 80,
                top: "0%"
            }), _obj2),
            "& .homehero5": (_obj3 = {
                right: "50%",
                top: "5%",
                position: "absolute",
                objectFit: "cover"
            }, _defineProperty(_obj3, theme.breakpoints.down("1250"), {
                right: "40%"
            }), _defineProperty(_obj3, theme.breakpoints.down("740"), {
                right: "30%"
            }), _defineProperty(_obj3, theme.breakpoints.down("610"), {
                top: "9%"
            }), _obj3),
            "& .homehero6": (_obj4 = {
                top: "5%",
                left: "25%",
                width: 150,
                border: "2px solid #fff",
                height: 150,
                position: "absolute",
                objectFit: "cover",
                borderRadius: "50%",
                boxShadow: "0 30px 60px 0 rgba(119, 133, 169, 0.28)"
            }, _defineProperty(_obj4, theme.breakpoints.down("980"), {
                width: 120,
                height: 120
            }), _defineProperty(_obj4, theme.breakpoints.down("610"), {
                width: 80,
                height: 80,
                top: "0%"
            }), _obj4),
            "& .homehero7": (_obj5 = {
                left: "20%",
                width: 100,
                border: "2px solid #fff",
                bottom: "5%",
                height: 100,
                position: "absolute",
                objectFit: "cover",
                borderRadius: "50%",
                boxShadow: "0 30px 60px 0 rgba(119, 133, 169, 0.28)"
            }, _defineProperty(_obj5, theme.breakpoints.down("1250"), {
                left: "40%"
            }), _defineProperty(_obj5, theme.breakpoints.down("980"), {
                width: 80,
                height: 80,
                bottom: "-10%"
            }), _defineProperty(_obj5, theme.breakpoints.down("480"), {
                bottom: "-7%"
            }), _obj5),
            "& .homehero8": (_obj6 = {
                left: "15%",
                bottom: "10%",
                position: "absolute",
                objectFit: "cover"
            }, _defineProperty(_obj6, theme.breakpoints.down("1250"), {
                left: "20%"
            }), _defineProperty(_obj6, theme.breakpoints.down("520"), {
                left: "0%"
            }), _obj6),
            "& .homehero9": (_obj7 = {
                top: "20%",
                left: "10%",
                width: 100,
                border: "2px solid #fff",
                height: "100px",
                position: "absolute",
                objectFit: "cover",
                borderRadius: "50%",
                boxShadow: "0 30px 60px 0 rgba(119, 133, 169, 0.28)"
            }, _defineProperty(_obj7, theme.breakpoints.down("980"), {
                width: 80,
                height: 80,
                top: "10%"
            }), _defineProperty(_obj7, theme.breakpoints.down("610"), {
                width: 60,
                height: 60,
                left: "0%"
            }), _obj7),
            "& .homehero10": (_obj8 = {
                position: "absolute",
                bottom: "10%",
                width: 200,
                height: 200,
                left: "-2%",
                borderRadius: "50%",
                border: "2px solid #fff",
                objectFit: "cover",
                boxShadow: "0 30px 60px 0 rgba(119, 133, 169, 0.28)"
            }, _defineProperty(_obj8, theme.breakpoints.down("980"), {
                width: 160,
                height: 160
            }), _defineProperty(_obj8, theme.breakpoints.down("520"), {
                width: 80,
                height: 80,
                bottom: "0"
            }), _obj8)
        },
        aboutHero: (_obj9 = {
            zIndex: 10,
            position: "relative",
            height: 750,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
        }, _defineProperty(_obj9, theme.breakpoints.down("sm"), {
            height: "auto",
            paddingTop: theme.spacing(20),
            paddingBottom: theme.spacing(10),
            backgroundSize: "cover"
        }), _defineProperty(_obj9, theme.breakpoints.down("xs"), {
            height: "auto",
            paddingTop: theme.spacing(20)
        }), _obj9),
        aboutHeroOverlay: {
            zIndex: 0,
            top: 0,
            position: "absolute",
            backgroundPosition: "top",
            backgroundSize: "cover",
            height: 900,
            width: "100%"
        },
        heroTitle: {
            color: "#4c4c78",
            textAlign: "center",
            textTransform: "uppercase",
            marginBottom: theme.spacing(2)
        },
        heroSubTitle: {
            color: "#4c4c78",
            textAlign: "center",
            fontWeight: 900
        },
        heroButton: _defineProperty({
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: theme.spacing(4),
            "& button": {
                margin: theme.spacing(2)
            }
        }, theme.breakpoints.down("sm"), {
            justifyContent: "center",
            flexDirection: "column;",
            alignItems: "center"
        })
    };
};
/* harmony default export */ var style = (styles);

// EXTERNAL MODULE: ./utils/prop-types.js
var utils_prop_types = __webpack_require__(9725);
;// CONCATENATED MODULE: ./slices/AboutHero/index.js













var AboutHero = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    var ref = (0,react.useState)(false), openModal = ref[0], setOpenModal = ref[1];
    var styles = {};
    var openVideoDialog = function() {
        setOpenModal(true);
    };
    var closeVideoDialog = function() {
        setOpenModal(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.outer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                maxWidth: "lg",
                className: classes.aboutHero,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h1",
                        className: classes.heroTitle,
                        children: prismic_reactjs.RichText.asText(primary.title)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle1",
                        className: classes.heroSubTitle,
                        children: prismic_reactjs.RichText.asText(primary.subtitle)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.heroButton,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                link: primary.primaryCtaButtonLink,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    color: "primary",
                                    children: prismic_reactjs.RichText.asText(primary.primaryCtaButtonText)
                                })
                            }),
                            !primary.secondaryButtonType ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                link: primary.secondaryCtaButtonLink,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    color: "secondary",
                                    children: prismic_reactjs.RichText.asText(primary.secondaryCtaButtonText)
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "contained",
                                color: "secondary",
                                onClick: openVideoDialog,
                                children: prismic_reactjs.RichText.asText(primary.secondaryCtaButtonText)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "./aboutUsHero/homehero1.svg",
                className: "homehero1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "./aboutUsHero/homehero2.svg",
                className: "homehero2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: primary.pic1.url,
                className: "homehero3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: primary.pic2.url,
                className: "homehero4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "./aboutUsHero/homehero5.svg",
                className: "homehero5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: primary.pic3.url,
                className: "homehero6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: primary.pic4.url,
                className: "homehero7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "./aboutUsHero/homehero8.svg",
                className: "homehero8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: primary.pic5.url,
                className: "homehero9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: primary.pic6.url,
                className: "homehero10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.aboutHeroOverlay
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModal/* default */.Z, {
                open: openModal,
                handleClose: closeVideoDialog,
                video: primary.videoUrl
            })
        ]
    });
};
AboutHero.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            backgroundImage: utils_prop_types/* imagePropTypes */.R,
            title: utils_prop_types/* structuredTextPropTypes */.h,
            subtitle: utils_prop_types/* structuredTextPropTypes */.h,
            primaryCtaButtonText: utils_prop_types/* structuredTextPropTypes */.h,
            primaryCtaButtonLink: utils_prop_types/* structuredTextPropTypes */.h,
            secondaryCtaButtonText: utils_prop_types/* structuredTextPropTypes */.h,
            secondaryCtaButtonLink: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_AboutHero = ((0,withStyles/* default */.Z)(style)(AboutHero));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(1749);
;// CONCATENATED MODULE: ./slices/AboutIntro/style.js
function style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var style_styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3, _obj4;
    return {
        intro: (_obj2 = {
            marginTop: theme.spacing(10),
            marginBottom: theme.spacing(10)
        }, style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(9),
            marginBottom: theme.spacing(9)
        }), style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(8),
            marginBottom: theme.spacing(8)
        }), style_defineProperty(_obj2, "& .label", {
            background: "linear-gradient( to left, #2f8dc0 50%, #4a92cf 100% ) left bottom no-repeat",
            backgroundSize: "100% 3px",
            paddingBottom: "2px"
        }), style_defineProperty(_obj2, "&  .description", (_obj = {
            lineHeight: 2.13,
            color: "#4c4c78",
            textAlign: "center",
            maxWidth: 1023,
            margin: theme.spacing(4, 0),
            fontFamily: "Raleway,Assistant",
            fontWeight: 700
        }, style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            margin: theme.spacing(3, 0)
        }), style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            margin: theme.spacing(2, 0)
        }), style_defineProperty(_obj, "& p", {
            lineHeight: 2.13,
            color: "#4c4c78",
            textAlign: "center",
            maxWidth: 1023,
            fontFamily: "Raleway,Assistant",
            fontWeight: 700
        }), _obj)), style_defineProperty(_obj2, "& .boldText", (_obj1 = {
            color: "#4c4c78",
            lineHeight: 1.75,
            maxWidth: 1023,
            marginBottom: theme.spacing(4),
            textAlign: "center"
        }, style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            marginBottom: theme.spacing(3)
        }), style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            marginBottom: theme.spacing(2)
        }), _obj1)), _obj2),
        highlightedText: (_obj4 = {
            backgroundColor: "#f4f6f8",
            padding: theme.spacing(2.5, 0, 2.5, 0),
            width: "100%"
        }, style_defineProperty(_obj4, theme.breakpoints.down("sm"), {
            padding: theme.spacing(2, 0, 2, 0)
        }), style_defineProperty(_obj4, theme.breakpoints.down("sm"), {
            padding: theme.spacing(1, 0, 1, 0)
        }), style_defineProperty(_obj4, "& p", (_obj3 = {
            padding: theme.spacing(0, 2, 0, 2),
            fontSize: 28,
            fontWeight: 900,
            color: "#4c4c78",
            fontFamily: "Raleway,Assistant",
            textAlign: "center",
            lineHeight: 1.75,
            margin: theme.spacing(0)
        }, style_defineProperty(_obj3, theme.breakpoints.down("sm"), {
            padding: theme.spacing(0, 1, 0, 1),
            fontSize: 24
        }), style_defineProperty(_obj3, theme.breakpoints.down("sm"), {
            fontSize: 20
        }), _obj3)), _obj4),
        aboutButton: style_defineProperty({
            display: "flex",
            "& .cta": {
                margin: theme.spacing(2)
            }
        }, theme.breakpoints.down("sm"), {
            justifyContent: "center",
            flexDirection: "column;",
            alignItems: "center"
        })
    };
};
/* harmony default export */ var AboutIntro_style = (style_styles);

;// CONCATENATED MODULE: ./slices/AboutIntro/index.js












var AboutIntro = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    var boldText = primary.boldText && prismic_reactjs.RichText.asText(primary.boldText);
    var primaryCtaButtonText = primary.primaryCtaButtonText && prismic_reactjs.RichText.asText(primary.primaryCtaButtonText);
    var secondaryCtaButtonText = primary.secondaryCtaButtonText && prismic_reactjs.RichText.asText(primary.secondaryCtaButtonText);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: "lg",
        className: classes.intro,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
            container: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                item: true,
                xs: 12,
                container: true,
                direction: "column",
                justify: "center",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.highlightedText,
                        children: prismic_reactjs.RichText.render(primary.highlightedText)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "description",
                        children: prismic_reactjs.RichText.render(primary.description)
                    }),
                    boldText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        className: "boldText",
                        children: boldText
                    }),
                    (primaryCtaButtonText || secondaryCtaButtonText) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.aboutButton,
                        children: [
                            primaryCtaButtonText && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                link: primary.primaryCtaButtonLink,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    color: "primary",
                                    className: "cta",
                                    children: primaryCtaButtonText
                                })
                            }),
                            secondaryCtaButtonText && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                link: primary.secondaryCtaButtonLink,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    color: "secondary",
                                    className: "cta",
                                    children: secondaryCtaButtonText
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
AboutIntro.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            highlightedText: utils_prop_types/* structuredTextPropTypes */.h,
            description: utils_prop_types/* structuredTextPropTypes */.h,
            boldText: utils_prop_types/* structuredTextPropTypes */.h,
            primaryCtaButtonText: utils_prop_types/* structuredTextPropTypes */.h,
            primaryCtaButtonLink: prop_types_default().objectOf((prop_types_default()).any),
            secondaryCtaButtonText: utils_prop_types/* structuredTextPropTypes */.h,
            secondaryCtaButtonLink: prop_types_default().objectOf((prop_types_default()).any)
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_AboutIntro = ((0,withStyles/* default */.Z)(AboutIntro_style)(AboutIntro));

;// CONCATENATED MODULE: ./slices/AboutQuote/style.js
function AboutQuote_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var AboutQuote_style_styles = function(theme) {
    var _obj, _obj1, _obj2;
    return {
        aboutQuoteBg: (_obj2 = {
            backgroundImage: 'url("/patternSimpleText.svg")',
            backgroundSize: "110% 158%",
            backgroundPosition: "100%",
            backgroundColor: "#397DB7",
            backgroundRepeat: "no-repeat",
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, AboutQuote_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9),
            backgroundPosition: "100%",
            backgroundSize: "cover"
        }), AboutQuote_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8),
            backgroundPosition: "100%",
            backgroundSize: "cover"
        }), AboutQuote_style_defineProperty(_obj2, "& .quoteImg", {
            width: 26,
            marginRight: theme.spacing(1)
        }), AboutQuote_style_defineProperty(_obj2, "& .quoteText", AboutQuote_style_defineProperty({
            fontWeight: 900,
            color: "#ffffff",
            fontStyle: "italic",
            lineHeight: 2.72
        }, theme.breakpoints.down("sm"), {
            lineHeight: 1.72
        })), AboutQuote_style_defineProperty(_obj2, "& .quoteAuthor", AboutQuote_style_defineProperty({
            fontSize: 21,
            fontWeight: 900,
            color: "#fff",
            marginTop: theme.spacing(7.5)
        }, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(3.5)
        })), AboutQuote_style_defineProperty(_obj2, "& .quoteRight", {
            position: "absolute",
            marginTop: theme.spacing(1),
            marginLeft: theme.spacing(1)
        }), AboutQuote_style_defineProperty(_obj2, "& .rightImage", (_obj = {
            borderRadius: "67% 40% 53% 60% / 40% 37% 63% 70%",
            height: 469,
            width: 570,
            objectFit: "cover",
            position: "relative",
            zIndex: 99
        }, AboutQuote_style_defineProperty(_obj, theme.breakpoints.down("md"), {
            width: 500
        }), AboutQuote_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            width: 570
        }), AboutQuote_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            width: "100%",
            height: "auto"
        }), _obj)), AboutQuote_style_defineProperty(_obj2, "& .rightImageOverlay", (_obj1 = {
            borderRadius: "32% 68% 42% 58% / 36% 71% 29% 64%",
            width: 570,
            height: 469,
            position: "absolute",
            zIndex: 9,
            backgroundColor: "rgba(0, 0, 0, 0.2)"
        }, AboutQuote_style_defineProperty(_obj1, theme.breakpoints.down("md"), {
            width: 500
        }), AboutQuote_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            width: 570
        }), AboutQuote_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            width: 350,
            height: 232
        }), AboutQuote_style_defineProperty(_obj1, theme.breakpoints.down("400"), {
            width: 250,
            height: 170
        }), _obj1)), _obj2)
    };
};
/* harmony default export */ var AboutQuote_style = (AboutQuote_style_styles);

;// CONCATENATED MODULE: ./slices/AboutQuote/index.js











var AboutQuote = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.aboutQuoteBg,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "lg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                spacing: 3,
                direction: "row",
                justify: "center",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        md: 6,
                        container: true,
                        direction: "row",
                        justify: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "rightImageOverlay"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: primary.leftImage.url,
                                className: "rightImage",
                                alt: "quotes"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "subtitle1",
                                className: "quoteText",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/quote-left-font-awesome.png",
                                        alt: "quotes",
                                        className: "quoteImg"
                                    }),
                                    prismic_reactjs.RichText.asText(primary.quoteText),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/quote-right-font-awesome.png",
                                        className: "quoteRight quoteImg",
                                        alt: "quotes"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "quoteAuthor",
                                children: prismic_reactjs.RichText.asText(primary.quoteAuthor)
                            })
                        ]
                    })
                ]
            })
        })
    });
};
AboutQuote.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            leftImage: utils_prop_types/* imagePropTypes */.R,
            quoteText: utils_prop_types/* structuredTextPropTypes */.h,
            quoteAuthor: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_AboutQuote = ((0,withStyles/* default */.Z)(AboutQuote_style)(AboutQuote));

;// CONCATENATED MODULE: ./slices/AllBlogs/style.js
function AllBlogs_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var AllBlogs_style_styles = function(theme) {
    var _obj, _obj1, _obj2;
    return {
        featuredBlogs: (_obj2 = {
            backgroundPosition: "center",
            backgroundSize: "150% 100%",
            backgroundRepeat: "no-repeat",
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10),
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"
        }, AllBlogs_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9),
            backgroundSize: "cover"
        }), AllBlogs_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), AllBlogs_style_defineProperty(_obj2, "& .CategoryTagWrapper", (_obj = {
            marginTop: theme.spacing(10),
            marginBottom: theme.spacing(10)
        }, AllBlogs_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(9),
            marginBottom: theme.spacing(9)
        }), AllBlogs_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(8),
            marginBottom: theme.spacing(8)
        }), _obj)), AllBlogs_style_defineProperty(_obj2, "& .featureBlogsContainer", (_obj1 = {
            marginTop: theme.spacing(10)
        }, AllBlogs_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(9)
        }), AllBlogs_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(8)
        }), _obj1)), _obj2)
    };
};
/* harmony default export */ var AllBlogs_style = (AllBlogs_style_styles);

// EXTERNAL MODULE: ./utils/additional-data-context.js
var additional_data_context = __webpack_require__(1623);
// EXTERNAL MODULE: ./components/PersonItem/index.js + 1 modules
var PersonItem = __webpack_require__(5568);
// EXTERNAL MODULE: ./components/TitleSubtitle/index.js + 1 modules
var TitleSubtitle = __webpack_require__(8785);
// EXTERNAL MODULE: ./components/CategoryTag/index.js + 1 modules
var CategoryTag = __webpack_require__(1130);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./slices/AllBlogs/index.js














var section = {
    maxWidth: "600px",
    margin: "4em auto",
    textAlign: "center"
};
var h2 = {
    color: "#8592e0"
};
var dateOptions = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
};
var AllBlogs = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    var additionalData = (0,additional_data_context/* useAdditionalData */.eP)();
    var ref = (0,react.useState)(additionalData.blogs.next_page), nextPage = ref[0], setNextPage = ref[1];
    var ref1 = (0,react.useState)(additionalData.blogs.results), results = ref1[0], setResults = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.featuredBlogs,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            maxWidth: "lg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                    title: prismic_reactjs.RichText.asText(primary.title),
                    subtitle: prismic_reactjs.RichText.asText(primary.subtitle),
                    showClass: false
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    spacing: 4,
                    direction: "row",
                    justify: "center",
                    alignItems: "center",
                    className: "CategoryTagWrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            md: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTag/* default */.Z, {
                                selected: true,
                                CategoryTagTitle: "View All",
                                showIcon: false
                            })
                        }, "random"),
                        additionalData.blog_topic.results.map(function(category, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                md: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                    link: category,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTag/* default */.Z, {
                                        CategoryTagTitle: prismic_reactjs.RichText.asText(category.data.topic_name),
                                        showIcon: false
                                    })
                                })
                            }, index);
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    container: true,
                    spacing: 4,
                    direction: "row",
                    justify: "center",
                    className: "featureBlogsContainer",
                    children: results.map(function(blog, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            md: index == 0 || index == 1 ? 6 : 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonItem/* default */.Z, {
                                link: blog,
                                showTag: blog.data.blog_topics && blog.data.blog_topics.length > 0,
                                tag: blog.data.blog_topics && blog.data.blog_topics.length > 0 && blog.data.blog_topics[0].blog_topic.data && blog.data.blog_topics[0].blog_topic.data.topic_name ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                    link: blog.data.blog_topics[0].blog_topic,
                                    children: prismic_reactjs.RichText.asText(blog.data.blog_topics[0].blog_topic.data.topic_name)
                                }) : null,
                                bannerImageSrc: blog.data.featured_image.url,
                                bannerImageAlt: blog.data.featured_image.alt,
                                name: prismic_reactjs.RichText.asText(blog.data.title),
                                title: (0,prismic_reactjs.Date)(blog.data.date).toLocaleDateString((0,next_router.useRouter)().locale, dateOptions)
                            })
                        }, index);
                    })
                })
            ]
        })
    });
};
AllBlogs.propTypes = {
    slice: (0,prop_types.shape)({
        primary: (0,prop_types.shape)({
            title: prop_types.array.isRequired
        }).isRequired
    }).isRequired
};
/* harmony default export */ var slices_AllBlogs = ((0,withStyles/* default */.Z)(AllBlogs_style)(AllBlogs));

;// CONCATENATED MODULE: ./slices/AllEndorsements/style.js
function AllEndorsements_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var AllEndorsements_style_styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3;
    return {
        endorsements: (_obj = {
            backgroundColor: "#F4F5F6",
            backgroundImage: 'url("/patternSimpleText.svg")',
            backgroundSize: "100% 111%",
            backgroundPosition: "100%",
            backgroundBlendMode: "color-burn",
            backgroundRepeat: "no-repeat",
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, AllEndorsements_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), AllEndorsements_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), _obj),
        testimonialCardGrid: {
            "& .flexEnd": {
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end"
            }
        },
        testimonialCard: (_obj2 = {
            borderRadius: 6,
            boxShadow: "0 20px 30px 0 rgba(0, 0, 0, 0.2)",
            backgroundColor: "#ffffff",
            padding: theme.spacing(4),
            display: "flex",
            flexDirection: "column",
            height: "100%"
        }, AllEndorsements_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            padding: theme.spacing(3)
        }), AllEndorsements_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
            padding: theme.spacing(2)
        }), AllEndorsements_style_defineProperty(_obj2, "& .name", (_obj1 = {
            color: "#4c4c78",
            fontSize: 14,
            fontWeight: 700,
            lineHeight: 1.79,
            marginTop: theme.spacing(4)
        }, AllEndorsements_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(3)
        }), AllEndorsements_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(2)
        }), _obj1)), AllEndorsements_style_defineProperty(_obj2, "& .testimonialTitle", {
            color: "#4c4c78",
            fontWeight: 500,
            maxWidth: 200
        }), AllEndorsements_style_defineProperty(_obj2, "& .testimonial", {
            color: "#4c4c78",
            fontWeight: 700,
            lineHeight: 1.79,
            fontFamily: "Raleway,Assistant",
            fontStyle: "italic",
            flex: 1
        }), _obj2),
        testimonialImg: (_obj3 = {
            width: 113,
            height: 113,
            minWidth: 113,
            minHeight: 113,
            maxWidth: 113,
            maxHeight: 113,
            borderRadius: 100,
            background: "#fff",
            boxShadow: "0 38px 66px 0 rgba(80, 82, 138, 0.18)",
            border: "solid 2px #ffffff",
            marginTop: "-60px",
            marginRight: "-24px",
            objectFit: "cover"
        }, AllEndorsements_style_defineProperty(_obj3, theme.breakpoints.down("sm"), {
            marginRight: "-20px"
        }), AllEndorsements_style_defineProperty(_obj3, theme.breakpoints.down("xs"), {
            marginRight: "-10px"
        }), _obj3)
    };
};
/* harmony default export */ var AllEndorsements_style = (AllEndorsements_style_styles);

;// CONCATENATED MODULE: ./slices/AllEndorsements/index.js














var Endorsements = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    var additionalData = (0,additional_data_context/* useAdditionalData */.eP)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.endorsements,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "lg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                spacing: 4,
                direction: "row",
                justify: "center",
                alignItems: "stretch",
                children: additionalData.endorsements.results.map(function(endorsement, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 4,
                        container: true,
                        direction: "row",
                        justify: "center",
                        className: classes.testimonialCardGrid,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flexEnd",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.testimonialCard,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "subtitle2",
                                            className: "testimonial",
                                            children: prismic_reactjs.RichText.asText(endorsement.data.endorsement)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            className: "name",
                                            children: prismic_reactjs.RichText.asText(endorsement.data.endorser_name)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "subtitle2",
                                            className: "testimonialTitle",
                                            children: prismic_reactjs.RichText.asText(endorsement.data.endorser_title)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: endorsement.data.endorser_profile_image.url,
                                    alt: "profile",
                                    className: classes.testimonialImg
                                })
                            ]
                        })
                    });
                })
            })
        })
    });
};
Endorsements.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h,
            subtitle: utils_prop_types/* structuredTextPropTypes */.h,
            cta_button_text: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var AllEndorsements = ((0,withStyles/* default */.Z)(AllEndorsements_style)(Endorsements));

;// CONCATENATED MODULE: ./components/EventsItem/style.js
function EventsItem_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var EventsItem_style_styles = function(theme) {
    var _obj, _obj1, _obj2;
    return {
        eventsItem: (_obj2 = {
            borderRadius: 5,
            boxShadow: "0 30px 60px 0 rgba(73, 86, 149, 0.15)",
            backgroundColor: "#ffffff",
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            padding: theme.spacing(2),
            display: "flex",
            alignItems: "center",
            cursor: "pointer"
        }, EventsItem_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            flexDirection: "column",
            alignItems: "flex-start",
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        }), EventsItem_style_defineProperty(_obj2, "& img", EventsItem_style_defineProperty({
            width: 260,
            height: 260,
            objectFit: "cover"
        }, theme.breakpoints.down("sm"), {
            width: "100%",
            height: "100%"
        })), EventsItem_style_defineProperty(_obj2, "& .eventInfo", (_obj = {
            flex: 1,
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(2)
        }, EventsItem_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(2),
            paddingLeft: theme.spacing(0)
        }), EventsItem_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            flex: "none",
            width: "100%"
        }), EventsItem_style_defineProperty(_obj, "& .eventName,.moreDetails", {
            color: "#4c4c78",
            fontWeight: 700,
            marginBottom: theme.spacing(2)
        }), EventsItem_style_defineProperty(_obj, "& .eventPlace,.eventDate", {
            lineHeight: 1.44,
            color: "#4c4c78",
            fontWeight: 500
        }), EventsItem_style_defineProperty(_obj, "& .moreDetails", {
            color: "#4c4c78",
            fontWeight: 700,
            marginTop: theme.spacing(2.5),
            textDecoration: "underline",
            cursor: "pointer"
        }), _obj)), EventsItem_style_defineProperty(_obj2, "& .eventRegister", (_obj1 = {
            textAlign: "center"
        }, EventsItem_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            width: "100%",
            marginTop: "-20px",
            textAlign: "left"
        }), EventsItem_style_defineProperty(_obj1, "& .eventPrice", EventsItem_style_defineProperty({
            color: "#4c4c78",
            fontWeight: 700,
            textAlign: "center",
            marginBottom: theme.spacing(3.5)
        }, theme.breakpoints.down("sm"), {
            textAlign: "left"
        })), _obj1)), _obj2)
    };
};
/* harmony default export */ var EventsItem_style = (EventsItem_style_styles);

// EXTERNAL MODULE: ./utils/layout-context.tsx
var layout_context = __webpack_require__(5385);
;// CONCATENATED MODULE: ./components/EventsItem/index.js












var EventsItem = function(param) {
    var classes = param.classes, imgSrc = param.imgSrc, imgAlt = param.imgAlt, eventName = param.eventName, eventPlace = param.eventPlace, eventDate = param.eventDate, eventPrice = param.eventPrice, btnLbl = param.btnLbl, item = param.item, moreDetailsLink = param.moreDetailsLink, pastOrFuture = param.pastOrFuture;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    var buttonText = !pastOrFuture ? btnLbl : prismic_reactjs.RichText.asText(layout.past_event_watch_button_text);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
        items: true,
        xs: 12,
        children: item && layout && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
            link: item,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.eventsItem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: imgSrc,
                        alt: imgAlt
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        item: true,
                        className: "eventInfo",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h5",
                                className: "eventName",
                                children: eventName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h6",
                                className: "eventPlace",
                                children: eventPlace
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h6",
                                className: "eventDate",
                                children: eventDate
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h6",
                                className: "moreDetails",
                                children: prismic_reactjs.RichText.asText(layout.event_more_details_button_text)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        item: true,
                        className: "eventRegister",
                        children: [
                            !pastOrFuture && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h3",
                                className: "eventPrice",
                                children: eventPrice
                            }),
                            moreDetailsLink && buttonText && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                link: !pastOrFuture ? moreDetailsLink : item,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    color: "primary",
                                    children: buttonText
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
EventsItem.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    imgSrc: prop_types_default().objectOf((prop_types_default()).string).isRequired,
    imgAlt: prop_types_default().objectOf((prop_types_default()).string).isRequired,
    eventName: prop_types_default().objectOf((prop_types_default()).string).isRequired,
    eventPlace: prop_types_default().objectOf((prop_types_default()).string).isRequired,
    eventDate: prop_types_default().objectOf((prop_types_default()).string).isRequired,
    moreDetails: prop_types_default().objectOf((prop_types_default()).string).isRequired,
    eventPrice: prop_types_default().objectOf((prop_types_default()).string).isRequired,
    btnLbl: prop_types_default().objectOf((prop_types_default()).string).isRequired
};
/* harmony default export */ var components_EventsItem = ((0,withStyles/* default */.Z)(EventsItem_style)(EventsItem));

;// CONCATENATED MODULE: ./slices/AllEvents/index.js













var EventList = function(param) {
    var slice = param.slice;
    var primary = slice.primary, items = slice.items, add = slice.add;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    var additionalData = (0,additional_data_context/* useAdditionalData */.eP)();
    var ref = (0,react.useState)(additionalData.events.next_page), nextPage = ref[0], setNextPage = ref[1];
    var ref1 = (0,react.useState)(additionalData.events.results), results = ref1[0], setResults = ref1[1];
    (0,react.useEffect)(function() {
        fetch("".concat(nextPage)).then(function(response) {
            return response.json();
        }).then(function(data) {
            setResults(results.concat(data.results));
            setNextPage(data.next_page);
        });
    }, [
        nextPage
    ]);
    var events = results && results.filter(function(event) {
        return event.data.upcoming_or_past == false;
    }).map(function(item) {
        return item && layout && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EventsItem, {
            pastOrFuture: item.data.upcoming_or_past,
            item: item,
            moreDetailsLink: item.data.register_button_link,
            imgSrc: item.data.featured_image.url,
            imgAlt: item.data.featured_image.alt,
            eventName: prismic_reactjs.RichText.asText(item.data.title),
            eventPlace: prismic_reactjs.RichText.asText(item.data.subtitle1),
            eventDate: prismic_reactjs.RichText.asText(item.data.subtitle2),
            moreDetails: prismic_reactjs.RichText.asText(layout.event_more_details_button_text),
            eventPrice: prismic_reactjs.RichText.asText(item.data.price_text),
            btnLbl: prismic_reactjs.RichText.asText(item.data.register_button_text)
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: events && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
            container: true,
            children: events
        })
    });
};
EventList.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h,
            subtitle: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var AllEvents = ((0,withStyles/* default */.Z)()(EventList));

;// CONCATENATED MODULE: ./slices/AllMembers/style.js
function AllMembers_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var AllMembers_style_styles = function(theme) {
    var _obj;
    return {
        featuredMember: (_obj = {
            paddingBottom: theme.spacing(10)
        }, AllMembers_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            paddingBottom: theme.spacing(9)
        }), AllMembers_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            paddingBottom: theme.spacing(8)
        }), AllMembers_style_defineProperty(_obj, "& .viewAll", {
            margin: "0 auto"
        }), _obj)
    };
};
/* harmony default export */ var AllMembers_style = (AllMembers_style_styles);

// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(6261);
;// CONCATENATED MODULE: ./slices/AllMembers/index.js















var AllTeam = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary, items = slice.items;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    var additionalData = (0,additional_data_context/* useAdditionalData */.eP)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: "lg",
        className: classes.featuredMember,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
            container: true,
            spacing: 4,
            className: "boardMemberItem",
            direction: "row",
            justify: "center",
            alignItems: "center",
            children: additionalData.allTeam.results.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    md: 4,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonItem/* default */.Z, {
                        bannerImageSrc: item.data.portrait_image.url,
                        bannerImageAlt: "",
                        name: prismic_reactjs.RichText.asText(item.data.name),
                        title: prismic_reactjs.RichText.asText(item.data.title),
                        btnLabel: prismic_reactjs.RichText.asText(layout.full_bio_button_text),
                        showTag: false,
                        showBtn: true,
                        link: item
                    })
                });
            })
        })
    });
};
AllTeam.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: (prop_types_default()).array
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var AllMembers = ((0,withStyles/* default */.Z)(AllMembers_style)(AllTeam));

;// CONCATENATED MODULE: ./slices/AllPastEvents/index.js












var PastEventList = function(param) {
    var slice = param.slice;
    var primary = slice.primary, items = slice.items, add = slice.add;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    var additionalData = (0,additional_data_context/* useAdditionalData */.eP)();
    var ref = (0,react.useState)(additionalData.past_events.next_page), nextPage = ref[0], setNextPage = ref[1];
    var ref1 = (0,react.useState)(additionalData.past_events.results), results = ref1[0], setResults = ref1[1];
    (0,react.useEffect)(function() {
        fetch("".concat(nextPage)).then(function(response) {
            return response.json();
        }).then(function(data) {
            setResults(results.concat(data.results));
            setNextPage(data.next_page);
        });
    }, [
        nextPage
    ]);
    var events = results && results.filter(function(event) {
        return event.data.upcoming_or_past == true;
    }).map(function(item) {
        return item && layout && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EventsItem, {
            pastOrFuture: item.data.upcoming_or_past,
            item: item,
            moreDetailsLink: item.data.register_button_link,
            imgSrc: item.data.featured_image.url,
            imgAlt: item.data.featured_image.alt,
            eventName: prismic_reactjs.RichText.asText(item.data.title),
            eventPlace: prismic_reactjs.RichText.asText(item.data.subtitle1),
            eventDate: prismic_reactjs.RichText.asText(item.data.subtitle2),
            moreDetails: prismic_reactjs.RichText.asText(layout.event_more_details_button_text),
            eventPrice: prismic_reactjs.RichText.asText(item.data.price_text),
            btnLbl: prismic_reactjs.RichText.asText(item.data.register_button_text)
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
            container: true,
            children: events
        })
    });
};
PastEventList.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h,
            subtitle: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var AllPastEvents = ((0,withStyles/* default */.Z)()(PastEventList));

;// CONCATENATED MODULE: ./slices/BigImage/style.js
function BigImage_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var BigImage_style_styles = function(theme) {
    var _obj;
    return {
        bigImage: (_obj = {
            marginTop: theme.spacing(5),
            marginBottom: theme.spacing(5)
        }, BigImage_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(4)
        }), BigImage_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(3)
        }), _obj),
        image: {
            width: "100%",
            display: "block"
        }
    };
};
/* harmony default export */ var BigImage_style = (BigImage_style_styles);

;// CONCATENATED MODULE: ./slices/BigImage/index.js















var BigImage = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.bigImage,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "lg",
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                justify: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    sm: 10,
                    md: 8,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: classes.image,
                        src: primary.image.url
                    })
                })
            })
        })
    });
};
BigImage.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            image: utils_prop_types/* imagePropTypes */.R
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_BigImage = ((0,withStyles/* default */.Z)(BigImage_style)(BigImage));

;// CONCATENATED MODULE: ./slices/BlogPostHero/style.js
function BlogPostHero_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var BlogPostHero_style_styles = function(theme) {
    var _obj;
    return {
        background: {
            backgroundPosition: "center",
            backgroundSize: "cover",
            position: "relative",
            "& .container ": {
                height: "100%",
                position: "relative"
            }
        },
        backgroundOverlay: (_obj = {
            backgroundColor: "rgba(0,0,0,0.2)",
            height: 560
        }, BlogPostHero_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            padding: theme.spacing(20, 2),
            height: "100%"
        }), BlogPostHero_style_defineProperty(_obj, "& .blogPostTagWrapper", BlogPostHero_style_defineProperty({
            display: "flex"
        }, theme.breakpoints.down("xs"), {
            display: "block"
        })), BlogPostHero_style_defineProperty(_obj, "& .blogPostTag,.blogPostTitle, .boldPostDate", {
            color: "#fff",
            textTransform: "uppercase",
            padding: theme.spacing(1.5, 0)
        }), BlogPostHero_style_defineProperty(_obj, "& .boldPostDate", {
            fontWeight: 900
        }), BlogPostHero_style_defineProperty(_obj, "& .blogPostTag", BlogPostHero_style_defineProperty({
            borderRadius: 6,
            backgroundColor: "#4a92cf",
            width: "fit-content",
            padding: theme.spacing(0.5, 1),
            marginRight: theme.spacing(1),
            cursor: "pointer",
            fontWeight: 900
        }, theme.breakpoints.down("xs"), {
            marginRight: theme.spacing(0),
            marginTop: theme.spacing(1)
        })), BlogPostHero_style_defineProperty(_obj, "& .shareButton", {
            position: "relative",
            bottom: "-32px"
        }), _obj),
        heroButton: BlogPostHero_style_defineProperty({
            display: "flex",
            marginTop: theme.spacing(4),
            "& button": {
                margin: theme.spacing(2)
            }
        }, theme.breakpoints.down("sm"), {
            justifyContent: "center",
            flexDirection: "column;",
            alignItems: "center"
        })
    };
};
/* harmony default export */ var BlogPostHero_style = (BlogPostHero_style_styles);

// EXTERNAL MODULE: ./components/share-component/index.js + 3 modules
var share_component = __webpack_require__(9830);
;// CONCATENATED MODULE: ./slices/BlogPostHero/index.js
function BlogPostHero_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}













var BlogPostHero_dateOptions = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
};
var BlogPostHero = function(param) {
    var classes = param.classes, slice = param.slice;
    var primary = slice.primary;
    var additionalData = (0,additional_data_context/* useAdditionalData */.eP)();
    var styles = {};
    if (additionalData.blog_post.data.featured_image) {
        styles.backgroundImage = "url(".concat(additionalData.blog_post.data.featured_image.url, ")");
    }
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.background,
        style: styles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.backgroundOverlay,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    maxWidth: "lg",
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        direction: "column",
                        justify: "center",
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "blogPostTagWrapper",
                                children: [
                                    additionalData.blog_post.data && additionalData.blog_post.data.blog_topics && additionalData.blog_post.data.blog_topics.length > 0 && additionalData.blog_post.data.blog_topics.map(function(category) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                            link: category.blog_topic,
                                            children: category.blog_topic.data && category.blog_topic.data.topic_name && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                className: "blogPostTag",
                                                children: prismic_reactjs.RichText.asText(category.blog_topic.data.topic_name)
                                            })
                                        });
                                    }),
                                    additionalData.blog_post.data && additionalData.blog_post.data.project_categories && additionalData.blog_post.data.project_categories.length > 0 && additionalData.blog_post.data.project_categories.map(function(category) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                            link: category.project_category,
                                            children: category.project_category.data && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                className: "blogPostTag",
                                                children: prismic_reactjs.RichText.asText(category.project_category.data.title)
                                            })
                                        });
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h3",
                                className: "blogPostTitle",
                                children: prismic_reactjs.RichText.asText(additionalData.blog_post.data.title)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle2",
                                className: "boldPostDate",
                                children: (0,prismic_reactjs.Date)(additionalData.blog_post.data.date).toLocaleDateString((0,next_router.useRouter)().locale, BlogPostHero_dateOptions)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, (_obj = {
                    maxWidth: "lg",
                    className: "container"
                }, BlogPostHero_defineProperty(_obj, "className", "shareButton"), BlogPostHero_defineProperty(_obj, "children", /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(share_component/* default */.Z, {})
                })), _obj))
            ]
        })
    });
};
BlogPostHero.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({}).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_BlogPostHero = ((0,withStyles/* default */.Z)(BlogPostHero_style)(BlogPostHero));

;// CONCATENATED MODULE: ./slices/BlogPostRichText/style.js
function BlogPostRichText_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var BlogPostRichText_style_styles = function(theme) {
    var _obj, _obj1, _obj2;
    return {
        blogPostRichText: (_obj2 = {
            marginTop: theme.spacing(5),
            marginBottom: theme.spacing(5),
            color: "#4c4c78"
        }, BlogPostRichText_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(4)
        }), BlogPostRichText_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(3)
        }), BlogPostRichText_style_defineProperty(_obj2, "& p", (_obj = {
            margin: 0,
            fontSize: 20,
            fontWeight: 500,
            lineHeight: "30px",
            letterSpacing: 0.4,
            wordSpacing: 4
        }, BlogPostRichText_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            fontSize: 19,
            lineHeight: "28px"
        }), BlogPostRichText_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            fontSize: 18,
            lineHeight: "26px"
        }), _obj)), BlogPostRichText_style_defineProperty(_obj2, "& li", (_obj1 = {
            fontSize: 20,
            fontWeight: 500,
            lineHeight: "30px",
            letterSpacing: 0.4,
            wordSpacing: 4
        }, BlogPostRichText_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            fontSize: 19,
            lineHeight: "28px"
        }), BlogPostRichText_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            fontSize: 18,
            lineHeight: "26px"
        }), _obj1)), BlogPostRichText_style_defineProperty(_obj2, "& .title", {
            lineHeight: 1.92,
            margin: theme.spacing(0)
        }), BlogPostRichText_style_defineProperty(_obj2, "&  .boldText", {
            lineHeight: 2.13,
            margin: theme.spacing(7.5, 0, 2),
            fontWeight: 700
        }), BlogPostRichText_style_defineProperty(_obj2, "& .para", {
            lineHeight: 2.13,
            fontWeight: 500
        }), _obj2)
    };
};
/* harmony default export */ var BlogPostRichText_style = (BlogPostRichText_style_styles);

;// CONCATENATED MODULE: ./slices/BlogPostRichText/index.js









var BlogPostRichText = function(param) {
    var classes = param.classes, slice = param.slice;
    var primary = slice.primary;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: "lg",
        className: classes.blogPostRichText,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
            container: true,
            justify: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                xs: 12,
                sm: 10,
                md: 8,
                children: prismic_reactjs.RichText.render(primary.richText)
            })
        })
    });
};
BlogPostRichText.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({}).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_BlogPostRichText = ((0,withStyles/* default */.Z)(BlogPostRichText_style)(BlogPostRichText));

;// CONCATENATED MODULE: ./slices/BlogPostVideo/style.js
function BlogPostVideo_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var BlogPostVideo_style_styles = function(theme) {
    var _obj, _obj1;
    return {
        blogPostVideo: (_obj1 = {
            clipPath: "polygon(0 10%, 100% 0, 100% 100%, 0% 100%)",
            position: "relative",
            backgroundColor: "#8BC249",
            backgroundImage: "url('/greenCirclePattner.png')",
            backgroundPosition: "bottom",
            backgroundSize: "128% 70%",
            backgroundRepeat: "no-repeat",
            paddingTop: theme.spacing(20),
            paddingBottom: theme.spacing(10)
        }, BlogPostVideo_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            clipPath: "polygon(0 15%, 100% 0, 100% 100%, 0% 100%)",
            paddingTop: theme.spacing(18),
            paddingBottom: theme.spacing(9),
            backgroundSize: "200% 70%"
        }), BlogPostVideo_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(16),
            paddingBottom: theme.spacing(8)
        }), BlogPostVideo_style_defineProperty(_obj1, "& .thumbnailWrapper", {
            cursor: "pointer",
            "& .playBtn": (_obj = {
                height: 69,
                width: 105,
                backgroundImage: "url('/playBtnBg.png')",
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                position: "absolute",
                borderRadius: 8,
                boxShadow: "0px 2px 6px 0px #1f1f1f",
                top: "55%",
                left: "50%",
                right: "50%",
                cursor: "pointer",
                transform: "translateY(-50%) translateX(-50%)"
            }, BlogPostVideo_style_defineProperty(_obj, theme.breakpoints.down("844"), {
                top: "60%"
            }), BlogPostVideo_style_defineProperty(_obj, theme.breakpoints.down("600"), {
                top: "60%",
                height: 35,
                width: 55,
                borderRadius: 8
            }), BlogPostVideo_style_defineProperty(_obj, theme.breakpoints.down("374"), {
                top: "63%"
            }), _obj)
        }), BlogPostVideo_style_defineProperty(_obj1, "&::after", BlogPostVideo_style_defineProperty({
            clipPath: "polygon(0 15%, 100% 0, 100% 90%, 0% 100%)",
            background: "linear-gradient(90deg,rgba(140,194,75,1) 10%, rgba(105, 144, 57,1) 60%,  rgba(74,146,207,1) 30%)",
            content: '""',
            position: "absolute",
            left: 0,
            top: "-89.5%",
            right: 0,
            height: "100%",
            display: "block",
            zIndex: 9
        }, theme.breakpoints.down("sm"), {
            top: "-84.5%",
            clipPath: "polygon(0% 0%, 100% 10%, 100% 84.8%, 0% 100%);"
        })), _obj1)
    };
};
/* harmony default export */ var BlogPostVideo_style = (BlogPostVideo_style_styles);

;// CONCATENATED MODULE: ./components/ThumbnailVideo/style.js
function ThumbnailVideo_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var ThumbnailVideo_style_styles = function(theme) {
    var _obj;
    return {
        imgBg: (_obj = {
            backgroundImage: "url('/videoBg.png')",
            backgroundPosition: "center",
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat",
            maxWidth: 1000,
            padding: theme.spacing(2.5, 2.5),
            margin: theme.spacing(8.5, 0, 8.5, 0)
        }, ThumbnailVideo_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            margin: theme.spacing(2, 0)
        }), ThumbnailVideo_style_defineProperty(_obj, "& img", {
            width: "100%",
            borderRadius: 18,
            maxHeight: 620,
            objectFit: "cover"
        }), _obj)
    };
};
/* harmony default export */ var ThumbnailVideo_style = (ThumbnailVideo_style_styles);

;// CONCATENATED MODULE: ./components/ThumbnailVideo/index.js






var ThumbnailVideo = function(param) {
    var classes = param.classes, thumbnailVideoUrl = param.thumbnailVideoUrl, thumbnailVideoAlt = param.thumbnailVideoAlt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.imgBg,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: thumbnailVideoUrl,
            alt: thumbnailVideoAlt
        })
    });
};
ThumbnailVideo.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    thumbnailVideoUrl: prop_types_default().objectOf((prop_types_default()).string).isRequired,
    thumbnailVideoAlt: prop_types_default().objectOf((prop_types_default()).string).isRequired
};
/* harmony default export */ var components_ThumbnailVideo = ((0,withStyles/* default */.Z)(ThumbnailVideo_style)(ThumbnailVideo));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(1810);
;// CONCATENATED MODULE: ./slices/BlogPostVideo/index.js











var BlogPostVideo = function(param) {
    var classes = param.classes, slice = param.slice;
    var primary = slice.primary;
    var ref = (0,react.useState)(false), openModal = ref[0], setOpenModal = ref[1];
    var openVideoDialog = function() {
        setOpenModal(true);
    };
    var closeVideoDialog = function() {
        setOpenModal(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.blogPostVideo,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                direction: "column",
                justify: "center",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onClick: function() {
                            return openVideoDialog();
                        },
                        className: "thumbnailWrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ThumbnailVideo, {
                                thumbnailVideoUrl: primary.thumbnailVideoUrl.url,
                                thumbnailVideoAlt: primary.thumbnailVideoUrl.alt
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                className: "playBtn",
                                onClick: openVideoDialog
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModal/* default */.Z, {
                        open: openModal,
                        handleClose: closeVideoDialog,
                        video: primary.videoId
                    })
                ]
            })
        })
    });
};
BlogPostVideo.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            section_title: utils_prop_types/* structuredTextPropTypes */.h,
            section_subtitle: utils_prop_types/* structuredTextPropTypes */.h,
            thumbnail: utils_prop_types/* imagePropTypes */.R,
            cta_button_text: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_BlogPostVideo = ((0,withStyles/* default */.Z)(BlogPostVideo_style)(BlogPostVideo));

;// CONCATENATED MODULE: ./slices/BlogsCategory/style.js
function BlogsCategory_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var BlogsCategory_style_styles = function(theme) {
    var _obj, _obj1, _obj2;
    return {
        featuredBlogs: (_obj2 = {
            backgroundPosition: "center",
            backgroundSize: "150% 100%",
            backgroundRepeat: "no-repeat",
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10),
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"
        }, BlogsCategory_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9),
            backgroundSize: "cover"
        }), BlogsCategory_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), BlogsCategory_style_defineProperty(_obj2, "& .CategoryTagWrapper", (_obj = {
            marginTop: theme.spacing(10),
            marginBottom: theme.spacing(10)
        }, BlogsCategory_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(9),
            marginBottom: theme.spacing(9)
        }), BlogsCategory_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(8),
            marginBottom: theme.spacing(8)
        }), _obj)), BlogsCategory_style_defineProperty(_obj2, "& .featureBlogsContainer", (_obj1 = {
            marginTop: theme.spacing(10),
            marginBottom: theme.spacing(10)
        }, BlogsCategory_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(9),
            marginBottom: theme.spacing(9)
        }), BlogsCategory_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(8),
            marginBottom: theme.spacing(8)
        }), _obj1)), _obj2)
    };
};
/* harmony default export */ var BlogsCategory_style = (BlogsCategory_style_styles);

;// CONCATENATED MODULE: ./slices/BlogsCategory/index.js














var BlogsCategory_section = {
    maxWidth: "600px",
    margin: "4em auto",
    textAlign: "center"
};
var BlogsCategory_h2 = {
    color: "#8592e0"
};
var BlogsCategory_dateOptions = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
};
var AllBlogsInTopic = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    var additionalData = (0,additional_data_context/* useAdditionalData */.eP)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.featuredBlogs,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            maxWidth: "lg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                    title: prismic_reactjs.RichText.asText(primary.title),
                    subtitle: prismic_reactjs.RichText.asText(primary.subtitle),
                    showClass: false
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    spacing: 4,
                    direction: "row",
                    justify: "center",
                    alignItems: "center",
                    className: "CategoryTagWrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            md: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                link: {
                                    type: "learn"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTag/* default */.Z, {
                                    selected: true,
                                    CategoryTagTitle: "View All",
                                    showIcon: false
                                })
                            })
                        }, "random"),
                        additionalData.blog_topics.results.map(function(category, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                md: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                    link: category,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTag/* default */.Z, {
                                        CategoryTagTitle: prismic_reactjs.RichText.asText(category.data.topic_name),
                                        showIcon: false
                                    })
                                })
                            }, index);
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    container: true,
                    spacing: 4,
                    direction: "row",
                    justify: "center",
                    className: "featureBlogsContainer",
                    children: additionalData.blogs_for_category.map(function(blog, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            md: index == 0 || index == 1 ? 6 : 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonItem/* default */.Z, {
                                link: blog,
                                showTag: blog.data.blog_topics && blog.data.blog_topics.length > 0 && blog.data.blog_topics && blog.data.blog_topics.length > 0 && blog.data.blog_topics[0].blog_topic.data && blog.data.blog_topics[0].blog_topic.data.topic_name,
                                tag: blog.data.blog_topics && blog.data.blog_topics.length > 0 && blog.data.blog_topics[0].blog_topic.data && blog.data.blog_topics[0].blog_topic.data.topic_name ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                    link: blog.data.blog_topics[0].blog_topic,
                                    children: prismic_reactjs.RichText.asText(blog.data.blog_topics[0].blog_topic.data.topic_name)
                                }) : null,
                                bannerImageSrc: blog.data.featured_image.url,
                                bannerImageAlt: blog.data.featured_image.alt,
                                name: prismic_reactjs.RichText.asText(blog.data.title),
                                title: (0,prismic_reactjs.Date)(blog.data.date).toLocaleDateString(useRouter().locale, BlogsCategory_dateOptions)
                            })
                        }, index);
                    })
                })
            ]
        })
    });
};
AllBlogsInTopic.propTypes = {
    slice: (0,prop_types.shape)({
        primary: (0,prop_types.shape)({
            title: prop_types.array.isRequired
        }).isRequired
    }).isRequired
};
/* harmony default export */ var BlogsCategory = ((0,withStyles/* default */.Z)(BlogsCategory_style)(AllBlogsInTopic));

;// CONCATENATED MODULE: ./slices/BlogTestimonial/style.js
function BlogTestimonial_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var BlogTestimonial_style_styles = function(theme) {
    var _obj, _obj1, _obj2;
    return {
        blogPostTestimonials: (_obj = {
            marginTop: theme.spacing(5),
            marginBottom: theme.spacing(5)
        }, BlogTestimonial_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(4)
        }), BlogTestimonial_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(3)
        }), _obj),
        workDetailsTestimonials: (_obj2 = {
            backgroundColor: "#ecf1f2",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: 16,
            padding: theme.spacing(5)
        }, BlogTestimonial_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            padding: theme.spacing(4),
            borderRadius: 12
        }), BlogTestimonial_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
            padding: theme.spacing(3),
            borderRadius: 8
        }), // '& .overlay': {
        //   height: '100%',
        //   width: '100%',
        //   display: 'flex',
        //   alignItems: 'center',
        //   flexDirection: 'column',
        //   justifyContent: 'center',
        //   backgroundColor: 'rgba(0,0,0,0.5)',
        //   paddingTop: theme.spacing(10),
        //   paddingBottom: theme.spacing(10),
        //   [theme.breakpoints.down('sm')]: {
        //     paddingTop: theme.spacing(9),
        //     paddingBottom: theme.spacing(9),
        //   },
        //   [theme.breakpoints.down('xs')]: {
        //     paddingTop: theme.spacing(8),
        //     paddingBottom: theme.spacing(8),
        //   },
        // },
        BlogTestimonial_style_defineProperty(_obj2, "& .testimonialText", {
            fontStyle: "italic",
            color: "#4c4c78",
            textAlign: "center",
            lineHeight: 1.75
        }), BlogTestimonial_style_defineProperty(_obj2, "& .author", (_obj1 = {
            color: "#4c4c78",
            textAlign: "center",
            lineHeight: 1.42,
            marginTop: theme.spacing(5)
        }, BlogTestimonial_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(4)
        }), BlogTestimonial_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(3)
        }), _obj1)), _obj2)
    };
};
/* harmony default export */ var BlogTestimonial_style = (BlogTestimonial_style_styles);

;// CONCATENATED MODULE: ./slices/BlogTestimonial/index.js










var BlogPostTestimonials = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    // leave  this for now i am not sure where it being used just in case something goes wrong i can resuse
    // const styles = {};
    // if (primary.backgroundImage) {
    //   styles.backgroundImage = `url(${primary.backgroundImage.url})`;
    //   styles.backgroundSize = "cover";
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "lg",
            className: classes.blogPostTestimonials,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                alignItems: "center",
                justify: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    sm: 10,
                    md: 8,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.workDetailsTestimonials,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h4",
                                className: "testimonialText",
                                children: prismic_reactjs.RichText.asText(primary.testimonialText)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h4",
                                className: "author",
                                children: prismic_reactjs.RichText.asText(primary.author)
                            })
                        ]
                    })
                })
            })
        })
    });
};
BlogPostTestimonials.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({}).isRequired,
        items: prop_types_default().arrayOf(prop_types_default().shape({
            background_image: utils_prop_types/* imagePropTypes */.R,
            testimonial_text: (prop_types_default()).string,
            author: (prop_types_default()).string
        })).isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var BlogTestimonial = ((0,withStyles/* default */.Z)(BlogTestimonial_style)(BlogPostTestimonials));

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
;// CONCATENATED MODULE: ./slices/CallToAction/style.js
function CallToAction_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var CallToAction_style_styles = function(theme) {
    var _obj;
    return {
        callToAction: (_obj = {
            backgroundColor: "#8BC249",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, CallToAction_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            backgroundSize: "200%",
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), CallToAction_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), _obj),
        firstBackground: {
            backgroundImage: "url('/greenCirclePattner.png')",
            backgroundPosition: "bottom",
            backgroundSize: "150%",
            backgroundRepeat: "no-repeat"
        },
        secondBackground: {
            backgroundImage: "url('/patternSimpleText.svg')",
            backgroundPosition: "center",
            backgroundSize: "cover"
        },
        description: {
            color: "#ffffff",
            textAlign: "center",
            lineHeight: 1.42,
            fontSize: 24,
            marginBottom: theme.spacing(5)
        },
        ctaButtonLink: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }
    };
};
/* harmony default export */ var CallToAction_style = (CallToAction_style_styles);

;// CONCATENATED MODULE: ./slices/CallToAction/index.js
function CallToAction_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}













var CallToAction = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)(classes.callToAction, (_obj = {}, CallToAction_defineProperty(_obj, classes.secondBackground, primary.pattern), CallToAction_defineProperty(_obj, classes.firstBackground, !primary.pattern), _obj)),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "lg",
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                direction: "column",
                justify: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    sm: 10,
                    md: 8,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h4",
                            className: classes.description,
                            children: prismic_reactjs.RichText.asText(primary.description)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.ctaButtonLink,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                link: primary.ctaButtonLink,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "outlined",
                                    children: prismic_reactjs.RichText.asText(primary.ctaButtonText)
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
CallToAction.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            description: utils_prop_types/* structuredTextPropTypes */.h,
            ctaButtonText: utils_prop_types/* structuredTextPropTypes */.h,
            ctaButtonLink: prop_types_default().objectOf((prop_types_default()).any),
            pattern: (prop_types_default()).bool
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_CallToAction = ((0,withStyles/* default */.Z)(CallToAction_style)(CallToAction));

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(5154);
;// CONCATENATED MODULE: ./slices/CompletePayment/style.ts
function CompletePayment_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var CompletePayment_style_styles = function(theme) {
    var _obj;
    return (0,createStyles/* default */.Z)({
        shortHero: (_obj = {
            marginTop: theme.spacing(10),
            marginBottom: theme.spacing(10)
        }, CompletePayment_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(9),
            marginBottom: theme.spacing(9)
        }), CompletePayment_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(8),
            marginBottom: theme.spacing(8)
        }), _obj)
    });
};
/* harmony default export */ var CompletePayment_style = (CompletePayment_style_styles);

// EXTERNAL MODULE: ./node_modules/braintree-web/dist/browser/local-payment.js
var local_payment = __webpack_require__(2516);
// EXTERNAL MODULE: ./models/braintree/DonationModels.ts
var DonationModels = __webpack_require__(2028);
// EXTERNAL MODULE: ./services/error-logging-service.ts
var error_logging_service = __webpack_require__(7124);
// EXTERNAL MODULE: ./services/braintree/shared/braintree-config.ts
var braintree_config = __webpack_require__(4770);
// EXTERNAL MODULE: ./node_modules/next/config.js
var next_config = __webpack_require__(1752);
// EXTERNAL MODULE: ./services/regionHelpers.ts + 1 modules
var regionHelpers = __webpack_require__(4477);
;// CONCATENATED MODULE: ./services/braintree/local-pay/bt-local-payment-service.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}







var siteUrl = (0,next_config["default"])().publicRuntimeConfig.siteUrl;
var ProviderMappings = [
    {
        provider: DonationModels/* LocalPaymentProviders.iDeal */.x_.iDeal,
        supportsRecurringPayments: false,
        countryCurrencies: [
            {
                countries: [
                    "NL"
                ],
                currencies: [
                    DonationModels/* CurrencyCode.Euro */.NE.Euro
                ]
            }
        ]
    },
    {
        provider: DonationModels/* LocalPaymentProviders.Klarna */.x_.Klarna,
        supportsRecurringPayments: false,
        countryCurrencies: [
            {
                countries: [
                    " ",
                    "BE",
                    "DE",
                    "IT",
                    "NL",
                    "ES"
                ],
                currencies: [
                    DonationModels/* CurrencyCode.Euro */.NE.Euro
                ]
            },
            {
                countries: [
                    "GB"
                ],
                currencies: [
                    DonationModels/* CurrencyCode.Pound */.NE.Pound
                ]
            }
        ]
    }
];
var LocalPayService = {
    getErrorType: function(paymentProvider) {
        switch(paymentProvider){
            case DonationModels/* LocalPaymentProviders.Klarna */.x_.Klarna:
                {
                    return DonationModels/* PaymentErrorType.Klarna */.zW.Klarna;
                }
            case DonationModels/* LocalPaymentProviders.iDeal */.x_.iDeal:
                {
                    return DonationModels/* PaymentErrorType.iDeal */.zW.iDeal;
                }
            default:
                {
                    throw "Could not get error type for ".concat(paymentProvider);
                }
        }
    },
    supportsLocalPaymentMethod: function(paymentProvider, paymentDetails) {
        var provider = ProviderMappings.find(function(x) {
            return x.provider === paymentProvider;
        });
        if (paymentDetails.isRecurring && !provider.supportsRecurringPayments) {
            return false;
        }
        if (!provider) {
            return false;
        }
        var supports = provider.countryCurrencies.find(function(x) {
            return x.countries.includes(paymentDetails.address.country.code) && x.currencies.includes(paymentDetails.currencyCode);
        });
        return Boolean(supports);
    },
    completePaymentAfterMobileRedirect: function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(transactionLogId, paymentDetails, clientToken) {
            var branch, localPaymentInstance, payload, url, response, paymentResult;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        branch = regionHelpers/* default.findBranchFromCountryCode */.Z.findBranchFromCountryCode(paymentDetails.address.country.code);
                        if (!(!branch || !braintree_config/* default.validateBranch */.Z.validateBranch(branch))) {
                            _ctx.next = 5;
                            break;
                        }
                        error_logging_service/* default.logTrace */.Z.logTrace("invalid branch", {
                            branch: branch
                        });
                        return _ctx.abrupt("return", {
                            success: false,
                            message: "invalid branch"
                        });
                    case 5:
                        if (clientToken) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            success: false,
                            message: "could not tokenize"
                        });
                    case 7:
                        _ctx.next = 9;
                        return local_payment.create({
                            authorization: clientToken
                        });
                    case 9:
                        localPaymentInstance = _ctx.sent;
                        if (!localPaymentInstance.hasTokenizationParams()) {
                            _ctx.next = 30;
                            break;
                        }
                        _ctx.next = 13;
                        return localPaymentInstance.tokenize();
                    case 13:
                        payload = _ctx.sent;
                        if (!payload.nonce) {
                            _ctx.next = 27;
                            break;
                        }
                        url = "/api/donations/checkout/".concat(branch, "/complete-local-payment-after-fallback");
                        _ctx.next = 18;
                        return fetch(url, {
                            method: "POST",
                            body: JSON.stringify({
                                transactionLogId: transactionLogId,
                                branch: branch,
                                nonce: payload.nonce
                            }),
                            headers: {
                                "Content-Type": "application/json"
                            }
                        });
                    case 18:
                        response = _ctx.sent;
                        if (!response.ok) {
                            _ctx.next = 24;
                            break;
                        }
                        _ctx.next = 22;
                        return response.json();
                    case 22:
                        paymentResult = _ctx.sent;
                        return _ctx.abrupt("return", paymentResult);
                    case 24:
                        return _ctx.abrupt("return", {
                            success: false,
                            message: "complete-local-payment-after-fallback failed"
                        });
                    case 27:
                        return _ctx.abrupt("return", {
                            success: false,
                            message: "tokenization failed"
                        });
                    case 28:
                        _ctx.next = 32;
                        break;
                    case 30:
                        console.log("could not tokenize abc");
                        return _ctx.abrupt("return", {
                            success: false,
                            message: "could not tokenize as the parameters are not set"
                        });
                    case 32:
                        _ctx.next = 37;
                        break;
                    case 34:
                        _ctx.prev = 34;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            success: false,
                            message: _ctx.t0.message
                        });
                    case 37:
                        _ctx.prev = 37;
                        return _ctx.finish(37);
                    case 39:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    34,
                    37,
                    39
                ]
            ]);
        }));
        return function(transactionLogId, paymentDetails, clientToken) {
            return _ref.apply(this, arguments);
        };
    }(),
    createPayment: function(transactionLogId, paymentProvider, token, branch, paymentDetails, locale, redirectButtonText) {
        var promise = new Promise(function() {
            var _ref1 = _asyncToGenerator(runtime_default().mark(function _callee1(resolve, reject) {
                var supports, merchantAccountId, localPaymentInstance, fallbackURL, localPaymentResult;
                return runtime_default().wrap(function _callee$(_ctx1) {
                    while(1)switch(_ctx1.prev = _ctx1.next){
                        case 0:
                            _ctx1.prev = 0;
                            supports = LocalPayService.supportsLocalPaymentMethod(paymentProvider, paymentDetails);
                            if (supports) {
                                _ctx1.next = 5;
                                break;
                            }
                            resolve({
                                success: false,
                                provider: paymentProvider,
                                message: "".concat(paymentProvider, " is not a supported payment method")
                            });
                            return _ctx1.abrupt("return");
                        case 5:
                            merchantAccountId = braintree_config/* default.getMerchantAccountId */.Z.getMerchantAccountId(branch, paymentDetails.currencyCode);
                            if (merchantAccountId) {
                                _ctx1.next = 9;
                                break;
                            }
                            resolve({
                                success: false,
                                provider: paymentProvider,
                                message: "".concat(paymentProvider, " could not get merchant account id for ").concat(branch, " and ").concat(paymentDetails.currencyCode)
                            });
                            return _ctx1.abrupt("return");
                        case 9:
                            _ctx1.next = 11;
                            return local_payment.create({
                                authorization: token,
                                merchantAccountId: merchantAccountId
                            });
                        case 11:
                            localPaymentInstance = _ctx1.sent;
                            fallbackURL = "".concat(siteUrl, "/").concat(locale, "/complete-payment/").concat(transactionLogId);
                            _ctx1.next = 15;
                            return localPaymentInstance.startPayment({
                                paymentType: paymentProvider,
                                amount: braintree_config/* default.getTotalAmountString */.Z.getTotalAmountString(paymentDetails.netAmount, paymentDetails.coverTransactionCosts),
                                fallback: {
                                    // this is mobile phone app fallback, to get back to our app. Requires testing with the real apps.
                                    url: fallbackURL,
                                    buttonText: redirectButtonText || "Click here to complete your payment" // todo, add text to layout
                                },
                                currencyCode: paymentDetails.currencyCode,
                                address: {
                                    countryCode: paymentDetails.address.country.code
                                },
                                onPaymentStart: function() {
                                    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(data, start) {
                                        var addLocalPaymentIdToTransactionLogResult;
                                        return runtime_default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    error_logging_service/* default.logTrace */.Z.logTrace("".concat(paymentProvider, " on payment start called"), {
                                                        data: data,
                                                        start: start
                                                    });
                                                    _ctx.next = 3;
                                                    return addLocalPaymentIdToTransactionLog(transactionLogId, data.paymentId, paymentProvider, branch);
                                                case 3:
                                                    addLocalPaymentIdToTransactionLogResult = _ctx.sent;
                                                    if (!addLocalPaymentIdToTransactionLogResult.success) {
                                                        _ctx.next = 8;
                                                        break;
                                                    }
                                                    {
                                                        error_logging_service/* default.logTrace */.Z.logTrace("addLocalPaymentIdToTransactionLogResult result yay", {
                                                            addLocalPaymentIdToTransactionLogResult: addLocalPaymentIdToTransactionLogResult
                                                        });
                                                        start();
                                                    }
                                                    _ctx.next = 11;
                                                    break;
                                                case 8:
                                                    error_logging_service/* default.logTrace */.Z.logTrace("addLocalPaymentIdToTransactionLogResult result nay", {
                                                        addLocalPaymentIdToTransactionLogResult: addLocalPaymentIdToTransactionLogResult
                                                    });
                                                    resolve({
                                                        success: false,
                                                        message: "Error adding payment id to transaction log",
                                                        provider: paymentProvider
                                                    });
                                                    return _ctx.abrupt("return");
                                                case 11:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee);
                                    }));
                                    return function(data, start) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()
                            });
                        case 15:
                            localPaymentResult = _ctx1.sent;
                            if (localPaymentResult.nonce) {
                                resolve({
                                    success: true,
                                    message: "got the nonce",
                                    nonce: localPaymentResult.nonce,
                                    provider: paymentProvider
                                });
                            } else {
                                resolve({
                                    success: false,
                                    message: "Could not get nonce",
                                    provider: paymentProvider
                                });
                            }
                            _ctx1.next = 22;
                            break;
                        case 19:
                            _ctx1.prev = 19;
                            _ctx1.t0 = _ctx1["catch"](0);
                            if (_ctx1.t0.code === "LOCAL_PAYMENT_POPUP_CLOSED" || _ctx1.t0.code === "LOCAL_PAYMENT_WINDOW_CLOSED") {
                                resolve({
                                    success: true,
                                    provider: paymentProvider,
                                    error: _ctx1.t0,
                                    suspectedDropOff: true
                                });
                            } else {
                                resolve({
                                    success: false,
                                    provider: paymentProvider,
                                    error: _ctx1.t0
                                });
                            }
                        case 22:
                            _ctx1.prev = 22;
                            error_logging_service/* default.logTrace */.Z.logTrace("Finished creating local payment");
                            return _ctx1.finish(22);
                        case 25:
                        case "end":
                            return _ctx1.stop();
                    }
                }, _callee1, null, [
                    [
                        0,
                        19,
                        22,
                        25
                    ]
                ]);
            }));
            return function(resolve, reject) {
                return _ref1.apply(this, arguments);
            };
        }());
        return promise;
    }
};
/* harmony default export */ var bt_local_payment_service = (LocalPayService);
var generateObjectId = function() {
    var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
    var suffix = "xxxxxxxxxxxxxxxx".replace(/[x]/g, function() {
        return (Math.random() * 16 | 0).toString(16);
    }).toLowerCase();
    return "".concat(timestamp).concat(suffix);
};
var addLocalPaymentIdToTransactionLog = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(transactionLogId, paymentId, paymentProvider, branch) {
        var url, response, paymentResult;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    url = "/api/donations/checkout/".concat(branch, "/log-local-payment-id");
                    _ctx.next = 4;
                    return fetch(url, {
                        method: "POST",
                        body: JSON.stringify({
                            paymentProvider: paymentProvider,
                            transactionLogId: transactionLogId,
                            paymentId: paymentId
                        }),
                        headers: {
                            "Content-Type": "application/json"
                        }
                    });
                case 4:
                    response = _ctx.sent;
                    if (!response.ok) {
                        _ctx.next = 10;
                        break;
                    }
                    _ctx.next = 8;
                    return response.json();
                case 8:
                    paymentResult = _ctx.sent;
                    return _ctx.abrupt("return", paymentResult);
                case 10:
                    return _ctx.abrupt("return", {
                        success: false,
                        id: null
                    });
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    error_logging_service/* default.logTrace */.Z.logTrace("local payment error", {
                        error: _ctx.t0
                    });
                    error_logging_service/* default.logError */.Z.logError(_ctx.t0);
                    return _ctx.abrupt("return", {
                        success: false,
                        id: null
                    });
                case 18:
                    _ctx.prev = 18;
                    return _ctx.finish(18);
                case 20:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13,
                18,
                20
            ]
        ]);
    }));
    return function addLocalPaymentIdToTransactionLog(transactionLogId, paymentId, paymentProvider, branch) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./slices/DonatePayNow/ThankYouForDonating/style.ts
function ThankYouForDonating_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

// Theme-dependent styles
var ThankYouForDonating_style_styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3, _obj4;
    return (0,createStyles/* default */.Z)({
        thankYouForDonating: {
            color: "#4c4c78",
            textAlign: "center",
            "& .MuiGrid-item": (_obj = {
                padding: theme.spacing(5),
                borderRadius: 6,
                boxShadow: "0 7px 28px 0 rgba(184, 196, 214, 0.5)",
                backgroundColor: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column"
            }, ThankYouForDonating_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
                padding: theme.spacing(4)
            }), ThankYouForDonating_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
                padding: theme.spacing(3)
            }), _obj)
        },
        thankYouTransID: (_obj1 = {
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(4),
            maxWidth: 475
        }, ThankYouForDonating_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(3)
        }), ThankYouForDonating_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2)
        }), _obj1),
        desc: (_obj2 = {
            maxWidth: 475,
            marginTop: theme.spacing(2)
        }, ThankYouForDonating_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(1.5)
        }), ThankYouForDonating_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(1)
        }), _obj2),
        surveyLinkTxt: {
            maxWidth: 350,
            width: "100%"
        },
        homepageLinkTxt: (_obj3 = {
            marginTop: theme.spacing(3),
            fontWeight: 700,
            color: "#4c4c78",
            textDecoration: "underline",
            fontSize: 14,
            cursor: "pointer"
        }, ThankYouForDonating_style_defineProperty(_obj3, theme.breakpoints.down("sm"), {
            marginBottom: theme.spacing(2),
            fontSize: 13
        }), ThankYouForDonating_style_defineProperty(_obj3, theme.breakpoints.down("sm"), {
            marginBottom: theme.spacing(1),
            fontSize: 12
        }), _obj3),
        grayBgBox: (_obj4 = {
            padding: theme.spacing(4),
            borderRadius: 6,
            backgroundColor: "#f3f3f3",
            fontWeight: 700
        }, ThankYouForDonating_style_defineProperty(_obj4, theme.breakpoints.down("sm"), {
            padding: theme.spacing(3)
        }), ThankYouForDonating_style_defineProperty(_obj4, theme.breakpoints.down("sm"), {
            padding: theme.spacing(2)
        }), _obj4)
    });
};
/* harmony default export */ var ThankYouForDonating_style = (ThankYouForDonating_style_styles);

;// CONCATENATED MODULE: ./slices/DonatePayNow/ThankYouForDonating/index.tsx









var ThankYouForDonating = function(param) {
    var classes = param.classes, transactionId = param.transactionId;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "lg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                alignItems: "center",
                justify: "center",
                className: classes.thankYouForDonating,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    sm: 10,
                    md: 8,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h5",
                            children: layout.thank_you_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: classes.desc,
                            children: layout.thank_you_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.thankYouTransID,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h6",
                                    children: layout.thank_you_transaction_id && layout.thank_you_transaction_id.replace("{{transaction_id}}", transactionId)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: (0,clsx_m/* default */.Z)(classes.desc, classes.grayBgBox),
                                    children: layout.thank_you_feedback_text
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                            classes: classes,
                            link: layout.survey_link,
                            className: (0,clsx_m/* default */.Z)(classes.surveyLinkTxt, "adam"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "contained",
                                color: "primary",
                                fullWidth: true,
                                children: layout.survey_link_text
                            })
                        }, "a"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                            link: layout.continue_link,
                            className: classes.homepageLinkTxt,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: layout.homepage_link_text
                            })
                        }, "")
                    ]
                })
            })
        })
    });
};
ThankYouForDonating.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var DonatePayNow_ThankYouForDonating = ((0,withStyles/* default */.Z)(ThankYouForDonating_style)(ThankYouForDonating));

// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Alert/Alert.js + 4 modules
var Alert_Alert = __webpack_require__(8936);
;// CONCATENATED MODULE: ./slices/CompletePayment/index.tsx
function CompletePayment_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function CompletePayment_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                CompletePayment_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                CompletePayment_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}











var CompletePayment = function(param) {
    var slice = param.slice, classes = param.classes;
    var ref = (0,react.useState)(false), errorState = ref[0], setErrorState = ref[1];
    var ref1 = (0,react.useState)(false), successState = ref1[0], setSuccessState = ref1[1];
    var ref2 = (0,react.useState)(false), finishedLoading = ref2[0], setFinishedLoading = ref2[1];
    var ref3 = (0,react.useState)(), transactionId = ref3[0], setTransactionId = ref3[1];
    var ref4 = (0,react.useState)(), transactionResult1 = ref4[0], setTransactionResult = ref4[1];
    var additionalData = (0,additional_data_context/* useAdditionalData */.eP)();
    if (!transactionResult1 && additionalData.transactionResult) {
        setTransactionResult(additionalData.transactionResult);
    }
    var completePaymentAsync = function() {
        var _ref = CompletePayment_asyncToGenerator(runtime_default().mark(function _callee(transactionResult, clientToken) {
            var paymentResult;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        console.log("*** completing payment ***", additionalData);
                        _ctx.next = 3;
                        return bt_local_payment_service.completePaymentAfterMobileRedirect(transactionResult.transactionLogId, transactionResult.paymentDetails, clientToken);
                    case 3:
                        paymentResult = _ctx.sent;
                        setFinishedLoading(true);
                        setErrorState(!paymentResult.success);
                        setSuccessState(paymentResult.success);
                        setTransactionId(paymentResult.transactionId);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function completePaymentAsync(transactionResult, clientToken) {
            return _ref.apply(this, arguments);
        };
    }();
    var setPaymentAlreadyProcessed = function(transactionResult) {
        console.log("*** setting payment already processed", additionalData);
        setFinishedLoading(true);
        setErrorState(false);
        setSuccessState(true);
        setTransactionId(transactionResult.transactionId);
    };
    (0,react.useEffect)(function() {
        if (transactionResult1) {
            if (transactionResult1.alreadyProcessed) {
                setPaymentAlreadyProcessed(transactionResult1);
            } else {
                completePaymentAsync(transactionResult1, additionalData.clientToken);
            }
        }
    }, [
        transactionResult1
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "md",
        className: classes.shortHero,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    !finishedLoading && slice.primary.loadingMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                        severity: "info",
                        children: slice.primary.loadingMessage
                    }),
                    finishedLoading && errorState && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                        severity: "info",
                        children: slice.primary.errorMessage
                    }),
                    finishedLoading && successState && transactionId && /*#__PURE__*/ (0,jsx_runtime.jsx)(DonatePayNow_ThankYouForDonating, {
                        transactionId: transactionId
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var slices_CompletePayment = ((0,withStyles/* default */.Z)(CompletePayment_style)(CompletePayment));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Snackbar/Snackbar.js + 2 modules
var Snackbar = __webpack_require__(3950);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(553);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(5625);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js + 2 modules
var TextField = __webpack_require__(6131);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CheckRounded.js
var CheckRounded = __webpack_require__(5569);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/WarningOutlined.js
var WarningOutlined = __webpack_require__(1427);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ErrorRounded.js
var ErrorRounded = __webpack_require__(7447);
;// CONCATENATED MODULE: ./components/ContactOurBranches/style.js
function ContactOurBranches_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var ContactOurBranches_style_styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3, _obj4;
    return {
        contactBranchMainWrapper: {
            backgroundColor: "#fff",
            backgroundImage: "-webkit-linear-gradient(-84deg, #fff 18%, #f4f5f6 18%)"
        },
        contactOurBranch: (_obj = {
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, ContactOurBranches_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), ContactOurBranches_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), _obj),
        branchWrapper: (_obj4 = {
            paddingBottom: theme.spacing(10),
            zIndex: 9
        }, ContactOurBranches_style_defineProperty(_obj4, theme.breakpoints.down("sm"), {
            paddingBottom: theme.spacing(9)
        }), ContactOurBranches_style_defineProperty(_obj4, theme.breakpoints.down("xs"), {
            paddingBottom: theme.spacing(8)
        }), ContactOurBranches_style_defineProperty(_obj4, "& .branchCard", (_obj3 = {
            height: "100%",
            borderRadius: 6,
            boxShadow: "0 23px 42px 0 rgba(106, 118, 154, 0.15)",
            backgroundColor: "#ffffff",
            display: "flex",
            flexDirection: "column"
        }, ContactOurBranches_style_defineProperty(_obj3, theme.breakpoints.down("sm"), {
            height: "auto"
        }), ContactOurBranches_style_defineProperty(_obj3, "& .bannerImg", {
            height: 350,
            width: "100%",
            objectFit: "cover"
        }), ContactOurBranches_style_defineProperty(_obj3, "& .branchCardData", (_obj2 = {
            padding: theme.spacing(3.5, 3.5, 1),
            flex: 1,
            display: "flex",
            flexDirection: "column"
        }, ContactOurBranches_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            padding: theme.spacing(2, 2, 0.5)
        }), ContactOurBranches_style_defineProperty(_obj2, "& .country", (_obj1 = {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginBottom: theme.spacing(4)
        }, ContactOurBranches_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            marginBottom: theme.spacing(3)
        }), ContactOurBranches_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            marginBottom: theme.spacing(2)
        }), ContactOurBranches_style_defineProperty(_obj1, "& img", {
            height: 33
        }), ContactOurBranches_style_defineProperty(_obj1, "& .countryName", {
            color: "#4c4c78",
            fontWeight: 700,
            marginLeft: theme.spacing(2)
        }), _obj1)), ContactOurBranches_style_defineProperty(_obj2, "& .infoTitle", {
            color: "#4c4c78",
            margin: theme.spacing(0, 0)
        }), ContactOurBranches_style_defineProperty(_obj2, "& .infoData", {
            color: "#4c4c78",
            fontWeight: 500,
            margin: theme.spacing(0),
            fontFamily: "Raleway,Assistant,sans-serif",
            "& a": {
                color: "#4c4c78",
                borderBottom: "1.5px solid #4c4c78",
                textDecoration: "none"
            }
        }), _obj2)), _obj3)), _obj4)
    };
};
/* harmony default export */ var ContactOurBranches_style = (ContactOurBranches_style_styles);

;// CONCATENATED MODULE: ./components/ContactOurBranches/index.js












var ContactOurBranch = function(param) {
    var classes = param.classes, primary = param.primary, items = param.items, slice = param.slice;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.contactBranchMainWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    container: true,
                    className: classes.contactOurBranch,
                    justify: "center",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        sm: 12,
                        md: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                            title: prismic_reactjs.RichText.asText(primary.ourBranchesTitle),
                            subtitle: prismic_reactjs.RichText.asText(primary.ourBranchesSubtitle)
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    container: true,
                    spacing: 4,
                    className: classes.branchWrapper,
                    children: items.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            sm: 12,
                            md: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "branchCard",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: item.bannerImage.url,
                                        alt: "",
                                        className: "bannerImg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "branchCardData",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "country",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: item.flagImage.url,
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "h5",
                                                        className: "countryName",
                                                        children: prismic_reactjs.RichText.asText(item.locationName).toUpperCase()
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "h6",
                                                className: "infoTitle",
                                                children: primary.contactTitle
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "subtitle3",
                                                className: "infoData",
                                                children: prismic_reactjs.RichText.render(item.contactDetails)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "h6",
                                                className: "infoTitle",
                                                children: primary.addressTitle
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "subtitle3",
                                                className: "infoData",
                                                children: prismic_reactjs.RichText.render(item.addressDetails)
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, index);
                    })
                })
            ]
        })
    });
};
ContactOurBranch.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h,
            subtitle: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: prop_types_default().arrayOf(prop_types_default().shape({
            flag: utils_prop_types/* imagePropTypes */.R,
            location_name: (prop_types_default()).string,
            contact_info: (prop_types_default()).string
        })).isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var ContactOurBranches = ((0,withStyles/* default */.Z)(ContactOurBranches_style)(ContactOurBranch));

;// CONCATENATED MODULE: ./utils/country-email-mapper.ts

var emails = (0,next_config["default"])().publicRuntimeConfig.emails;
var countryEmailConfig = [
    {
        code: "US",
        includedCountryCodes: [
            "US"
        ],
        contactEmail: emails.US
    },
    {
        code: "UK",
        includedCountryCodes: [
            "GB",
            "GI",
            "JE",
            "NO",
            "ZA"
        ],
        contactEmail: emails.UK
    },
    {
        code: "NL",
        includedCountryCodes: [
            "NL",
            "BE"
        ],
        contactEmail: emails.NL
    },
    {
        code: "DE",
        includedCountryCodes: [
            "DE",
            "AD",
            "AT",
            "CY",
            "EE",
            "FI",
            "FR",
            "GR",
            "IE",
            "IT",
            "LV",
            "LT",
            "LU",
            "MT",
            "MC",
            "ME",
            "PL",
            "PT",
            "BL",
            "PM",
            "SM",
            "SK",
            "SI",
            "ES",
            "CH"
        ],
        contactEmail: emails.DE
    },
    {
        code: "IL",
        includedCountryCodes: [
            "IL"
        ],
        contactEmail: emails.IL
    }, 
];
var getCountryEmailConfig = function(twoLetterIsoCountryCode) {
    var country = countryEmailConfig.find(function(countryConfig) {
        if (twoLetterIsoCountryCode === countryConfig.code || countryConfig.includedCountryCodes.includes(twoLetterIsoCountryCode)) {
            return true;
        }
    });
    return country !== null && country !== void 0 ? country : countryEmailConfig.find(function(config) {
        return config.code === "US";
    });
};
/* harmony default export */ var country_email_mapper = (getCountryEmailConfig);

;// CONCATENATED MODULE: ./slices/ContactForm/style.js
function ContactForm_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var ContactForm_style_styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3, _obj4;
    return (0,createStyles/* default */.Z)({
        contactForm: {
            "& .FormCard": (_obj = {
                padding: theme.spacing(6),
                borderRadius: 6,
                boxShadow: "0 23px 42px 0 rgba(106, 118, 154, 0.15)",
                backgroundColor: "#ffffff",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                width: "100%"
            }, ContactForm_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
                padding: theme.spacing(4)
            }), ContactForm_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
                padding: theme.spacing(2)
            }), ContactForm_style_defineProperty(_obj, "& .formTitle", {
                color: "#4c4c78",
                textAlign: "center",
                marginBottom: theme.spacing(5)
            }), ContactForm_style_defineProperty(_obj, "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline", {
                borderColor: "#8bc249"
            }), ContactForm_style_defineProperty(_obj, "& fieldset", {
                border: "2px solid #f3f3f3",
                "&:hover": {
                    border: "2px solid #8bc249"
                }
            }), ContactForm_style_defineProperty(_obj, "& .MuiInputBase-root", {
                backgroundColor: "#f3f3f3"
            }), ContactForm_style_defineProperty(_obj, "& .formtnc p", {
                margin: 0,
                fontSize: 14,
                fontWeight: 500,
                color: "#4c4c78",
                lineHeight: 1.71,
                textAlign: "center",
                fontFamily: "Raleway,Assistant,sans-serif",
                "& a": {
                    color: "#4c4c78",
                    borderBottom: "1.5px solid #4c4c78",
                    textDecoration: "none"
                }
            }), ContactForm_style_defineProperty(_obj, "& .sendBtn", ContactForm_style_defineProperty({
                maxWidth: 350,
                margin: "0 auto",
                display: "block"
            }, theme.breakpoints.down("500"), {
                width: "100%"
            })), _obj),
            "& .branchCard": (_obj3 = {
                height: "100%",
                borderRadius: 6,
                boxShadow: "0 23px 42px 0 rgba(106, 118, 154, 0.15)",
                backgroundColor: "#ffffff",
                display: "flex",
                flexDirection: "column"
            }, ContactForm_style_defineProperty(_obj3, theme.breakpoints.down("sm"), {
                height: "auto"
            }), ContactForm_style_defineProperty(_obj3, "& .bannerImg", {
                height: 350,
                width: "100%",
                objectFit: "cover"
            }), ContactForm_style_defineProperty(_obj3, "& .branchCardData", (_obj2 = {
                padding: theme.spacing(3.5, 3.5, 1),
                flex: 1,
                display: "flex",
                flexDirection: "column"
            }, ContactForm_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
                padding: theme.spacing(2, 2, 0.5)
            }), ContactForm_style_defineProperty(_obj2, "& .country", (_obj1 = {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginBottom: theme.spacing(4)
            }, ContactForm_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
                marginBottom: theme.spacing(3)
            }), ContactForm_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
                marginBottom: theme.spacing(2)
            }), ContactForm_style_defineProperty(_obj1, "& img", {
                height: 33
            }), ContactForm_style_defineProperty(_obj1, "& .countryName", {
                color: "#4c4c78",
                fontWeight: 700,
                marginLeft: theme.spacing(2)
            }), _obj1)), ContactForm_style_defineProperty(_obj2, "& .infoTitle", {
                color: "#4c4c78",
                margin: theme.spacing(0, 0)
            }), ContactForm_style_defineProperty(_obj2, "& .infoData", {
                color: "#4c4c78",
                fontWeight: 500,
                margin: theme.spacing(0),
                fontFamily: "Raleway,Assistant,sans-serif",
                "& a": {
                    color: "#4c4c78",
                    borderBottom: "1.5px solid #4c4c78",
                    textDecoration: "none"
                }
            }), _obj2)), _obj3)
        },
        codeWrapper: {
            display: "flex",
            "& span": {
                marginRight: 4
            }
        },
        contactBranch: (_obj4 = {
            background: "#f4f5f6"
        }, ContactForm_style_defineProperty(_obj4, "background", "-webkit-linear-gradient(176deg, white 0%, white, 36%, #f4f5f6 15%, #f4f5f6 100%)"), ContactForm_style_defineProperty(_obj4, "background", "-o-linear-gradient(176deg, white 0%, white, 36%, #f4f5f6 15%, #f4f5f6 100%)"), ContactForm_style_defineProperty(_obj4, "background", "-moz-linear-gradient(176deg, white 0%, white, 36%, #f4f5f6 15%, #f4f5f6 100%)"), ContactForm_style_defineProperty(_obj4, "background", "linear-gradient(176deg, white 0%, white, 36%, #f4f5f6 15%, #f4f5f6 100%)"), _obj4),
        donateMailList: {
            flexDirection: theme.direction === "ltr" ? "row" : "row",
            marginRight: theme.direction === "ltr" ? "" : "0px",
            marginLeft: theme.direction === "ltr" ? "0px" : "",
            width: "100%",
            alignItems: "flex-start",
            "& .MuiCheckbox-root": {
                marginTop: "-6px"
            }
        },
        mailingListSignupFailure: {
            color: "red"
        },
        autocompletePaper: {
            "& .MuiAutocomplete-option": {
                direction: theme.direction === "ltr" ? "ltr" : "rtl"
            }
        }
    });
};
/* harmony default export */ var ContactForm_style = (ContactForm_style_styles);

// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Autocomplete/Autocomplete.js + 7 modules
var Autocomplete = __webpack_require__(6272);
// EXTERNAL MODULE: ./utils/countries.ts
var countries = __webpack_require__(894);
// EXTERNAL MODULE: ./node_modules/match-sorter/dist/match-sorter.esm.js + 1 modules
var match_sorter_esm = __webpack_require__(3141);
;// CONCATENATED MODULE: ./utils/autocomplete-filters.ts

var filters = {
    dialingCodes: function(options, param) {
        var inputValue = param.inputValue;
        return (0,match_sorter_esm/* matchSorter */.Lu)(options, inputValue, {
            keys: [
                "label",
                "dialingCode"
            ]
        });
    },
    countryFilter: function(options, param) {
        var inputValue = param.inputValue;
        return (0,match_sorter_esm/* matchSorter */.Lu)(options, inputValue, {
            keys: [
                "label"
            ]
        });
    }
};
/* harmony default export */ var autocomplete_filters = (filters);

// EXTERNAL MODULE: ./utils/constants/vfi-constants.ts
var vfi_constants = __webpack_require__(1274);
// EXTERNAL MODULE: ./store/vfi-easy-peasy-store.ts
var vfi_easy_peasy_store = __webpack_require__(2601);
;// CONCATENATED MODULE: ./slices/ContactForm/index.tsx
function ContactForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ContactForm_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ContactForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ContactForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ContactForm_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ContactForm_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




























var ContactForm = function(param) {
    var classes = param.classes, slice = param.slice;
    var Alert = function Alert(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, _objectSpread({
            elevation: 6,
            variant: "filled"
        }, props));
    };
    var ref22, ref1, ref2, ref3;
    var state1 = (0,vfi_easy_peasy_store/* useVFIStoreState */.As)(function(state) {
        return state;
    });
    var primary = slice.primary, items = slice.items;
    var locale = (0,next_router.useRouter)().locale;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    var ref4 = (0,react.useState)([]), ourBranchesItems = ref4[0], setOurBranchesItems = ref4[1];
    var ref5 = (0,react.useState)(), localBranchesItem = ref5[0], setLocalBranchesItem = ref5[1];
    var ref6 = (0,react.useState)(layout.contact_auto_select_mailing_list_signup), signUpForEmail = ref6[0], setSignUpForEmail = ref6[1];
    var ref7 = (0,react.useState)(""), message = ref7[0], setMessage = ref7[1];
    var ref8 = (0,react.useState)(""), fullName = ref8[0], setFullName = ref8[1];
    var ref9 = (0,react.useState)(""), phoneNumber = ref9[0], setPhoneNumber = ref9[1];
    var ref10 = (0,react.useState)(state1 === null || state1 === void 0 ? void 0 : (ref22 = state1.country) === null || ref22 === void 0 ? void 0 : ref22.code), countryTwoLetterIsoCode = ref10[0], setCountryTwoLetterIsoCode = ref10[1];
    var ref11 = (0,react.useState)(state1 === null || state1 === void 0 ? void 0 : (ref1 = state1.country) === null || ref1 === void 0 ? void 0 : ref1.dialingCode), countryPhoneDialingCode = ref11[0], setCountryPhoneDialingCode = ref11[1];
    var ref12 = (0,react.useState)(state1 === null || state1 === void 0 ? void 0 : (ref2 = state1.country) === null || ref2 === void 0 ? void 0 : ref2.code), dialingCodeCountry = ref12[0], setDialingCodeCountry = ref12[1];
    var ref13 = (0,react.useState)(state1 === null || state1 === void 0 ? void 0 : (ref3 = state1.country) === null || ref3 === void 0 ? void 0 : ref3.label), countryName = ref13[0], setCountryName = ref13[1];
    var ref14 = (0,react.useState)(""), email = ref14[0], setEmail = ref14[1];
    var ref15 = (0,react.useState)(false), showSignupFailMessage = ref15[0], setShowSignupFailMessage = ref15[1];
    var ref16 = (0,react.useState)(false), emailValid = ref16[0], setEmailValid = ref16[1];
    var ref17 = (0,react.useState)(false), emailTouched = ref17[0], setEmailTouched = ref17[1];
    var ref18 = (0,react.useState)(false), error = ref18[0], setError = ref18[1];
    var ref19 = (0,react.useState)(false), success = ref19[0], setSuccess = ref19[1];
    var ref20 = (0,react.useState)(false), snackbarOpen = ref20[0], setSnackbarOpen = ref20[1];
    var ref21 = (0,react.useState)(false), verifying = ref21[0], setVerifying = ref21[1];
    var setBranches = function() {
        var ref;
        if ((state1 === null || state1 === void 0 ? void 0 : (ref = state1.country) === null || ref === void 0 ? void 0 : ref.code) && items) {
            var localBranch = items.find(function(branch) {
                return branch.countryCode === state1.country.code;
            }) || items[0]; // instead of items[0] should we be calculating the correct branch as we do for donations???
            var otherBranches = items.filter(function(branch) {
                if (localBranch.countryCode !== "US") {
                    return branch.countryCode !== state1.country.code;
                } else {
                    return branch.countryCode !== state1.country.code && branch.countryCode !== "US";
                }
            });
            setLocalBranchesItem(localBranch);
            setOurBranchesItems(otherBranches);
            setCountryTwoLetterIsoCode(state1.country.code);
            setCountryPhoneDialingCode(state1.country.dialingCode);
            setCountryName(state1.country.label);
        } else {
            console.log("could not set branches");
        }
    };
    (0,react.useEffect)(setBranches, [
        state1.country,
        items
    ]);
    var submitForm = function() {
        var _ref1 = ContactForm_asyncToGenerator(runtime_default().mark(function _callee1(e) {
            var country, ref;
            return runtime_default().wrap(function _callee$(_ctx1) {
                while(1)switch(_ctx1.prev = _ctx1.next){
                    case 0:
                        setShowSignupFailMessage(false);
                        e.preventDefault();
                        country = country_email_mapper(countryTwoLetterIsoCode);
                        setVerifying(true);
                        if (emailValid) {
                            ;
                            fetch("/api/contact/submit-contact-form", {
                                method: "POST",
                                body: JSON.stringify({
                                    sendEmail: (ref = country === null || country === void 0 ? void 0 : country.contactEmail) !== null && ref !== void 0 ? ref : "info@visionforisrael.com",
                                    country: countryName,
                                    f_name: fullName,
                                    phone_number: "+" + countryPhoneDialingCode + phoneNumber,
                                    email: email,
                                    message: message,
                                    signUpForEmail: signUpForEmail,
                                    twoLetterLanguageCode: locale
                                }),
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            }).then(function() {
                                var _ref = ContactForm_asyncToGenerator(runtime_default().mark(function _callee(response) {
                                    var result;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                if (!response.ok) {
                                                    _ctx.next = 19;
                                                    break;
                                                }
                                                setVerifying(false);
                                                setSuccess(true);
                                                setError(false);
                                                setMessage("");
                                                setCountryPhoneDialingCode("");
                                                setFullName("");
                                                setPhoneNumber("");
                                                setEmail("");
                                                if (!signUpForEmail) {
                                                    _ctx.next = 16;
                                                    break;
                                                }
                                                _ctx.next = 12;
                                                return response.json();
                                            case 12:
                                                result = _ctx.sent;
                                                if (!result.signupSuccess) {
                                                    setShowSignupFailMessage(true);
                                                } else {
                                                    setShowSignupFailMessage(false);
                                                }
                                                _ctx.next = 17;
                                                break;
                                            case 16:
                                                {
                                                    setShowSignupFailMessage(false);
                                                }
                                            case 17:
                                                _ctx.next = 20;
                                                break;
                                            case 19:
                                                {
                                                    setError(true);
                                                    setSuccess(false);
                                                    setSnackbarOpen(true);
                                                    setShowSignupFailMessage(false);
                                                }
                                            case 20:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(response) {
                                    return _ref.apply(this, arguments);
                                };
                            }()).catch(function(err) {
                                setShowSignupFailMessage(false);
                                setVerifying(false);
                                setSuccess(false);
                                setError(true);
                            });
                        } else {
                            setSnackbarOpen(true);
                            setSuccess(false);
                            setError(false);
                        }
                    case 5:
                    case "end":
                        return _ctx1.stop();
                }
            }, _callee1);
        }));
        return function submitForm(e) {
            return _ref1.apply(this, arguments);
        };
    }();
    var handleClose = function(event, reason) {
        if (reason === "clickaway") {
            return;
        }
        setSuccess(false);
        setSnackbarOpen(false);
        setError(false);
    };
    var emailValidation = function(e) {
        setEmailValid(vfi_constants/* default.emailRegex.test */.Z.emailRegex.test(e.target.value));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: classes.contactForm,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            sm: 12,
                            md: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "FormCard",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h6",
                                        className: "formTitle",
                                        children: prismic_reactjs.RichText.asText(layout.contact_form_title)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                        onSubmit: function(e) {
                                            return submitForm(e);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                            container: true,
                                            spacing: 2,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                    item: true,
                                                    xs: 12,
                                                    children: countryTwoLetterIsoCode && /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.ZP, {
                                                        id: "country-select-demo",
                                                        style: {
                                                            width: "100%"
                                                        },
                                                        options: countries/* default */.Z,
                                                        classes: {
                                                            option: classes.option,
                                                            paper: classes.autocompletePaper
                                                        },
                                                        defaultValue: countries/* default.find */.Z.find(function(ccountry) {
                                                            return ccountry.code == countryTwoLetterIsoCode;
                                                        }),
                                                        value: countries/* default.find */.Z.find(function(ccountry) {
                                                            return ccountry.code == countryTwoLetterIsoCode;
                                                        }),
                                                        autoHighlight: true,
                                                        getOptionLabel: function(option) {
                                                            return option.label;
                                                        },
                                                        onChange: function(e, v) {
                                                            setCountryTwoLetterIsoCode(v != null ? v.code : state1.country.code);
                                                            setDialingCodeCountry(v != null ? v.code : state1.country.code);
                                                            setCountryPhoneDialingCode(v != null ? v.dialingCode : state1.country.dialingCode);
                                                            setCountryName(v != null ? v.label : state1.country.label);
                                                        },
                                                        renderOption: function(option) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: classes.codeWrapper,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        children: [
                                                                            regionHelpers/* default.countryToFlag */.Z.countryToFlag(option.code),
                                                                            " "
                                                                        ]
                                                                    }),
                                                                    option.label,
                                                                    " (",
                                                                    option.code,
                                                                    ") +",
                                                                    option.dialingCode
                                                                ]
                                                            });
                                                        },
                                                        renderInput: function(params) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, _objectSpread({}, params, {
                                                                placeholder: prismic_reactjs.RichText.asText(layout.your_country_placeholder_contact),
                                                                variant: "outlined",
                                                                fullWidth: true,
                                                                margin: "dense",
                                                                className: classes.custInput,
                                                                inputProps: _objectSpread({}, params.inputProps, {
                                                                    autoComplete: "new-password"
                                                                })
                                                            }));
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                        placeholder: prismic_reactjs.RichText.asText(layout.first_name_placeholder_contact),
                                                        variant: "outlined",
                                                        fullWidth: true,
                                                        required: true,
                                                        margin: "dense",
                                                        value: fullName,
                                                        autoComplete: "name",
                                                        className: classes.custInput,
                                                        onChange: function(e) {
                                                            return setFullName(e.target.value);
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                        autoComplete: "email",
                                                        placeholder: prismic_reactjs.RichText.asText(layout.email_placeholder_contact),
                                                        variant: "outlined",
                                                        fullWidth: true,
                                                        required: true,
                                                        margin: "dense",
                                                        className: classes.custInput,
                                                        value: email,
                                                        onChange: function(e) {
                                                            setEmail(e.target.value);
                                                            emailValidation(e);
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                    item: true,
                                                    xs: 12,
                                                    sm: 6,
                                                    md: 5,
                                                    children: countryTwoLetterIsoCode && /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.ZP, {
                                                        id: "country-select-demo",
                                                        style: {
                                                            width: "100%"
                                                        },
                                                        options: countries/* default */.Z,
                                                        classes: {
                                                            option: classes.option,
                                                            paper: classes.autocompletePaper
                                                        },
                                                        defaultValue: countries/* default.find */.Z.find(function(country) {
                                                            return country.code == dialingCodeCountry;
                                                        }),
                                                        value: countries/* default.find */.Z.find(function(country) {
                                                            return country.code == dialingCodeCountry;
                                                        }),
                                                        autoHighlight: true,
                                                        getOptionLabel: function(option) {
                                                            return "+" + option.dialingCode;
                                                        },
                                                        filterOptions: autocomplete_filters.dialingCodes,
                                                        onChange: function(e, chosenCode) {
                                                            setDialingCodeCountry(chosenCode != null ? chosenCode.code : null);
                                                            setCountryPhoneDialingCode(chosenCode != null ? chosenCode.dialingCode : null);
                                                        },
                                                        renderOption: function(option) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: classes.codeWrapper,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: regionHelpers/* default.countryToFlag */.Z.countryToFlag(option.code)
                                                                    }),
                                                                    "(",
                                                                    option.code,
                                                                    ") +",
                                                                    option.dialingCode
                                                                ]
                                                            });
                                                        },
                                                        renderInput: function(params) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, _objectSpread({}, params, {
                                                                fullWidth: true,
                                                                className: classes.custInput,
                                                                placeholder: prismic_reactjs.RichText.asText(layout.code_placeholder_contact),
                                                                variant: "outlined",
                                                                margin: "dense",
                                                                inputProps: _objectSpread({}, params.inputProps, {
                                                                    autoComplete: "new-password"
                                                                })
                                                            }));
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                    item: true,
                                                    xs: 12,
                                                    sm: 6,
                                                    md: 7,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                        autoComplete: "tel-local",
                                                        placeholder: prismic_reactjs.RichText.asText(layout.phone_number_placeholder_contact),
                                                        variant: "outlined",
                                                        fullWidth: true,
                                                        margin: "dense",
                                                        value: phoneNumber,
                                                        className: classes.custInput,
                                                        onChange: function(e) {
                                                            return setPhoneNumber(e.target.value);
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                        placeholder: prismic_reactjs.RichText.asText(layout.message_placeholder),
                                                        variant: "outlined",
                                                        className: classes.custTxtArea,
                                                        fullWidth: true,
                                                        multiline: true,
                                                        margin: "dense",
                                                        value: message,
                                                        rows: 12,
                                                        onChange: function(e) {
                                                            return setMessage(e.target.value);
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                                        checked: signUpForEmail,
                                                        value: "start",
                                                        className: classes.donateMailList,
                                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                            color: "primary",
                                                            onChange: function(e) {
                                                                setSignUpForEmail(e.target.checked);
                                                            }
                                                        }),
                                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: layout.contact_mailing_list_signup_text
                                                        }),
                                                        labelPlacement: "start"
                                                    })
                                                }),
                                                showSignupFailMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mailingListSignupFailure",
                                                        children: layout.contact_mailing_list_signup_failure
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        variant: "contained",
                                                        color: "primary",
                                                        type: "submit",
                                                        fullWidth: true,
                                                        className: "sendBtn",
                                                        children: prismic_reactjs.RichText.asText(layout.send_button_text)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "formtnc",
                                                        children: prismic_reactjs.RichText.render(layout.privacy_text_contact)
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        localBranchesItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            sm: 12,
                            md: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "branchCard",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: localBranchesItem.bannerImage.url,
                                        alt: "",
                                        className: "bannerImg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "branchCardData",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "country",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: localBranchesItem.flagImage.url,
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "h5",
                                                        className: "countryName",
                                                        children: prismic_reactjs.RichText.asText(localBranchesItem.locationName).toUpperCase()
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "h6",
                                                className: "infoTitle",
                                                children: primary.contactTitle
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "infoData",
                                                children: prismic_reactjs.RichText.render(localBranchesItem.contactDetails)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "h6",
                                                className: "infoTitle",
                                                children: primary.addressTitle
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "infoData",
                                                children: prismic_reactjs.RichText.render(localBranchesItem.addressDetails)
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
                            open: success,
                            autoHideDuration: 6000,
                            onClose: handleClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckRounded/* default */.Z, {
                                    fontSize: "inherit"
                                }),
                                onClose: handleClose,
                                severity: "success",
                                children: prismic_reactjs.RichText.asText(layout.contact_success_message)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
                            open: snackbarOpen && !success && !error,
                            autoHideDuration: 6000,
                            onClose: handleClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningOutlined/* default */.Z, {
                                    fontSize: "inherit"
                                }),
                                onClose: handleClose,
                                severity: "warning",
                                children: prismic_reactjs.RichText.asText(layout.contact_email_error_message)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
                            open: error && snackbarOpen && !success,
                            autoHideDuration: 6000,
                            onClose: handleClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorRounded/* default */.Z, {
                                    fontSize: "inherit"
                                }),
                                onClose: handleClose,
                                severity: "error",
                                children: prismic_reactjs.RichText.asText(layout.contact_error_message)
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactOurBranches, {
                items: ourBranchesItems,
                primary: primary
            })
        ]
    });
};
ContactForm.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h,
            placeholderName: (prop_types_default()).string
        }).isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_ContactForm = ((0,withStyles/* default */.Z)(ContactForm_style)(ContactForm));

;// CONCATENATED MODULE: ./slices/ContactOurBranches/style.js
function slices_ContactOurBranches_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var slices_ContactOurBranches_style_styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3;
    return {
        contactOurBranch: (_obj3 = {
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, slices_ContactOurBranches_style_defineProperty(_obj3, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), slices_ContactOurBranches_style_defineProperty(_obj3, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), slices_ContactOurBranches_style_defineProperty(_obj3, "& .branchWrapper", (_obj = {
            marginTop: theme.spacing(10)
        }, slices_ContactOurBranches_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(9)
        }), slices_ContactOurBranches_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(8)
        }), _obj)), slices_ContactOurBranches_style_defineProperty(_obj3, "& .branchCard", (_obj2 = {
            height: 724,
            borderRadius: 6,
            boxShadow: "0 23px 42px 0 rgba(106, 118, 154, 0.15)",
            backgroundColor: "#ffffff",
            display: "flex",
            flexDirection: "column"
        }, slices_ContactOurBranches_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            height: "auto"
        }), slices_ContactOurBranches_style_defineProperty(_obj2, "& .bannerImg", {
            height: 350,
            width: "100%",
            objectFit: "cover"
        }), slices_ContactOurBranches_style_defineProperty(_obj2, "& .branchCardData", (_obj1 = {
            padding: theme.spacing(3.5, 3.5),
            flex: 1,
            display: "flex",
            flexDirection: "column"
        }, slices_ContactOurBranches_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            padding: theme.spacing(2)
        }), slices_ContactOurBranches_style_defineProperty(_obj1, "& .country", {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            "& img": {
                height: 33
            },
            "& .countryName": {
                color: "#4c4c78",
                fontWeight: 700,
                marginLeft: theme.spacing(2)
            }
        }), slices_ContactOurBranches_style_defineProperty(_obj1, "& .infoTitle", {
            color: "#4c4c78",
            margin: theme.spacing(2, 0)
        }), slices_ContactOurBranches_style_defineProperty(_obj1, "& .infoData", {
            color: "#4c4c78",
            fontWeight: 500,
            margin: theme.spacing(0.5, 0),
            fontFamily: "Raleway,Assistant,sans-serif"
        }), _obj1)), _obj2)), _obj3)
    };
};
/* harmony default export */ var slices_ContactOurBranches_style = (slices_ContactOurBranches_style_styles);

;// CONCATENATED MODULE: ./slices/ContactOurBranches/index.js











var ContactOurBranches_ContactOurBranch = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary, items = slice.items;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        className: classes.contactOurBranch,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                title: prismic_reactjs.RichText.asText(primary.title),
                subtitle: prismic_reactjs.RichText.asText(primary.subTitle)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                spacing: 4,
                className: "branchWrapper",
                children: items.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        sm: 12,
                        md: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "branchCard",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: item.bannerImage.url,
                                    alt: "",
                                    className: "bannerImg"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "branchCardData",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "country",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: item.flagImage.url,
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "h4",
                                                    className: "countryName",
                                                    children: prismic_reactjs.RichText.asText(item.locationName)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            className: "infoTitle",
                                            children: prismic_reactjs.RichText.asText(primary.contactTitle)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "subtitle3",
                                            className: "infoData",
                                            children: prismic_reactjs.RichText.asText(item.contactDetails)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            className: "infoTitle",
                                            children: prismic_reactjs.RichText.asText(primary.addressTitle)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "subtitle3",
                                            className: "infoData",
                                            children: prismic_reactjs.RichText.asText(item.addressDetails)
                                        })
                                    ]
                                })
                            ]
                        })
                    }, index);
                })
            })
        ]
    });
};
ContactOurBranches_ContactOurBranch.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h,
            subtitle: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: prop_types_default().arrayOf(prop_types_default().shape({
            flag: utils_prop_types/* imagePropTypes */.R,
            location_name: (prop_types_default()).string,
            contact_info: (prop_types_default()).string
        })).isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_ContactOurBranches = ((0,withStyles/* default */.Z)(slices_ContactOurBranches_style)(ContactOurBranches_ContactOurBranch));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Select/Select.js + 7 modules
var Select = __webpack_require__(4951);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonGroup/ButtonGroup.js
var ButtonGroup = __webpack_require__(4837);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(5639);
;// CONCATENATED MODULE: ./slices/DonateNow/style.ts
function DonateNow_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var DonateNow_style_styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5, _obj6;
    return (0,createStyles/* default */.Z)({
        amountInput: {
            marginLeft: 15
        },
        donate: {
            backgroundColor: "#4A92CF",
            display: "flex",
            justifyContent: "center",
            "& .bgImg": {
                width: "100%",
                height: "100%",
                backgroundPosition: "center",
                backgroundSize: "cover",
                display: "flex",
                justifyContent: "center"
            }
        },
        donateCardBg: (_obj = {
            backgroundImage: "url(/homevideoBg.png)",
            backgroundPosition: "0%",
            backgroundSize: "100.4% 100%",
            backgroundRepeat: "no-repeat",
            display: "flex",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            paddingTop: theme.spacing(30),
            paddingBottom: theme.spacing(20)
        }, DonateNow_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            paddingRight: theme.spacing(10),
            paddingLeft: theme.spacing(10)
        }), DonateNow_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8),
            paddingRight: theme.spacing(2),
            paddingLeft: theme.spacing(2),
            backgroundSize: "cover",
            backgroundPosition: "center"
        }), _obj),
        donateCard: (_obj6 = {
            maxWidth: 890,
            borderRadius: 12,
            zIndex: 9,
            boxShadow: "0 20px 30px 0 rgba(147, 158, 193, 0.2)",
            display: "flex"
        }, DonateNow_style_defineProperty(_obj6, theme.breakpoints.down("sm"), {
            display: "block",
            height: "auto"
        }), DonateNow_style_defineProperty(_obj6, "& .donateLeft", (_obj3 = {
            flex: 1,
            backgroundColor: "#ffffff",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            padding: theme.spacing(5)
        }, DonateNow_style_defineProperty(_obj3, theme.breakpoints.down("sm"), {
            padding: theme.spacing(2)
        }), DonateNow_style_defineProperty(_obj3, "& .amtGroup", {
            marginBottom: theme.spacing(3),
            "& button:first-child": {
                borderTopRightRadius: theme.direction === "ltr" ? 0 : 6,
                borderBottomRightRadius: theme.direction === "ltr" ? 0 : 6,
                borderTopLeftRadius: theme.direction === "ltr" ? 6 : 0,
                borderBottomLeftRadius: theme.direction === "ltr" ? 6 : 0
            },
            "& button:last-child": {
                borderTopLeftRadius: theme.direction === "ltr" ? 0 : 6,
                borderBottomLeftRadius: theme.direction === "ltr" ? 0 : 6,
                borderTopRightRadius: theme.direction === "ltr" ? 6 : 0,
                borderBottomRightRadius: theme.direction === "ltr" ? 6 : 0
            }
        }), DonateNow_style_defineProperty(_obj3, "& .MuiButton-outlinedPrimary", {
            color: "#4c4c78 ",
            border: "solid 1px #4c4c78",
            flex: 1,
            fontWeight: 700,
            height: "fit-content",
            padding: theme.spacing(1.3, 0),
            "&:hover": {
                backgroundColor: "#4a92cf"
            }
        }), DonateNow_style_defineProperty(_obj3, "& .title", {
            textTransform: "uppercase",
            fontFamily: "Raleway,Assistant",
            fontWeight: 900,
            color: "#4c4c78",
            textAlign: "center"
        }), DonateNow_style_defineProperty(_obj3, "& .label", (_obj1 = {
            fontFamily: "Raleway,Assistant",
            fontSize: 14,
            fontWeight: 700,
            color: "#4c4c78",
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(2.5)
        }, DonateNow_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(2)
        }), DonateNow_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1)
        }), _obj1)), DonateNow_style_defineProperty(_obj3, "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline", {
            borderColor: "#8bc249"
        }), DonateNow_style_defineProperty(_obj3, "& fieldset", {
            border: "2px solid #f3f3f3",
            "&:hover": {
                border: "2px solid #8bc249"
            }
        }), DonateNow_style_defineProperty(_obj3, "& .donateBtn", (_obj2 = {
            margin: "0 auto",
            marginTop: theme.spacing(4),
            display: "flex"
        }, DonateNow_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            padding: theme.spacing(3),
            marginTop: theme.spacing(3)
        }), DonateNow_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
            padding: theme.spacing(2),
            marginTop: theme.spacing(2)
        }), _obj2)), _obj3)), DonateNow_style_defineProperty(_obj6, "& .donateRight", (_obj5 = {
            display: "flex",
            flex: 1,
            alignItems: "center",
            backgroundColor: "#242440 ",
            padding: theme.spacing(0, 5, 0, 7.5)
        }, DonateNow_style_defineProperty(_obj5, theme.breakpoints.down("sm"), {
            padding: theme.spacing(2)
        }), DonateNow_style_defineProperty(_obj5, "& p", (_obj4 = {
            fontFamily: "Raleway,Assistant",
            fontSize: 21,
            fontWeight: 700,
            lineHeight: 1.62,
            color: "#ffffff"
        }, DonateNow_style_defineProperty(_obj4, theme.breakpoints.down("sm"), {
            margin: theme.spacing(0)
        }), DonateNow_style_defineProperty(_obj4, "& .underline", {
            borderBottom: "2px solid #4a92cf"
        }), _obj4)), _obj5)), _obj6),
        selectMenuItem: {
            direction: theme.direction === "ltr" ? "ltr" : "rtl"
        }
    });
};
/* harmony default export */ var DonateNow_style = (DonateNow_style_styles);

// EXTERNAL MODULE: ./utils/basket-context.tsx
var basket_context = __webpack_require__(1954);
;// CONCATENATED MODULE: ./services/analytics-service.ts


var analytics = (0,next_config["default"])().publicRuntimeConfig.analytics;
// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
var logPageView = function(url) {
    window.gtag("config", analytics.googleAnalyticsId, {
        page_path: url
    });
};
var logAddItemToBasket = function(item, currency) {
    var track = {
        id: item.id,
        value: item.amount,
        currency: currency
    };
    window.gtag("event", "add_to_cart", track);
    if (window.fbq) window.fbq("track", "AddToCart", track);
};
var logInitiateCheckout = function(paymentInfo) {
    var track = {
        currency: paymentInfo.currencyCode,
        value: braintree_config/* default.getTotalAmountNumber */.Z.getTotalAmountNumber(paymentInfo.netAmount, paymentInfo.coverTransactionCosts),
        payment_type: paymentInfo.isRecurring ? "recurring" : "single"
    };
    window.gtag("event", "begin_checkout", track);
    if (window.fbq) window.fbq("track", "InitiateCheckout", track);
};
var logAddPaymentInfo = function(paymentInfo) {
    //add whether we cover the costs
    var track = {
        currency: paymentInfo.currencyCode,
        value: braintree_config/* default.getTotalAmountNumber */.Z.getTotalAmountNumber(paymentInfo.netAmount, paymentInfo.coverTransactionCosts),
        payment_type: paymentInfo.isRecurring ? "recurring" : "single"
    };
    window.gtag("event", "add_payment_info", track);
    if (window.fbq) window.fbq("track", "AddPaymentInfo", track);
};
var logSingleDonation = function(basket, transactionId) {
    var trackingObject = {
        "transaction_id": transactionId,
        "payment_type": "single",
        "payment_method": basket.paymentMethod,
        "value": +basket.totalAmount,
        "currency": basket.currency_code,
        "items": basket.items.map(function(x) {
            return {
                "id": x.id,
                "name": x.name,
                "quantity": x.amount,
                "price": "1.0"
            };
        })
    };
    window.gtag("event", "purchase", trackingObject);
    if (window.fbq) {
        window.fbq("track", "Purchase", trackingObject);
    }
};
var logRecurringDonation = function(basket, subscriptionId) {
    var trackingObject = {
        "transaction_id": subscriptionId,
        "value": +basket.totalAmount,
        "payment_type": "recurring",
        "currency": basket.currency_code,
        "payment_method": basket.paymentMethod,
        "cover_transaction_costs": basket.coverTransactionCosts
    };
    window.gtag("event", "purchase", trackingObject);
    if (window.fbq) window.fbq("track", "Purchase", trackingObject);
    console.log("LX ogged recurring event to e-commerce");
};
// https://developers.google.com/analytics/devguides/collection/gtagjs/events
var logEvent = function(category, action, label, value) {
    //this needs to become more like
    window.gtag("event", action, {
        event_category: category,
        event_label: label,
        value: value
    });
};
var analyticsService = {
    logEvent: logEvent,
    logPageView: logPageView,
    logAddItemToBasket: logAddItemToBasket,
    logInitiateCheckout: logInitiateCheckout,
    logAddPaymentInfo: logAddPaymentInfo,
    logSingleDonation: logSingleDonation,
    logRecurringDonation: logRecurringDonation
};
/* harmony default export */ var analytics_service = (analyticsService);

;// CONCATENATED MODULE: ./services/donation-service.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var addToBasket = function(basketItems, selectedProject, amount, currencyCode, basketContext, setAmount) {
    var tempCopyOfBasket = _toConsumableArray(basketItems);
    var projectIndex = tempCopyOfBasket.findIndex(function(item) {
        return item.id == selectedProject.id;
    });
    if (projectIndex != -1) {
        tempCopyOfBasket[projectIndex]["amount"] = tempCopyOfBasket[projectIndex]["amount"] + +amount;
    } else {
        // it is a new item. Add it in to the basket
        var newItem = {
            amount: +amount,
            name: selectedProject.name,
            id: selectedProject.id
        };
        tempCopyOfBasket = _toConsumableArray(basketItems).concat([
            newItem
        ]);
        analytics_service.logAddItemToBasket(newItem, currencyCode);
    }
    localStorage.setItem("Basket", JSON.stringify(tempCopyOfBasket));
    basketContext.basket.setBasket(tempCopyOfBasket);
    setAmount(null);
    return tempCopyOfBasket;
};
var getAvailableProjects = function(layout) {
    if (layout && layout.donation_dedication_options) {
        return layout.donation_dedication_options.map(function(x) {
            return {
                id: x.designation_id,
                name: prismic_reactjs.RichText.asText(x.dedication_fund)
            };
        });
    }
    return [];
};
var donationService = {
    addToBasket: addToBasket,
    getAvailableProjects: getAvailableProjects
};
/* harmony default export */ var donation_service = (donationService);

// EXTERNAL MODULE: ./services/currency-service.ts
var currency_service = __webpack_require__(1729);
;// CONCATENATED MODULE: ./slices/DonateNow/index.tsx


















var DonateNow = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    var basketContext = (0,basket_context/* useBasket */.Kc)();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)([]), basketItems = ref[0], setBasketItems = ref[1];
    var ref1 = (0,react.useState)(null), amount1 = ref1[0], setAmount = ref1[1];
    var ref2 = (0,react.useState)(null), selectedProject = ref2[0], setSelectedProject = ref2[1];
    var ref3 = (0,react.useState)(0), selectedProjectIndex = ref3[0], setSelectedProjectIndex = ref3[1];
    var styles = {};
    var state1 = (0,vfi_easy_peasy_store/* useVFIStoreState */.As)(function(state) {
        return state;
    });
    var actions1 = (0,vfi_easy_peasy_store/* useVFIStoreActions */._v)(function(actions) {
        return actions;
    });
    var availableProjects = donation_service.getAvailableProjects(layout);
    if (primary.backgroundImage) {
        styles.backgroundImage = "url(".concat(primary.backgroundImage.url, ")");
    }
    //#region EFFECTS
    (0,react.useEffect)(function() {
        if (selectedProjectIndex > -1) {
            setSelectedProject(availableProjects[selectedProjectIndex]);
        } else {
            setSelectedProject(null);
        }
    }, [
        selectedProjectIndex
    ]);
    (0,react.useEffect)(function() {
        var basketTotal;
        if (localStorage.getItem("Basket")) {
            setBasketItems(JSON.parse(localStorage.getItem("Basket")));
            basketTotal = JSON.parse(localStorage.getItem("Basket"));
        }
    }, []);
    var addToBasket = function() {
        donation_service.addToBasket(basketItems, selectedProject, amount1, state1.currency.code, basketContext, setAmount);
        setSelectedProjectIndex(0);
        setSelectedProject(null);
        router.push(layout.give_button_link.url);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.donate,
        children: layout && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "bgImg",
            style: styles,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.donateCardBg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.donateCard,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "donateLeft",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h5",
                                    className: "title",
                                    children: prismic_reactjs.RichText.asText(layout.homepage_donation_card_title)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "label",
                                    children: prismic_reactjs.RichText.asText(layout.select_amount_text)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup/* default */.Z, {
                                    color: "primary",
                                    className: "amtGroup",
                                    children: layout.amounts.map(function(amount, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                            style: {
                                                backgroundColor: amount.amount == amount && "#4a92cf"
                                            },
                                            onClick: function() {
                                                return setAmount(amount.amount);
                                            },
                                            children: [
                                                state1.currency.symbol,
                                                " ",
                                                amount.amount
                                            ]
                                        }, i);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                    onSubmit: function(e) {
                                        e.preventDefault();
                                        addToBasket();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                            container: true,
                                            spacing: 2,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                    item: true,
                                                    xs: 12,
                                                    sm: 5,
                                                    md: 4,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                        displayEmpty: true,
                                                        fullWidth: true,
                                                        id: "currency",
                                                        variant: "outlined",
                                                        margin: "dense",
                                                        required: true,
                                                        value: state1.currency.code,
                                                        onChange: function(e) {
                                                            actions1.setCurrency(e.target.value);
                                                        },
                                                        children: currency_service/* allCurrencies.map */.Z.map(function(currency, i) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                                className: classes.selectMenuItem,
                                                                value: currency.code,
                                                                children: [
                                                                    currency.code,
                                                                    " ",
                                                                    currency.symbol
                                                                ]
                                                            }, i);
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                    item: true,
                                                    xs: 12,
                                                    sm: 7,
                                                    md: 8,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                        placeholder: prismic_reactjs.RichText.asText(layout.other_amount_placeholder),
                                                        fullWidth: true,
                                                        required: true,
                                                        type: "number",
                                                        variant: "outlined",
                                                        margin: "dense",
                                                        value: amount1 ? Number(amount1) : "",
                                                        onChange: function(e) {
                                                            setAmount(+e.target.value || null);
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "label",
                                            children: prismic_reactjs.RichText.asText(layout.dedicate_donation_placeholder)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                            displayEmpty: true,
                                            id: "dedicateTo",
                                            variant: "outlined",
                                            fullWidth: true,
                                            required: true,
                                            margin: "dense",
                                            value: selectedProjectIndex,
                                            onChange: function(e) {
                                                setSelectedProjectIndex(+e.target.value);
                                            },
                                            className: classes.custInput,
                                            children: availableProjects.map(function(project, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                    className: classes.selectMenuItem,
                                                    value: i,
                                                    children: project.name
                                                }, i);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "contained",
                                            color: "primary",
                                            type: "submit",
                                            className: "donateBtn",
                                            disabled: amount1 <= 0,
                                            children: prismic_reactjs.RichText.asText(layout.donate_now_button_text)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "donateRight",
                            children: prismic_reactjs.RichText.render(primary.rightText)
                        })
                    ]
                })
            })
        })
    });
};
DonateNow.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            background_image: utils_prop_types/* imagePropTypes */.R,
            right_text: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_DonateNow = ((0,withStyles/* default */.Z)(DonateNow_style)(DonateNow));

;// CONCATENATED MODULE: ./slices/DonateOtherModes/style.js
function DonateOtherModes_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var DonateOtherModes_style_styles = function(theme) {
    var _obj, _obj1, _obj2;
    return {
        donateOtherModes: (_obj2 = {
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, DonateOtherModes_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), DonateOtherModes_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), DonateOtherModes_style_defineProperty(_obj2, "& .subtitle", {
            display: "none"
        }), DonateOtherModes_style_defineProperty(_obj2, "& .methodGridWrapper", (_obj = {
            display: "flex",
            paddingTop: theme.spacing(10)
        }, DonateOtherModes_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9)
        }), DonateOtherModes_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8)
        }), _obj)), DonateOtherModes_style_defineProperty(_obj2, "& .methodGrid", DonateOtherModes_style_defineProperty({
            textAlign: "center",
            flex: 1,
            transition: "transform .5s",
            "&:hover": {
                transform: "scale(1.1)"
            }
        }, theme.breakpoints.down("768"), {
            flex: "unset"
        })), DonateOtherModes_style_defineProperty(_obj2, "& .pModeHeadtitle", DonateOtherModes_style_defineProperty({
            color: "#4c4c78",
            textAlign: "center",
            marginBottom: theme.spacing(13)
        }, theme.breakpoints.down("xs"), {
            marginBottom: theme.spacing(7.5)
        })), DonateOtherModes_style_defineProperty(_obj2, "& .pModeTitle", (_obj1 = {
            color: "#4c4c78",
            textAlign: "center",
            fontWeight: 700,
            marginTop: theme.spacing(2.5)
        }, DonateOtherModes_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(2)
        }), DonateOtherModes_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(1)
        }), _obj1)), _obj2)
    };
};
/* harmony default export */ var DonateOtherModes_style = (DonateOtherModes_style_styles);

;// CONCATENATED MODULE: ./slices/DonateOtherModes/index.js












var DonateOtherModes = function(param) {
    var classes = param.classes, slice = param.slice;
    var primary = slice.primary, items = slice.items;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "lg",
        className: classes.donateOtherModes,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                        title: prismic_reactjs.RichText.asText(primary.title)
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                spacing: 4,
                justify: "center",
                alignItems: "center",
                className: "methodGridWrapper",
                children: items.map(function(item, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        className: "methodGrid",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomLink/* default */.Z, {
                            link: item.link,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: item.icon.url,
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    className: "pModeTitle",
                                    children: prismic_reactjs.RichText.asText(item.linkText)
                                })
                            ]
                        })
                    }, i);
                })
            })
        ]
    });
};
DonateOtherModes.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_DonateOtherModes = ((0,withStyles/* default */.Z)(DonateOtherModes_style)(DonateOtherModes));

// EXTERNAL MODULE: ./theme/index.js
var theme_0 = __webpack_require__(9385);
;// CONCATENATED MODULE: ./slices/DonatePayNow/AddADonation/style.ts
function AddADonation_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


// Theme-dependent styles
var AddADonation_style_styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5, _obj6;
    return (0,createStyles/* default */.Z)({
        donateLeft: (_obj = {
            padding: theme.spacing(5)
        }, AddADonation_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            padding: theme.spacing(4)
        }), AddADonation_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            padding: theme.spacing(2)
        }), AddADonation_style_defineProperty(_obj, "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline", {
            borderColor: "#8bc249"
        }), AddADonation_style_defineProperty(_obj, "& fieldset", {
            border: "2px solid #f3f3f3",
            "&:hover": {
                border: "2px solid #8bc249"
            }
        }), _obj),
        givePageDonationCardTitle: {
            fontWeight: 900,
            letterSpacing: 1.24,
            textAlign: "center",
            color: "#4c4c78"
        },
        divider: (_obj1 = {
            height: 1,
            backgroundColor: "#ecf1f2",
            width: "100%",
            margin: theme.spacing(2.5, 0)
        }, AddADonation_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            margin: theme.spacing(2, 0)
        }), AddADonation_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            margin: theme.spacing(1.5, 0)
        }), _obj1),
        editOrSaveButtonText: (_obj2 = {
            maxWidth: 350,
            marginTop: theme.spacing(4),
            margin: "0 auto",
            display: "block"
        }, AddADonation_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(3)
        }), AddADonation_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(2)
        }), _obj2),
        selectAmountText: (_obj3 = {
            fontSize: 16,
            fontWeight: 700,
            color: "#4c4c78",
            marginBottom: theme.spacing(2)
        }, AddADonation_style_defineProperty(_obj3, theme.breakpoints.down("sm"), {
            fontSize: 15,
            marginBottom: theme.spacing(1.5)
        }), AddADonation_style_defineProperty(_obj3, theme.breakpoints.down("xs"), {
            fontSize: 14,
            marginBottom: theme.spacing(1)
        }), _obj3),
        amtGroup: (_obj5 = {
            marginBottom: theme.spacing(5),
            width: "100%"
        }, AddADonation_style_defineProperty(_obj5, theme.breakpoints.down("sm"), {
            marginBottom: theme.spacing(4)
        }), AddADonation_style_defineProperty(_obj5, theme.breakpoints.down("xs"), {
            marginBottom: theme.spacing(3)
        }), AddADonation_style_defineProperty(_obj5, "& button:first-child", {
            borderTopRightRadius: theme.direction === "ltr" ? 0 : 6,
            borderBottomRightRadius: theme.direction === "ltr" ? 0 : 6,
            borderTopLeftRadius: theme.direction === "ltr" ? 6 : 0,
            borderBottomLeftRadius: theme.direction === "ltr" ? 6 : 0
        }), AddADonation_style_defineProperty(_obj5, "& button:last-child", {
            borderTopLeftRadius: theme.direction === "ltr" ? 0 : 6,
            borderBottomLeftRadius: theme.direction === "ltr" ? 0 : 6,
            borderTopRightRadius: theme.direction === "ltr" ? 6 : 0,
            borderBottomRightRadius: theme.direction === "ltr" ? 6 : 0
        }), AddADonation_style_defineProperty(_obj5, "& .MuiButton-outlinedPrimary", (_obj4 = {
            color: "#4c4c78",
            border: "solid 1px #4c4c78",
            flex: 1,
            fontSize: 18,
            fontWeight: 700,
            height: "fit-content",
            padding: theme.spacing(1.3, 0),
            "&:hover": {
                backgroundColor: theme_0/* secondary.500 */.BD[500]
            }
        }, AddADonation_style_defineProperty(_obj4, theme.breakpoints.down("sm"), {
            fontSize: 17
        }), AddADonation_style_defineProperty(_obj4, theme.breakpoints.down("xs"), {
            fontSize: 16
        }), _obj4)), _obj5),
        dedicateDonationPlaceholder: (_obj6 = {
            fontSize: 16,
            fontWeight: 700,
            color: "#4c4c78",
            marginTop: theme.spacing(5),
            marginBottom: theme.spacing(2)
        }, AddADonation_style_defineProperty(_obj6, theme.breakpoints.down("sm"), {
            fontSize: 15,
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(1.5)
        }), AddADonation_style_defineProperty(_obj6, theme.breakpoints.down("xs"), {
            fontSize: 14,
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(1)
        }), _obj6),
        selectMenuItem: {
            direction: theme.direction === "ltr" ? "ltr" : "rtl"
        }
    });
};
/* harmony default export */ var AddADonation_style = (AddADonation_style_styles);

;// CONCATENATED MODULE: ./slices/DonatePayNow/AddADonation/index.tsx














var AddADonation = function(param) {
    var classes = param.classes, addToBasket = param.addToBasket, setAmount = param.setAmount, amount = param.amount, amountInput = param.amountInput, selectedProjectIndex = param.selectedProjectIndex, setSelectedProjectIndex = param.setSelectedProjectIndex, availableProjects = param.availableProjects, editOrSaveButtonText = param.editOrSaveButtonText;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    var state1 = (0,vfi_easy_peasy_store/* useVFIStoreState */.As)(function(state) {
        return state;
    });
    var actions1 = (0,vfi_easy_peasy_store/* useVFIStoreActions */._v)(function(actions) {
        return actions;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.donateLeft,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                className: classes.givePageDonationCardTitle,
                children: prismic_reactjs.RichText.asText(layout.give_page_donation_card_title)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.divider
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: function(e) {
                    e.preventDefault();
                    addToBasket();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.selectAmountText,
                        children: prismic_reactjs.RichText.asText(layout.select_amount_text)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup/* default */.Z, {
                        color: "primary",
                        className: classes.amtGroup,
                        children: layout.amounts.map(function(amountConfig, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                style: {
                                    backgroundColor: amountConfig.amount == amount && "#4a92cf"
                                },
                                onClick: function() {
                                    return setAmount(amountConfig.amount);
                                },
                                children: [
                                    state1.currency.symbol,
                                    " ",
                                    amountConfig.amount
                                ]
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        spacing: 2,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                sm: 4,
                                md: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                    displayEmpty: true,
                                    id: "currency",
                                    variant: "outlined",
                                    required: true,
                                    fullWidth: true,
                                    margin: "dense",
                                    value: state1.currency.code,
                                    onChange: function(e) {
                                        actions1.setCurrency(e.target.value);
                                    },
                                    className: classes.custInput,
                                    children: currency_service/* allCurrencies.map */.Z.map(function(currency, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                            className: classes.selectMenuItem,
                                            value: currency.code,
                                            children: [
                                                currency.code,
                                                " ",
                                                currency.symbol
                                            ]
                                        }, i);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                sm: 8,
                                md: 9,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    placeholder: prismic_reactjs.RichText.asText(layout.other_amount_placeholder),
                                    fullWidth: true,
                                    required: true,
                                    inputRef: amountInput,
                                    type: "number",
                                    variant: "outlined",
                                    margin: "dense",
                                    value: amount ? Number(amount) : "",
                                    onChange: function(e) {
                                        setAmount(+e.target.value || null);
                                    },
                                    className: (0,clsx_m/* default */.Z)(classes.custInput, classes.amountInput)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.dedicateDonationPlaceholder,
                        children: prismic_reactjs.RichText.asText(layout.dedicate_donation_placeholder)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                        displayEmpty: true,
                        id: "dedicateTo",
                        variant: "outlined",
                        fullWidth: true,
                        required: true,
                        margin: "dense",
                        value: selectedProjectIndex,
                        onChange: function(e) {
                            setSelectedProjectIndex(+e.target.value);
                        },
                        className: classes.custInput,
                        children: availableProjects.map(function(project, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                className: classes.selectMenuItem,
                                value: i,
                                children: project.name
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        disabled: selectedProjectIndex < 0 || !amount || amount <= 0,
                        variant: "contained",
                        color: "primary",
                        fullWidth: true,
                        className: classes.editOrSaveButtonText,
                        type: "submit",
                        children: editOrSaveButtonText
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var DonatePayNow_AddADonation = ((0,withStyles/* default */.Z)(AddADonation_style)(AddADonation));

;// CONCATENATED MODULE: ./models/braintree/CountryConfig.ts
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var CountryConfig = function CountryConfig() {
    "use strict";
    _classCallCheck(this, CountryConfig);
};

var Address = /*#__PURE__*/ function() {
    "use strict";
    function Address(init) {
        _classCallCheck(this, Address);
        Object.assign(this, init);
    }
    Address.getFullPhoneNumber = function getFullPhoneNumber(address) {
        var ref;
        if (((ref = address.country) === null || ref === void 0 ? void 0 : ref.dialingCode) && address.phoneNumberLocal) {
            return "+" + address.country.dialingCode + address.phoneNumberLocal;
        }
        return "";
    };
    return Address;
}();

;// CONCATENATED MODULE: ./slices/DonatePayNow/AddressForm/style.ts

// Theme-dependent styles
var AddressForm_style_styles = function(theme) {
    return (0,createStyles/* default */.Z)({
        codeWrapper: {
            display: "flex",
            "& span": {
                marginRight: 4
            }
        },
        addressformGrid: {
            flexDirection: theme.direction === "ltr" ? "row" : "row-reverse",
            "& input": {
                textAlign: theme.direction === "ltr" ? "left" : "right"
            }
        },
        donateMailList: {
            flexDirection: theme.direction === "ltr" ? "row" : "row-reverse",
            marginRight: theme.direction === "ltr" ? "0px" : "",
            marginLeft: theme.direction === "ltr" ? "" : "0px",
            width: "100%",
            alignItems: "flex-start",
            "& .MuiCheckbox-root": {
                marginTop: "-6px"
            }
        },
        autocompletePaper: {
            "& .MuiAutocomplete-option": {
                direction: theme.direction === "ltr" ? "ltr" : "rtl"
            }
        }
    });
};
/* harmony default export */ var AddressForm_style = (AddressForm_style_styles);

;// CONCATENATED MODULE: ./slices/DonatePayNow/AddressForm/index.tsx
function AddressForm_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function AddressForm_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return AddressForm_arrayLikeToArray(arr);
}
function AddressForm_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AddressForm_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function AddressForm_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AddressForm_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AddressForm_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function AddressForm_toConsumableArray(arr) {
    return AddressForm_arrayWithoutHoles(arr) || AddressForm_iterableToArray(arr) || AddressForm_unsupportedIterableToArray(arr) || AddressForm_nonIterableSpread();
}
function AddressForm_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return AddressForm_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AddressForm_arrayLikeToArray(o, minLen);
}















var AddressForm = function(param) {
    var classes = param.classes, address = param.address, handleAddressChange = param.handleAddressChange;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    var ref = (0,react.useState)(), stateRequired = ref[0], setStateRequired = ref[1];
    (0,react.useEffect)(function() {
        if (address.country) {
            setStateRequired(address.country.code === "US");
        }
    }, [
        address === null || address === void 0 ? void 0 : address.country
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
            container: true,
            spacing: 2,
            className: classes.addressformGrid,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        autoComplete: "given-name",
                        placeholder: prismic_reactjs.RichText.asText(layout.first_name_placeholder),
                        variant: "outlined",
                        fullWidth: true,
                        required: true,
                        margin: "dense",
                        name: "firstName",
                        value: address.firstName,
                        onChange: handleAddressChange
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        autoComplete: "family-name",
                        placeholder: prismic_reactjs.RichText.asText(layout.last_name_placeholder),
                        variant: "outlined",
                        fullWidth: true,
                        required: true,
                        margin: "dense",
                        name: "lastName",
                        value: address.lastName,
                        onChange: handleAddressChange
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        autoComplete: "address-line1",
                        placeholder: prismic_reactjs.RichText.asText(layout.address_1_placeholder),
                        variant: "outlined",
                        fullWidth: true,
                        required: true,
                        margin: "dense",
                        name: "address1",
                        value: address.address1,
                        onChange: handleAddressChange
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        autoComplete: "address-line2",
                        placeholder: prismic_reactjs.RichText.asText(layout.address_2_placeholder),
                        variant: "outlined",
                        fullWidth: true,
                        margin: "dense",
                        name: "address2",
                        value: address.address2,
                        onChange: handleAddressChange
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        autoComplete: "home city",
                        placeholder: prismic_reactjs.RichText.asText(layout.city_placeholder),
                        variant: "outlined",
                        fullWidth: true,
                        required: true,
                        margin: "dense",
                        name: "city",
                        value: address.city,
                        onChange: handleAddressChange
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        autoComplete: "home state",
                        placeholder: prismic_reactjs.RichText.asText(layout.state_placeholder),
                        variant: "outlined",
                        fullWidth: true,
                        margin: "dense",
                        required: stateRequired,
                        name: "state",
                        value: address.state,
                        onChange: handleAddressChange
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        autoComplete: "postal-code",
                        placeholder: prismic_reactjs.RichText.asText(layout.zipcode_placeholder),
                        variant: "outlined",
                        fullWidth: true,
                        required: true,
                        margin: "dense",
                        name: "zip",
                        value: address.zip,
                        onChange: handleAddressChange
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.ZP, {
                        id: "country-select-demo",
                        fullWidth: true,
                        autoHighlight: true,
                        value: address.country || null,
                        renderOption: function(option, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.codeWrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: regionHelpers/* default.countryToFlag */.Z.countryToFlag(option.code)
                                    }),
                                    option.label,
                                    " (",
                                    option.code,
                                    ")"
                                ]
                            });
                        },
                        filterOptions: autocomplete_filters.countryFilter,
                        onChange: function(e, countryFromAutocomplete) {
                            handleAddressChange({
                                target: {
                                    value: countryFromAutocomplete,
                                    name: "country"
                                }
                            });
                        },
                        classes: {
                            option: classes.option,
                            paper: classes.autocompletePaper
                        },
                        renderInput: function(params) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, AddressForm_objectSpread({}, params, {
                                fullWidth: true,
                                placeholder: prismic_reactjs.RichText.asText(layout.country_placeholder),
                                variant: "outlined",
                                margin: "dense",
                                required: true,
                                inputProps: AddressForm_objectSpread({}, params.inputProps, {
                                    autoComplete: "new-password"
                                })
                            }));
                        },
                        getOptionLabel: function(option) {
                            return option.label;
                        },
                        options: AddressForm_toConsumableArray(countries/* default.sort */.Z.sort(function(a, b) {
                            return a.label > b.label ? 1 : -1;
                        }))
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        autoComplete: "email",
                        placeholder: prismic_reactjs.RichText.asText(layout.email_placeholder),
                        variant: "outlined",
                        required: true,
                        fullWidth: true,
                        type: "email",
                        name: "email",
                        margin: "dense",
                        value: address.email,
                        onChange: handleAddressChange
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    sm: 4,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.ZP, {
                        id: "dialing-code-select",
                        fullWidth: true,
                        options: AddressForm_toConsumableArray(countries/* default.sort */.Z.sort(function(a, b) {
                            return a.code > b.code ? 1 : -1;
                        })),
                        classes: {
                            option: classes.option,
                            paper: classes.autocompletePaper
                        },
                        filterOptions: autocomplete_filters.dialingCodes,
                        autoHighlight: true,
                        getOptionLabel: function(option) {
                            return "+" + option.dialingCode;
                        },
                        value: address.dialingCodeCountryConfig || null,
                        onChange: function(e, country) {
                            if (country) {
                                handleAddressChange({
                                    target: {
                                        value: country,
                                        name: "dialingCodeCountryConfig"
                                    }
                                });
                                handleAddressChange({
                                    target: {
                                        value: country.dialingCode,
                                        name: "dialingCode"
                                    }
                                });
                            } else {
                                handleAddressChange({
                                    target: {
                                        value: null,
                                        name: "dialingCodeCountryConfig"
                                    }
                                });
                                handleAddressChange({
                                    target: {
                                        value: "",
                                        name: "dialingCode"
                                    }
                                });
                            }
                        },
                        renderOption: function(option) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.codeWrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: regionHelpers/* default.countryToFlag */.Z.countryToFlag(option.code)
                                    }),
                                    "(",
                                    option.code,
                                    ") +",
                                    option.dialingCode
                                ]
                            });
                        },
                        renderInput: function(params) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, AddressForm_objectSpread({}, params, {
                                fullWidth: true,
                                placeholder: prismic_reactjs.RichText.asText(layout.code_placeholder),
                                variant: "outlined",
                                margin: "dense",
                                required: true,
                                inputProps: AddressForm_objectSpread({}, params.inputProps, {
                                    autoComplete: "new-password"
                                })
                            }));
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    sm: 8,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        placeholder: prismic_reactjs.RichText.asText(layout.phone_number_placeholder),
                        variant: "outlined",
                        fullWidth: true,
                        required: true,
                        type: "phone",
                        margin: "dense",
                        name: "phoneNumberLocal",
                        autoComplete: "tel-local",
                        value: address.phoneNumberLocal,
                        onChange: handleAddressChange
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                        checked: address.signUpForEmail,
                        value: "start",
                        className: classes.donateMailList,
                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            color: "primary",
                            onChange: function(e) {
                                handleAddressChange({
                                    target: {
                                        value: e.target.checked,
                                        name: "signUpForEmail"
                                    }
                                });
                            }
                        }),
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: layout.donation_mailing_list_sign_up_text
                        }),
                        labelPlacement: "end"
                    })
                })
            ]
        })
    });
};
AddressForm.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
var getDefaultAddress = function(signUpForEmail, country) {
    return new Address({
        firstName: "",
        dialingCode: country === null || country === void 0 ? void 0 : country.dialingCode,
        dialingCodeCountryConfig: country,
        country: country,
        lastName: "",
        address1: "",
        address2: "",
        city: "",
        email: "",
        phoneNumberLocal: "",
        state: "",
        zip: "",
        signUpForEmail: signUpForEmail
    });
};
/* harmony default export */ var DonatePayNow_AddressForm = ((0,withStyles/* default */.Z)(AddressForm_style)(AddressForm));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(2663);
;// CONCATENATED MODULE: ./components/Modal/index.js





var SimpleDialog = function(param) {
    var handleClose = param.handleClose, open = param.open, onRendered = param.onRendered, classes = param.classes, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        onRendered: onRendered,
        onClose: handleClose,
        "aria-labelledby": "simple-dialog-title",
        open: open,
        className: classes.modal,
        children: children
    });
};
SimpleDialog.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    handleClose: (prop_types_default()).func.isRequired,
    open: (prop_types_default()).bool.isRequired,
    children: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var Modal = ((0,withStyles/* default */.Z)()(SimpleDialog));

;// CONCATENATED MODULE: ./slices/DonatePayNow/AddressPopup/style.ts
function AddressPopup_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

// Theme-dependent styles
var AddressPopup_style_styles = function(theme) {
    var _obj, _obj1, _obj2;
    return (0,createStyles/* default */.Z)({
        modal: (_obj = {
            padding: theme.spacing(4),
            display: "flex",
            flexDirection: "column",
            color: "#4c4c78",
            fontFamily: "Raleway,Assistant"
        }, AddressPopup_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            padding: theme.spacing(3)
        }), AddressPopup_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            padding: theme.spacing(2)
        }), AddressPopup_style_defineProperty(_obj, "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline", {
            borderColor: "#8bc249"
        }), AddressPopup_style_defineProperty(_obj, "& fieldset", {
            border: "2px solid #f3f3f3",
            "&:hover": {
                border: "2px solid #8bc249"
            }
        }), AddressPopup_style_defineProperty(_obj, "& .MuiInputBase-root", {
            backgroundColor: "#f3f3f3"
        }), _obj),
        modalTitle: {
            textTransform: "uppercase",
            fontWeight: 900,
            textAlign: "center",
            marginBottom: theme.spacing(2)
        },
        modalSectionTitle: (_obj1 = {
            fontSize: 16,
            fontWeight: 700,
            marginTop: theme.spacing(2.5),
            marginBottom: theme.spacing(2.5),
            textAlign: theme.direction === "ltr" ? "left" : "right"
        }, AddressPopup_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            marginBottom: theme.spacing(2),
            marginTop: theme.spacing(2)
        }), AddressPopup_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            marginBottom: theme.spacing(1.5),
            marginTop: theme.spacing(1.5)
        }), _obj1),
        proceedBtn: (_obj2 = {
            maxWidth: 350,
            margin: "0 auto",
            display: "block",
            marginTop: theme.spacing(4)
        }, AddressPopup_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(3)
        }), AddressPopup_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(2)
        }), _obj2),
        tnc: {
            "& p": {
                fontSize: 14,
                fontWeight: 500,
                lineHeight: 1.71,
                textAlign: "center",
                marginTop: theme.spacing(2),
                "& span": {
                    textDecoration: "none"
                },
                "& a": {
                    color: "#4c4c78",
                    textDecoration: "underline",
                    textDecorationThickness: "1.5px"
                }
            }
        },
        recaptcha: {
            "& p": {
                fontSize: 14,
                fontWeight: 500,
                lineHeight: 1.71,
                textAlign: "center",
                "& span": {
                    textDecoration: "none"
                },
                "& a": {
                    color: "#4c4c78",
                    textDecoration: "underline",
                    textDecorationThickness: "1.5px"
                }
            }
        },
        extraImpactWrapper: {
            "& .MuiFormControlLabel-root": {
                alignItems: "flex-start",
                "& .MuiCheckbox-root": {
                    marginTop: "-6px"
                }
            }
        }
    });
};
/* harmony default export */ var AddressPopup_style = (AddressPopup_style_styles);

;// CONCATENATED MODULE: ./slices/DonatePayNow/ExtraImpact/index.tsx







var ExtraImpact = function(param) {
    var classes = param.classes, address = param.address, mappedCheckboxes = param.mappedCheckboxes, setCheckbox = param.setCheckbox;
    var ref;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    var branch = regionHelpers/* default.findBranchFromCountryCode */.Z.findBranchFromCountryCode(address === null || address === void 0 ? void 0 : (ref = address.country) === null || ref === void 0 ? void 0 : ref.code);
    if (branch !== DonationModels/* BraintreeBranch.UK */.tn.UK) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
    var giftAidCheckbox = layout.extra_impact_checkboxes.find(function(x) {
        return x.extra_impact_id === "gift-aid";
    });
    if (!giftAidCheckbox) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.modalSectionTitle,
                children: prismic_reactjs.RichText.asText(giftAidCheckbox.checkbox_title)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.extraImpactWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    value: "end",
                    checked: mappedCheckboxes(giftAidCheckbox.extra_impact_id),
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        color: "primary",
                        onChange: function(e) {
                            setCheckbox(giftAidCheckbox.extra_impact_id, e);
                        }
                    }),
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: prismic_reactjs.RichText.asText(giftAidCheckbox.checkbox_text)
                    }),
                    labelPlacement: "end"
                })
            })
        ]
    });
};
/* harmony default export */ var DonatePayNow_ExtraImpact = ((/* unused pure expression or super */ null && (ExtraImpact)));

;// CONCATENATED MODULE: ./slices/DonatePayNow/AddressPopup/index.tsx















var AddressPopup = function(param) {
    var classes = param.classes, openDonationPopup = param.openDonationPopup, closeAllPopups = param.closeAllPopups, openPayNowPopup = param.openPayNowPopup, address = param.address, handleAddressChange = param.handleAddressChange, setCheckbox = param.setCheckbox, mappedCheckboxes = param.mappedCheckboxes, getPaymentInfo = param.getPaymentInfo;
    var isBlank = function isBlank(str) {
        return !str || /^\s*$/.test(str);
    };
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    var ref1 = (0,react.useState)(), addressValidationError = ref1[0], setAddressValidationError = ref1[1];
    // todo - translatable messages. Hardcoded to English for now so we can get it out for testing.
    // todo - place error next to relevant field
    var validateAddress = function() {
        var ref;
        if (isBlank((ref = address.country) === null || ref === void 0 ? void 0 : ref.code)) {
            error_logging_service/* default.logMessage */.Z.logMessage("country code missing", {
                address: address
            });
            setAddressValidationError("Country code missing");
            return false;
        }
        if (isBlank(address.dialingCode)) {
            error_logging_service/* default.logMessage */.Z.logMessage("dialing code missing", {
                address: address
            });
            setAddressValidationError("Dialing code missing");
            return false;
        }
        if (isBlank(address.email)) {
            error_logging_service/* default.logMessage */.Z.logMessage("email missing", {
                address: address
            });
            setAddressValidationError("Email missing");
            return false;
        }
        if (address.country.code === "US") {
            if (isBlank(address.state)) {
                error_logging_service/* default.logMessage */.Z.logMessage("state missing for US transaction", {
                    address: address
                });
                setAddressValidationError("State missing");
                return false;
            }
        }
        return true;
    };
    var isCountryCurrencyMatch = function() {
        return address.country ? getPaymentInfo().currencyCode === regionHelpers/* default.getCountryFromCode */.Z.getCountryFromCode(address.country.code).vfiCurrencyCode : true;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
        onRendered: function() {
            analytics_service.logInitiateCheckout(getPaymentInfo());
        },
        open: openDonationPopup,
        handleClose: closeAllPopups,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.modal,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "h5",
                    className: classes.modalTitle,
                    children: [
                        prismic_reactjs.RichText.asText(layout.personal_details_popup_title),
                        " "
                    ]
                }),
                !isCountryCurrencyMatch() && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                    severity: "warning",
                    children: layout.country_currency_mismatch_warning
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classes.modalSectionTitle,
                    children: prismic_reactjs.RichText.asText(layout.personal_details_popup_title)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: function(e) {
                        setAddressValidationError("");
                        e.preventDefault();
                        if (!validateAddress()) {
                            error_logging_service/* default.logMessage */.Z.logMessage("could not validate address", {
                                address: address
                            });
                            return;
                        }
                        openPayNowPopup();
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DonatePayNow_AddressForm, {
                            address: address,
                            handleAddressChange: handleAddressChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExtraImpact, {
                            classes: classes,
                            address: address,
                            mappedCheckboxes: mappedCheckboxes,
                            setCheckbox: setCheckbox
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "contained",
                            color: "primary",
                            type: "submit",
                            fullWidth: true,
                            className: classes.proceedBtn,
                            children: prismic_reactjs.RichText.asText(layout.proceed_button_text)
                        }),
                        addressValidationError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                            severity: "error",
                            children: addressValidationError
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classes.tnc,
                    children: prismic_reactjs.RichText.render(layout.privacy_text1)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classes.recaptcha,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "This site is protected by reCAPTCHA.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "The Google",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://policies.google.com/privacy",
                                children: "Privacy Policy"
                            }),
                            " and",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: "https://policies.google.com/terms",
                                children: [
                                    " ",
                                    "Terms of Service"
                                ]
                            }),
                            " ",
                            "apply."
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var DonatePayNow_AddressPopup = ((0,withStyles/* default */.Z)(AddressPopup_style)(AddressPopup));

;// CONCATENATED MODULE: ./services/security-service.ts
function security_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function security_service_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                security_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                security_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var reCAPTCHA_site_key = (0,next_config["default"])().publicRuntimeConfig.recaptchaSiteKey;
// rather than having to go through the whole project
var SecurityService = {
    // returns a recaptcha token
    // the token should be verified on our server using validateRecaptchaToken
    getRecaptchaToken: function() {
        var _ref = security_service_asyncToGenerator(runtime_default().mark(function _callee(action) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (reCAPTCHA_site_key) {
                            _ctx.next = 3;
                            break;
                        }
                        error_logging_service/* default.logError */.Z.logError({
                            message: "missing recaptcha token",
                            name: "missing_recaptcha_token"
                        }, null);
                        return _ctx.abrupt("return", "");
                    case 3:
                        if (window.grecaptcha) {
                            _ctx.next = 6;
                            break;
                        }
                        error_logging_service/* default.logError */.Z.logError({
                            message: "missing recaptcha object on the window",
                            name: "missing_recaptcha_object"
                        }, null);
                        return _ctx.abrupt("return", "");
                    case 6:
                        return _ctx.abrupt("return", new Promise(function(res, rej) {
                            window.grecaptcha.ready(function() {
                                window.grecaptcha.execute(reCAPTCHA_site_key, {
                                    action: action
                                }).then(function(token) {
                                    return res(token);
                                });
                            });
                        }).catch(function(err) {
                            error_logging_service/* default.logError */.Z.logError(err, {
                                recaptchaAction: action
                            });
                            return "";
                        }));
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(action) {
            return _ref.apply(this, arguments);
        };
    }(),
    validateRecaptchaTokenWithGoogle: function() {
        var _ref = security_service_asyncToGenerator(runtime_default().mark(function _callee(token) {
            var secretKey, verificationResponse, json;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        secretKey = (0,next_config["default"])().serverRuntimeConfig.recaptchaSecretKey;
                        if (secretKey) {
                            _ctx.next = 4;
                            break;
                        }
                        error_logging_service/* default.logMessage */.Z.logMessage("tcould not find secret recaptcha key when validating on the server", null);
                        return _ctx.abrupt("return", {
                            status: 400,
                            recaptchaResponse: {
                                success: false,
                                score: 0,
                                message: "key not provided",
                                action: "submit"
                            }
                        });
                    case 4:
                        if (token) {
                            _ctx.next = 7;
                            break;
                        }
                        error_logging_service/* default.logMessage */.Z.logMessage("Could not find recaptcha token when validating on the server", null);
                        return _ctx.abrupt("return", {
                            status: 400,
                            recaptchaResponse: {
                                success: false,
                                score: 0,
                                message: "token not provided",
                                action: "submit"
                            }
                        });
                    case 7:
                        _ctx.next = 9;
                        return fetch("https://www.google.com/recaptcha/api/siteverify?secret=".concat(secretKey, "&response=").concat(token), {
                            method: "POST"
                        });
                    case 9:
                        verificationResponse = _ctx.sent;
                        _ctx.next = 12;
                        return verificationResponse.json();
                    case 12:
                        json = _ctx.sent;
                        return _ctx.abrupt("return", {
                            status: verificationResponse.status,
                            recaptchaResponse: json
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(token) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var security_service = (SecurityService);

// EXTERNAL MODULE: ./node_modules/braintree-web/dist/browser/hosted-fields.js
var hosted_fields = __webpack_require__(3770);
;// CONCATENATED MODULE: ./services/braintree/credit-card/bt-credit-card-service.ts
function bt_credit_card_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function bt_credit_card_service_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                bt_credit_card_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                bt_credit_card_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var CreditCardService = {
    //this takes and validates the user's credit card info
    tokenizeCard: function() {
        var _ref = bt_credit_card_service_asyncToGenerator(runtime_default().mark(function _callee(hostedFieldsInstance, paymentInfo) {
            var hostedFieldsResult;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return hostedFieldsInstance.tokenize({
                            billingAddress: {
                                postalCode: paymentInfo.address.zip,
                                streetAddress: paymentInfo.address.address1,
                                countryCodeAlpha2: paymentInfo.address.country.code
                            }
                        });
                    case 3:
                        hostedFieldsResult = _ctx.sent;
                        return _ctx.abrupt("return", hostedFieldsResult);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        error_logging_service/* default.logError */.Z.logError(_ctx.t0, {
                            type: "tokenization"
                        });
                        return _ctx.abrupt("return", null);
                    case 11:
                        _ctx.prev = 11;
                        console.log("finished tokenizing card");
                        return _ctx.finish(11);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7,
                    11,
                    14
                ]
            ]);
        }));
        return function(hostedFieldsInstance, paymentInfo) {
            return _ref.apply(this, arguments);
        };
    }(),
    create: function() {
        var _ref = bt_credit_card_service_asyncToGenerator(runtime_default().mark(function _callee(clientToken, paymentInfo, uiEvents) {
            var hostedFieldsInstance;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return hosted_fields.create({
                            authorization: clientToken,
                            styles: {
                                "input": {
                                    "font-size": "16px",
                                    "color": "#4c4c78",
                                    "font-weight": "500"
                                },
                                ":focus": {
                                    border: "2px solid #9ad455"
                                },
                                ":focus-within": {
                                    border: "2px solid #9ad455"
                                },
                                ":hover": {
                                    border: "2px solid #9ad455"
                                },
                                ".invalid": {
                                    "color": "red"
                                }
                            },
                            preventAutofill: false,
                            fields: {
                                number: {
                                    selector: "#card-number",
                                    placeholder: paymentInfo.creditCardPlaceholders.cardNumber
                                },
                                cvv: {
                                    selector: "#cvv",
                                    placeholder: paymentInfo.creditCardPlaceholders.cvv
                                },
                                expirationDate: {
                                    selector: "#expiration-date",
                                    placeholder: paymentInfo.creditCardPlaceholders.expiry
                                },
                                cardholderName: {
                                    selector: "#cardholder-name",
                                    placeholder: paymentInfo.creditCardPlaceholders.cardholderName
                                }
                            }
                        });
                    case 3:
                        hostedFieldsInstance = _ctx.sent;
                        hostedFieldsInstance.on("empty", function(event) {
                            uiEvents.onCreditCardTypeChanged(null);
                        });
                        hostedFieldsInstance.on("cardTypeChange", function(event) {
                            // Change card bg depending on card type
                            if (event.cards.length === 1) {
                                uiEvents.onCreditCardTypeChanged(event.cards[0].type);
                                // Change the CVV length for AmericanExpress cards
                                if (event.cards[0].code.size === 4) {
                                    hostedFieldsInstance.setAttribute({
                                        field: "cvv",
                                        attribute: "placeholder",
                                        value: "1234"
                                    });
                                }
                            } else {
                                hostedFieldsInstance.setAttribute({
                                    field: "cvv",
                                    attribute: "placeholder",
                                    value: "123"
                                });
                            }
                        });
                        return _ctx.abrupt("return", {
                            hostedFieldsInstance: hostedFieldsInstance,
                            success: true
                        });
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        //this runs when the form has been processed by braintree successfully / unsuccessfully
                        error_logging_service/* default.logError */.Z.logError(_ctx.t0, {
                            page: "donations",
                            action: "hosted-fields-error"
                        });
                        return _ctx.abrupt("return", {
                            success: false,
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        }));
        return function(clientToken, paymentInfo, uiEvents) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var bt_credit_card_service = (CreditCardService);

// EXTERNAL MODULE: ./node_modules/braintree-web/dist/browser/venmo.js
var venmo = __webpack_require__(3872);
;// CONCATENATED MODULE: ./services/braintree/venmo/bt-venmo-service.ts
function bt_venmo_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function bt_venmo_service_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                bt_venmo_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                bt_venmo_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var VenmoService = {
    branchSupportedByVenmo: function(branch) {
        return branch === DonationModels/* BraintreeBranch.US */.tn.US;
    },
    payWithVenmo: function() {
        var _ref = bt_venmo_service_asyncToGenerator(runtime_default().mark(function _callee(authorizationToken, paymentInfo) {
            var venmoInstance, venmoResult;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return venmo.create({
                            authorization: authorizationToken,
                            paymentMethodUsage: paymentInfo.isRecurring ? "multi_use" : "single_use",
                            allowDesktop: true,
                            allowNewBrowserTab: false
                        });
                    case 3:
                        venmoInstance = _ctx.sent;
                        _ctx.next = 6;
                        return venmoInstance.tokenize();
                    case 6:
                        venmoResult = _ctx.sent;
                        error_logging_service/* default.logTrace */.Z.logTrace("venmo tokenization result", {
                            venmoResult: venmoResult
                        });
                        return _ctx.abrupt("return", {
                            success: true,
                            nonce: venmoResult.nonce,
                            username: venmoResult.details.username
                        });
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        if (!(_ctx.t0.code === "VENMO_DESKTOP_CANCELED")) {
                            _ctx.next = 15;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            success: true,
                            error: _ctx.t0
                        });
                    case 15:
                        error_logging_service/* default.logError */.Z.logError(_ctx.t0);
                        return _ctx.abrupt("return", {
                            success: false,
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11
                ]
            ]);
        }));
        return function(authorizationToken, paymentInfo) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var bt_venmo_service = (VenmoService);

// EXTERNAL MODULE: ./node_modules/braintree-web/dist/browser/google-payment.js
var google_payment = __webpack_require__(1307);
;// CONCATENATED MODULE: ./services/braintree/google-pay/bt-google-pay-service.ts
function bt_google_pay_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function bt_google_pay_service_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                bt_google_pay_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                bt_google_pay_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var googlePlayEnv = (0,next_config["default"])().publicRuntimeConfig.googlePayEnvironment;
if (!googlePlayEnv) {
    error_logging_service/* default.logError */.Z.logError({
        name: "google_pay_setup_error",
        message: "no google play env set"
    });
}
var GooglePayService = {
    makePayment: function() {
        var _ref = bt_google_pay_service_asyncToGenerator(runtime_default().mark(function _callee(authorizationToken, paymentInfo) {
            var paymentsClient, googlePaymentInstance, allowedPaymentMethods, paymentsClientResponse, paymentDataRequest, cardPaymentMethod, paymentData, finalAuthResult;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        paymentsClient = new window.google.payments.api.PaymentsClient({
                            environment: googlePlayEnv
                        });
                        if (paymentsClient) {
                            _ctx.next = 5;
                            break;
                        }
                        error_logging_service/* default.logMessage */.Z.logMessage("Could not get google payments client");
                        return _ctx.abrupt("return", {
                            success: false
                        });
                    case 5:
                        _ctx.next = 7;
                        return google_payment.create({
                            authorization: authorizationToken,
                            googlePayVersion: 2
                        });
                    case 7:
                        googlePaymentInstance = _ctx.sent;
                        allowedPaymentMethods = googlePaymentInstance.createPaymentDataRequest().allowedPaymentMethods;
                        if (!(!allowedPaymentMethods || allowedPaymentMethods.length === 0)) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            success: false,
                            error: {
                                message: "no payment methods added",
                                name: "no_payment_methods"
                            }
                        });
                    case 11:
                        _ctx.next = 13;
                        return paymentsClient.isReadyToPay({
                            // see https://developers.google.com/pay/api/web/reference/object#IsReadyToPayRequest
                            apiVersion: 2,
                            apiVersionMinor: 0,
                            allowedPaymentMethods: allowedPaymentMethods,
                            existingPaymentMethodRequired: true // Optional
                        });
                    case 13:
                        paymentsClientResponse = _ctx.sent;
                        if (paymentsClientResponse === null || paymentsClientResponse === void 0 ? void 0 : paymentsClientResponse.result) {
                            _ctx.next = 16;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            success: false,
                            error: {
                                name: "google_pay_error",
                                message: "Is ready to pay returned an error"
                            }
                        });
                    case 16:
                        paymentDataRequest = googlePaymentInstance.createPaymentDataRequest({
                            transactionInfo: {
                                currencyCode: paymentInfo.currencyCode,
                                totalPriceStatus: "FINAL",
                                totalPrice: braintree_config/* default.getTotalAmountString */.Z.getTotalAmountString(paymentInfo.netAmount, paymentInfo.coverTransactionCosts)
                            }
                        });
                        cardPaymentMethod = paymentDataRequest.allowedPaymentMethods[0];
                        cardPaymentMethod.parameters.billingAddressRequired = true;
                        cardPaymentMethod.parameters.billingAddressParameters = {
                            format: "FULL",
                            phoneNumberRequired: true
                        };
                        _ctx.next = 22;
                        return paymentsClient.loadPaymentData(paymentDataRequest);
                    case 22:
                        paymentData = _ctx.sent;
                        _ctx.next = 25;
                        return googlePaymentInstance.parseResponse(paymentData);
                    case 25:
                        finalAuthResult = _ctx.sent;
                        if (finalAuthResult === null || finalAuthResult === void 0 ? void 0 : finalAuthResult.nonce) {
                            _ctx.next = 28;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            success: false,
                            error: {
                                name: "google_pay_error",
                                message: "could_not_get_nonce"
                            }
                        });
                    case 28:
                        return _ctx.abrupt("return", {
                            success: true,
                            nonce: finalAuthResult.nonce
                        });
                    case 31:
                        _ctx.prev = 31;
                        _ctx.t0 = _ctx["catch"](0);
                        error_logging_service/* default.logError */.Z.logError(_ctx.t0, {
                            doingWhat: "google_payment",
                            paymentInfo: paymentInfo
                        });
                        return _ctx.abrupt("return", {
                            success: false,
                            error: _ctx.t0
                        });
                    case 35:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    31
                ]
            ]);
        }));
        return function(authorizationToken, paymentInfo) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var bt_google_pay_service = (GooglePayService);

// EXTERNAL MODULE: ./node_modules/braintree-web/dist/browser/paypal-checkout.js
var paypal_checkout = __webpack_require__(9794);
;// CONCATENATED MODULE: ./services/braintree/paypal/bt-paypal-service.ts
function bt_paypal_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function bt_paypal_service_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                bt_paypal_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                bt_paypal_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var PaypalService = {
    init: function() {
        var _ref1 = bt_paypal_service_asyncToGenerator(runtime_default().mark(function _callee1(transactionLogId, token, paymentInfo, uiEvents, makePaymentGeneric, branch) {
            var waitForPaypalInit, timeoutPromise, paypalInitResult;
            return runtime_default().wrap(function _callee$(_ctx1) {
                while(1)switch(_ctx1.prev = _ctx1.next){
                    case 0:
                        waitForPaypalInit = function() {
                            var _ref2 = bt_paypal_service_asyncToGenerator(runtime_default().mark(function _callee2() {
                                var paypalInitPromise;
                                return runtime_default().wrap(function _callee$(_ctx2) {
                                    while(1)switch(_ctx2.prev = _ctx2.next){
                                        case 0:
                                            paypalInitPromise = new Promise(function() {
                                                var _ref3 = bt_paypal_service_asyncToGenerator(runtime_default().mark(function _callee3(resolve, reject) {
                                                    var paypalButtonActions, paypalCheckoutInstance, paypalSetupResult;
                                                    return runtime_default().wrap(function _callee$(_ctx3) {
                                                        while(1)switch(_ctx3.prev = _ctx3.next){
                                                            case 0:
                                                                paypalButtonActions = null;
                                                                _ctx3.prev = 1;
                                                                error_logging_service/* default.logTrace */.Z.logTrace("setting up paypal");
                                                                _ctx3.next = 5;
                                                                return paypal_checkout.create({
                                                                    authorization: token
                                                                });
                                                            case 5:
                                                                paypalCheckoutInstance = _ctx3.sent;
                                                                error_logging_service/* default.logTrace */.Z.logTrace("got the paypal checkout instance, now loading SDK", {
                                                                    vault: true,
                                                                    currency: paymentInfo.currencyCode,
                                                                    paypalCheckoutInstance: paypalCheckoutInstance
                                                                });
                                                                _ctx3.next = 9;
                                                                return paypalCheckoutInstance.loadPayPalSDK({
                                                                    vault: true,
                                                                    currency: paymentInfo.currencyCode
                                                                });
                                                            case 9:
                                                                paypalSetupResult = _ctx3.sent;
                                                                error_logging_service/* default.logTrace */.Z.logTrace("paypalSetupResult", paypalSetupResult);
                                                                _ctx3.next = 13;
                                                                return window.paypal.Buttons({
                                                                    fundingSource: window.paypal.FUNDING.PAYPAL,
                                                                    createBillingAgreement: function() {
                                                                        error_logging_service/* default.logTrace */.Z.logTrace("paypal create billing agreement");
                                                                        return paypalCheckoutInstance.createPayment({
                                                                            flow: "vault"
                                                                        });
                                                                    },
                                                                    onInit: function(data, actions) {
                                                                        error_logging_service/* default.logTrace */.Z.logTrace("PAYPAL BUTTON ACTIONS IN PAYPAL SERVICE", actions);
                                                                        paypalButtonActions = actions;
                                                                        resolve({
                                                                            paypalButtonActions: actions,
                                                                            success: true,
                                                                            code: "init-succeeded"
                                                                        });
                                                                    },
                                                                    onApprove: function() {
                                                                        var _ref = bt_paypal_service_asyncToGenerator(runtime_default().mark(function _callee(data, actions) {
                                                                            var paypalNonceResult;
                                                                            return runtime_default().wrap(function _callee$(_ctx) {
                                                                                while(1)switch(_ctx.prev = _ctx.next){
                                                                                    case 0:
                                                                                        error_logging_service/* default.logTrace */.Z.logTrace("paypal on approve");
                                                                                        _ctx.prev = 1;
                                                                                        uiEvents.showLoading();
                                                                                        _ctx.next = 5;
                                                                                        return paypalCheckoutInstance.tokenizePayment(data);
                                                                                    case 5:
                                                                                        paypalNonceResult = _ctx.sent;
                                                                                        error_logging_service/* default.logTrace */.Z.logTrace("paypal nonce result", paypalNonceResult);
                                                                                        _ctx.next = 9;
                                                                                        return makePaymentGeneric(transactionLogId, DonationModels/* PaymentMethod.PAYPAL */.XL.PAYPAL, branch, paypalNonceResult.nonce, paymentInfo, uiEvents, {
                                                                                            success: true,
                                                                                            paypalButtonActions: paypalButtonActions,
                                                                                            paypalCheckoutInstance: paypalCheckoutInstance
                                                                                        }, token);
                                                                                    case 9:
                                                                                        _ctx.next = 16;
                                                                                        break;
                                                                                    case 11:
                                                                                        _ctx.prev = 11;
                                                                                        _ctx.t0 = _ctx["catch"](1);
                                                                                        error_logging_service/* default.logError */.Z.logError(_ctx.t0, {
                                                                                            page: "donations",
                                                                                            action: "tokenize paypal payment"
                                                                                        });
                                                                                        uiEvents.onError(DonationModels/* PaymentErrorType.Paypal */.zW.Paypal, _ctx.t0);
                                                                                        return _ctx.abrupt("return");
                                                                                    case 16:
                                                                                        _ctx.prev = 16;
                                                                                        error_logging_service/* default.logTrace */.Z.logTrace("paypal onapprove finally executing, hiding loading");
                                                                                        uiEvents.hideLoading();
                                                                                        return _ctx.finish(16);
                                                                                    case 20:
                                                                                    case "end":
                                                                                        return _ctx.stop();
                                                                                }
                                                                            }, _callee, null, [
                                                                                [
                                                                                    1,
                                                                                    11,
                                                                                    16,
                                                                                    20
                                                                                ]
                                                                            ]);
                                                                        }));
                                                                        return function(data, actions) {
                                                                            return _ref.apply(this, arguments);
                                                                        };
                                                                    }(),
                                                                    onCancel: function onCancel(data) {
                                                                        error_logging_service/* default.logTrace */.Z.logTrace("PayPal payment canceled", data);
                                                                        resolve({
                                                                            success: true,
                                                                            code: "cancelled"
                                                                        });
                                                                    },
                                                                    onError: function onError(err) {
                                                                        if ((err === null || err === void 0 ? void 0 : err.message) === "Detected popup close") {
                                                                            error_logging_service/* default.logTrace */.Z.logTrace("PayPal payment canceled");
                                                                            resolve({
                                                                                success: true,
                                                                                code: "cancelled"
                                                                            });
                                                                        } else {
                                                                            error_logging_service/* default.logError */.Z.logError(err, {
                                                                                page: "donations",
                                                                                action: "generic paypal error"
                                                                            });
                                                                            uiEvents.onError(DonationModels/* PaymentErrorType.Paypal */.zW.Paypal, err);
                                                                            resolve({
                                                                                success: false,
                                                                                code: "cancelled"
                                                                            });
                                                                        }
                                                                    },
                                                                    style: {
                                                                        color: "blue",
                                                                        //shape:  'pill',
                                                                        label: "pay",
                                                                        height: 40,
                                                                        size: "responsive"
                                                                    }
                                                                }).render("#paypal-button");
                                                            case 13:
                                                                // The PayPal button will be rendered in an html element with the ID `paypal-button`.
                                                                error_logging_service/* default.logTrace */.Z.logTrace("THE PAYPAL BUTTON IS SET UP AND READY TO USE");
                                                                return _ctx3.abrupt("return", {
                                                                    success: true,
                                                                    error: null,
                                                                    paypalCheckoutInstance: paypalSetupResult
                                                                });
                                                            case 17:
                                                                _ctx3.prev = 17;
                                                                _ctx3.t0 = _ctx3["catch"](1);
                                                                error_logging_service/* default.logError */.Z.logError(_ctx3.t0, _ctx3.t0);
                                                                uiEvents.onError(DonationModels/* PaymentErrorType.Paypal */.zW.Paypal, _ctx3.t0);
                                                                return _ctx3.abrupt("return", {
                                                                    success: false,
                                                                    error: _ctx3.t0
                                                                });
                                                            case 22:
                                                                _ctx3.prev = 22;
                                                                error_logging_service/* default.logTrace */.Z.logTrace("paypal finally block executing");
                                                                return _ctx3.finish(22);
                                                            case 25:
                                                            case "end":
                                                                return _ctx3.stop();
                                                        }
                                                    }, _callee3, null, [
                                                        [
                                                            1,
                                                            17,
                                                            22,
                                                            25
                                                        ]
                                                    ]);
                                                }));
                                                return function(resolve, reject) {
                                                    return _ref3.apply(this, arguments);
                                                };
                                            }());
                                            return _ctx2.abrupt("return", paypalInitPromise);
                                        case 2:
                                        case "end":
                                            return _ctx2.stop();
                                    }
                                }, _callee2);
                            }));
                            return function waitForPaypalInit() {
                                return _ref2.apply(this, arguments);
                            };
                        }();
                        _ctx1.prev = 1;
                        timeoutPromise = new Promise(function(res) {
                            return setTimeout(function() {
                                return res({
                                    success: false,
                                    code: "timed_out_waiting_for_paypal_init"
                                });
                            }, 10000);
                        });
                        _ctx1.next = 5;
                        return Promise.race([
                            timeoutPromise,
                            waitForPaypalInit()
                        ]);
                    case 5:
                        paypalInitResult = _ctx1.sent;
                        error_logging_service/* default.logTrace */.Z.logTrace("paypal init result", paypalInitResult);
                        return _ctx1.abrupt("return", paypalInitResult);
                    case 10:
                        _ctx1.prev = 10;
                        _ctx1.t0 = _ctx1["catch"](1);
                        error_logging_service/* default.logTrace */.Z.logTrace("paypal init error: " + _ctx1.t0.message, {
                            error: _ctx1.t0
                        });
                        return _ctx1.abrupt("return", {
                            success: false,
                            error: _ctx1.t0
                        });
                    case 14:
                        _ctx1.prev = 14;
                        error_logging_service/* default.logTrace */.Z.logTrace("paypal init finally");
                        return _ctx1.finish(14);
                    case 17:
                    case "end":
                        return _ctx1.stop();
                }
            }, _callee1, null, [
                [
                    1,
                    10,
                    14,
                    17
                ]
            ]);
        }));
        return function(transactionLogId, token, paymentInfo, uiEvents, makePaymentGeneric, branch) {
            return _ref1.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var bt_paypal_service = (PaypalService);

// EXTERNAL MODULE: ./node_modules/braintree-web/dist/browser/three-d-secure.js
var three_d_secure = __webpack_require__(7040);
;// CONCATENATED MODULE: ./utils/regions.ts
var getRegionCode = function(branch, name) {
    console.log("getting region codes for branch:", branch);
    if (!branch || !name) {
        console.log("no branch or no state", branch, name);
        return null;
    }
    var localRegions = allRegions[branch];
    if (localRegions) {
        for(var i = 0; i < localRegions.length; i++){
            var regionConfig = localRegions[i];
            if (regionConfig.Code.toLowerCase() == name.toLowerCase() || regionConfig.Name.toLowerCase() === name.toLowerCase()) {
                console.log("found region code", regionConfig);
                return regionConfig.Code;
            }
        }
        console.log("went through them all, found nadda");
        return null;
    }
    console.log("no local regions");
    return null;
};
var allRegions = {
    UK: [
        {
            Code: "ABE",
            Name: "Aberdeen City"
        },
        {
            Code: "ABD",
            Name: "Aberdeenshire"
        },
        {
            Code: "ANS",
            Name: "Angus"
        },
        {
            Code: "ANN",
            Name: "Antrim and Newtownabbey"
        },
        {
            Code: "AND",
            Name: "Ards and North Down"
        },
        {
            Code: "AGB",
            Name: "Argyll and Bute"
        },
        {
            Code: "ABC",
            Name: "Armagh City, Banbridge and Craigavon"
        },
        {
            Code: "BDG",
            Name: "Barking and Dagenham"
        },
        {
            Code: "BNE",
            Name: "Barnet"
        },
        {
            Code: "BNS",
            Name: "Barnsley"
        },
        {
            Code: "BAS",
            Name: "Bath and North East Somerset"
        },
        {
            Code: "BDF",
            Name: "Bedford"
        },
        {
            Code: "BFS",
            Name: "Belfast City"
        },
        {
            Code: "BEX",
            Name: "Bexley"
        },
        {
            Code: "BIR",
            Name: "Birmingham"
        },
        {
            Code: "BBD",
            Name: "Blackburn with Darwen"
        },
        {
            Code: "BPL",
            Name: "Blackpool"
        },
        {
            Code: "BGW",
            Name: "Blaenau Gwent"
        },
        {
            Code: "BOL",
            Name: "Bolton"
        },
        {
            Code: "BCP",
            Name: "Bournemouth, Christchurch and Poole"
        },
        {
            Code: "BRC",
            Name: "Bracknell Forest"
        },
        {
            Code: "BRD",
            Name: "Bradford"
        },
        {
            Code: "BEN",
            Name: "Brent"
        },
        {
            Code: "BGE",
            Name: "Bridgend\xa0[Pen-y-bont ar Ogwr\xa0GB-POG]"
        },
        {
            Code: "BNH",
            Name: "Brighton and Hove"
        },
        {
            Code: "BST",
            Name: "Bristol, City of"
        },
        {
            Code: "BRY",
            Name: "Bromley"
        },
        {
            Code: "BKM",
            Name: "Buckinghamshire"
        },
        {
            Code: "BUR",
            Name: "Bury"
        },
        {
            Code: "CAY",
            Name: "Caerphilly\xa0[Caerffili\xa0GB-CAF]"
        },
        {
            Code: "CLD",
            Name: "Calderdale"
        },
        {
            Code: "CAM",
            Name: "Cambridgeshire"
        },
        {
            Code: "CMD",
            Name: "Camden"
        },
        {
            Code: "CRF",
            Name: "Cardiff\xa0[Caerdydd\xa0GB-CRD]"
        },
        {
            Code: "CMN",
            Name: "Carmarthenshire\xa0[Sir Gaerfyrddin\xa0GB-GFY]"
        },
        {
            Code: "CCG",
            Name: "Causeway Coast and Glens"
        },
        {
            Code: "CBF",
            Name: "Central Bedfordshire"
        },
        {
            Code: "CGN",
            Name: "Ceredigion\xa0[Sir Ceredigion]"
        },
        {
            Code: "CHE",
            Name: "Cheshire East"
        },
        {
            Code: "CHW",
            Name: "Cheshire West and Chester"
        },
        {
            Code: "CLK",
            Name: "Clackmannanshire"
        },
        {
            Code: "CWY",
            Name: "Conwy"
        },
        {
            Code: "CON",
            Name: "Cornwall"
        },
        {
            Code: "COV",
            Name: "Coventry"
        },
        {
            Code: "CRY",
            Name: "Croydon"
        },
        {
            Code: "CMA",
            Name: "Cumbria"
        },
        {
            Code: "DAL",
            Name: "Darlington"
        },
        {
            Code: "DEN",
            Name: "Denbighshire\xa0[Sir Ddinbych\xa0GB-DDB]"
        },
        {
            Code: "DER",
            Name: "Derby"
        },
        {
            Code: "DBY",
            Name: "Derbyshire"
        },
        {
            Code: "DRS",
            Name: "Derry and Strabane"
        },
        {
            Code: "DEV",
            Name: "Devon"
        },
        {
            Code: "DNC",
            Name: "Doncaster"
        },
        {
            Code: "DOR",
            Name: "Dorset"
        },
        {
            Code: "DUD",
            Name: "Dudley"
        },
        {
            Code: "DGY",
            Name: "Dumfries and Galloway"
        },
        {
            Code: "DND",
            Name: "Dundee City"
        },
        {
            Code: "DUR",
            Name: "Durham, County"
        },
        {
            Code: "EAL",
            Name: "Ealing"
        },
        {
            Code: "EAY",
            Name: "East Ayrshire"
        },
        {
            Code: "EDU",
            Name: "East Dunbartonshire"
        },
        {
            Code: "ELN",
            Name: "East Lothian"
        },
        {
            Code: "ERW",
            Name: "East Renfrewshire"
        },
        {
            Code: "ERY",
            Name: "East Riding of Yorkshire"
        },
        {
            Code: "ESX",
            Name: "East Sussex"
        },
        {
            Code: "EDH",
            Name: "Edinburgh, City of"
        },
        {
            Code: "ELS",
            Name: "Eilean Siar"
        },
        {
            Code: "ENF",
            Name: "Enfield"
        },
        {
            Code: "ESS",
            Name: "Essex"
        },
        {
            Code: "FAL",
            Name: "Falkirk"
        },
        {
            Code: "FMO",
            Name: "Fermanagh and Omagh"
        },
        {
            Code: "FIF",
            Name: "Fife"
        },
        {
            Code: "FLN",
            Name: "Flintshire\xa0[Sir y Fflint\xa0GB-FFL]"
        },
        {
            Code: "GAT",
            Name: "Gateshead"
        },
        {
            Code: "GLG",
            Name: "Glasgow City"
        },
        {
            Code: "GLS",
            Name: "Gloucestershire"
        },
        {
            Code: "GRE",
            Name: "Greenwich"
        },
        {
            Code: "GWN",
            Name: "Gwynedd"
        },
        {
            Code: "HCK",
            Name: "Hackney"
        },
        {
            Code: "HAL",
            Name: "Halton"
        },
        {
            Code: "HMF",
            Name: "Hammersmith and Fulham"
        },
        {
            Code: "HAM",
            Name: "Hampshire"
        },
        {
            Code: "HRY",
            Name: "Haringey"
        },
        {
            Code: "HRW",
            Name: "Harrow"
        },
        {
            Code: "HPL",
            Name: "Hartlepool"
        },
        {
            Code: "HAV",
            Name: "Havering"
        },
        {
            Code: "HEF",
            Name: "Herefordshire"
        },
        {
            Code: "HRT",
            Name: "Hertfordshire"
        },
        {
            Code: "HLD",
            Name: "Highland"
        },
        {
            Code: "HIL",
            Name: "Hillingdon"
        },
        {
            Code: "HNS",
            Name: "Hounslow"
        },
        {
            Code: "IVC",
            Name: "Inverclyde"
        },
        {
            Code: "AGY",
            Name: "Isle of Anglesey\xa0[Sir Ynys M\xf4n\xa0GB-YNM]"
        },
        {
            Code: "IOW",
            Name: "Isle of Wight"
        },
        {
            Code: "IOS",
            Name: "Isles of Scilly"
        },
        {
            Code: "ISL",
            Name: "Islington"
        },
        {
            Code: "KEC",
            Name: "Kensington and Chelsea"
        },
        {
            Code: "KEN",
            Name: "Kent"
        },
        {
            Code: "KHL",
            Name: "Kingston upon Hull"
        },
        {
            Code: "KTT",
            Name: "Kingston upon Thames"
        },
        {
            Code: "KIR",
            Name: "Kirklees"
        },
        {
            Code: "KWL",
            Name: "Knowsley"
        },
        {
            Code: "LBH",
            Name: "Lambeth"
        },
        {
            Code: "LAN",
            Name: "Lancashire"
        },
        {
            Code: "LDS",
            Name: "Leeds"
        },
        {
            Code: "LCE",
            Name: "Leicester"
        },
        {
            Code: "LEC",
            Name: "Leicestershire"
        },
        {
            Code: "LEW",
            Name: "Lewisham"
        },
        {
            Code: "LIN",
            Name: "Lincolnshire"
        },
        {
            Code: "LBC",
            Name: "Lisburn and Castlereagh"
        },
        {
            Code: "LIV",
            Name: "Liverpool"
        },
        {
            Code: "LND",
            Name: "London, City of"
        },
        {
            Code: "LUT",
            Name: "Luton"
        },
        {
            Code: "MAN",
            Name: "Manchester"
        },
        {
            Code: "MDW",
            Name: "Medway"
        },
        {
            Code: "MTY",
            Name: "Merthyr Tydfil\xa0[Merthyr Tudful\xa0GB-MTU]"
        },
        {
            Code: "MRT",
            Name: "Merton"
        },
        {
            Code: "MEA",
            Name: "Mid and East Antrim"
        },
        {
            Code: "MDB",
            Name: "Middlesbrough"
        },
        {
            Code: "MLN",
            Name: "Midlothian"
        },
        {
            Code: "MUL",
            Name: "Mid-Ulster"
        },
        {
            Code: "MIK",
            Name: "Milton Keynes"
        },
        {
            Code: "MON",
            Name: "Monmouthshire\xa0[Sir Fynwy\xa0GB-FYN]"
        },
        {
            Code: "MRY",
            Name: "Moray"
        },
        {
            Code: "NTL",
            Name: "Neath Port Talbot\xa0[Castell-nedd Port Talbot\xa0GB-CTL]"
        },
        {
            Code: "NET",
            Name: "Newcastle upon Tyne"
        },
        {
            Code: "NWM",
            Name: "Newham"
        },
        {
            Code: "NWP",
            Name: "Newport\xa0[Casnewydd\xa0GB-CNW]"
        },
        {
            Code: "NMD",
            Name: "Newry, Mourne and Down"
        },
        {
            Code: "NFK",
            Name: "Norfolk"
        },
        {
            Code: "NAY",
            Name: "North Ayrshire"
        },
        {
            Code: "NEL",
            Name: "North East Lincolnshire"
        },
        {
            Code: "NLK",
            Name: "North Lanarkshire"
        },
        {
            Code: "NLN",
            Name: "North Lincolnshire"
        },
        {
            Code: "NSM",
            Name: "North Somerset"
        },
        {
            Code: "NTY",
            Name: "North Tyneside"
        },
        {
            Code: "NYK",
            Name: "North Yorkshire"
        },
        {
            Code: "NTH",
            Name: "Northamptonshire"
        },
        {
            Code: "NBL",
            Name: "Northumberland"
        },
        {
            Code: "NGM",
            Name: "Nottingham"
        },
        {
            Code: "NTT",
            Name: "Nottinghamshire"
        },
        {
            Code: "OLD",
            Name: "Oldham"
        },
        {
            Code: "ORK",
            Name: "Orkney Islands"
        },
        {
            Code: "OXF",
            Name: "Oxfordshire"
        },
        {
            Code: "PEM",
            Name: "Pembrokeshire\xa0[Sir Benfro\xa0GB-BNF]"
        },
        {
            Code: "PKN",
            Name: "Perth and Kinross"
        },
        {
            Code: "PTE",
            Name: "Peterborough"
        },
        {
            Code: "PLY",
            Name: "Plymouth"
        },
        {
            Code: "POR",
            Name: "Portsmouth"
        },
        {
            Code: "POW",
            Name: "Powys"
        },
        {
            Code: "RDG",
            Name: "Reading"
        },
        {
            Code: "RDB",
            Name: "Redbridge"
        },
        {
            Code: "RCC",
            Name: "Redcar and Cleveland"
        },
        {
            Code: "RFW",
            Name: "Renfrewshire"
        },
        {
            Code: "RCT",
            Name: "Rhondda Cynon Taff\xa0[Rhondda CynonTaf]"
        },
        {
            Code: "RIC",
            Name: "Richmond upon Thames"
        },
        {
            Code: "RCH",
            Name: "Rochdale"
        },
        {
            Code: "ROT",
            Name: "Rotherham"
        },
        {
            Code: "RUT",
            Name: "Rutland"
        },
        {
            Code: "SLF",
            Name: "Salford"
        },
        {
            Code: "SAW",
            Name: "Sandwell"
        },
        {
            Code: "SCB",
            Name: "Scottish Borders"
        },
        {
            Code: "SFT",
            Name: "Sefton"
        },
        {
            Code: "SHF",
            Name: "Sheffield"
        },
        {
            Code: "ZET",
            Name: "Shetland Islands"
        },
        {
            Code: "SHR",
            Name: "Shropshire"
        },
        {
            Code: "SLG",
            Name: "Slough"
        },
        {
            Code: "SOL",
            Name: "Solihull"
        },
        {
            Code: "SOM",
            Name: "Somerset"
        },
        {
            Code: "SAY",
            Name: "South Ayrshire"
        },
        {
            Code: "SGC",
            Name: "South Gloucestershire"
        },
        {
            Code: "SLK",
            Name: "South Lanarkshire"
        },
        {
            Code: "STY",
            Name: "South Tyneside"
        },
        {
            Code: "STH",
            Name: "Southampton"
        },
        {
            Code: "SOS",
            Name: "Southend-on-Sea"
        },
        {
            Code: "SWK",
            Name: "Southwark"
        },
        {
            Code: "SHN",
            Name: "St. Helens"
        },
        {
            Code: "STS",
            Name: "Staffordshire"
        },
        {
            Code: "STG",
            Name: "Stirling"
        },
        {
            Code: "SKP",
            Name: "Stockport"
        },
        {
            Code: "STT",
            Name: "Stockton-on-Tees"
        },
        {
            Code: "STE",
            Name: "Stoke-on-Trent"
        },
        {
            Code: "SFK",
            Name: "Suffolk"
        },
        {
            Code: "SND",
            Name: "Sunderland"
        },
        {
            Code: "SRY",
            Name: "Surrey"
        },
        {
            Code: "STN",
            Name: "Sutton"
        },
        {
            Code: "SWA",
            Name: "Swansea\xa0[Abertawe\xa0GB-ATA]"
        },
        {
            Code: "SWD",
            Name: "Swindon"
        },
        {
            Code: "TAM",
            Name: "Tameside"
        },
        {
            Code: "TFW",
            Name: "Telford and Wrekin"
        },
        {
            Code: "THR",
            Name: "Thurrock"
        },
        {
            Code: "TOB",
            Name: "Torbay"
        },
        {
            Code: "TOF",
            Name: "Torfaen\xa0[Tor-faen]"
        },
        {
            Code: "TWH",
            Name: "Tower Hamlets"
        },
        {
            Code: "TRF",
            Name: "Trafford"
        },
        {
            Code: "VGL",
            Name: "Vale of Glamorgan, The\xa0[Bro Morgannwg\xa0GB-BMG]"
        },
        {
            Code: "WKF",
            Name: "Wakefield"
        },
        {
            Code: "WLL",
            Name: "Walsall"
        },
        {
            Code: "WFT",
            Name: "Waltham Forest"
        },
        {
            Code: "WND",
            Name: "Wandsworth"
        },
        {
            Code: "WRT",
            Name: "Warrington"
        },
        {
            Code: "WAR",
            Name: "Warwickshire"
        },
        {
            Code: "WBK",
            Name: "West Berkshire"
        },
        {
            Code: "WDU",
            Name: "West Dunbartonshire"
        },
        {
            Code: "WLN",
            Name: "West Lothian"
        },
        {
            Code: "WSX",
            Name: "West Sussex"
        },
        {
            Code: "WSM",
            Name: "Westminster"
        },
        {
            Code: "WGN",
            Name: "Wigan"
        },
        {
            Code: "WIL",
            Name: "Wiltshire"
        },
        {
            Code: "WNM",
            Name: "Windsor and Maidenhead"
        },
        {
            Code: "WRL",
            Name: "Wirral"
        },
        {
            Code: "WOK",
            Name: "Wokingham"
        },
        {
            Code: "WLV",
            Name: "Wolverhampton"
        },
        {
            Code: "WOR",
            Name: "Worcestershire"
        },
        {
            Code: "WRX",
            Name: "Wrexham\xa0[Wrecsam\xa0GB-WRC]"
        },
        {
            Code: "YOR",
            Name: "York"
        }
    ],
    NL: [
        {
            Code: "DR",
            Name: "Drenthe"
        },
        {
            Code: "FL",
            Name: "Flevoland"
        },
        {
            Code: "FR",
            Name: "Frysl\xe2n (fy)"
        },
        {
            Code: "GE",
            Name: "Gelderland"
        },
        {
            Code: "GR",
            Name: "Groningen"
        },
        {
            Code: "LI",
            Name: "Limburg"
        },
        {
            Code: "NB",
            Name: "Noord-Brabant"
        },
        {
            Code: "NH",
            Name: "Noord-Holland"
        },
        {
            Code: "OV",
            Name: "Overijssel"
        },
        {
            Code: "UT",
            Name: "Utrecht"
        },
        {
            Code: "ZE",
            Name: "Zeeland"
        },
        {
            Code: "ZH",
            Name: "Zuid-Holland"
        }
    ],
    US: [
        {
            Code: "AL",
            Name: "Alabama"
        },
        {
            Code: "AK",
            Name: "Alaska"
        },
        {
            Code: "AZ",
            Name: "Arizona"
        },
        {
            Code: "AR",
            Name: "Arkansas"
        },
        {
            Code: "CA",
            Name: "California"
        },
        {
            Code: "CO",
            Name: "Colorado"
        },
        {
            Code: "CT",
            Name: "Connecticut"
        },
        {
            Code: "DE",
            Name: "Delaware"
        },
        {
            Code: "FL",
            Name: "Florida"
        },
        {
            Code: "GA",
            Name: "Georgia"
        },
        {
            Code: "HI",
            Name: "Hawaii"
        },
        {
            Code: "ID",
            Name: "Idaho"
        },
        {
            Code: "IL",
            Name: "Illinois"
        },
        {
            Code: "IN",
            Name: "Indiana"
        },
        {
            Code: "IA",
            Name: "Iowa"
        },
        {
            Code: "KS",
            Name: "Kansas"
        },
        {
            Code: "KY",
            Name: "Kentucky"
        },
        {
            Code: "LA",
            Name: "Louisiana"
        },
        {
            Code: "ME",
            Name: "Maine"
        },
        {
            Code: "MD",
            Name: "Maryland"
        },
        {
            Code: "MA",
            Name: "Massachusetts"
        },
        {
            Code: "MI",
            Name: "Michigan"
        },
        {
            Code: "MN",
            Name: "Minnesota"
        },
        {
            Code: "MS",
            Name: "Mississippi"
        },
        {
            Code: "MO",
            Name: "Missouri"
        },
        {
            Code: "MT",
            Name: "Montana"
        },
        {
            Code: "NE",
            Name: "Nebraska"
        },
        {
            Code: "NV",
            Name: "Nevada"
        },
        {
            Code: "NH",
            Name: "New Hampshire"
        },
        {
            Code: "NJ",
            Name: "New Jersey"
        },
        {
            Code: "NM",
            Name: "New Mexico"
        },
        {
            Code: "NY",
            Name: "New York"
        },
        {
            Code: "NC",
            Name: "North Carolina"
        },
        {
            Code: "ND",
            Name: "North Dakota"
        },
        {
            Code: "OH",
            Name: "Ohio"
        },
        {
            Code: "OK",
            Name: "Oklahoma"
        },
        {
            Code: "OR",
            Name: "Oregon"
        },
        {
            Code: "PA",
            Name: "Pennsylvania"
        },
        {
            Code: "RI",
            Name: "Rhode Island"
        },
        {
            Code: "SC",
            Name: "South Carolina"
        },
        {
            Code: "SD",
            Name: "South Dakota"
        },
        {
            Code: "TN",
            Name: "Tennessee"
        },
        {
            Code: "TX",
            Name: "Texas"
        },
        {
            Code: "UT",
            Name: "Utah"
        },
        {
            Code: "VT",
            Name: "Vermont"
        },
        {
            Code: "VA",
            Name: "Virginia"
        },
        {
            Code: "WA",
            Name: "Washington"
        },
        {
            Code: "WV",
            Name: "West Virginia"
        },
        {
            Code: "WI",
            Name: "Wisconsin"
        },
        {
            Code: "WY",
            Name: "Wyoming"
        },
        {
            Code: "DC",
            Name: "District of Columbia"
        },
        {
            Code: "AS",
            Name: "American Samoa"
        },
        {
            Code: "GU",
            Name: "Guam"
        },
        {
            Code: "MP",
            Name: "Northern Mariana Islands"
        },
        {
            Code: "PR",
            Name: "Puerto Rico"
        },
        {
            Code: "UM",
            Name: "United States Minor Outlying Islands"
        },
        {
            Code: "VI",
            Name: "U.S. Virgin Islands"
        }
    ],
    DE: [
        {
            Code: "BW",
            Name: "Baden-W\xfcrttemberg"
        },
        {
            Code: "BY",
            Name: "Bavaria"
        },
        {
            Code: "BE",
            Name: "Berlin"
        },
        {
            Code: "BB",
            Name: "Brandenburg"
        },
        {
            Code: "HB",
            Name: "Bremen"
        },
        {
            Code: "HH",
            Name: "Hamburg"
        },
        {
            Code: "HE",
            Name: "Hesse"
        },
        {
            Code: "MV",
            Name: "Mecklenburg-Western Pomerania"
        },
        {
            Code: "NI",
            Name: "Lower Saxony"
        },
        {
            Code: "NW",
            Name: "North Rhine-Westphalia"
        },
        {
            Code: "RP",
            Name: "Rhineland-Palatinate"
        },
        {
            Code: "SL",
            Name: "Saarland"
        },
        {
            Code: "SN",
            Name: "Saxony"
        },
        {
            Code: "ST",
            Name: "Saxony-Anhalt"
        },
        {
            Code: "SH",
            Name: "Schleswig-Holstein"
        },
        {
            Code: "TH",
            Name: "Thuringia"
        }
    ]
};
/* harmony default export */ var regions = ((/* unused pure expression or super */ null && (allRegions)));

;// CONCATENATED MODULE: ./services/braintree/bt-three-d-secure-service.ts
function bt_three_d_secure_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function bt_three_d_secure_service_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                bt_three_d_secure_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                bt_three_d_secure_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var ThreeDSecureService = {
    create: function() {
        var _ref = bt_three_d_secure_service_asyncToGenerator(runtime_default().mark(function _callee(authToken) {
            var tds;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return three_d_secure.create({
                            authorization: authToken,
                            version: 2
                        });
                    case 3:
                        tds = _ctx.sent;
                        return _ctx.abrupt("return", {
                            success: true,
                            tds: tds
                        });
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        error_logging_service/* default.logError */.Z.logError(_ctx.t0);
                        return _ctx.abrupt("return", {
                            success: false,
                            error: _ctx.t0
                        });
                    case 11:
                        _ctx.prev = 11;
                        error_logging_service/* default.logTrace */.Z.logTrace("Finished Creating TDS", null);
                        return _ctx.finish(11);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7,
                    11,
                    14
                ]
            ]);
        }));
        return function(authToken) {
            return _ref.apply(this, arguments);
        };
    }(),
    //https://braintree.github.io/braintree-web/current/ThreeDSecure.html#verifyCard
    verifyCard: function() {
        var _ref = bt_three_d_secure_service_asyncToGenerator(runtime_default().mark(function _callee(tds, totalAmount, tokenizationPayload, paymentInfo, branch) {
            var verifyCardResult, info;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return tds.verifyCard({
                            onLookupComplete: function(data, next) {
                                error_logging_service/* default.logTrace */.Z.logTrace("on lookup complete 3ds", {
                                    data: data
                                });
                                next();
                            },
                            amount: totalAmount,
                            nonce: tokenizationPayload.nonce,
                            bin: tokenizationPayload.details.bin,
                            email: paymentInfo.address.email,
                            billingAddress: {
                                givenName: paymentInfo.address.firstName,
                                surname: paymentInfo.address.lastName,
                                phoneNumber: Address.getFullPhoneNumber(paymentInfo.address).replace(/[\(\)\s\-]/g, ""),
                                streetAddress: paymentInfo.address.address1,
                                extendedAddress: paymentInfo.address.address2,
                                locality: paymentInfo.address.city,
                                region: getRegionCode(branch, paymentInfo.address.state),
                                postalCode: paymentInfo.address.zip,
                                countryCodeAlpha2: paymentInfo.address.country.code
                            }
                        });
                    case 3:
                        verifyCardResult = _ctx.sent;
                        info = verifyCardResult.threeDSecureInfo;
                        if (!((info.liabilityShifted || !info.liabilityShiftPossible) && verifyCardResult.nonce)) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            success: true,
                            verifyCardResult: verifyCardResult
                        });
                    case 7:
                        return _ctx.abrupt("return", {
                            success: false,
                            error: {
                                code: "-999",
                                message: "could_not_verify"
                            }
                        });
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        error_logging_service/* default.logError */.Z.logError(_ctx.t0, {
                            type: "3ds_verifiy"
                        });
                        return _ctx.abrupt("return", {
                            success: false,
                            error: _ctx.t0
                        });
                    case 14:
                        _ctx.prev = 14;
                        error_logging_service/* default.logTrace */.Z.logTrace("finished 3ds verify card call");
                        return _ctx.finish(14);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10,
                    14,
                    17
                ]
            ]);
        }));
        return function(tds, totalAmount, tokenizationPayload, paymentInfo, branch) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var bt_three_d_secure_service = (ThreeDSecureService);

// EXTERNAL MODULE: ./node_modules/braintree-web/dist/browser/apple-pay.js
var apple_pay = __webpack_require__(918);
;// CONCATENATED MODULE: ./services/braintree/apple-pay/bt-apple-pay-service.ts
function bt_apple_pay_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function bt_apple_pay_service_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                bt_apple_pay_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                bt_apple_pay_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var ApplePayService = {
    deviceSupportsApplePay: function() {
        return window.ApplePaySession && window.ApplePaySession.supportsVersion(3) && window.ApplePaySession.canMakePayments();
    },
    makePayment: function() {
        var _ref1 = bt_apple_pay_service_asyncToGenerator(runtime_default().mark(function _callee1(transactionLogId, branch, authorizationToken, paymentInfo, uiEvents, makePaymentGeneric, companyNameLabel) {
            var applePayInstance, paymentRequest, session, noncePromise;
            return runtime_default().wrap(function _callee$(_ctx1) {
                while(1)switch(_ctx1.prev = _ctx1.next){
                    case 0:
                        _ctx1.prev = 0;
                        error_logging_service/* default.logTrace */.Z.logTrace("Apple pay started");
                        _ctx1.next = 4;
                        return apple_pay.create({
                            authorization: authorizationToken
                        });
                    case 4:
                        applePayInstance = _ctx1.sent;
                        error_logging_service/* default.logTrace */.Z.logTrace("Apple pay instance created", {
                            applePayInstance: applePayInstance
                        });
                        paymentRequest = applePayInstance.createPaymentRequest({
                            total: {
                                label: companyNameLabel || "Vision for Israel",
                                amount: braintree_config/* default.getTotalAmountString */.Z.getTotalAmountString(paymentInfo.netAmount, paymentInfo.coverTransactionCosts)
                            },
                            requiredBillingContactFields: [
                                "postalAddress"
                            ]
                        });
                        error_logging_service/* default.logTrace */.Z.logTrace("Apple pay payment request created", {
                            paymentRequest: paymentRequest
                        });
                        paymentRequest.currencyCode = paymentInfo.currencyCode;
                        error_logging_service/* default.logTrace */.Z.logTrace("Apple pay currency code updated", {
                            currency: paymentRequest.currencyCode
                        });
                        session = new window.ApplePaySession(3, paymentRequest);
                        error_logging_service/* default.logTrace */.Z.logTrace("Apple pay session created", {
                            session: session
                        });
                        noncePromise = new Promise(function(resolve, reject) {
                            session.onvalidatemerchant = function() {
                                var _ref = bt_apple_pay_service_asyncToGenerator(runtime_default().mark(function _callee(event) {
                                    var merchantSession;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                _ctx.prev = 0;
                                                error_logging_service/* default.logTrace */.Z.logTrace("Apple pay on validate merchant", {
                                                    event: event
                                                });
                                                _ctx.next = 4;
                                                return applePayInstance.performValidation({
                                                    validationURL: event.validationURL,
                                                    displayName: "VFI"
                                                });
                                            case 4:
                                                merchantSession = _ctx.sent;
                                                error_logging_service/* default.logTrace */.Z.logTrace("Apple pay merchant session created", {
                                                    merchantSession: merchantSession
                                                });
                                                session.completeMerchantValidation(merchantSession);
                                                error_logging_service/* default.logTrace */.Z.logTrace("Apple pay completed merchant validation", {
                                                    merchantSession: merchantSession
                                                });
                                                resolve({
                                                    success: true
                                                });
                                                _ctx.next = 16;
                                                break;
                                            case 11:
                                                _ctx.prev = 11;
                                                _ctx.t0 = _ctx["catch"](0);
                                                // You should show an error to the user, e.g. 'Apple Pay failed to load.'
                                                error_logging_service/* default.logError */.Z.logError(_ctx.t0, {
                                                    doingWhat: "validating apple pay merchant"
                                                });
                                                session.abort();
                                                reject({
                                                    success: false,
                                                    error: _ctx.t0
                                                });
                                            case 16:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee, null, [
                                        [
                                            0,
                                            11
                                        ]
                                    ]);
                                }));
                                return function(event) {
                                    return _ref.apply(this, arguments);
                                };
                            }();
                            session.onpaymentauthorized = function() {
                                var _ref = bt_apple_pay_service_asyncToGenerator(runtime_default().mark(function _callee(event) {
                                    var payload;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                _ctx.prev = 0;
                                                error_logging_service/* default.logTrace */.Z.logTrace("Apple pay was authorized ok", {
                                                    event: event
                                                });
                                                _ctx.next = 4;
                                                return applePayInstance.tokenize({
                                                    token: event.payment.token
                                                });
                                            case 4:
                                                payload = _ctx.sent;
                                                error_logging_service/* default.logTrace */.Z.logTrace("Apple pay was tokenized ok", {
                                                    event: event
                                                });
                                                _ctx.next = 8;
                                                return makePaymentGeneric(transactionLogId, DonationModels/* PaymentMethod.APPLE */.XL.APPLE, branch, payload.nonce, paymentInfo, uiEvents, null, authorizationToken);
                                            case 8:
                                                error_logging_service/* default.logTrace */.Z.logTrace("Apple pay payment was made", {
                                                    event: event
                                                });
                                                // call `completePayment` to dismiss the Apple Pay sheet.
                                                session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
                                                error_logging_service/* default.logTrace */.Z.logTrace("Apple pay payment was completed", {
                                                    event: event
                                                });
                                                resolve({
                                                    success: true
                                                });
                                                _ctx.next = 19;
                                                break;
                                            case 14:
                                                _ctx.prev = 14;
                                                _ctx.t0 = _ctx["catch"](0);
                                                error_logging_service/* default.logError */.Z.logError(_ctx.t0, {
                                                    doingWhat: "Error tokenizing Apple Pay:"
                                                });
                                                session.completePayment(window.ApplePaySession.STATUS_FAILURE);
                                                reject("error tokenizing apple pay");
                                            case 19:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee, null, [
                                        [
                                            0,
                                            14
                                        ]
                                    ]);
                                }));
                                return function(event) {
                                    return _ref.apply(this, arguments);
                                };
                            }();
                            session.oncancel = function() {
                                var _ref = bt_apple_pay_service_asyncToGenerator(runtime_default().mark(function _callee(event) {
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                try {
                                                    error_logging_service/* default.logTrace */.Z.logTrace("Apple pay was cancelled by user", {
                                                        event: event
                                                    });
                                                    resolve({
                                                        success: true
                                                    });
                                                } catch (error) {
                                                    error_logging_service/* default.logError */.Z.logError(error, {
                                                        doingWhat: "error when cancelling apple pay, aborting session"
                                                    });
                                                    session.abort();
                                                    reject("error cancelling apple pay");
                                                }
                                            case 1:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(event) {
                                    return _ref.apply(this, arguments);
                                };
                            }();
                            error_logging_service/* default.logTrace */.Z.logTrace("Apple pay about to begin session");
                            session.begin();
                            error_logging_service/* default.logTrace */.Z.logTrace("Apple pay session began");
                        });
                        return _ctx1.abrupt("return", noncePromise);
                    case 16:
                        _ctx1.prev = 16;
                        _ctx1.t0 = _ctx1["catch"](0);
                        error_logging_service/* default.logError */.Z.logError(_ctx1.t0);
                        return _ctx1.abrupt("return", {
                            success: false,
                            error: _ctx1.t0
                        });
                    case 20:
                    case "end":
                        return _ctx1.stop();
                }
            }, _callee1, null, [
                [
                    0,
                    16
                ]
            ]);
        }));
        return function(transactionLogId, branch, authorizationToken, paymentInfo, uiEvents, makePaymentGeneric, companyNameLabel) {
            return _ref1.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var bt_apple_pay_service = (ApplePayService);

;// CONCATENATED MODULE: ./services/braintree/shared/braintree-client-service.ts
function braintree_client_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function braintree_client_service_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                braintree_client_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                braintree_client_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

















var braintree_client_service_reCAPTCHA_site_key = (0,next_config["default"])().publicRuntimeConfig.recaptchaSiteKey;
var data_token_key = "data-token";
var transaction_log_id_key = "transaction-log-id";
///This class handles interaction with the braintree api from the front end
/// it calls the backend to make the payment then handles returning success or error messages to the component
/// it calls out to various payment-type sepcific services for credit card, paypal etc
var braintreeClientService = {
    getVerificationUrl: function(paymentInfo, uiEvents) {
        var config = (0,next_config["default"])().publicRuntimeConfig;
        var branch = regionHelpers/* default.findBranchFromCountryCode */.Z.findBranchFromCountryCode(paymentInfo.address.country.code);
        error_logging_service/* default.logTrace */.Z.logTrace("branch", {
            branch: branch
        });
        if (!branch || !braintree_config/* default.validateBranch */.Z.validateBranch(branch)) {
            error_logging_service/* default.logTrace */.Z.logTrace("invalid branch", {
                branch: branch
            });
            uiEvents.onError(DonationModels/* PaymentErrorType.Server */.zW.Server, null);
            return null;
        }
        var merchantId = config.braintreeClientTokens[branch].merchantId;
        var domain = config.braintreeEnvironment === DonationModels/* BraintreeEnvironment.PRODUCTION */._d.PRODUCTION ? "www" : "sandbox";
        return "https://".concat(domain, ".braintreegateway.com/merchants/").concat(merchantId, "/verified");
    },
    // when we finish filling in the address popup, and click proceed having chosen "credit card"
    // we need to intialise the braintree credit card form
    // this involves registering our form with braintree "hosted fields" which will automaticaly validate our credit card input
    // and on successful submission provide us with a secure encrypted token representing the user's card details
    // we can submit to our server without storing the credit card details or ever transferring them over the network
    initPaymentForm: function() {
        var _ref1 = braintree_client_service_asyncToGenerator(runtime_default().mark(function _callee1(paymentForm, getPaymentInfo, uiEvents, paymentProviderButtons) {
            var paymentInfo, branch, clientTokenResult, transactionLogResult, transactionLogId, promiseResults, paypalResult, creditCardInitResult, tdsCreateResult, ref, onSubmitMakeCreditCardPayment;
            return runtime_default().wrap(function _callee$(_ctx1) {
                while(1)switch(_ctx1.prev = _ctx1.next){
                    case 0:
                        _ctx1.prev = 0;
                        paymentInfo = getPaymentInfo();
                        uiEvents.showLoading();
                        error_logging_service/* default.logTrace */.Z.logTrace("payment info", {
                            paymentInfo: paymentInfo
                        });
                        branch = regionHelpers/* default.findBranchFromCountryCode */.Z.findBranchFromCountryCode(paymentInfo.address.country.code);
                        error_logging_service/* default.logTrace */.Z.logTrace("branch", {
                            branch: branch
                        });
                        if (!(!branch || !braintree_config/* default.validateBranch */.Z.validateBranch(branch))) {
                            _ctx1.next = 10;
                            break;
                        }
                        error_logging_service/* default.logTrace */.Z.logTrace("invalid branch", {
                            branch: branch
                        });
                        uiEvents.onError(DonationModels/* PaymentErrorType.Server */.zW.Server, null);
                        return _ctx1.abrupt("return");
                    case 10:
                        _ctx1.next = 12;
                        return getClientToken(branch, paymentInfo.currencyCode);
                    case 12:
                        clientTokenResult = _ctx1.sent;
                        error_logging_service/* default.logTrace */.Z.logTrace("clientTokenResult", {
                            clientTokenResult: clientTokenResult
                        });
                        if (!(!clientTokenResult.success || !clientTokenResult.token)) {
                            _ctx1.next = 18;
                            break;
                        }
                        error_logging_service/* default.logError */.Z.logError(clientTokenResult.error, {
                            id: "init_payment_form",
                            paymentInfo: paymentInfo,
                            branch: branch
                        });
                        uiEvents.onError(DonationModels/* PaymentErrorType.Server */.zW.Server, clientTokenResult.error);
                        return _ctx1.abrupt("return");
                    case 18:
                        _ctx1.next = 20;
                        return logTransactionStart(paymentInfo, branch);
                    case 20:
                        transactionLogResult = _ctx1.sent;
                        if (!(!transactionLogResult.success || !transactionLogResult.id)) {
                            _ctx1.next = 25;
                            break;
                        }
                        error_logging_service/* default.logTrace */.Z.logTrace("Transaction log start error");
                        uiEvents.onError(DonationModels/* PaymentErrorType.Server */.zW.Server, null);
                        return _ctx1.abrupt("return");
                    case 25:
                        transactionLogId = transactionLogResult.id.toString();
                        paymentForm.setAttribute(transaction_log_id_key, transactionLogId);
                        setupPaymentProviderButtons(paymentProviderButtons, branch, clientTokenResult.token, paymentInfo, transactionLogId);
                        error_logging_service/* default.logTrace */.Z.logTrace("Setup payment provider buttons");
                        _ctx1.next = 31;
                        return Promise.all([
                            bt_paypal_service.init(transactionLogId, clientTokenResult.token, paymentInfo, uiEvents, makePaymentGeneric, branch),
                            bt_credit_card_service.create(clientTokenResult.token, paymentInfo, uiEvents),
                            bt_three_d_secure_service.create(clientTokenResult.token)
                        ]);
                    case 31:
                        promiseResults = _ctx1.sent;
                        paypalResult = promiseResults[0];
                        creditCardInitResult = promiseResults[1];
                        tdsCreateResult = promiseResults[2];
                        if (paypalResult.success) {
                            _ctx1.next = 40;
                            break;
                        }
                        // hide paypal button, inform withlove
                        error_logging_service/* default.logTrace */.Z.logTrace("Error initialising paypal", {
                            paypalResult: paypalResult
                        });
                        return _ctx1.abrupt("return");
                    case 40:
                        {
                            ;
                            error_logging_service/* default.logTrace */.Z.logTrace("setting paypal button to be visible", {
                                button: paymentProviderButtons.paypalButton
                            });
                            (ref = paymentProviderButtons.paypalButton) === null || ref === void 0 ? void 0 : ref.setAttribute("style", "display: flex !important");
                        }
                    case 41:
                        if (tdsCreateResult.success) {
                            _ctx1.next = 45;
                            break;
                        }
                        error_logging_service/* default.logTrace */.Z.logTrace("error creating tds", {
                            tdsCreateResult: tdsCreateResult
                        });
                        uiEvents.onError(DonationModels/* PaymentErrorType.ThreeDS */.zW.ThreeDS, "error_creating_3ds");
                        return _ctx1.abrupt("return");
                    case 45:
                        if (creditCardInitResult.success) {
                            _ctx1.next = 49;
                            break;
                        }
                        error_logging_service/* default.logTrace */.Z.logTrace("credit card init failure", {
                            creditCardInitResult: creditCardInitResult
                        });
                        uiEvents.onError(DonationModels/* PaymentErrorType.CreditCard */.zW.CreditCard, "error_creating_credit_card");
                        return _ctx1.abrupt("return");
                    case 49:
                        onSubmitMakeCreditCardPayment = function() {
                            var _ref = braintree_client_service_asyncToGenerator(runtime_default().mark(function _callee(event) {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.prev = 0;
                                            event.preventDefault();
                                            _ctx.next = 4;
                                            return tokenizeCardAndMakePayment(transactionLogResult.id.toString(), creditCardInitResult, branch, getPaymentInfo, uiEvents, paypalResult, tdsCreateResult.tds, clientTokenResult.token);
                                        case 4:
                                            _ctx.next = 9;
                                            break;
                                        case 6:
                                            _ctx.prev = 6;
                                            _ctx.t0 = _ctx["catch"](0);
                                            uiEvents.onError(DonationModels/* PaymentErrorType.CreditCard */.zW.CreditCard, _ctx.t0);
                                        case 9:
                                            _ctx.prev = 9;
                                            uiEvents.hideLoading();
                                            return _ctx.finish(9);
                                        case 12:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee, null, [
                                    [
                                        0,
                                        6,
                                        9,
                                        12
                                    ]
                                ]);
                            }));
                            return function onSubmitMakeCreditCardPayment(event) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        "";
                        paymentForm.addEventListener("submit", onSubmitMakeCreditCardPayment, false);
                        _ctx1.next = 58;
                        break;
                    case 54:
                        _ctx1.prev = 54;
                        _ctx1.t0 = _ctx1["catch"](0);
                        error_logging_service/* default.logError */.Z.logError(_ctx1.t0, {
                            page: "donations",
                            action: "payment-error"
                        });
                        uiEvents.onError(DonationModels/* PaymentErrorType.Server */.zW.Server, null);
                    case 58:
                        _ctx1.prev = 58;
                        uiEvents.hideLoading();
                        error_logging_service/* default.logTrace */.Z.logTrace("Payment init form complete");
                        return _ctx1.finish(58);
                    case 62:
                    case "end":
                        return _ctx1.stop();
                }
            }, _callee1, null, [
                [
                    0,
                    54,
                    58,
                    62
                ]
            ]);
        }));
        return function(paymentForm, getPaymentInfo, uiEvents, paymentProviderButtons) {
            return _ref1.apply(this, arguments);
        };
    }(),
    payWithLocalPaymentProvider: function() {
        var _ref = braintree_client_service_asyncToGenerator(runtime_default().mark(function _callee(paymentProvider, button, paymentInfo, uiEvents, locale, redirectButtonText) {
            var branch, token, transactionLogId, paymentResult;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        uiEvents.showLoading();
                        branch = regionHelpers/* default.findBranchFromCountryCode */.Z.findBranchFromCountryCode(paymentInfo.address.country.code);
                        if (branch) {
                            _ctx.next = 7;
                            break;
                        }
                        error_logging_service/* default.logMessage */.Z.logMessage("Could not get branch when making a ".concat(paymentProvider, "  payment"));
                        uiEvents.onError(bt_local_payment_service.getErrorType(paymentProvider), {
                            name: "".concat(paymentProvider, "_error"),
                            message: "could not get branch"
                        });
                        return _ctx.abrupt("return");
                    case 7:
                        token = button === null || button === void 0 ? void 0 : button.getAttribute(data_token_key);
                        if (token) {
                            _ctx.next = 12;
                            break;
                        }
                        error_logging_service/* default.logMessage */.Z.logMessage("Could not get auth token when making a ".concat(paymentProvider, "  payment"));
                        uiEvents.onError(bt_local_payment_service.getErrorType(paymentProvider), null);
                        return _ctx.abrupt("return");
                    case 12:
                        transactionLogId = button === null || button === void 0 ? void 0 : button.getAttribute(transaction_log_id_key);
                        if (transactionLogId) {
                            _ctx.next = 17;
                            break;
                        }
                        error_logging_service/* default.logMessage */.Z.logMessage("Could not get transactionLogId when making a ".concat(paymentProvider, "  payment"));
                        uiEvents.onError(bt_local_payment_service.getErrorType(paymentProvider), null);
                        return _ctx.abrupt("return");
                    case 17:
                        _ctx.next = 19;
                        return bt_local_payment_service.createPayment(transactionLogId, paymentProvider, token, branch, paymentInfo, locale, redirectButtonText);
                    case 19:
                        paymentResult = _ctx.sent;
                        if (!paymentResult.success) {
                            _ctx.next = 27;
                            break;
                        }
                        if (!paymentResult.nonce) {
                            _ctx.next = 24;
                            break;
                        }
                        _ctx.next = 24;
                        return makePaymentGeneric(transactionLogId, DonationModels/* PaymentMethod.LOCAL */.XL.LOCAL, branch, paymentResult.nonce, paymentInfo, uiEvents, null, token);
                    case 24:
                        if (paymentResult.suspectedDropOff) {
                            uiEvents.handleSuspectedDropOff();
                        }
                        _ctx.next = 28;
                        break;
                    case 27:
                        {
                            uiEvents.onError(bt_local_payment_service.getErrorType(paymentProvider), paymentResult.error);
                        }
                    case 28:
                        _ctx.next = 33;
                        break;
                    case 30:
                        _ctx.prev = 30;
                        _ctx.t0 = _ctx["catch"](0);
                        uiEvents.onError(bt_local_payment_service.getErrorType(paymentProvider), _ctx.t0);
                    case 33:
                        _ctx.prev = 33;
                        uiEvents.hideLoading();
                        return _ctx.finish(33);
                    case 36:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    30,
                    33,
                    36
                ]
            ]);
        }));
        return function(paymentProvider, button, paymentInfo, uiEvents, locale, redirectButtonText) {
            return _ref.apply(this, arguments);
        };
    }(),
    payWithVenmo: function() {
        var _ref = braintree_client_service_asyncToGenerator(runtime_default().mark(function _callee(venmoButtonRef, paymentInfo, uiEvents) {
            var branch, token, transactionLogId, nonceResult;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        uiEvents.showLoading();
                        branch = regionHelpers/* default.findBranchFromCountryCode */.Z.findBranchFromCountryCode(paymentInfo.address.country.code);
                        if (branch) {
                            _ctx.next = 7;
                            break;
                        }
                        error_logging_service/* default.logMessage */.Z.logMessage("Could not get branch when making a venmo payment");
                        uiEvents.onError(DonationModels/* PaymentErrorType.Venmo */.zW.Venmo, {
                            name: "venmo_error",
                            message: "could not get branch"
                        });
                        return _ctx.abrupt("return");
                    case 7:
                        token = venmoButtonRef === null || venmoButtonRef === void 0 ? void 0 : venmoButtonRef.getAttribute(data_token_key);
                        if (token) {
                            _ctx.next = 12;
                            break;
                        }
                        error_logging_service/* default.logMessage */.Z.logMessage("Could not get auth token when making an venmo payment");
                        uiEvents.onError(DonationModels/* PaymentErrorType.Venmo */.zW.Venmo, null);
                        return _ctx.abrupt("return");
                    case 12:
                        transactionLogId = venmoButtonRef === null || venmoButtonRef === void 0 ? void 0 : venmoButtonRef.getAttribute(transaction_log_id_key);
                        if (transactionLogId) {
                            _ctx.next = 17;
                            break;
                        }
                        error_logging_service/* default.logMessage */.Z.logMessage("Could not get transactionLogId when making a venmo payment");
                        uiEvents.onError(DonationModels/* PaymentErrorType.Venmo */.zW.Venmo, null);
                        return _ctx.abrupt("return");
                    case 17:
                        _ctx.next = 19;
                        return bt_venmo_service.payWithVenmo(token, paymentInfo);
                    case 19:
                        nonceResult = _ctx.sent;
                        if (!nonceResult.nonce) {
                            _ctx.next = 25;
                            break;
                        }
                        _ctx.next = 23;
                        return makePaymentGeneric(transactionLogId, DonationModels/* PaymentMethod.VENMO */.XL.VENMO, branch, nonceResult.nonce, paymentInfo, uiEvents, null, token);
                    case 23:
                        _ctx.next = 26;
                        break;
                    case 25:
                        {
                            if (!nonceResult.success) {
                                uiEvents.onError(DonationModels/* PaymentErrorType.Venmo */.zW.Venmo, nonceResult.error);
                            } else {
                                error_logging_service/* default.logTrace */.Z.logTrace("venmo cancelled");
                            }
                        }
                    case 26:
                        _ctx.next = 31;
                        break;
                    case 28:
                        _ctx.prev = 28;
                        _ctx.t0 = _ctx["catch"](0);
                        uiEvents.onError(DonationModels/* PaymentErrorType.Venmo */.zW.Venmo, _ctx.t0);
                    case 31:
                        _ctx.prev = 31;
                        uiEvents.hideLoading();
                        return _ctx.finish(31);
                    case 34:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    28,
                    31,
                    34
                ]
            ]);
        }));
        return function(venmoButtonRef, paymentInfo, uiEvents) {
            return _ref.apply(this, arguments);
        };
    }(),
    payWithGoogle: function() {
        var _ref = braintree_client_service_asyncToGenerator(runtime_default().mark(function _callee(googleButtonRef, paymentInfo, uiEvents) {
            var branch, clientTokenResult, transactionLogId, nonceResult;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        branch = regionHelpers/* default.findBranchFromCountryCode */.Z.findBranchFromCountryCode(paymentInfo.address.country.code);
                        if (branch) {
                            _ctx.next = 5;
                            break;
                        }
                        error_logging_service/* default.logMessage */.Z.logMessage("Could not get branch when making a google payment");
                        return _ctx.abrupt("return");
                    case 5:
                        _ctx.next = 7;
                        return getClientToken(branch, paymentInfo.currencyCode);
                    case 7:
                        clientTokenResult = _ctx.sent;
                        if (!(!clientTokenResult.success || !clientTokenResult.token)) {
                            _ctx.next = 12;
                            break;
                        }
                        error_logging_service/* default.logError */.Z.logError(clientTokenResult.error, {
                            id: "init_payment_form",
                            paymentInfo: paymentInfo,
                            branch: branch
                        });
                        uiEvents.onError(DonationModels/* PaymentErrorType.Server */.zW.Server, clientTokenResult.error);
                        return _ctx.abrupt("return");
                    case 12:
                        transactionLogId = googleButtonRef === null || googleButtonRef === void 0 ? void 0 : googleButtonRef.getAttribute(transaction_log_id_key);
                        if (transactionLogId) {
                            _ctx.next = 17;
                            break;
                        }
                        error_logging_service/* default.logMessage */.Z.logMessage("Could not get transactionLogId when making a google payment");
                        uiEvents.onError(DonationModels/* PaymentErrorType.Google */.zW.Google, null);
                        return _ctx.abrupt("return");
                    case 17:
                        _ctx.next = 19;
                        return bt_google_pay_service.makePayment(clientTokenResult.token, paymentInfo);
                    case 19:
                        nonceResult = _ctx.sent;
                        if (!nonceResult.nonce) {
                            _ctx.next = 25;
                            break;
                        }
                        _ctx.next = 23;
                        return makePaymentGeneric(transactionLogId, DonationModels/* PaymentMethod.GOOGLE */.XL.GOOGLE, branch, nonceResult.nonce, paymentInfo, uiEvents, null, clientTokenResult.token);
                    case 23:
                        _ctx.next = 26;
                        break;
                    case 25:
                        {
                            uiEvents.onError(DonationModels/* PaymentErrorType.Google */.zW.Google, {
                                name: "google_error",
                                message: "no nonce"
                            });
                        }
                    case 26:
                        _ctx.next = 32;
                        break;
                    case 28:
                        _ctx.prev = 28;
                        _ctx.t0 = _ctx["catch"](0);
                        error_logging_service/* default.logError */.Z.logError(_ctx.t0);
                        uiEvents.onError(DonationModels/* PaymentErrorType.Google */.zW.Google, _ctx.t0);
                    case 32:
                        _ctx.prev = 32;
                        uiEvents.hideLoading();
                        return _ctx.finish(32);
                    case 35:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    28,
                    32,
                    35
                ]
            ]);
        }));
        return function(googleButtonRef, paymentInfo, uiEvents) {
            return _ref.apply(this, arguments);
        };
    }(),
    payWithApple: function() {
        var _ref = braintree_client_service_asyncToGenerator(runtime_default().mark(function _callee(applePayButton, paymentInfo, uiEvents, companyNameLabel) {
            var branch, authToken, transactionLogId, applePayResult;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        uiEvents.showLoading();
                        branch = regionHelpers/* default.findBranchFromCountryCode */.Z.findBranchFromCountryCode(paymentInfo.address.country.code);
                        if (branch) {
                            _ctx.next = 7;
                            break;
                        }
                        error_logging_service/* default.logMessage */.Z.logMessage("Could not get branch when making an apple payment");
                        uiEvents.onError(DonationModels/* PaymentErrorType.ApplePay */.zW.ApplePay, null);
                        return _ctx.abrupt("return");
                    case 7:
                        authToken = applePayButton === null || applePayButton === void 0 ? void 0 : applePayButton.getAttribute(data_token_key);
                        if (authToken) {
                            _ctx.next = 12;
                            break;
                        }
                        error_logging_service/* default.logMessage */.Z.logMessage("Could not get auth token when making an apple payment");
                        uiEvents.onError(DonationModels/* PaymentErrorType.ApplePay */.zW.ApplePay, null);
                        return _ctx.abrupt("return");
                    case 12:
                        transactionLogId = applePayButton === null || applePayButton === void 0 ? void 0 : applePayButton.getAttribute(transaction_log_id_key);
                        if (transactionLogId) {
                            _ctx.next = 17;
                            break;
                        }
                        error_logging_service/* default.logMessage */.Z.logMessage("Could not get transactionLogId when making an apple payment");
                        uiEvents.onError(DonationModels/* PaymentErrorType.Google */.zW.Google, null);
                        return _ctx.abrupt("return");
                    case 17:
                        _ctx.next = 19;
                        return bt_apple_pay_service.makePayment(transactionLogId, branch, authToken, paymentInfo, uiEvents, makePaymentGeneric, companyNameLabel);
                    case 19:
                        applePayResult = _ctx.sent;
                        if (!applePayResult.success) {
                            error_logging_service/* default.logMessage */.Z.logMessage("failed apple pay attempt", {
                                result: applePayResult
                            });
                            uiEvents.onError(DonationModels/* PaymentErrorType.ApplePay */.zW.ApplePay, null);
                        }
                        _ctx.next = 27;
                        break;
                    case 23:
                        _ctx.prev = 23;
                        _ctx.t0 = _ctx["catch"](0);
                        error_logging_service/* default.logError */.Z.logError(_ctx.t0);
                        uiEvents.onError(DonationModels/* PaymentErrorType.ApplePay */.zW.ApplePay, _ctx.t0);
                    case 27:
                        _ctx.prev = 27;
                        uiEvents.hideLoading();
                        return _ctx.finish(27);
                    case 30:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    23,
                    27,
                    30
                ]
            ]);
        }));
        return function(applePayButton, paymentInfo, uiEvents, companyNameLabel) {
            return _ref.apply(this, arguments);
        };
    }()
};
var setupPaymentProviderButtons = function(paymentProviderButtons, branch, authToken, paymentInfo, transactionLogId) {
    var ref, ref1, ref2, ref3;
    var showElement = function(elementHolder) {
        elementHolder.setShow(true);
        elementHolder.button.setAttribute(data_token_key, authToken);
        elementHolder.button.setAttribute(transaction_log_id_key, transactionLogId);
    };
    var hideElement = function(elementHolder) {
        elementHolder.setShow(false);
        elementHolder.button.setAttribute(data_token_key, "");
    };
    if ((ref = paymentProviderButtons.applePay) === null || ref === void 0 ? void 0 : ref.button) {
        if (bt_apple_pay_service.deviceSupportsApplePay()) {
            error_logging_service/* default.logTrace */.Z.logTrace("This device supports version 3 of Apple Pay.");
            showElement(paymentProviderButtons.applePay);
        } else {
            error_logging_service/* default.logTrace */.Z.logTrace("device does not support apple pay, hiding apple pay button", paymentProviderButtons.applePay.button);
            hideElement(paymentProviderButtons.applePay);
        }
    }
    if ((ref1 = paymentProviderButtons.venmo) === null || ref1 === void 0 ? void 0 : ref1.button) {
        if (bt_venmo_service.branchSupportedByVenmo(branch)) {
            showElement(paymentProviderButtons.venmo);
        } else {
            hideElement(paymentProviderButtons.venmo);
        }
    }
    if ((ref2 = paymentProviderButtons.klarna) === null || ref2 === void 0 ? void 0 : ref2.button) {
        if (bt_local_payment_service.supportsLocalPaymentMethod(DonationModels/* LocalPaymentProviders.Klarna */.x_.Klarna, paymentInfo)) {
            showElement(paymentProviderButtons.klarna);
        } else {
            hideElement(paymentProviderButtons.klarna);
        }
    }
    if ((ref3 = paymentProviderButtons.ideal) === null || ref3 === void 0 ? void 0 : ref3.button) {
        if (bt_local_payment_service.supportsLocalPaymentMethod(DonationModels/* LocalPaymentProviders.iDeal */.x_.iDeal, paymentInfo)) {
            showElement(paymentProviderButtons.ideal);
        } else {
            hideElement(paymentProviderButtons.ideal);
        }
    }
};
/* harmony default export */ var braintree_client_service = (braintreeClientService);
//PRIVATE METHODS
var logTransactionStart = function() {
    var _ref = braintree_client_service_asyncToGenerator(runtime_default().mark(function _callee(paymentDetails, branch) {
        var url, response, paymentResult;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    url = "/api/donations/checkout/".concat(branch, "/log-transaction-start");
                    _ctx.next = 4;
                    return fetch(url, {
                        method: "POST",
                        body: JSON.stringify({
                            paymentDetails: paymentDetails
                        }),
                        headers: {
                            "Content-Type": "application/json"
                        }
                    });
                case 4:
                    response = _ctx.sent;
                    if (!response.ok) {
                        _ctx.next = 10;
                        break;
                    }
                    _ctx.next = 8;
                    return response.json();
                case 8:
                    paymentResult = _ctx.sent;
                    return _ctx.abrupt("return", paymentResult);
                case 10:
                    return _ctx.abrupt("return", {
                        success: false,
                        id: null
                    });
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    error_logging_service/* default.logTrace */.Z.logTrace("local payment error", {
                        error: _ctx.t0
                    });
                    error_logging_service/* default.logError */.Z.logError(_ctx.t0);
                    return _ctx.abrupt("return", {
                        success: false,
                        id: null
                    });
                case 18:
                    _ctx.prev = 18;
                    return _ctx.finish(18);
                case 20:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13,
                18,
                20
            ]
        ]);
    }));
    return function logTransactionStart(paymentDetails, branch) {
        return _ref.apply(this, arguments);
    };
}();
//todo - move this to the credit card service
var tokenizeCardAndMakePayment = function() {
    var _ref = braintree_client_service_asyncToGenerator(runtime_default().mark(function _callee(transactionLogId, creditCardInitResult, branch, getFieldValues, uiEvents, paypalInitResult, tds, clientAuthToken) {
        var paymentInfo, tokenizationPayload, interimBasketForInfoOnly, tdsVerifyCardResult;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    if (paypalInitResult === null || paypalInitResult === void 0 ? void 0 : paypalInitResult.paypalButtonActions) {
                        error_logging_service/* default.logTrace */.Z.logTrace("disabling paypal buttons");
                        paypalInitResult.paypalButtonActions.disable();
                    }
                    paymentInfo = getFieldValues();
                    _ctx.next = 5;
                    return bt_credit_card_service.tokenizeCard(creditCardInitResult.hostedFieldsInstance, paymentInfo);
                case 5:
                    tokenizationPayload = _ctx.sent;
                    if (tokenizationPayload) {
                        _ctx.next = 9;
                        break;
                    }
                    uiEvents.onError(DonationModels/* PaymentErrorType.CreditCard */.zW.CreditCard, {
                        message: "tokenization_error"
                    });
                    return _ctx.abrupt("return");
                case 9:
                    uiEvents.onSubmit();
                    _ctx.next = 12;
                    return getBasket(uiEvents, paymentInfo, DonationModels/* PaymentMethod.CREDIT_CARD */.XL.CREDIT_CARD, tokenizationPayload.nonce, null);
                case 12:
                    interimBasketForInfoOnly = _ctx.sent;
                    if (interimBasketForInfoOnly) {
                        _ctx.next = 16;
                        break;
                    }
                    uiEvents.onError(DonationModels/* PaymentErrorType.CreditCard */.zW.CreditCard, {
                        message: "no_basket_error"
                    });
                    return _ctx.abrupt("return");
                case 16:
                    _ctx.next = 18;
                    return bt_three_d_secure_service.verifyCard(tds, interimBasketForInfoOnly.totalAmount, tokenizationPayload, paymentInfo, branch);
                case 18:
                    tdsVerifyCardResult = _ctx.sent;
                    if (tdsVerifyCardResult.success) {
                        _ctx.next = 23;
                        break;
                    }
                    uiEvents.onError(DonationModels/* PaymentErrorType.ThreeDS */.zW.ThreeDS, tdsVerifyCardResult.error);
                    uiEvents.hideLoading();
                    return _ctx.abrupt("return");
                case 23:
                    error_logging_service/* default.logTrace */.Z.logTrace("Successful 3ds validation");
                    interimBasketForInfoOnly.braintree_payment_nonce = tdsVerifyCardResult.verifyCardResult.nonce;
                    _ctx.next = 27;
                    return makePaymentGeneric(transactionLogId, DonationModels/* PaymentMethod.CREDIT_CARD */.XL.CREDIT_CARD, branch, interimBasketForInfoOnly.braintree_payment_nonce, paymentInfo, uiEvents, paypalInitResult, clientAuthToken);
                case 27:
                    _ctx.next = 34;
                    break;
                case 29:
                    _ctx.prev = 29;
                    _ctx.t0 = _ctx["catch"](0);
                    error_logging_service/* default.logError */.Z.logError(_ctx.t0, {
                        type: "tokenize_card_and_make_payment"
                    });
                    uiEvents.onError(DonationModels/* PaymentErrorType.CreditCard */.zW.CreditCard, _ctx.t0);
                    uiEvents.hideLoading();
                case 34:
                    _ctx.prev = 34;
                    error_logging_service/* default.logTrace */.Z.logTrace("finished tokenize card and make payment");
                    if (paypalInitResult === null || paypalInitResult === void 0 ? void 0 : paypalInitResult.paypalButtonActions) {
                        paypalInitResult.paypalButtonActions.enable();
                    }
                    return _ctx.finish(34);
                case 38:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                29,
                34,
                38
            ]
        ]);
    }));
    return function tokenizeCardAndMakePayment(transactionLogId, creditCardInitResult, branch, getFieldValues, uiEvents, paypalInitResult, tds, clientAuthToken) {
        return _ref.apply(this, arguments);
    };
}();
var getBasket = function() {
    var _ref = braintree_client_service_asyncToGenerator(runtime_default().mark(function _callee(uiEvents, paymentInfo, paymentMethod, nonce, deviceData) {
        var recaptchaToken, basket;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return security_service.getRecaptchaToken("submit");
                case 2:
                    recaptchaToken = _ctx.sent;
                    if (recaptchaToken) {
                        _ctx.next = 6;
                        break;
                    }
                    uiEvents.onError(DonationModels/* PaymentErrorType.Recaptcha */.zW.Recaptcha, {
                        errorCodes: [
                            "Do you have an adblocker or a password manager enabled? These can intefere with our anti-fraud detection. Please disable them and try again."
                        ]
                    });
                    return _ctx.abrupt("return");
                case 6:
                    basket = paymentInfo.isRecurring ? new DonationModels/* RecurringPaymentBasket */.bm(nonce, paymentMethod, paymentInfo, recaptchaToken, deviceData) : new DonationModels/* SinglePaymentBasket */.Qn(nonce, paymentMethod, paymentInfo, recaptchaToken, deviceData);
                    return _ctx.abrupt("return", basket);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBasket(uiEvents, paymentInfo, paymentMethod, nonce, deviceData) {
        return _ref.apply(this, arguments);
    };
}();
///Once we have the braintree payment nonce, we can hit the same backend method to process the transaction for any payment type
// regardless whether it is paypal, credit card, apple pay or other
var makePaymentGeneric = function() {
    var _ref = braintree_client_service_asyncToGenerator(runtime_default().mark(function _callee(transactionLogId, paymentMethod, branch, nonce, paymentInfo, uiEvents, paypalInitResult, clientAuthToken) {
        var deviceDataResult, basket, transactionType, url, response, paymentResult, transactionId;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    uiEvents.showLoading();
                    _ctx.next = 4;
                    return braintree_config/* default.getDeviceData */.Z.getDeviceData(clientAuthToken, paymentMethod === DonationModels/* PaymentMethod.PAYPAL */.XL.PAYPAL);
                case 4:
                    deviceDataResult = _ctx.sent;
                    if (deviceDataResult.success) {
                        _ctx.next = 10;
                        break;
                    }
                    error_logging_service/* default.logError */.Z.logError(deviceDataResult.error, {
                        id: "init_payment_form",
                        type: "device_data"
                    });
                    //todo - unify error type with payment type somehow
                    uiEvents.onError(DonationModels/* PaymentErrorType.CreditCard */.zW.CreditCard, deviceDataResult.error);
                    uiEvents.hideLoading();
                    return _ctx.abrupt("return");
                case 10:
                    _ctx.next = 12;
                    return getBasket(uiEvents, paymentInfo, paymentMethod, nonce, deviceDataResult.deviceData);
                case 12:
                    basket = _ctx.sent;
                    if (basket) {
                        _ctx.next = 15;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 15:
                    transactionType = paymentInfo.isRecurring ? "recurring" : "single";
                    url = "/api/donations/checkout/".concat(transactionType, "-transaction/").concat(branch);
                    _ctx.next = 19;
                    return fetch(url, {
                        method: "POST",
                        body: JSON.stringify({
                            transactionLogId: transactionLogId,
                            paymentDetails: basket,
                            twoLetterLanguageCode: paymentInfo.twoLetterLanguageCode
                        }),
                        headers: {
                            "Content-Type": "application/json"
                        }
                    });
                case 19:
                    response = _ctx.sent;
                    _ctx.next = 22;
                    return response.json();
                case 22:
                    paymentResult = _ctx.sent;
                    if (!response.ok) {
                        _ctx.next = 33;
                        break;
                    }
                    error_logging_service/* default.logMessage */.Z.logMessage("We made a ".concat(paymentMethod, " ").concat(transactionType, " payment! Firing onSuccess"), paymentResult);
                    if (!(paypalInitResult === null || paypalInitResult === void 0 ? void 0 : paypalInitResult.paypalCheckoutInstance)) {
                        _ctx.next = 28;
                        break;
                    }
                    _ctx.next = 28;
                    return paypalInitResult.paypalCheckoutInstance.teardown();
                case 28:
                    transactionId = paymentInfo.isRecurring ? paymentResult.subscriptionId : paymentResult.transactionId;
                    paymentInfo.isRecurring ? analytics_service.logRecurringDonation(basket, transactionId) : analytics_service.logSingleDonation(basket, transactionId);
                    paymentInfo.onSuccess(paymentInfo.isRecurring ? paymentResult.subscriptionId : paymentResult.transactionId);
                    _ctx.next = 34;
                    break;
                case 33:
                    {
                        if (paymentResult.recaptchaError) {
                            uiEvents.onError(DonationModels/* PaymentErrorType.Recaptcha */.zW.Recaptcha, paymentResult);
                        } else if (paymentMethod === DonationModels/* PaymentMethod.PAYPAL */.XL.PAYPAL) {
                            uiEvents.onError(DonationModels/* PaymentErrorType.Paypal */.zW.Paypal, paymentResult);
                        } else {
                            uiEvents.onError(DonationModels/* PaymentErrorType.CreditCard */.zW.CreditCard, paymentResult);
                        }
                    }
                case 34:
                    if (paypalInitResult === null || paypalInitResult === void 0 ? void 0 : paypalInitResult.paypalButtonActions) {
                        paypalInitResult.paypalButtonActions.enable();
                    }
                    _ctx.next = 41;
                    break;
                case 37:
                    _ctx.prev = 37;
                    _ctx.t0 = _ctx["catch"](0);
                    error_logging_service/* default.logError */.Z.logError(_ctx.t0, {
                        page: "donations",
                        action: "error-making-payment",
                        paymentMethod: paymentMethod
                    });
                    uiEvents.onError(DonationModels/* PaymentErrorType.Server */.zW.Server, _ctx.t0);
                case 41:
                    _ctx.prev = 41;
                    uiEvents.hideLoading();
                    return _ctx.finish(41);
                case 44:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                37,
                41,
                44
            ]
        ]);
    }));
    return function makePaymentGeneric(transactionLogId, paymentMethod, branch, nonce, paymentInfo, uiEvents, paypalInitResult, clientAuthToken) {
        return _ref.apply(this, arguments);
    };
}();
var getTransactionDetails = function() {
    var _ref = braintree_client_service_asyncToGenerator(runtime_default().mark(function _callee(transactionLogId) {
        var response, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetch("/api/donations/get-transaction?tlid=".concat(transactionLogId), {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json"
                        }
                    });
                case 2:
                    response = _ctx.sent;
                    if (response.ok) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        success: false,
                        transactionLogId: transactionLogId
                    });
                case 5:
                    _ctx.next = 7;
                    return response.json();
                case 7:
                    result = _ctx.sent;
                    console.log("get transaction details result", result);
                    return _ctx.abrupt("return", result === null || result === void 0 ? void 0 : result.result);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTransactionDetails(transactionLogId) {
        return _ref.apply(this, arguments);
    };
}();
var getClientToken = function() {
    var _ref = braintree_client_service_asyncToGenerator(runtime_default().mark(function _callee(branch, currency) {
        var tokenResponse, tokenObj, _$error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return fetch("/api/donations/token/".concat(branch, "/").concat(currency), {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json"
                        }
                    });
                case 3:
                    tokenResponse = _ctx.sent;
                    if (!tokenResponse.ok) {
                        _ctx.next = 11;
                        break;
                    }
                    _ctx.next = 7;
                    return tokenResponse.json();
                case 7:
                    tokenObj = _ctx.sent;
                    return _ctx.abrupt("return", {
                        success: true,
                        token: tokenObj.token
                    });
                case 11:
                    _$error = new Error("".concat(tokenResponse.status));
                    error_logging_service/* default.logError */.Z.logError(_$error, {
                        branch: branch,
                        currency: currency
                    });
                    return _ctx.abrupt("return", {
                        success: false,
                        error: _$error
                    });
                case 14:
                    _ctx.next = 20;
                    break;
                case 16:
                    _ctx.prev = 16;
                    _ctx.t0 = _ctx["catch"](0);
                    error_logging_service/* default.logError */.Z.logError(_ctx.t0, {
                        branch: branch,
                        currency: currency
                    });
                    return _ctx.abrupt("return", {
                        success: false,
                        error: _ctx.t0
                    });
                case 20:
                    _ctx.prev = 20;
                    error_logging_service/* default.logTrace */.Z.logTrace("Finally in get client token");
                    return _ctx.finish(20);
                case 23:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                16,
                20,
                23
            ]
        ]);
    }));
    return function getClientToken(branch, currency) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./slices/DonatePayNow/PayNowPopup/style.ts
function PayNowPopup_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

// Theme-dependent styles
var PayNowPopup_style_styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5, _obj6, _obj7;
    return (0,createStyles/* default */.Z)({
        payNowPopupWrapper: (_obj = {
            padding: theme.spacing(4),
            display: "flex",
            flexDirection: "column",
            color: "#4c4c78",
            fontFamily: "Raleway,Assistant",
            position: "relative"
        }, PayNowPopup_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            padding: theme.spacing(3)
        }), PayNowPopup_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            padding: theme.spacing(2)
        }), _obj),
        modalTitle: (_obj1 = {
            textTransform: "uppercase",
            fontWeight: 900,
            textAlign: "center",
            marginBottom: theme.spacing(4)
        }, PayNowPopup_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            marginBottom: theme.spacing(3)
        }), PayNowPopup_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            marginBottom: theme.spacing(2)
        }), _obj1),
        generalError: (_obj2 = {
            color: "red",
            fontWeight: 500,
            fontSize: 16,
            marginLeft: 0
        }, PayNowPopup_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            fontSize: 14,
            marginLeft: 0
        }), PayNowPopup_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
            fontSize: 14,
            marginLeft: 0
        }), _obj2),
        fieldError: (_obj3 = {
            color: "red",
            marginTop: 2,
            position: "absolute",
            fontWeight: 500,
            fontSize: 12,
            marginLeft: 16
        }, PayNowPopup_style_defineProperty(_obj3, theme.breakpoints.down("sm"), {
            fontSize: 11.5,
            marginLeft: 12
        }), PayNowPopup_style_defineProperty(_obj3, theme.breakpoints.down("xs"), {
            fontSize: 11,
            marginLeft: 8
        }), _obj3),
        paypalErrors: (_obj4 = {
            color: "red",
            fontWeight: 500,
            fontSize: 16,
            marginTop: 16
        }, PayNowPopup_style_defineProperty(_obj4, theme.breakpoints.down("sm"), {
            fontSize: 15,
            marginTop: 12
        }), PayNowPopup_style_defineProperty(_obj4, theme.breakpoints.down("xs"), {
            fontSize: 14,
            marginTop: 8
        }), _obj4),
        cardSize: {
            fontSize: 40
        },
        totalAmt: {
            fontFamily: "Raleway,Assistant",
            fontSize: 16,
            fontWeight: 700,
            color: "#4c4c78",
            textAlign: "center",
            margin: theme.spacing(1, 0, 0)
        },
        braintreeEntryField: (_obj6 = {
            fontFamily: "Raleway,Assistant",
            paddingLeft: 16,
            paddingRight: 16,
            borderRadius: 6,
            backgroundColor: "#ecf1f2",
            height: 48,
            display: "flex",
            alignItems: "center",
            position: "relative"
        }, PayNowPopup_style_defineProperty(_obj6, theme.breakpoints.down("sm"), {
            paddingLeft: 12,
            paddingRight: 12,
            height: 40
        }), PayNowPopup_style_defineProperty(_obj6, theme.breakpoints.down("xs"), {
            paddingLeft: 8,
            paddingRight: 8,
            height: 32
        }), PayNowPopup_style_defineProperty(_obj6, "& svg", (_obj5 = {
            position: "absolute",
            right: 8
        }, PayNowPopup_style_defineProperty(_obj5, theme.breakpoints.down("sm"), {
            height: 32
        }), PayNowPopup_style_defineProperty(_obj5, theme.breakpoints.down("sm"), {
            height: 24
        }), _obj5)), _obj6),
        proceedBtn: {
            maxWidth: 350,
            margin: "0 auto",
            display: "block"
        },
        orWrapper: (_obj7 = {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            textAlign: "center"
        }, PayNowPopup_style_defineProperty(_obj7, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(1.5),
            marginBottom: theme.spacing(1.5)
        }), PayNowPopup_style_defineProperty(_obj7, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        }), _obj7),
        paypalButton: {
            maxWidth: 350,
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
            borderRadius: 6,
            width: "100%",
            height: 48,
            background: "#0070ba"
        },
        buttonProgress: {
            position: "absolute",
            width: "100%",
            height: "100%",
            left: 0,
            top: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0,0,0,0.2)"
        },
        paynowGrid: {
            flexDirection: theme.direction === "ltr" ? "row" : "row-reverse",
            "& input": {
                textAlign: theme.direction === "ltr" ? "left" : "right"
            }
        },
        applePayButton: {
            backgroundColor: "#000",
            color: "#fff",
            maxWidth: 350,
            height: 48,
            borderRadius: 6,
            margin: "0 auto",
            alignItems: "center",
            fontWeight: 600,
            textTransform: "unset",
            width: "100%",
            marginTop: 16,
            marginBottom: 16,
            "& svg": {
                fontSize: 48,
                marginLeft: 4
            },
            "&:hover": {
                backgroundColor: "#000"
            }
        },
        showPaymentButton: {
            display: "flex !important"
        },
        hidePaymentButton: {
            display: "none !important"
        },
        venmoButton: {
            maxWidth: 350,
            margin: "16px auto",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 24,
            width: "100%",
            height: 48,
            background: "#008CFF",
            "&:hover": {
                background: "#008CFF"
            },
            "& img": {
                display: "block",
                margin: "0px auto",
                height: 16
            }
        },
        klarnaPayButton: {
            color: "white",
            maxWidth: 350,
            margin: "16px auto",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 24,
            width: "100%",
            height: 48,
            background: "#008CFF",
            "&:hover": {
                background: "#008CFF"
            },
            "& img": {
                display: "block",
                margin: "0px auto",
                height: 16
            }
        },
        iDealPayButton: {
            color: "white",
            maxWidth: 350,
            margin: "16px auto",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 24,
            width: "100%",
            height: 48,
            background: "#008CFF",
            "&:hover": {
                background: "#008CFF"
            },
            "& img": {
                display: "block",
                margin: "0px auto",
                height: 16
            }
        }
    });
};
/* harmony default export */ var PayNowPopup_style = (PayNowPopup_style_styles);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(7812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(5477);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/index.es.js
var index_es = __webpack_require__(1417);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var react_fontawesome_index_es = __webpack_require__(2814);
;// CONCATENATED MODULE: ./slices/DonatePayNow/RecaptchaErrorPopup/style.ts
function RecaptchaErrorPopup_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

// Theme-dependent styles
var RecaptchaErrorPopup_style_styles = function(theme) {
    var _obj, _obj1, _obj2;
    return (0,createStyles/* default */.Z)({
        errorMessage: {
            color: "red"
        },
        modal: (_obj = {
            padding: theme.spacing(4),
            display: "flex",
            flexDirection: "column",
            color: "#4c4c78",
            fontFamily: "Raleway"
        }, RecaptchaErrorPopup_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            padding: theme.spacing(3)
        }), RecaptchaErrorPopup_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            padding: theme.spacing(2)
        }), RecaptchaErrorPopup_style_defineProperty(_obj, "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline", {
            borderColor: "#8bc249"
        }), RecaptchaErrorPopup_style_defineProperty(_obj, "& fieldset", {
            border: "2px solid #f3f3f3",
            "&:hover": {
                border: "2px solid #8bc249"
            }
        }), RecaptchaErrorPopup_style_defineProperty(_obj, "& .MuiInputBase-root", {
            backgroundColor: "#f3f3f3"
        }), _obj),
        modalTitle: {
            textTransform: "uppercase",
            fontWeight: 900,
            textAlign: "left",
            marginBottom: theme.spacing(2)
        },
        modalSectionTitle: (_obj1 = {
            fontSize: 16,
            fontWeight: 700,
            marginTop: theme.spacing(2.5),
            marginBottom: theme.spacing(2.5),
            textAlign: theme.direction === "ltr" ? "left" : "right"
        }, RecaptchaErrorPopup_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            marginBottom: theme.spacing(2),
            marginTop: theme.spacing(2)
        }), RecaptchaErrorPopup_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            marginBottom: theme.spacing(1.5),
            marginTop: theme.spacing(1.5)
        }), _obj1),
        proceedBtn: (_obj2 = {
            maxWidth: 350,
            margin: "0 auto",
            display: "block",
            marginTop: theme.spacing(4)
        }, RecaptchaErrorPopup_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(3)
        }), RecaptchaErrorPopup_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(2)
        }), _obj2),
        tnc: {
            "& p": {
                fontSize: 14,
                fontWeight: 500,
                lineHeight: 1.71,
                textAlign: "center",
                marginTop: theme.spacing(2),
                "& span": {
                    textDecoration: "none"
                },
                "& a": {
                    color: "#4c4c78",
                    textDecoration: "underline",
                    textDecorationThickness: "1.5px"
                }
            }
        },
        extraImpactWrapper: {
            "& .MuiFormControlLabel-root": {
                alignItems: "flex-start",
                "& .MuiCheckbox-root": {
                    marginTop: "-6px"
                }
            }
        }
    });
};
/* harmony default export */ var RecaptchaErrorPopup_style = (RecaptchaErrorPopup_style_styles);

;// CONCATENATED MODULE: ./slices/DonatePayNow/RecaptchaErrorPopup/index.tsx









var RecaptchaErrorPopup = function(param) {
    var classes = param.classes, openPopup = param.openPopup, closePopup = param.closePopup, errorCodes = param.errorCodes;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
        onRendered: function() {},
        open: openPopup,
        handleClose: closePopup,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.modal,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h5",
                    className: classes.modalTitle,
                    children: layout.recaptcha_error_title
                }),
                errorCodes && errorCodes.map(function(code, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                        severity: "error",
                        children: code
                    }, index);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classes.modalSectionTitle,
                    children: prismic_reactjs.RichText.render(layout.recaptcha_error_message)
                })
            ]
        })
    });
};
/* harmony default export */ var DonatePayNow_RecaptchaErrorPopup = ((0,withStyles/* default */.Z)(RecaptchaErrorPopup_style)(RecaptchaErrorPopup));

;// CONCATENATED MODULE: ./slices/DonatePayNow/MobilePopupWarningPopup/style.ts
function MobilePopupWarningPopup_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

// Theme-dependent styles
var MobilePopupWarningPopup_style_styles = function(theme) {
    return (0,createStyles/* default */.Z)({
        modal: MobilePopupWarningPopup_style_defineProperty({
            padding: theme.spacing(4),
            display: "flex",
            flexDirection: "column",
            color: "#4c4c78",
            fontFamily: "Raleway,Assistant",
            textAlign: "center"
        }, theme.breakpoints.down("sm"), {
            padding: theme.spacing(3)
        })
    });
};
/* harmony default export */ var MobilePopupWarningPopup_style = (MobilePopupWarningPopup_style_styles);

;// CONCATENATED MODULE: ./slices/DonatePayNow/MobilePopupWarningPopup/index.tsx







var MobilePopupWarningPopup = function(param) {
    var classes = param.classes, openPopup = param.openPopup, handleClosePopup = param.handleClosePopup, handleContinue = param.handleContinue;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        open: openPopup,
        onBackdropClick: handleClosePopup,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.modal,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h5",
                    children: layout.enable_mobile_popups_title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    onClick: handleContinue,
                    variant: "contained",
                    color: "primary",
                    fullWidth: true,
                    children: layout.enable_mobile_popups_continue
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    onClick: handleClosePopup,
                    variant: "contained",
                    color: "secondary",
                    children: layout.enable_mobile_popups_cancel
                })
            ]
        })
    });
};
/* harmony default export */ var DonatePayNow_MobilePopupWarningPopup = ((0,withStyles/* default */.Z)(MobilePopupWarningPopup_style)(MobilePopupWarningPopup));

// EXTERNAL MODULE: ./node_modules/@react-hook/media-query/dist/module/index.js
var dist_module = __webpack_require__(4990);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowBack.js
var ArrowBack = __webpack_require__(9826);
;// CONCATENATED MODULE: ./slices/DonatePayNow/PayNowPopup/index.tsx
function PayNowPopup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function PayNowPopup_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                PayNowPopup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                PayNowPopup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


























var PayNowPopup = function(param) {
    var classes = param.classes, popupOpen = param.popupOpen, closePopup = param.closePopup, getPaymentInfo = param.getPaymentInfo, recurringDonation = param.recurringDonation, netAmount = param.netAmount, coverTransactionCosts = param.coverTransactionCosts, goBackToAddressPopup = param.goBackToAddressPopup;
    var locale = (0,next_router.useRouter)().locale;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    var state1 = (0,vfi_easy_peasy_store/* useVFIStoreState */.As)(function(state) {
        return state;
    });
    var creditCardFormRef = (0,react.useRef)(null);
    var venmoButtonRef = (0,react.useRef)(null);
    var klarnaButtonRef = (0,react.useRef)(null);
    var iDealButtonRef = (0,react.useRef)(null);
    var applePayButtonRef = (0,react.useRef)(null);
    var payPalButtonRef = (0,react.useRef)(null);
    var googlePayButtonRef = (0,react.useRef)(null);
    var ref21 = (0,react.useState)(false), paymentMethodsLoading = ref21[0], setPaymentMethodsLoading = ref21[1];
    var ref1 = (0,react.useState)(), showMobilePopupWarning = ref1[0], setShowMobilePopupWarning = ref1[1];
    var ref2 = (0,react.useState)(), handleMobilePopupContinue = ref2[0], setHandleMobilePopupContinue = ref2[1];
    var ref3 = (0,react.useState)(null), creditCardType = ref3[0], setCreditCardType = ref3[1];
    var ref4 = (0,react.useState)(false), paymentInProgress = ref4[0], setPaymentInProgress = ref4[1];
    var ref5 = (0,react.useState)(), creditCardPaymentErrors = ref5[0], setCreditCardPaymentErrors = ref5[1];
    var ref6 = (0,react.useState)(), verificationUrl = ref6[0], setVerificiationUrl = ref6[1];
    var ref7 = (0,react.useState)(false), paymentFormInitComplete = ref7[0], setPaymentFormInitComplete = ref7[1];
    var ref8 = (0,react.useState)(), paypalErrors = ref8[0], setPaypalErrors = ref8[1];
    var ref9 = (0,react.useState)(false), showRecaptchaErrorPopup = ref9[0], setShowRecaptchaErrorPopup = ref9[1];
    var ref10 = (0,react.useState)(false), showApplePay = ref10[0], setShowApplePay = ref10[1];
    var ref11 = (0,react.useState)(false), showVenmo = ref11[0], setShowVenmo = ref11[1];
    var ref12 = (0,react.useState)(false), showPaypal = ref12[0], setShowPaypal = ref12[1];
    var ref13 = (0,react.useState)(false), showKlarna = ref13[0], setShowKlarna = ref13[1];
    var ref14 = (0,react.useState)(false), showIdeal = ref14[0], setShowIdeal = ref14[1];
    var ref15 = (0,react.useState)(), recaptchaErrorCodes = ref15[0], setRecaptchaErrorCodes = ref15[1];
    //credit card state
    var ref16 = (0,react.useState)(), cardNumberErrorText = ref16[0], setCardNumberErrorText = ref16[1];
    var ref17 = (0,react.useState)(), cvvErrorText = ref17[0], setCvvErrorText = ref17[1];
    var ref18 = (0,react.useState)(), expirationDateErrorText = ref18[0], setExpirationDateErrorText = ref18[1];
    var ref19 = (0,react.useState)(), cardholderNameErrorText = ref19[0], setCardholderNameErrorText = ref19[1];
    // catch mobile-devices
    var ref20 = (0,dist_module/* useMediaQueries */.l)({
        screen: "screen",
        width: "(max-width: 600px)"
    }), matches = ref20.matches, matchesAny = ref20.matchesAny, matchesAll = ref20.matchesAll;
    (0,react.useEffect)(function() {
        return function() {
            resetPaypal();
        };
    }, []);
    var resetPaypal = function() {
        Object.keys(window).forEach(function(key) {
            if (/paypal|zoid|post_robot/.test(key)) {
                console.log("DELETING PAYPAL SDK ON UNMOUNT");
                delete window[key];
            }
        });
        document.querySelectorAll('script[src*="www.paypal.com/sdk"]').forEach(function(node) {
            return node.remove();
        });
    };
    var payLocalMaybeOpenMobileWarningFirst = function() {
        var _ref = PayNowPopup_asyncToGenerator(runtime_default().mark(function _callee1(isMobileDevice, paymentProvider, buttonRef) {
            return runtime_default().wrap(function _callee$(_ctx1) {
                while(1)switch(_ctx1.prev = _ctx1.next){
                    case 0:
                        if (!isMobileDevice) {
                            _ctx1.next = 4;
                            break;
                        }
                        {
                            setShowMobilePopupWarning(true);
                            setHandleMobilePopupContinue(function() {
                                return PayNowPopup_asyncToGenerator(runtime_default().mark(function _callee() {
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                setShowMobilePopupWarning(false);
                                                setHandleMobilePopupContinue(null);
                                                _ctx.next = 4;
                                                return braintree_client_service.payWithLocalPaymentProvider(paymentProvider, buttonRef, getPaymentInfo(), paymentUIEvents, locale, layout.confirm_local_payment_button_text);
                                            case 4:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                            });
                        }
                        _ctx1.next = 6;
                        break;
                    case 4:
                        _ctx1.next = 6;
                        return braintree_client_service.payWithLocalPaymentProvider(paymentProvider, buttonRef, getPaymentInfo(), paymentUIEvents, locale, layout.confirm_local_payment_button_text);
                    case 6:
                    case "end":
                        return _ctx1.stop();
                }
            }, _callee1);
        }));
        return function payLocalMaybeOpenMobileWarningFirst(isMobileDevice, paymentProvider, buttonRef) {
            return _ref.apply(this, arguments);
        };
    }();
    var renderErrors = function(errors) {
        if (!errors) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        }
        return errors.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.paymentErrorItem,
                children: layout[item] || item
            }, index);
        });
    };
    var onCreditCardTypeChanged = function(type) {
        if (!type) {
            setCreditCardType(null);
        }
        switch(type){
            case "visa":
                {
                    setCreditCardType(index_es/* faCcVisa */.k9Y);
                    break;
                }
            case "master-card":
                {
                    setCreditCardType(index_es/* faCcMastercard */.N$R);
                    break;
                }
            case "american-express":
                {
                    setCreditCardType(index_es/* faCcAmex */.veW);
                    break;
                }
            case "diners-club":
                {
                    setCreditCardType(index_es/* faCcDinersClub */.Us5);
                    break;
                }
            case "discover":
                {
                    setCreditCardType(index_es/* faCcDiscover */.fpC);
                    break;
                }
            case "jcb":
                {
                    setCreditCardType(index_es/* faCcJcb */.i4Q);
                    break;
                }
        }
    };
    var handleClosePopup = function() {
        setCreditCardType(null);
        setCreditCardPaymentErrors([]);
        closePopup();
        setPaymentFormInitComplete(false);
        resetPaypal();
    };
    var clearCreditCardErrors = function() {
        setCardNumberErrorText("");
        setCvvErrorText("");
        setExpirationDateErrorText("");
        setCardholderNameErrorText("");
        setCreditCardPaymentErrors([]);
    };
    var clearPaypalErrors = function() {
        setPaypalErrors([]);
    };
    var clearAllErrors = function() {
        clearPaypalErrors();
        clearCreditCardErrors();
    };
    var handlePaypalError = function(errorResult) {
        var ref;
        console.log("handle paypal errors", errorResult);
        clearAllErrors();
        var errors = [];
        if (errorResult === null || errorResult === void 0 ? void 0 : (ref = errorResult.errorObject) === null || ref === void 0 ? void 0 : ref.message) {
            setPaypalErrors([
                errorResult.errorObject.message
            ]);
        } else {
            setPaypalErrors([
                "paypal_error"
            ]);
        }
    };
    var handleGoogleError = function(errorResult) {
        setCreditCardPaymentErrors([
            "google_pay_error"
        ]);
    };
    var handleApplePayError = function(errorResult) {
        setCreditCardPaymentErrors([
            "apple_pay_error"
        ]);
    };
    var handleVenmoError = function(errorResult) {
        setCreditCardPaymentErrors([
            "venmo_error"
        ]);
    };
    var handleThreeDSecureError = function(errorResult) {
        setCreditCardPaymentErrors([
            "three_d_secure_error"
        ]);
        if (!errorResult.code) {
            return;
        }
        if (errorResult.code.indexOf("THREEDS_LOOKUP") === 0) {
            // an error occurred during the initial lookup request
            if (errorResult.code === "THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR") {
            // either the passed payment method nonce does not exist
            // or it was already consumed before the lookup call was made
            } else if (errorResult.code.indexOf("THREEDS_LOOKUP_VALIDATION") === 0) {
            // a validation error occurred
            // likely some non-ascii characters were included in the billing
            // address given name or surname fields, or the cardholdername field
            // Instruct your user to check their data and try again
            } else {
            // an unknown lookup error occurred
            }
        } else {
        // some other kind of error
        }
    };
    var handleCreditCardError = function(tokenizeErr) {
        clearPaypalErrors();
        clearCreditCardErrors();
        clearAllErrors();
        var creditCardErrors = [];
        switch(tokenizeErr.code){
            case "HOSTED_FIELDS_FIELDS_EMPTY":
                // occurs when none of the fields are filled in
                console.error("All fields are empty! Please fill out the form.");
                creditCardErrors.push(tokenizeErr.code.toLowerCase());
                break;
            case "HOSTED_FIELDS_FIELDS_INVALID":
                // occurs when certain fields do not pass client side validation
                console.error("Some fields are invalid:", tokenizeErr.details.invalidFieldKeys);
                // you can also programmatically access the field containers for the invalid fields
                tokenizeErr.details.invalidFieldKeys.forEach(function(key) {
                    var errorKey = "credit_card_error_".concat(key).toLowerCase();
                    var error = layout[errorKey] || "";
                    switch(key){
                        case "number":
                            {
                                setCardNumberErrorText(error);
                                break;
                            }
                        case "cvv":
                            {
                                setCvvErrorText(error);
                                break;
                            }
                        case "expirationDate":
                            {
                                setExpirationDateErrorText(error);
                                break;
                            }
                        case "cardholderName":
                            {
                                setCardholderNameErrorText(error);
                                break;
                            }
                    }
                    var cssSelector = tokenizeErr.details.invalidFields[key];
                });
                break;
            case "HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE":
                // occurs when:
                //   * the client token used for client authorization was generated
                //     with a customer ID and the fail on duplicate payment method
                //     option is set to true
                //   * the card being tokenized has previously been vaulted (with any customer)
                // See: https://developers.braintreepayments.com/reference/request/client-token/generate/#options.fail_on_duplicate_payment_method
                console.error("This payment method already exists in your vault.");
                creditCardErrors.push(tokenizeErr.code.toLowerCase());
                break;
            case "HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED":
                // occurs when:
                //   * the client token used for client authorization was generated
                //     with a customer ID and the verify card option is set to true
                //     and you have credit card verification turned on in the Braintree
                //     control panel
                //   * the cvv does not pass verification (https://developers.braintreepayments.com/reference/general/testing/#avs-and-cvv/cid-responses)
                // See: https://developers.braintreepayments.com/reference/request/client-token/generate/#options.verify_card
                console.error("CVV did not pass verification");
                creditCardErrors.push(tokenizeErr.code.toLowerCase());
                break;
            case "HOSTED_FIELDS_FAILED_TOKENIZATION":
                // occurs for any other tokenization error on the server
                console.error("Tokenization failed server side. Is the card valid?");
                creditCardErrors.push(tokenizeErr.code.toLowerCase());
                break;
            case "HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR":
                // occurs when the Braintree gateway cannot be contacted
                console.error("Network error occurred when tokenizing.");
                creditCardErrors.push(tokenizeErr.code.toLowerCase());
                break;
            case "three_d_secure_error":
                {
                    // occurs when a 3ds error happens
                    console.error("three 3ds when tokenizing.");
                    creditCardErrors.push(tokenizeErr.code.toLowerCase());
                    break;
                }
            default:
                {
                    var ref, ref22;
                    if (tokenizeErr === null || tokenizeErr === void 0 ? void 0 : (ref = tokenizeErr.errorObject) === null || ref === void 0 ? void 0 : (ref22 = ref.transaction) === null || ref22 === void 0 ? void 0 : ref22.gatewayRejectionReason) {
                        switch(tokenizeErr.errorObject.transaction.gatewayRejectionReason){
                            case "three_d_secure":
                                {
                                    creditCardErrors.push("three_d_secure_error");
                                    break;
                                }
                            default:
                                {
                                    creditCardErrors.push("credit_card_generic_error");
                                    break;
                                }
                        }
                    } else {
                        creditCardErrors.push("credit_card_generic_error");
                    }
                    break;
                }
        }
        setCreditCardPaymentErrors(creditCardErrors);
    };
    var paymentUIEvents = {
        showLoading: function() {
            setPaymentMethodsLoading(true);
            clearAllErrors();
        },
        hideLoading: function() {
            setPaymentMethodsLoading(false);
        },
        onCreditCardTypeChanged: onCreditCardTypeChanged,
        onSubmit: PayNowPopup_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setPaymentInProgress(true);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        handleSuspectedDropOff: function() {
            error_logging_service/* default.logTrace */.Z.logTrace("Suspected drop off after successful local payment, closing popup");
            handleClosePopup();
        },
        onError: function(errorType, errorResult) {
            setPaymentInProgress(false);
            setPaymentMethodsLoading(false);
            switch(errorType){
                case DonationModels/* PaymentErrorType.Google */.zW.Google:
                    {
                        handleGoogleError(errorResult);
                        break;
                    }
                case DonationModels/* PaymentErrorType.ApplePay */.zW.ApplePay:
                    {
                        handleApplePayError(errorResult);
                        break;
                    }
                case DonationModels/* PaymentErrorType.Venmo */.zW.Venmo:
                    {
                        handleVenmoError(errorResult);
                        break;
                    }
                case DonationModels/* PaymentErrorType.ThreeDS */.zW.ThreeDS:
                    {
                        handleThreeDSecureError(errorResult);
                        break;
                    }
                case DonationModels/* PaymentErrorType.Recaptcha */.zW.Recaptcha:
                    {
                        console.log("***", errorResult);
                        closePopup();
                        setRecaptchaErrorCodes(errorResult.errorCodes);
                        setShowRecaptchaErrorPopup(true);
                        break;
                    }
                case DonationModels/* PaymentErrorType.CreditCard */.zW.CreditCard:
                    {
                        handleCreditCardError(errorResult);
                        break;
                    }
                case DonationModels/* PaymentErrorType.Paypal */.zW.Paypal:
                    {
                        handlePaypalError(errorResult);
                        break;
                    }
                case DonationModels/* PaymentErrorType.Server */.zW.Server:
                    {
                        setCreditCardPaymentErrors([
                            "credit_card_generic_error"
                        ]);
                        break;
                    }
                case DonationModels/* PaymentErrorType.Klarna */.zW.Klarna:
                    {
                        setCreditCardPaymentErrors([
                            "klarna_error"
                        ]);
                        break;
                    }
                case DonationModels/* PaymentErrorType.iDeal */.zW.iDeal:
                    {
                        setCreditCardPaymentErrors([
                            "i_deal_error"
                        ]);
                        break;
                    }
                default:
                    {
                        console.log("We are not handling this kind of error yet: ", errorType);
                        console.error("The error: ", errorType);
                    }
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showRecaptchaErrorPopup && recaptchaErrorCodes && /*#__PURE__*/ (0,jsx_runtime.jsx)(DonatePayNow_RecaptchaErrorPopup, {
                errorCodes: recaptchaErrorCodes,
                openPopup: showRecaptchaErrorPopup,
                closePopup: function() {
                    setRecaptchaErrorCodes(null);
                    setShowRecaptchaErrorPopup(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                disableEnforceFocus: true,
                "aria-labelledby": "simple-dialog-title",
                open: popupOpen,
                onClose: handleClosePopup,
                onRendered: PayNowPopup_asyncToGenerator(runtime_default().mark(function _callee() {
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                clearAllErrors();
                                _ctx.prev = 1;
                                setVerificiationUrl(braintree_client_service.getVerificationUrl(getPaymentInfo(), paymentUIEvents));
                                _ctx.next = 5;
                                return braintree_client_service.initPaymentForm(creditCardFormRef.current, getPaymentInfo, paymentUIEvents, {
                                    venmo: {
                                        button: venmoButtonRef.current,
                                        setShow: setShowVenmo
                                    },
                                    applePay: {
                                        button: applePayButtonRef.current,
                                        setShow: setShowApplePay
                                    },
                                    paypalButton: payPalButtonRef.current,
                                    ideal: {
                                        button: iDealButtonRef.current,
                                        setShow: setShowIdeal
                                    },
                                    klarna: {
                                        button: klarnaButtonRef.current,
                                        setShow: setShowKlarna
                                    }
                                });
                            case 5:
                                analytics_service.logAddPaymentInfo(getPaymentInfo());
                                setPaymentFormInitComplete(true);
                                _ctx.next = 12;
                                break;
                            case 9:
                                _ctx.prev = 9;
                                _ctx.t0 = _ctx["catch"](1);
                                error_logging_service/* default.logError */.Z.logError(_ctx.t0, {
                                    page: "donations",
                                    action: "init payment form"
                                });
                            case 12:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            9
                        ]
                    ]);
                })),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.payNowPopupWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "h5",
                            className: classes.modalTitle,
                            style: {
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    style: {
                                        left: 0,
                                        position: "absolute",
                                        padding: 0
                                    },
                                    onClick: function() {
                                        goBackToAddressPopup();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {})
                                }),
                                layout.credit_card_details_title
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                            ref: creditCardFormRef,
                            id: "credit-card-form",
                            name: "credit-card-form",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                container: true,
                                alignItems: "center",
                                justify: "center",
                                spacing: 3,
                                className: classes.paynowGrid,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        xs: 12,
                                        children: creditCardPaymentErrors && creditCardPaymentErrors.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                                            severity: "error",
                                            children: renderErrors(creditCardPaymentErrors)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                        item: true,
                                        xs: 12,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (0,clsx_m/* default */.Z)(classes.braintreeEntryField),
                                                id: "card-number",
                                                children: [
                                                    " ",
                                                    creditCardType && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es/* FontAwesomeIcon */.G, {
                                                        style: {
                                                            maxWidth: 40
                                                        },
                                                        size: "lg",
                                                        className: classes.cardSize,
                                                        pull: "right",
                                                        color: "blue",
                                                        icon: creditCardType
                                                    })
                                                ]
                                            }),
                                            cardNumberErrorText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.fieldError,
                                                children: cardNumberErrorText
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                        item: true,
                                        xs: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                id: "expiration-date",
                                                className: classes.braintreeEntryField
                                            }),
                                            expirationDateErrorText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.fieldError,
                                                children: expirationDateErrorText
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                        item: true,
                                        xs: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                id: "cvv",
                                                className: classes.braintreeEntryField
                                            }),
                                            cvvErrorText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.fieldError,
                                                children: cvvErrorText
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                        item: true,
                                        xs: 12,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                id: "cardholder-name",
                                                className: classes.braintreeEntryField
                                            }),
                                            cardholderNameErrorText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.fieldError,
                                                children: cardholderNameErrorText
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                        item: true,
                                        xs: 12,
                                        className: classes.totalAmt,
                                        children: [
                                            netAmount && !recurringDonation && layout.total_single_payment_message && layout.total_single_payment_message.replace("{{paymentString}}", "".concat(state1.currency.symbol, " ").concat(braintree_config/* default.getTotalAmountString */.Z.getTotalAmountString(netAmount, coverTransactionCosts), " ").concat(state1.currency.code)),
                                            netAmount && recurringDonation && layout.total_recurring_payment_message && layout.total_recurring_payment_message.replace("{{paymentString}}", "".concat(state1.currency.symbol, " ").concat(braintree_config/* default.getTotalAmountString */.Z.getTotalAmountString(netAmount, coverTransactionCosts), " ").concat(state1.currency.code))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "contained",
                                            disabled: paymentInProgress,
                                            color: "primary",
                                            fullWidth: true,
                                            className: classes.proceedBtn,
                                            type: "submit",
                                            children: layout.pay_now_with_credit_card_button
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: "additional-payment-methods",
                            style: {
                                display: paymentFormInitComplete ? "block" : "none"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h5",
                                    className: classes.orWrapper,
                                    children: layout.or_divider
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "paypal-button",
                                    className: classes.paypalButton,
                                    ref: payPalButtonRef,
                                    style: {
                                        display: "none"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    id: "apple-pay",
                                    ref: applePayButtonRef,
                                    className: (0,clsx_m/* default */.Z)(classes.applePayButton, showApplePay ? classes.showPaymentButton : classes.hidePaymentButton),
                                    onClick: function() {
                                        return braintree_client_service.payWithApple(applePayButtonRef.current, getPaymentInfo(), paymentUIEvents, layout.apple_pay_company_name_label);
                                    },
                                    children: [
                                        layout.pay_with_prefix,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es/* FontAwesomeIcon */.G, {
                                            icon: index_es/* faApplePay */.x6_,
                                            size: "lg"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    id: "venmo",
                                    ref: venmoButtonRef,
                                    className: (0,clsx_m/* default */.Z)(classes.venmoButton, showVenmo ? classes.showPaymentButton : classes.hidePaymentButton),
                                    onClick: function() {
                                        return braintree_client_service.payWithVenmo(venmoButtonRef.current, getPaymentInfo(), paymentUIEvents);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/venmo.svg"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    id: "klarna",
                                    ref: klarnaButtonRef,
                                    className: (0,clsx_m/* default */.Z)(classes.klarnaPayButton, showKlarna ? classes.showPaymentButton : classes.hidePaymentButton),
                                    onClick: PayNowPopup_asyncToGenerator(runtime_default().mark(function _callee() {
                                        return runtime_default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    _ctx.next = 2;
                                                    return payLocalMaybeOpenMobileWarningFirst(matchesAll, DonationModels/* LocalPaymentProviders.Klarna */.x_.Klarna, klarnaButtonRef.current);
                                                case 2:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee);
                                    })),
                                    children: layout.pay_with_klarna
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    id: "iDeal",
                                    ref: iDealButtonRef,
                                    className: (0,clsx_m/* default */.Z)(classes.iDealPayButton, showIdeal ? classes.showPaymentButton : classes.hidePaymentButton),
                                    onClick: PayNowPopup_asyncToGenerator(runtime_default().mark(function _callee() {
                                        return runtime_default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    _ctx.next = 2;
                                                    return payLocalMaybeOpenMobileWarningFirst(matchesAll, DonationModels/* LocalPaymentProviders.iDeal */.x_.iDeal, iDealButtonRef.current);
                                                case 2:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee);
                                    })),
                                    children: layout.pay_with_ideal
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DonatePayNow_MobilePopupWarningPopup, {
                                    openPopup: showMobilePopupWarning,
                                    handleContinue: handleMobilePopupContinue,
                                    handleClosePopup: function() {
                                        setShowMobilePopupWarning(false);
                                        setHandleMobilePopupContinue(null);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            container: true,
                            alignItems: "center",
                            justify: "center",
                            spacing: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    item: true,
                                    children: paypalErrors && paypalErrors.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                                        severity: "error",
                                        children: renderErrors(paypalErrors)
                                    })
                                })
                            })
                        }),
                        !paymentMethodsLoading && verificationUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            style: {
                                paddingTop: 20
                            },
                            container: true,
                            direction: "column",
                            alignItems: "center",
                            justify: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: verificationUrl,
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "https://s3.amazonaws.com/braintree-badges/braintree-badge-wide-light.png",
                                        style: {
                                            width: "100%",
                                            maxWidth: 350
                                        }
                                    })
                                })
                            })
                        }),
                        (paymentMethodsLoading || paymentInProgress) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.buttonProgress,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                size: 64
                            })
                        })
                    ]
                })
            })
        ]
    });
};
PayNowPopup.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var DonatePayNow_PayNowPopup = ((0,withStyles/* default */.Z)(PayNowPopup_style)(PayNowPopup));

;// CONCATENATED MODULE: ./slices/DonatePayNow/style.ts
function DonatePayNow_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

// Theme-dependent styles
var DonatePayNow_style_styles = function(theme) {
    return (0,createStyles/* default */.Z)({
        donateCard: {
            borderRadius: 12,
            boxShadow: "0 7px 28px 0 rgba(184, 196, 214, 0.5)",
            "&>.MuiGrid-item:first-child": DonatePayNow_style_defineProperty({
                borderRight: "1px solid #ecf1f2"
            }, theme.breakpoints.down("sm"), {
                borderRight: "0"
            })
        }
    });
};
/* harmony default export */ var DonatePayNow_style = (DonatePayNow_style_styles);

;// CONCATENATED MODULE: ./slices/DonatePayNow/YourBasket/style.ts
function YourBasket_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

// Theme-dependent styles
var YourBasket_style_styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5, _obj6;
    return (0,createStyles/* default */.Z)({
        donateRight: (_obj = {
            padding: theme.spacing(5),
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
        }, YourBasket_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            padding: theme.spacing(4)
        }), YourBasket_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            padding: theme.spacing(2)
        }), _obj),
        proceedButtonText: (_obj1 = {
            maxWidth: 350,
            marginTop: theme.spacing(4),
            margin: "0 auto"
        }, YourBasket_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(3)
        }), YourBasket_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(2)
        }), _obj1),
        checkboxWrapper: {
            width: "100%",
            display: "flex",
            flexDirection: "column",
            "& .custCheckBox": {
                width: "fit-content",
                marginRight: 0
            },
            "& .custCheckBoxLbl": {
                "& span": (_obj2 = {
                    display: "block",
                    fontWeight: " 700 !important",
                    color: "#4c4c78",
                    fontSize: 12
                }, YourBasket_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
                    fontSize: 11.5
                }), YourBasket_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
                    fontSize: 11
                }), _obj2)
            }
        },
        donationBasketTitle: {
            color: "#4c4c78",
            textTransform: "uppercase",
            fontWeight: 900,
            textAlign: "center",
            lineHeight: "1.5"
        },
        divider: (_obj3 = {
            height: 1,
            backgroundColor: "#ecf1f2",
            width: "100%",
            margin: theme.spacing(2.5, 0)
        }, YourBasket_style_defineProperty(_obj3, theme.breakpoints.down("sm"), {
            margin: theme.spacing(2, 0)
        }), YourBasket_style_defineProperty(_obj3, theme.breakpoints.down("xs"), {
            margin: theme.spacing(1.5, 0)
        }), _obj3),
        donateData: (_obj4 = {
            flex: 1,
            width: "104%",
            maxHeight: 200,
            overflowY: "scroll",
            overflowX: "hidden",
            paddingRight: 20,
            marginRight: "-20px"
        }, YourBasket_style_defineProperty(_obj4, theme.breakpoints.down("sm"), {
            maxHeight: "unset",
            flex: "unset"
        }), YourBasket_style_defineProperty(_obj4, theme.breakpoints.down("xs"), {
            width: "107%"
        }), _obj4),
        totalAmtTxt: (_obj5 = {
            fontWeight: 900,
            textAlign: "center",
            color: "#4c4c78",
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(2)
        }, YourBasket_style_defineProperty(_obj5, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(1.5)
        }), YourBasket_style_defineProperty(_obj5, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1)
        }), _obj5),
        monthlyOptionDisclaimer: (_obj6 = {
            fontSize: 12,
            lineHeight: 2,
            color: "#4c4c78",
            fontWeight: 500
        }, YourBasket_style_defineProperty(_obj6, theme.breakpoints.down("sm"), {
            fontSize: 11.5
        }), YourBasket_style_defineProperty(_obj6, theme.breakpoints.down("xs"), {
            fontSize: 11
        }), _obj6)
    });
};
/* harmony default export */ var YourBasket_style = (YourBasket_style_styles);

;// CONCATENATED MODULE: ./slices/DonatePayNow/BasketItems/style.ts
function BasketItems_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

// Theme-dependent styles
var BasketItems_style_styles = function(theme) {
    var _obj, _obj1, _obj2;
    return (0,createStyles/* default */.Z)({
        greyBg: (_obj = {
            borderRadius: 6,
            backgroundColor: "#ecf1f2",
            padding: theme.spacing(4),
            marginTop: 8,
            marginBottom: theme.spacing(2.5),
            display: "flex",
            flexDirection: "column",
            width: "100%",
            position: "relative",
            transition: "0.3s"
        }, BasketItems_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            padding: theme.spacing(3)
        }), BasketItems_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            padding: theme.spacing(2)
        }), _obj),
        noBasketItemsMessage: {
            color: "#4c4c78",
            textAlign: "center",
            fontWeight: 700,
            cursor: "pointer"
        },
        closeItem: {
            cursor: "pointer",
            position: "absolute",
            width: 20,
            height: 20,
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "4px",
            top: "-8px",
            right: "-8px",
            boxShadow: "0 8px 18px 0 rgba(121, 125, 176, 0.28)",
            fontSize: 16,
            fontWeight: 700,
            color: "#4c4c78"
        },
        yourBasketTitle: (_obj1 = {
            color: "#4c4c78",
            lineHeight: "1.71",
            fontFamily: "Raleway,Assistant",
            textAlign: "center",
            fontSize: 14
        }, BasketItems_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            fontSize: 13
        }), BasketItems_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            fontSize: 13
        }), _obj1),
        editAmt: (_obj2 = {
            textAlign: "center",
            fontSize: 14,
            color: "#4c4c78",
            textDecoration: "underline",
            fontWeight: 700,
            marginTop: theme.spacing(1.5),
            cursor: "pointer"
        }, BasketItems_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            fontSize: 13,
            marginTop: theme.spacing(1)
        }), BasketItems_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
            fontSize: 12,
            marginTop: theme.spacing(0.5)
        }), _obj2)
    });
};
/* harmony default export */ var BasketItems_style = (BasketItems_style_styles);

;// CONCATENATED MODULE: ./slices/DonatePayNow/BasketItems/index.tsx









var BasketItems = function(param) {
    var classes = param.classes, basketItemsArray = param.basketItemsArray, updateItem = param.updateItem, deleteItem = param.deleteItem, amountInput = param.amountInput, netAmount = param.netAmount;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    var state1 = (0,vfi_easy_peasy_store/* useVFIStoreState */.As)(function(state) {
        return state;
    });
    // NO BASKET ITEMS
    if (!basketItemsArray || basketItemsArray.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.greyBg,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                onClick: function() {
                    amountInput.current.focus();
                },
                variant: "h5",
                className: classes.noBasketItemsMessage,
                children: [
                    "+ ",
                    layout.no_basket_items_message
                ]
            })
        });
    }
    // BASKET ITEMS 
    var items = basketItemsArray.map(function(item, i) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.greyBg,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: function() {
                        return deleteItem(i);
                    },
                    className: classes.closeItem,
                    children: "x"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.yourBasketTitle,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classes.adam,
                            children: netAmount && layout.donation_card_text1 && layout.donation_card_text1.replace("{{currencySymbol}}", state1.currency.symbol).replace("{{currency}}", state1.currency.code).replace("{{amount}}", item.amount.toFixed(2))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: layout.donation_card_text2 && layout.donation_card_text2.replace("{{dedicateTo}}", item.name)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: function() {
                        updateItem(i, item, item.amount);
                    },
                    className: classes.editAmt,
                    children: prismic_reactjs.RichText.asText(layout.edit_amount_text)
                })
            ]
        }, i);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: items
    });
};
BasketItems.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    basketItemsArray: prop_types_default().arrayOf((prop_types_default()).any).isRequired
};
//export default BasketItems
/* harmony default export */ var DonatePayNow_BasketItems = ((0,withStyles/* default */.Z)(BasketItems_style)(BasketItems));

;// CONCATENATED MODULE: ./slices/DonatePayNow/YourBasket/index.tsx











var YourBasket = function(param) {
    var classes = param.classes, netAmount = param.netAmount, basketItems = param.basketItems, updateItem = param.updateItem, coverTransactionCosts = param.coverTransactionCosts, deleteItem = param.deleteItem, amountInput = param.amountInput, setCheckbox = param.setCheckbox, isRecurringDonation = param.isRecurringDonation, handleOpenDonationPopup = param.handleOpenDonationPopup;
    var ref;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    var state1 = (0,vfi_easy_peasy_store/* useVFIStoreState */.As)(function(state) {
        return state;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.donateRight,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                className: classes.donationBasketTitle,
                children: prismic_reactjs.RichText.asText(layout.donation_basket_title)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.divider
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.donateData,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DonatePayNow_BasketItems, {
                    netAmount: netAmount,
                    basketItemsArray: basketItems,
                    updateItem: updateItem,
                    deleteItem: deleteItem,
                    amountInput: amountInput
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.checkboxWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                        className: "custCheckBox",
                        value: "end",
                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            color: "primary",
                            onChange: function(e) {
                                setCheckbox("cover-transaction", e);
                            }
                        }),
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "custCheckBoxLbl",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: prismic_reactjs.RichText.asText((ref = layout.extra_impact_checkboxes.find(function(x) {
                                    return x.extra_impact_id === "cover-transaction";
                                })) === null || ref === void 0 ? void 0 : ref.checkbox_title)
                            })
                        }),
                        labelPlacement: "end"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                        className: "custCheckBox",
                        value: "end",
                        // key={i}
                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            color: "primary",
                            onChange: function(e) {
                                setCheckbox("monthly", e);
                            }
                        }),
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "custCheckBoxLbl",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: prismic_reactjs.RichText.asText(layout.monthly_option_text)
                            })
                        }),
                        labelPlacement: "end"
                    }),
                    isRecurringDonation && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.monthlyOptionDisclaimer,
                        children: prismic_reactjs.RichText.asText(layout.monthly_option_disclaimer)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "h6",
                className: classes.totalAmtTxt,
                children: [
                    prismic_reactjs.RichText.asText(layout.total_amount_text),
                    ": ",
                    state1.currency.symbol,
                    braintree_config/* default.getTotalAmountString */.Z.getTotalAmountString(netAmount, coverTransactionCosts)
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: handleOpenDonationPopup,
                variant: "contained",
                color: "primary",
                fullWidth: true,
                className: classes.proceedButtonText,
                disabled: !netAmount,
                children: prismic_reactjs.RichText.asText(layout.proceed_button_text)
            })
        ]
    });
};
/* harmony default export */ var DonatePayNow_YourBasket = ((0,withStyles/* default */.Z)(YourBasket_style)(YourBasket));

;// CONCATENATED MODULE: ./slices/DonatePayNow/index.tsx
function DonatePayNow_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function DonatePayNow_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return DonatePayNow_arrayLikeToArray(arr);
}
function DonatePayNow_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function DonatePayNow_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                DonatePayNow_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                DonatePayNow_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function DonatePayNow_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function DonatePayNow_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function DonatePayNow_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function DonatePayNow_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            DonatePayNow_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function DonatePayNow_toConsumableArray(arr) {
    return DonatePayNow_arrayWithoutHoles(arr) || DonatePayNow_iterableToArray(arr) || DonatePayNow_unsupportedIterableToArray(arr) || DonatePayNow_nonIterableSpread();
}
function DonatePayNow_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return DonatePayNow_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return DonatePayNow_arrayLikeToArray(o, minLen);
}























var DonatePayNow = function(param) {
    var classes = param.classes;
    //#region CONTEXTS
    var basketContext = (0,basket_context/* useBasket */.Kc)();
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    var locale = (0,next_router.useRouter)().locale;
    //#endregion CONTEXTS
    //#region Constants
    var amountInput = (0,react.useRef)(null);
    var availableProjects = donation_service.getAvailableProjects(layout);
    var state1 = (0,vfi_easy_peasy_store/* useVFIStoreState */.As)(function(state) {
        return state;
    });
    var handleAddressChange = function(e) {
        // this can be made into a helper function I am sure
        var _target = e.target, name = _target.name, value = _target.value;
        setAddressState(function(prevState) {
            return DonatePayNow_objectSpread({}, prevState, DonatePayNow_defineProperty({}, name, value));
        });
    };
    //#endregion Constants
    //#region STATES
    var ref = (0,react.useState)(getDefaultAddress(layout.donation_auto_select_mailing_list_signup, state1.country)), address = ref[0], setAddressState = ref[1];
    var ref1 = (0,react.useState)(false), agreeToGiftAid = ref1[0], setAgreeToGiftAid = ref1[1];
    var ref2 = (0,react.useState)(""), amount1 = ref2[0], setAmount = ref2[1]; // should not be a string
    var ref3 = (0,react.useState)([]), basketItems = ref3[0], setBasketItems = ref3[1];
    var ref4 = (0,react.useState)(false), coverTransactionCosts = ref4[0], setCoverTransactionCosts = ref4[1];
    var ref5 = (0,react.useState)(false), payNowPopupOpen = ref5[0], setPayNowPopupOpen = ref5[1];
    var ref6 = (0,react.useState)(prismic_reactjs.RichText.asText(layout.add_to_basket_button_text)), editOrSaveButtonText = ref6[0], setEditSave = ref6[1];
    var ref7 = (0,react.useState)(false), isRecurringDonation = ref7[0], setIsRecurringDonation = ref7[1];
    var ref8 = (0,react.useState)(), netAmount = ref8[0], setNetAmount = ref8[1];
    var ref9 = (0,react.useState)(false), openDonationPopup = ref9[0], setOpenDonationPopup = ref9[1];
    var ref10 = (0,react.useState)(false), otherMethodsPopupOpen = ref10[0], setOtherMethodsPopupOpen = ref10[1];
    var ref11 = (0,react.useState)(layout.payment_methods[0]), paymentMethod = ref11[0], setPaymentMethod = ref11[1];
    var ref12 = (0,react.useState)(null), selectedProject = ref12[0], setSelectedProject = ref12[1]; // the project
    var ref13 = (0,react.useState)(0), selectedProjectIndex = ref13[0], setSelectedProjectIndex = ref13[1];
    var ref14 = (0,react.useState)(false), thankyouVisible = ref14[0], setThankyouVisible = ref14[1];
    var ref15 = (0,react.useState)(), transactionId1 = ref15[0], setTransactionId = ref15[1];
    //#endregion STATES
    //#region EFFECTS
    (0,react.useEffect)(function() {
        if (selectedProjectIndex > -1) {
            setSelectedProject(availableProjects[selectedProjectIndex]);
        } else {
            setSelectedProject(null);
        }
    }, [
        selectedProjectIndex
    ]);
    (0,react.useEffect)(function() {
        if (thankyouVisible && state1.customLinkClicked > 0) {
            setThankyouVisible(false);
        }
    }, [
        state1.customLinkClicked
    ]);
    (0,react.useEffect)(function() {
        var basketTotal;
        var storedBasket = localStorage.getItem("Basket");
        if (storedBasket) {
            setBasketItems(JSON.parse(storedBasket));
            basketTotal = JSON.parse(storedBasket);
            calculateBasketTotal(basketTotal);
        }
    }, [
        netAmount
    ]);
    //#endregion EFFECTS
    // #region FUNCTIONS
    //#region POPUPS
    var handleOpenDonationPopup = function() {
        var _ref = DonatePayNow_asyncToGenerator(runtime_default().mark(function _callee() {
            var primeToken;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return security_service.getRecaptchaToken("prime");
                    case 2:
                        primeToken = _ctx.sent;
                        if (!primeToken) {
                            error_logging_service/* default.logMessage */.Z.logMessage("Could not get token on prime", null);
                        } else {
                            setOpenDonationPopup(true);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleOpenDonationPopup() {
            return _ref.apply(this, arguments);
        };
    }();
    var closeAllPopups = function() {
        setOpenDonationPopup(false);
        setPayNowPopupOpen(false);
    };
    var openPayNowPopup = function() {
        var _ref = DonatePayNow_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setOpenDonationPopup(false);
                        setPayNowPopupOpen(true);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function openPayNowPopup() {
            return _ref.apply(this, arguments);
        };
    }();
    var openOtherPaymentMethodsPopup = function() {
        setOpenDonationPopup(false);
        setOtherMethodsPopupOpen(true);
    };
    var handleCloseBankTransferPopup = function() {
        var _ref = DonatePayNow_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setOtherMethodsPopupOpen(false);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCloseBankTransferPopup() {
            return _ref.apply(this, arguments);
        };
    }();
    //#endregion POPUPS
    var mappedCheckboxes = function(checkbox) {
        if (checkbox == "cover-transaction") {
            return coverTransactionCosts;
        }
        if (checkbox == "gift-aid") {
            return agreeToGiftAid;
        }
        return false;
    };
    var setCheckbox = function(id, e) {
        switch(id){
            case "monthly":
                setIsRecurringDonation(e.target.checked);
                break;
            case "cover-transaction":
                {
                    setCoverTransactionCosts(e.target.checked);
                    break;
                }
            case "gift-aid":
                setAgreeToGiftAid(e.target.checked);
                break;
            default:
                false;
        }
    };
    //#region BASKET FUNCTIONS
    var calculateBasketTotal = function(changedBasket) {
        var total = changedBasket.reduce(function(accumulator, currentValue) {
            return +accumulator + +currentValue.amount;
        }, 0);
        setNetAmount(total);
    };
    var addToBasket = function() {
        var _ref = DonatePayNow_asyncToGenerator(runtime_default().mark(function _callee() {
            var newBasketItems;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        newBasketItems = donation_service.addToBasket(basketItems, selectedProject, amount1, state1.currency.code, basketContext, setAmount);
                        setBasketItems(newBasketItems);
                        calculateBasketTotal(newBasketItems);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function addToBasket() {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteItem = function(i) {
        //remove the item
        var basketWithoutItem = basketItems.filter(function(x) {
            return x !== basketItems[i];
        });
        //set local storage
        localStorage.setItem("Basket", JSON.stringify(basketWithoutItem));
        //set local state
        setBasketItems(DonatePayNow_toConsumableArray(basketWithoutItem));
        // set global state
        basketContext.basket.setBasket(DonatePayNow_toConsumableArray(basketWithoutItem));
        //calculate basket total
        calculateBasketTotal(basketWithoutItem);
    };
    var emptyBasket = function() {
        setBasketItems([]);
        basketContext.basket.setBasket([]);
        localStorage.removeItem("Basket");
        calculateBasketTotal([]);
        setAmount("");
    };
    var updateItem = function(i, project, amount) {
        deleteItem(i);
        var index = availableProjects.findIndex(function(x) {
            return x.id === project.id;
        });
        setSelectedProjectIndex(index);
        setEditSave("Save"); // hardcoded, needs to come from prismic layout
        amountInput.current.focus();
        setAmount(amount);
    };
    //#endregion BASKET FUNCTIONS
    var postDonationSuccess = function() {
        var _ref = DonatePayNow_asyncToGenerator(runtime_default().mark(function _callee(transactionId) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setTransactionId(transactionId);
                        emptyBasket();
                        setIsRecurringDonation(false);
                        setCoverTransactionCosts(false);
                        setThankyouVisible(true);
                        setAddressState(getDefaultAddress(layout.donation_auto_select_mailing_list_signup, state1.country));
                        closeAllPopups();
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function postDonationSuccess(transactionId) {
            return _ref.apply(this, arguments);
        };
    }();
    var getPaymentInfo = function() {
        return {
            address: address,
            agreeToGiftAid: agreeToGiftAid,
            basketItems: basketItems,
            creditCardPlaceholders: {
                cardNumber: layout.credit_card_number_placeholder,
                cvv: layout.credit_card_cvv_placeholder,
                expiry: layout.credit_card_expiry_placeholder,
                cardholderName: layout.cardholder_name_placeholder
            },
            coverTransactionCosts: coverTransactionCosts,
            currencyCode: state1.currency.code,
            isRecurring: isRecurringDonation,
            netAmount: netAmount,
            onSuccess: postDonationSuccess,
            twoLetterLanguageCode: locale || "en"
        };
    };
    // #endregion FUNCTIONS
    //#region RETURN STATEMENT / HTML RENDER FUNCTIONS
    var BankTransferPopup = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
            className: classes.modal,
            "aria-labelledby": "simple-dialog-title",
            open: otherMethodsPopupOpen,
            onClose: handleCloseBankTransferPopup,
            children: prismic_reactjs.RichText.render(paymentMethod.popup_text)
        });
    };
    if (thankyouVisible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DonatePayNow_ThankYouForDonating, {
            transactionId: transactionId1
        });
    }
    // ACTUAL RETURN STATEMENT
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DonatePayNow_PayNowPopup, {
                goBackToAddressPopup: function() {
                    setPayNowPopupOpen(false);
                    setOpenDonationPopup(true);
                },
                closePopup: function() {
                    setPayNowPopupOpen(false);
                },
                getPaymentInfo: getPaymentInfo,
                netAmount: netAmount,
                popupOpen: payNowPopupOpen,
                recurringDonation: isRecurringDonation,
                coverTransactionCosts: coverTransactionCosts
            }),
            BankTransferPopup(),
            openDonationPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(DonatePayNow_AddressPopup, {
                address: address,
                closeAllPopups: closeAllPopups,
                getPaymentInfo: getPaymentInfo,
                handleAddressChange: handleAddressChange,
                mappedCheckboxes: mappedCheckboxes,
                openPayNowPopup: openPayNowPopup,
                setCheckbox: setCheckbox,
                openDonationPopup: openDonationPopup
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    className: classes.donateCard,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            sm: 12,
                            md: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DonatePayNow_AddADonation, {
                                addToBasket: addToBasket,
                                amount: amount1,
                                amountInput: amountInput,
                                availableProjects: availableProjects,
                                editOrSaveButtonText: editOrSaveButtonText,
                                selectedProjectIndex: selectedProjectIndex,
                                setAmount: setAmount,
                                setSelectedProjectIndex: setSelectedProjectIndex
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            sm: 12,
                            md: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DonatePayNow_YourBasket, {
                                amountInput: amountInput,
                                basketItems: basketItems,
                                coverTransactionCosts: coverTransactionCosts,
                                deleteItem: deleteItem,
                                handleOpenDonationPopup: handleOpenDonationPopup,
                                isRecurringDonation: isRecurringDonation,
                                netAmount: netAmount,
                                setCheckbox: setCheckbox,
                                updateItem: updateItem
                            })
                        })
                    ]
                })
            })
        ]
    });
//#endregion RETURN STATEMENT / HTML
};
//#region EXPORT
DonatePayNow.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_DonatePayNow = ((0,withStyles/* default */.Z)(DonatePayNow_style)(DonatePayNow)); //#endregion EXPORT

;// CONCATENATED MODULE: ./slices/DonationThankyou/style.js
function DonationThankyou_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var DonationThankyou_style_styles = function(theme) {
    var _obj;
    return {
        shortHero: (_obj = {
            textAlign: "center",
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, DonationThankyou_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), DonationThankyou_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), _obj),
        ctaButton: {
            margin: "30px auto"
        }
    };
};
/* harmony default export */ var DonationThankyou_style = (DonationThankyou_style_styles);

;// CONCATENATED MODULE: ./slices/DonationThankyou/index.js
function DonationThankyou_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function DonationThankyou_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                DonationThankyou_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                DonationThankyou_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}













var DonationThankyou = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(DonationThankyou_asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    localStorage.removeItem("basket");
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })));
    var basket = (0,basket_context/* useBasket */.Kc)();
    var _thankyouPageDetails = basket.basket.thankyouPageDetails, recurring = _thankyouPageDetails.recurring, currencySymbol = _thankyouPageDetails.currencySymbol, totalAmount = _thankyouPageDetails.totalAmount, currency = _thankyouPageDetails.currency, designationAmounts = _thankyouPageDetails.designationAmounts;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "md",
        className: classes.shortHero,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h1",
                children: prismic_reactjs.RichText.render(primary.paymentConfirmationText)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "subtitle1",
                children: prismic_reactjs.RichText.render(primary.feedbackRequestText)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                link: primary.ctaButtonLink,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "primary",
                    className: classes.ctaButton,
                    children: prismic_reactjs.RichText.asText(primary.ctaButtonText)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                link: "/",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "contained",
                    className: classes.ctaButton,
                    children: prismic_reactjs.RichText.asText(primary.homepageLinkText)
                })
            })
        ]
    });
};
DonationThankyou.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h,
            subtitle: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_DonationThankyou = ((0,withStyles/* default */.Z)(DonationThankyou_style)(DonationThankyou));

;// CONCATENATED MODULE: ./slices/EndorsementsComponent/style.js
function EndorsementsComponent_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var EndorsementsComponent_style_styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3, _obj4;
    return {
        endorsements: (_obj1 = {
            backgroundColor: "#F4F5F6",
            backgroundImage: 'url("/patternSimpleText.svg")',
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundBlendMode: "color-burn",
            backgroundRepeat: "no-repeat",
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10),
            position: "relative"
        }, EndorsementsComponent_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), EndorsementsComponent_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), EndorsementsComponent_style_defineProperty(_obj1, "& .element", {
            position: "absolute",
            top: 80
        }), EndorsementsComponent_style_defineProperty(_obj1, "& .endorsmentWrapperContainer", (_obj = {
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, EndorsementsComponent_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), EndorsementsComponent_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), _obj)), _obj1),
        testimonialCardGrid: {
            "& .flexEnd": {
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end"
            }
        },
        testimonialCard: (_obj3 = {
            borderRadius: 6,
            boxShadow: "0 20px 30px 0 rgba(0, 0, 0, 0.2)",
            backgroundColor: "#ffffff",
            padding: theme.spacing(4),
            display: "flex",
            flexDirection: "column",
            height: "100%"
        }, EndorsementsComponent_style_defineProperty(_obj3, theme.breakpoints.down("sm"), {
            padding: theme.spacing(3)
        }), EndorsementsComponent_style_defineProperty(_obj3, theme.breakpoints.down("xs"), {
            padding: theme.spacing(2)
        }), EndorsementsComponent_style_defineProperty(_obj3, "& .name", (_obj2 = {
            color: "#4c4c78",
            fontSize: 14,
            fontWeight: 700,
            lineHeight: 1.79,
            marginTop: theme.spacing(4)
        }, EndorsementsComponent_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(3)
        }), EndorsementsComponent_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(2)
        }), _obj2)), EndorsementsComponent_style_defineProperty(_obj3, "& .testimonialTitle", {
            color: "#4c4c78",
            fontWeight: 500,
            maxWidth: 200
        }), EndorsementsComponent_style_defineProperty(_obj3, "& .testimonial", {
            color: "#4c4c78",
            fontWeight: 700,
            lineHeight: 1.79,
            fontFamily: "Raleway,Assistant",
            fontStyle: "italic",
            flex: 1
        }), _obj3),
        testimonialImg: (_obj4 = {
            width: 113,
            height: 113,
            minWidth: 113,
            minHeight: 113,
            maxWidth: 113,
            maxHeight: 113,
            borderRadius: 100,
            background: "#fff",
            boxShadow: "0 38px 66px 0 rgba(80, 82, 138, 0.18)",
            border: "solid 2px #ffffff",
            marginTop: "-60px",
            marginRight: "-24px",
            objectFit: "cover"
        }, EndorsementsComponent_style_defineProperty(_obj4, theme.breakpoints.down("sm"), {
            marginRight: "-20px"
        }), EndorsementsComponent_style_defineProperty(_obj4, theme.breakpoints.down("xs"), {
            marginRight: "-10px"
        }), _obj4)
    };
};
/* harmony default export */ var EndorsementsComponent_style = (EndorsementsComponent_style_styles);

;// CONCATENATED MODULE: ./slices/EndorsementsComponent/index.js















var EndorsementsComponent_Endorsements = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary, items = slice.items;
    var endorsements = items.map(function(endorsement, i) {
        return endorsement && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
            item: true,
            xs: 12,
            sm: 6,
            md: 4,
            container: true,
            direction: "row",
            justify: "center",
            className: classes.testimonialCardGrid,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flexEnd",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.testimonialCard,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle2",
                                className: "testimonial",
                                children: prismic_reactjs.RichText.asText(endorsement.endorsement.data.endorsement)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle1",
                                className: "name",
                                children: prismic_reactjs.RichText.asText(endorsement.endorsement.data.endorser_name)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle2",
                                className: "testimonialTitle",
                                children: prismic_reactjs.RichText.asText(endorsement.endorsement.data.endorser_title)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: endorsement.endorsement.data.endorser_profile_image.url,
                        alt: "profile",
                        className: classes.testimonialImg
                    })
                ]
            })
        }, i);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.endorsements,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            maxWidth: "lg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                    name: primary.anchorId,
                    className: "element"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                    title: prismic_reactjs.RichText.asText(primary.title),
                    subtitle: prismic_reactjs.RichText.asText(primary.subtitle)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    container: true,
                    spacing: 4,
                    direction: "row",
                    className: "endorsmentWrapperContainer",
                    children: endorsements
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    container: true,
                    direction: "row",
                    justify: "center",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                        link: primary.ctaButtonLink,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "contained",
                            color: "primary",
                            children: prismic_reactjs.RichText.asText(primary.ctaButtonText)
                        })
                    })
                })
            ]
        })
    });
};
EndorsementsComponent_Endorsements.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h,
            subtitle: utils_prop_types/* structuredTextPropTypes */.h,
            cta_button_text: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var EndorsementsComponent = ((0,withStyles/* default */.Z)(EndorsementsComponent_style)(EndorsementsComponent_Endorsements));

;// CONCATENATED MODULE: ./slices/EventDetailAbpout/style.js
function EventDetailAbpout_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var EventDetailAbpout_style_styles = function(theme) {
    var _obj, _obj1;
    return {
        eventDetailsAbout: (_obj1 = {
            marginTop: theme.spacing(10),
            marginBottom: theme.spacing(10),
            backgroundColor: "#fafafd",
            padding: theme.spacing(4)
        }, EventDetailAbpout_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(9),
            marginBottom: theme.spacing(9),
            padding: theme.spacing(3)
        }), EventDetailAbpout_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(8),
            marginBottom: theme.spacing(8),
            padding: theme.spacing(2)
        }), EventDetailAbpout_style_defineProperty(_obj1, "& .title,h1,h2,h3,h4,h5,h6", {
            color: "#4c4c78",
            lineHeight: 1.75
        }), EventDetailAbpout_style_defineProperty(_obj1, "& .subtitle,ul,p,a", {
            color: "#4c4c78",
            lineHeight: 1.89,
            fontWeight: 700,
            margin: theme.spacing(1, 0, 5)
        }), EventDetailAbpout_style_defineProperty(_obj1, "& ul", (_obj = {
            paddingLeft: 16,
            fontSize: 16
        }, EventDetailAbpout_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            fontSize: 15
        }), EventDetailAbpout_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            fontSize: 14
        }), _obj)), EventDetailAbpout_style_defineProperty(_obj1, "& .subtitleUnderline", {
            textDecoration: "underline"
        }), EventDetailAbpout_style_defineProperty(_obj1, "& .getTickets", {
            marginTop: theme.spacing(2.5)
        }), _obj1)
    };
};
/* harmony default export */ var EventDetailAbpout_style = (EventDetailAbpout_style_styles);

;// CONCATENATED MODULE: ./slices/EventDetailAbpout/index.js












var EventDetailsAbout = function(param) {
    var classes = param.classes, slice = param.slice;
    var ref;
    var primary = slice.primary;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: "lg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
            container: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.eventDetailsAbout,
                    children: [
                        prismic_reactjs.RichText.render(primary.description),
                        ((ref = primary.buttonLink) === null || ref === void 0 ? void 0 : ref.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                            link: primary.buttonLink,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "contained",
                                color: "primary",
                                className: "getTickets",
                                children: prismic_reactjs.RichText.asText(primary.buttonText)
                            })
                        })
                    ]
                })
            })
        })
    });
};
EventDetailsAbout.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h,
            subtitle: utils_prop_types/* structuredTextPropTypes */.h,
            cta_button_text: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var EventDetailAbpout = ((0,withStyles/* default */.Z)(EventDetailAbpout_style)(EventDetailsAbout));

;// CONCATENATED MODULE: ./slices/EventDetailsCta/style.js
function EventDetailsCta_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var EventDetailsCta_style_styles = function(theme) {
    var _obj;
    return {
        eventDetailsCta: (_obj = {
            backgroundImage: "url('/patternSimpleText.svg')",
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundColor: "#8BC249",
            height: 475,
            display: "flex",
            alignItems: "center",
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, EventDetailsCta_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), EventDetailsCta_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), _obj)
    };
};
/* harmony default export */ var EventDetailsCta_style = (EventDetailsCta_style_styles);

;// CONCATENATED MODULE: ./components/TextCta/style.js
function TextCta_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var TextCta_style_styles = function(theme) {
    return {
        description: TextCta_style_defineProperty({
            color: "#ffffff",
            textAlign: "center",
            lineHeight: 1.42,
            marginBottom: theme.spacing(5),
            maxWidth: 599
        }, theme.breakpoints.down("sm"), {
            maxWidth: "100%"
        })
    };
};
/* harmony default export */ var TextCta_style = (TextCta_style_styles);

;// CONCATENATED MODULE: ./components/TextCta/index.js










var TextCta = function(param) {
    var classes = param.classes, description = param.description, ctaButtonText = param.ctaButtonText, ctaButtonLink = param.ctaButtonLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: "lg",
        className: "container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
            container: true,
            direction: "column",
            justify: "center",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h4",
                    className: classes.description,
                    children: description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                    link: ctaButtonLink,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "outlined",
                        children: ctaButtonText
                    })
                })
            ]
        })
    });
};
TextCta.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    description: prop_types_default().objectOf((prop_types_default()).string).isRequired,
    ctaButtonText: prop_types_default().objectOf((prop_types_default()).string).isRequired
};
/* harmony default export */ var components_TextCta = ((0,withStyles/* default */.Z)(TextCta_style)(TextCta));

;// CONCATENATED MODULE: ./slices/EventDetailsCta/index.js









var EventDetailsCta = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.eventDetailsCta,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TextCta, {
            description: prismic_reactjs.RichText.render(primary.ctaText),
            ctaButtonText: prismic_reactjs.RichText.asText(primary.ctaButtonText),
            ctaButtonLink: primary.ctaButtonLink
        })
    });
};
EventDetailsCta.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            cta_text: utils_prop_types/* structuredTextPropTypes */.h,
            cta_button_text: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_EventDetailsCta = ((0,withStyles/* default */.Z)(EventDetailsCta_style)(EventDetailsCta));

;// CONCATENATED MODULE: ./slices/EventDetailsHero/style.js
function EventDetailsHero_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var EventDetailsHero_style_styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3;
    return {
        background: {
            backgroundPosition: "center",
            backgroundSize: "cover",
            "& .MuiGrid-container": {
                height: "100%"
            }
        },
        backgroundOverlay: EventDetailsHero_style_defineProperty({
            backgroundColor: "rgba(0,0,0,0.2)",
            height: 826
        }, theme.breakpoints.down("sm"), {
            padding: theme.spacing(20, 2),
            height: "100%"
        }),
        preTitle: (_obj = {
            padding: theme.spacing(0.5, 1),
            color: "#fff",
            zIndex: 99,
            textTransform: "uppercase",
            marginBottom: theme.spacing(3.5)
        }, EventDetailsHero_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            textAlign: "center"
        }), EventDetailsHero_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            textAlign: "center"
        }), _obj),
        heroTitle: (_obj1 = {
            backgroundImage: "url('/eventDetailsBlueBg.svg')",
            backgroundPosition: "center",
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat",
            width: "fit-content",
            padding: "33px 32px 26px 34px",
            color: "#fff",
            textAlign: "center",
            textTransform: "uppercase",
            marginRight: 250,
            marginBottom: "-10px"
        }, EventDetailsHero_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            backgroundSize: "cover",
            padding: theme.spacing(2),
            marginRight: 250
        }), EventDetailsHero_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            marginRight: 0
        }), _obj1),
        heroSubTitle: (_obj2 = {
            backgroundImage: "url('/eventDetailsGreenBg.svg')",
            backgroundPosition: "center",
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat",
            width: "fit-content",
            padding: "20px 31px",
            color: "#fff",
            textAlign: "center",
            marginLeft: 250
        }, EventDetailsHero_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            backgroundSize: "cover",
            padding: theme.spacing(2),
            marginLeft: 0
        }), EventDetailsHero_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
            marginLeft: 0
        }), _obj2),
        heroButton: EventDetailsHero_style_defineProperty({
            display: "flex",
            marginTop: theme.spacing(4),
            "& button": {
                margin: theme.spacing(2)
            }
        }, theme.breakpoints.down("sm"), {
            justifyContent: "center",
            flexDirection: "column;",
            alignItems: "center"
        }),
        eventDaysTime: (_obj3 = {
            backgroundColor: "#F4F5F6",
            backgroundImage: 'url("/patternSimpleText.svg")',
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundBlendMode: "color-burn",
            padding: theme.spacing(10, 4),
            fontFamily: "Raleway,Assistant",
            fontSize: 42,
            fontWeight: 900,
            lineHeight: 1.09,
            textAlign: "center",
            color: "#4c4c78",
            boxShadow: "0 30px 60px 0 rgba(73, 86, 149, 0.15)",
            margin: "0 80px",
            marginTop: "-105px",
            position: "absolute",
            left: 0,
            right: 0
        }, EventDetailsHero_style_defineProperty(_obj3, theme.breakpoints.down("sm"), {
            marginTop: "36px",
            padding: theme.spacing(9, 3),
            fontSize: 34
        }), EventDetailsHero_style_defineProperty(_obj3, theme.breakpoints.down("xs"), {
            padding: theme.spacing(8, 3),
            fontSize: 24
        }), EventDetailsHero_style_defineProperty(_obj3, "& .countType", {
            marginLeft: theme.spacing(1)
        }), EventDetailsHero_style_defineProperty(_obj3, "& .countSlash", EventDetailsHero_style_defineProperty({
            marginRight: theme.spacing(2),
            marginLeft: theme.spacing(2)
        }, theme.breakpoints.down("sm"), {
            marginRight: theme.spacing(1),
            marginLeft: theme.spacing(1)
        })), _obj3)
    };
};
/* harmony default export */ var EventDetailsHero_style = (EventDetailsHero_style_styles);

// EXTERNAL MODULE: ./node_modules/react-countdown-now/dist/index.es.js
var dist_index_es = __webpack_require__(6059);
;// CONCATENATED MODULE: ./slices/EventDetailsHero/index.js



// import { RichText } from 'prismic-reactjs'






// import { structuredTextPropTypes, imagePropTypes } from '../../utils/prop-types'
var EventDetailsHero = function(param1) {
    var classes = param1.classes;
    var divStyle = {};
    var Completionist = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.completion
        });
    };
    // Renderer callback with condition
    var renderer = function(param) {
        var days = param.days, hours = param.hours, minutes = param.minutes, seconds = param.seconds, completed = param.completed;
        if (completed) {
            // Render a completed state
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Completionist, {});
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    (0,dist_index_es/* zeroPad */.Bu)(days),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "countType",
                        children: "days"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "countSlash",
                        children: "/"
                    }),
                    (0,dist_index_es/* zeroPad */.Bu)(hours),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "countType",
                        children: "hours"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "countSlash",
                        children: "/"
                    }),
                    (0,dist_index_es/* zeroPad */.Bu)(minutes),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "countType",
                        children: "minutes"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "countSlash",
                        children: "/"
                    }),
                    (0,dist_index_es/* zeroPad */.Bu)(seconds),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "countType",
                        children: "seconds"
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.background,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.backgroundOverlay,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    direction: "column",
                    justify: "center",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h1",
                            className: classes.preTitle,
                            children: "SUCCOT CELEBRATION 2020"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h1",
                            className: classes.heroTitle,
                            children: "Jerusalem, Israel"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h1",
                            className: classes.heroSubTitle,
                            children: "September 18-19, 2020"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.heroButton,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "contained",
                                color: "primary",
                                children: "GET TICKETS"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classes.eventDaysTime
                })
            ]
        })
    });
};
EventDetailsHero.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_EventDetailsHero = ((0,withStyles/* default */.Z)(EventDetailsHero_style)(EventDetailsHero));

;// CONCATENATED MODULE: ./slices/EventDetailsVideo/style.js
function EventDetailsVideo_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var EventDetailsVideo_style_styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3, _obj4;
    return {
        eventDetailsVideo: (_obj4 = {
            clipPath: "polygon(0 5%, 100% 0, 100% 100%, 0% 100%)",
            position: "relative",
            backgroundColor: "#397DB7",
            backgroundImage: "url('/blueCirclePattern.png')",
            backgroundPosition: "30% 151%",
            backgroundSize: "150% 70%",
            backgroundRepeat: "no-repeat",
            paddingTop: theme.spacing(20),
            paddingBottom: theme.spacing(10)
        }, EventDetailsVideo_style_defineProperty(_obj4, theme.breakpoints.down("sm"), {
            clipPath: "polygon(0 4%, 100% 0, 100% 100%, 0% 100%)",
            paddingTop: theme.spacing(18),
            paddingBottom: theme.spacing(9)
        }), EventDetailsVideo_style_defineProperty(_obj4, theme.breakpoints.down("xs"), {
            clipPath: "polygon(0 3%, 100% 0, 100% 100%, 0% 100%)",
            paddingTop: theme.spacing(16),
            paddingBottom: theme.spacing(8)
        }), EventDetailsVideo_style_defineProperty(_obj4, "& .thumbnailWrapper", {
            position: "relative",
            cursor: "pointer",
            "& .playBtn": (_obj = {
                height: 69,
                width: 105,
                backgroundImage: "url('/playBtnBg.png')",
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                position: "absolute",
                borderRadius: 8,
                boxShadow: "0px 2px 6px 0px #1f1f1f",
                top: "50%",
                left: "50%",
                right: "50%",
                cursor: "pointer",
                transform: "translateY(-50%) translateX(-50%)"
            }, EventDetailsVideo_style_defineProperty(_obj, theme.breakpoints.down("844"), {
                height: 60,
                width: 90
            }), EventDetailsVideo_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
                height: 50,
                width: 80,
                borderRadius: 8
            }), _obj)
        }), EventDetailsVideo_style_defineProperty(_obj4, "&::after", (_obj1 = {
            clipPath: "polygon(0 15%, 100% 0, 100% 95%, 0% 100%)",
            background: "linear-gradient(90deg, rgba(140,194,75,1) 70%, rgba(74,146,207,1) 30%)",
            content: '""',
            position: "absolute",
            left: 0,
            top: "-94.7%",
            right: 0,
            height: "100%",
            display: "block",
            zIndex: 9
        }, EventDetailsVideo_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            top: "-95.7%",
            clipPath: "polygon(0% 0%, 100% 10%, 100% 96%, 0% 100%);"
        }), EventDetailsVideo_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            top: "-96.7%",
            clipPath: "polygon(0% 0%, 100% 10%, 100% 97%, 0% 100%)"
        }), _obj1)), EventDetailsVideo_style_defineProperty(_obj4, "& .speakerTitleSubWrapper", (_obj2 = {
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, EventDetailsVideo_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), EventDetailsVideo_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), _obj2)), EventDetailsVideo_style_defineProperty(_obj4, "& .getTickerSpeaker", (_obj3 = {
            margin: "64px auto 0px",
            display: "block"
        }, EventDetailsVideo_style_defineProperty(_obj3, theme.breakpoints.down("sm"), {
            margin: "56px auto 0px"
        }), EventDetailsVideo_style_defineProperty(_obj3, theme.breakpoints.down("xs"), {
            margin: "48px auto 0px"
        }), _obj3)), _obj4)
    };
};
/* harmony default export */ var EventDetailsVideo_style = (EventDetailsVideo_style_styles);

;// CONCATENATED MODULE: ./slices/EventDetailsVideo/index.js
















var EventDetailsVideo = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary, items = slice.items;
    var ref = (0,react.useState)(false), openModal = ref[0], setOpenModal = ref[1];
    var openVideoDialog = function() {
        setOpenModal(true);
    };
    var closeVideoDialog = function() {
        setOpenModal(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.eventDetailsVideo,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            maxWidth: "lg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                    title: prismic_reactjs.RichText.asText(primary.videoTitle),
                    subtitle: prismic_reactjs.RichText.asText(primary.videoSubtitle),
                    showClass: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    direction: "column",
                    justify: "center",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            onClick: function() {
                                openVideoDialog();
                            },
                            className: "thumbnailWrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ThumbnailVideo, {
                                    thumbnailVideoUrl: primary.thumbnail.url,
                                    thumbnailVideoAlt: primary.thumbnail.alt
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                    className: "playBtn",
                                    onClick: openVideoDialog
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModal/* default */.Z, {
                            open: openModal,
                            handleClose: closeVideoDialog,
                            video: primary.vimeoOrYoutubeLink
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    container: true,
                    direction: "column",
                    justify: "center",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                        link: primary.ctaButtonLink,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "contained",
                            color: "primary",
                            children: prismic_reactjs.RichText.asText(primary.ctaButtonText)
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "speakerTitleSubWrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                        title: prismic_reactjs.RichText.asText(primary.speakersTitle),
                        subtitle: prismic_reactjs.RichText.asText(primary.speakersSubtitle),
                        showClass: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    spacing: 4,
                    justify: "center",
                    className: classes.speakerItem,
                    children: [
                        items.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                sm: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonItem/* default */.Z, {
                                    bannerImageSrc: item.speakerImage.url,
                                    bannerImageAlt: item.speakerImage.alt,
                                    name: prismic_reactjs.RichText.asText(item.speakerName),
                                    title: prismic_reactjs.RichText.asText(item.title)
                                })
                            });
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                link: primary.ctaButtonLink,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    color: "primary",
                                    className: "getTickerSpeaker",
                                    children: prismic_reactjs.RichText.asText(primary.ctaButtonText)
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
EventDetailsVideo.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            video_title: utils_prop_types/* structuredTextPropTypes */.h,
            video_subtitle: utils_prop_types/* structuredTextPropTypes */.h,
            thumbnail: utils_prop_types/* imagePropTypes */.R,
            cta_button_text: utils_prop_types/* structuredTextPropTypes */.h,
            speakers_title: utils_prop_types/* structuredTextPropTypes */.h,
            speakers_subtitle: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: prop_types_default().arrayOf(prop_types_default().shape({
            speaker_image: utils_prop_types/* imagePropTypes */.R,
            name: (prop_types_default()).string,
            title1: (prop_types_default()).string
        })).isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_EventDetailsVideo = ((0,withStyles/* default */.Z)(EventDetailsVideo_style)(EventDetailsVideo));

;// CONCATENATED MODULE: ./slices/EventsDetailPastEvents/style.js
function EventsDetailPastEvents_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var EventsDetailPastEvents_style_styles = function(theme) {
    var _obj, _obj1;
    return {
        eventDetailsPastEvents: (_obj1 = {
            marginTop: theme.spacing(10),
            marginBottom: theme.spacing(10)
        }, EventsDetailPastEvents_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(9),
            marginBottom: theme.spacing(9)
        }), EventsDetailPastEvents_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(8),
            marginBottom: theme.spacing(8)
        }), EventsDetailPastEvents_style_defineProperty(_obj1, "& .eventsItemWrapper", (_obj = {
            marginTop: theme.spacing(8),
            marginBottom: theme.spacing(8)
        }, EventsDetailPastEvents_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(7),
            marginBottom: theme.spacing(7)
        }), EventsDetailPastEvents_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(6),
            marginBottom: theme.spacing(6)
        }), _obj)), _obj1)
    };
};
/* harmony default export */ var EventsDetailPastEvents_style = (EventsDetailPastEvents_style_styles);

;// CONCATENATED MODULE: ./slices/EventsDetailPastEvents/index.js














var EventDetailsPastEvents = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary, items = slice.items;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "lg",
        className: classes.eventDetailsPastEvents,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                title: prismic_reactjs.RichText.asText(primary.title),
                subtitle: prismic_reactjs.RichText.asText(primary.subtitle)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                justify: "center",
                alignItems: "center",
                className: "eventsItemWrapper",
                children: items.map(function(item) {
                    return item.pastEvent.data && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EventsItem, {
                        pastOrFuture: item.pastEvent.data.upcoming_or_past,
                        item: item.pastEvent,
                        moreDetailsLink: item.pastEvent.data.register_button_link,
                        imgSrc: item.pastEvent.data.featured_image.url,
                        imgAlt: "",
                        eventName: prismic_reactjs.RichText.asText(item.pastEvent.data.title),
                        eventPlace: prismic_reactjs.RichText.asText(item.pastEvent.data.subtitle1),
                        eventDate: prismic_reactjs.RichText.asText(item.pastEvent.data.subtitle2),
                        moreDetails: prismic_reactjs.RichText.asText(item.pastEvent.data.register_button_text),
                        eventPrice: prismic_reactjs.RichText.asText(item.pastEvent.data.price_text),
                        btnLbl: prismic_reactjs.RichText.asText(layout.past_event_watch_button_text)
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                justify: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                    link: primary.viewAllButtonLink,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "outlined",
                        color: "primary",
                        children: prismic_reactjs.RichText.asText(primary.viewAllButtonText)
                    })
                })
            })
        ]
    });
};
EventDetailsPastEvents.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            section_title: utils_prop_types/* structuredTextPropTypes */.h,
            section_subtitle: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var EventsDetailPastEvents = ((0,withStyles/* default */.Z)(EventsDetailPastEvents_style)(EventDetailsPastEvents));

;// CONCATENATED MODULE: ./slices/EventVideos/style.js
function EventVideos_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var EventVideos_style_styles = function(theme) {
    var _obj, _obj1;
    return {
        eventVideos: (_obj1 = {
            position: "relative",
            marginTop: theme.spacing(10),
            marginBottom: theme.spacing(10)
        }, EventVideos_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(9),
            marginBottom: theme.spacing(9)
        }), EventVideos_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(8),
            marginBottom: theme.spacing(8)
        }), EventVideos_style_defineProperty(_obj1, "& .thumbnailWrapper", {
            position: "relative",
            cursor: "pointer",
            "& .playBtn": (_obj = {
                height: 69,
                width: 105,
                backgroundImage: "url('/playBtnBg.png')",
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                position: "absolute",
                borderRadius: 8,
                boxShadow: "0px 2px 6px 0px #1f1f1f",
                top: "50%",
                left: "50%",
                right: "50%",
                cursor: "pointer",
                transform: "translateY(-70%) translateX(-50%)"
            }, EventVideos_style_defineProperty(_obj, theme.breakpoints.down("844"), {
                height: 60,
                width: 90
            }), EventVideos_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
                height: 50,
                width: 80,
                borderRadius: 8
            }), _obj),
            "& .titleDescWrapper": {
                marginTop: theme.spacing(-4),
                paddingLeft: theme.spacing(4),
                "& .title": {
                    color: "#4c4c78",
                    fontWeight: 700,
                    marginBottom: 16
                },
                "& .shortDescription": {
                    color: "#4c4c78",
                    fontWeight: 500,
                    lineHeight: 1.44
                }
            }
        }), _obj1)
    };
};
/* harmony default export */ var EventVideos_style = (EventVideos_style_styles);

;// CONCATENATED MODULE: ./slices/EventVideos/index.js


















var EventVideos_dateOptions = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
};
var EventVideos = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary, items = slice.items;
    var ref = (0,react.useState)(false), openModal = ref[0], setOpenModal = ref[1];
    var ref1 = (0,react.useState)(false), videoUrl = ref1[0], setVideoUrl = ref1[1];
    var openVideoDialog = function() {
        setOpenModal(true);
    };
    var closeVideoDialog = function() {
        setOpenModal(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.eventVideos,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            maxWidth: "lg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                    title: prismic_reactjs.RichText.asText(primary.title)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    container: true,
                    spacing: 4,
                    direction: "row",
                    justify: "center",
                    className: "featureBlogsContainer",
                    children: items.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            items: true,
                            xs: 12,
                            sm: 6,
                            md: 6,
                            onClick: function() {
                                setVideoUrl(item.vimeoLink);
                                openVideoDialog();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "thumbnailWrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ThumbnailVideo, {
                                        thumbnailVideoUrl: item.thumbnail.url,
                                        thumbnailVideoAlt: item.thumbnail.alt
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                        className: "playBtn",
                                        onClick: openVideoDialog
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "titleDescWrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "h4",
                                                className: "title",
                                                children: prismic_reactjs.RichText.asText(item.title)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                className: "shortDescription",
                                                children: prismic_reactjs.RichText.asText(item.shortDescription)
                                            })
                                        ]
                                    })
                                ]
                            })
                        });
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModal/* default */.Z, {
                    open: openModal,
                    handleClose: closeVideoDialog,
                    video: videoUrl
                })
            ]
        })
    });
};
EventVideos.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: prop_types_default().arrayOf(prop_types_default().shape({
            blogPost: prop_types_default().objectOf((prop_types_default()).any)
        })).isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_EventVideos = ((0,withStyles/* default */.Z)(EventVideos_style)(EventVideos));

;// CONCATENATED MODULE: ./slices/FeaturedBlogs/style.js
function FeaturedBlogs_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var FeaturedBlogs_style_styles = function(theme) {
    var _obj, _obj1;
    return {
        featuredBlogs: (_obj1 = {
            zIndex: -1,
            backgroundImage: "url('/homeLearnBg.jpg')",
            backgroundColor: "#4A92CF",
            backgroundPosition: "center",
            backgroundSize: "101% 101%",
            backgroundRepeat: "no-repeat",
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10),
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"
        }, FeaturedBlogs_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9),
            backgroundSize: "101% 101%"
        }), FeaturedBlogs_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8),
            backgroundSize: "101% 101%"
        }), FeaturedBlogs_style_defineProperty(_obj1, "& .featureBlogsContainer", (_obj = {
            marginTop: theme.spacing(10),
            marginBottom: theme.spacing(10)
        }, FeaturedBlogs_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(9),
            marginBottom: theme.spacing(9)
        }), FeaturedBlogs_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(8),
            marginBottom: theme.spacing(8)
        }), FeaturedBlogs_style_defineProperty(_obj, "& .speakerInfo", {
            backgroundColor: "#242440 ",
            marginTop: "-4px",
            "& .name, .title": {
                color: "#fff",
                textAlign: "left"
            }
        }), _obj)), _obj1)
    };
};
/* harmony default export */ var FeaturedBlogs_style = (FeaturedBlogs_style_styles);

;// CONCATENATED MODULE: ./slices/FeaturedBlogs/index.js















var FeaturedBlogs_dateOptions = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
};
var FeaturedBlogs = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary, items = slice.items;
    var additionalData = (0,additional_data_context/* useAdditionalData */.eP)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.featuredBlogs,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            maxWidth: "lg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                    title: prismic_reactjs.RichText.asText(primary.title),
                    subtitle: prismic_reactjs.RichText.asText(primary.subtitle),
                    showClass: true
                }),
                primary.showLatestBlogs && additionalData.blogs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    container: true,
                    spacing: 4,
                    direction: "row",
                    justify: "center",
                    className: "featureBlogsContainer",
                    children: additionalData.blogs.results.map(function(blog, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            md: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonItem/* default */.Z, {
                                showTag: blog.data.blog_topics && blog.data.blog_topics.length > 0,
                                link: blog,
                                tag: blog.data.blog_topics && blog.data.blog_topics.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                    link: blog.data.blog_topics[0].blog_topic,
                                    children: blog.data.blog_topics[0].blog_topic.uid
                                }) : null,
                                bannerImageSrc: blog.data.featured_image.url,
                                bannerImageAlt: blog.data.featured_image.alt,
                                name: prismic_reactjs.RichText.asText(blog.data.title),
                                title: (0,prismic_reactjs.Date)(blog.data.date).toLocaleDateString((0,next_router.useRouter)().locale, FeaturedBlogs_dateOptions)
                            })
                        }, index);
                    })
                }),
                !primary.showLatestBlogs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    container: true,
                    spacing: 4,
                    direction: "row",
                    justify: "center",
                    className: "featureBlogsContainer",
                    children: items && items.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            md: 4,
                            children: item.blogPost && item.blogPost.data && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                link: item.blogPost,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonItem/* default */.Z, {
                                    showTag: item.blogPost.data.blog_topics && item.blogPost.data.blog_topics.length > 0,
                                    bannerImageSrc: item.blogPost.data.featured_image.url,
                                    bannerImageAlt: item.blogPost.data.featured_image.alt,
                                    name: prismic_reactjs.RichText.asText(item.blogPost.data.title),
                                    title: (0,prismic_reactjs.Date)(item.blogPost.data.date).toLocaleDateString((0,next_router.useRouter)().locale, FeaturedBlogs_dateOptions),
                                    tag: item.blogPost.data.blog_topics && item.blogPost.data.blog_topics.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                        link: item.blogPost.data.blog_topics[0].blog_topic,
                                        children: item.blogPost.data.blog_topics[0].blog_topic.uid
                                    }) : null
                                })
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    container: true,
                    direction: "row",
                    justify: "center",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                        link: primary.ctaButtonLink,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "outlined",
                            children: prismic_reactjs.RichText.asText(primary.ctaButtonText)
                        })
                    })
                })
            ]
        })
    });
};
FeaturedBlogs.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h,
            subtitle: utils_prop_types/* structuredTextPropTypes */.h,
            ctaButtonText: utils_prop_types/* structuredTextPropTypes */.h,
            ctaButtonLink: prop_types_default().objectOf((prop_types_default()).any),
            showLatestBlogs: (prop_types_default()).bool
        }).isRequired,
        items: prop_types_default().arrayOf(prop_types_default().shape({
            blogPost: prop_types_default().objectOf((prop_types_default()).any)
        })).isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_FeaturedBlogs = ((0,withStyles/* default */.Z)(FeaturedBlogs_style)(FeaturedBlogs));

;// CONCATENATED MODULE: ./slices/FeaturedBlogsInProject/index.js




var FeaturedBlogsInProject_section = {
    maxWidth: "600px",
    margin: "4em auto",
    textAlign: "center"
};
var FeaturedBlogsInProject_h2 = {
    color: "#8592e0"
};
var MySlice = function(param) {
    var slice = param.slice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        style: FeaturedBlogsInProject_section,
        children: [
            slice.primary.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                render: slice.primary.title
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                style: FeaturedBlogsInProject_h2,
                children: "Template slice, update me!"
            }),
            slice.primary.description ? /*#__PURE__*/ (0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                render: slice.primary.description
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "start by editing this slice from inside the SliceMachine builder!"
            })
        ]
    });
};
MySlice.propTypes = {
    slice: (0,prop_types.shape)({
        primary: (0,prop_types.shape)({
            title: prop_types.array.isRequired
        }).isRequired
    }).isRequired
};
/* harmony default export */ var FeaturedBlogsInProject = (MySlice);

;// CONCATENATED MODULE: ./slices/FeaturedMembers/style.js
function FeaturedMembers_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var FeaturedMembers_style_styles = function(theme) {
    var _obj, _obj1;
    return {
        featuredMember: (_obj1 = {
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10),
            position: "relative"
        }, FeaturedMembers_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), FeaturedMembers_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), FeaturedMembers_style_defineProperty(_obj1, "& .boardMemberItem", (_obj = {
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, FeaturedMembers_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), FeaturedMembers_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), _obj)), FeaturedMembers_style_defineProperty(_obj1, "& .viewAll", {
            margin: "0 auto"
        }), FeaturedMembers_style_defineProperty(_obj1, "& .element", {
            position: "absolute",
            top: 80
        }), _obj1)
    };
};
/* harmony default export */ var FeaturedMembers_style = (FeaturedMembers_style_styles);

;// CONCATENATED MODULE: ./slices/FeaturedMembers/index.js















var FeaturedMembers = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary, items = slice.items;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "lg",
        className: classes.featuredMember,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: primary.anchorId,
                className: "element"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                title: prismic_reactjs.RichText.asText(primary.title),
                subtitle: prismic_reactjs.RichText.asText(primary.subtitle)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                spacing: 4,
                className: "boardMemberItem",
                direction: "row",
                justify: "center",
                alignItems: "center",
                children: items && items.map(function(item) {
                    return layout && item && item.person && item.person.data && item.person.data.person_type && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonItem/* default */.Z, {
                            bannerImageSrc: item.person.data.portrait_image.url,
                            bannerImageAlt: "",
                            name: prismic_reactjs.RichText.asText(item.person.data.name),
                            title: prismic_reactjs.RichText.asText(item.person.data.title),
                            btnLabel: prismic_reactjs.RichText.asText(layout.full_bio_button_text),
                            showTag: false,
                            showBtn: true,
                            link: item.person
                        })
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                direction: "row",
                justify: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                    link: primary.ctaButtonLink,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "contained",
                        color: "primary",
                        children: prismic_reactjs.RichText.asText(primary.ctaButtonText)
                    })
                })
            })
        ]
    });
};
FeaturedMembers.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h,
            subtitle: utils_prop_types/* structuredTextPropTypes */.h,
            cta_button_text: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_FeaturedMembers = ((0,withStyles/* default */.Z)(FeaturedMembers_style)(FeaturedMembers));

;// CONCATENATED MODULE: ./slices/FeaturedWork/style.js
function FeaturedWork_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var FeaturedWork_style_styles = function(theme) {
    var _obj, _obj1, _obj2;
    return {
        FeaturedWork: (_obj2 = {
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, FeaturedWork_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), FeaturedWork_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), FeaturedWork_style_defineProperty(_obj2, "& .CategoryTagWrapper", (_obj = {
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, FeaturedWork_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), FeaturedWork_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), _obj)), FeaturedWork_style_defineProperty(_obj2, "& .viewAll", (_obj1 = {
            margin: "80px auto 0px"
        }, FeaturedWork_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            margin: "72px auto 0px"
        }), FeaturedWork_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            margin: "64px auto 0px"
        }), _obj1)), _obj2)
    };
};
/* harmony default export */ var FeaturedWork_style = (FeaturedWork_style_styles);

// EXTERNAL MODULE: ./components/WorkItem/index.js + 1 modules
var WorkItem = __webpack_require__(3438);
;// CONCATENATED MODULE: ./slices/FeaturedWork/index.js
















var FeaturedWork = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary, items = slice.items;
    var additionalData = (0,additional_data_context/* useAdditionalData */.eP)();
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    var ref = (0,react.useState)(additionalData && additionalData.project && additionalData.project.next_page), nextPage = ref[0], setNextPage = ref[1];
    var ref1 = (0,react.useState)(additionalData && additionalData.project && additionalData.project.results), results = ref1[0], setResults = ref1[1];
    (0,react.useEffect)(function() {
        fetch("".concat(nextPage)).then(function(response) {
            return response.json();
        }).then(function(data) {
            setResults(results.concat(data.results));
            setNextPage(data.next_page);
        });
    }, [
        nextPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "lg",
        className: classes.FeaturedWork,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                title: prismic_reactjs.RichText.asText(primary.title),
                subtitle: prismic_reactjs.RichText.asText(primary.subtitle)
            }),
            primary.showAllCategories && additionalData.project_category && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                spacing: 2,
                direction: "row",
                justify: "center",
                alignItems: "center",
                className: "CategoryTagWrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            style: {
                                textDecoration: "none"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTag/* default */.Z, {
                                CategoryTagIconSrc: "/viewAll.svg",
                                CategoryTagIconAlt: "View All",
                                CategoryTagTitle: prismic_reactjs.RichText.asText(layout.projects_view_all_button_text),
                                showIcon: true
                            })
                        })
                    }),
                    additionalData.project_category.results.map(function(category, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                link: category,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTag/* default */.Z, {
                                    CategoryTagIconSrc: category.data.icon.url,
                                    CategoryTagIconAlt: category.data.icon.alt,
                                    CategoryTagTitle: prismic_reactjs.RichText.asText(category.data.title),
                                    showIcon: true
                                })
                            })
                        }, index);
                    })
                ]
            }),
            !primary.showAllCategories && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                spacing: 4,
                direction: "row",
                justify: "center",
                alignItems: "center",
                className: "CategoryTagWrapper",
                children: [
                    primary.featuredWorkCategory1 && primary.featuredWorkCategory1.data && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        sm: 4,
                        md: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                            link: primary.featuredWorkCategory1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTag/* default */.Z, {
                                CategoryTagIconSrc: primary.featuredWorkCategory1.data.icon.url,
                                CategoryTagIconAlt: primary.featuredWorkCategory1.data.icon.alt,
                                CategoryTagTitle: prismic_reactjs.RichText.asText(primary.featuredWorkCategory1.data.title),
                                showIcon: true
                            })
                        })
                    }),
                    primary.featuredWorkCategory2 && primary.featuredWorkCategory2.data && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        sm: 4,
                        md: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                            link: primary.featuredWorkCategory2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTag/* default */.Z, {
                                CategoryTagIconSrc: primary.featuredWorkCategory2.data.icon.url,
                                CategoryTagIconAlt: primary.featuredWorkCategory2.data.icon.alt,
                                CategoryTagTitle: prismic_reactjs.RichText.asText(primary.featuredWorkCategory2.data.title),
                                showIcon: true
                            })
                        })
                    }),
                    primary.featuredWorkCategory3 && primary.featuredWorkCategory3.data && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        sm: 4,
                        md: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                            link: primary.featuredWorkCategory3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTag/* default */.Z, {
                                CategoryTagIconSrc: primary.featuredWorkCategory3.data.icon.url,
                                CategoryTagIconAlt: primary.featuredWorkCategory3.data.icon.alt,
                                CategoryTagTitle: prismic_reactjs.RichText.asText(primary.featuredWorkCategory3.data.title),
                                showIcon: true
                            })
                        })
                    }),
                    primary.featuredWorkCategory4 && primary.featuredWorkCategory4.data && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        sm: 4,
                        md: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                            link: primary.featuredWorkCategory4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTag/* default */.Z, {
                                CategoryTagIconSrc: primary.featuredWorkCategory4.data.icon.url,
                                CategoryTagIconAlt: primary.featuredWorkCategory4.data.icon.alt,
                                CategoryTagTitle: prismic_reactjs.RichText.asText(primary.featuredWorkCategory4.data.title),
                                showIcon: true
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                spacing: 4,
                direction: "row",
                justify: "center",
                children: [
                    !primary.showAllProjects && items.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            md: 4,
                            children: item.featuredProject && item.featuredProject.data && /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkItem/* default */.Z, {
                                work: item.featuredProject
                            })
                        }, index);
                    }),
                    primary.showAllProjects && results && results.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            md: 4,
                            children: item.data && /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkItem/* default */.Z, {
                                work: item
                            })
                        }, index);
                    })
                ]
            }),
            !primary.showAllProjects && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                direction: "row",
                justify: "center",
                alignItems: "center",
                className: "viewAll",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                    link: primary.viewAllButtonLink,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "contained",
                        color: "primary",
                        children: prismic_reactjs.RichText.asText(primary.viewAllButtonText)
                    })
                })
            })
        ]
    });
};
FeaturedWork.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h,
            subtitle: utils_prop_types/* structuredTextPropTypes */.h,
            featuredWorkCategory1: prop_types_default().objectOf((prop_types_default()).any),
            featuredWorkCategory2: prop_types_default().objectOf((prop_types_default()).any),
            featuredWorkCategory3: prop_types_default().objectOf((prop_types_default()).any),
            featuredWorkCategory4: prop_types_default().objectOf((prop_types_default()).any),
            viewAllButtonText: utils_prop_types/* structuredTextPropTypes */.h,
            viewAllButtonLink: prop_types_default().objectOf((prop_types_default()).any),
            showAllProjects: (prop_types_default()).bool,
            showAllCategories: (prop_types_default()).bool
        }).isRequired,
        items: prop_types_default().arrayOf(prop_types_default().shape({
            featuredProject: prop_types_default().objectOf((prop_types_default()).any)
        })).isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_FeaturedWork = ((0,withStyles/* default */.Z)(FeaturedWork_style)(FeaturedWork));

;// CONCATENATED MODULE: ./slices/HeroBackgroundImage/style.js
function HeroBackgroundImage_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var HeroBackgroundImage_style_styles = function(theme) {
    var _obj;
    return {
        workDetailsHeroBackground: {
            backgroundPosition: "center",
            backgroundSize: "cover",
            "& .container ": {
                height: "100%"
            }
        },
        backgroundOverlay: (_obj = {
            backgroundColor: "rgba(0,0,0,0.2)",
            height: 826
        }, HeroBackgroundImage_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            padding: theme.spacing(20, 2),
            height: "100%"
        }), HeroBackgroundImage_style_defineProperty(_obj, "& .highlightedText,.description, .boldText", {
            color: "#fff",
            textTransform: "uppercase",
            textAlign: "center",
            padding: theme.spacing(1.5, 0)
        }), HeroBackgroundImage_style_defineProperty(_obj, "& .boldText", {
            fontWeight: 900
        }), _obj),
        heroButton: HeroBackgroundImage_style_defineProperty({
            display: "flex",
            marginTop: theme.spacing(4),
            "& button": {
                margin: theme.spacing(2)
            }
        }, theme.breakpoints.down("sm"), {
            justifyContent: "center",
            flexDirection: "column;",
            alignItems: "center"
        })
    };
};
/* harmony default export */ var HeroBackgroundImage_style = (HeroBackgroundImage_style_styles);

;// CONCATENATED MODULE: ./slices/HeroBackgroundImage/index.js











var HeroBackgroundImage = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    var styles = {};
    if (primary.backgroundImage) {
        styles.backgroundImage = "url(".concat(primary.backgroundImage.url, ")");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.workDetailsHeroBackground,
        style: styles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.backgroundOverlay,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "lg",
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    direction: "column",
                    justify: "center",
                    alignItems: "center",
                    className: "container",
                    children: [
                        primary.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h3",
                            className: "description",
                            children: prismic_reactjs.RichText.asText(primary.title)
                        }),
                        primary.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "subtitle1",
                            className: "boldText",
                            children: prismic_reactjs.RichText.asText(primary.description)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.heroButton,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    color: "primary",
                                    children: prismic_reactjs.RichText.asText(primary.primaryCtaButtonText)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "outlined",
                                    children: prismic_reactjs.RichText.asText(primary.secondaryCtaButtonText)
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
HeroBackgroundImage.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h,
            description: utils_prop_types/* structuredTextPropTypes */.h,
            backgroundImage: utils_prop_types/* imagePropTypes */.R,
            primaryCtaButtonText: utils_prop_types/* structuredTextPropTypes */.h,
            secondaryCtaButtonText: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_HeroBackgroundImage = ((0,withStyles/* default */.Z)(HeroBackgroundImage_style)(HeroBackgroundImage));

;// CONCATENATED MODULE: ./slices/HomepageHero/style.js
function HomepageHero_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var HomepageHero_style_styles = function(theme) {
    var _obj;
    return {
        background: {
            display: "flex",
            backgroundPosition: "center",
            backgroundSize: "cover",
            "& .MuiGrid-container": {
                height: "100%"
            }
        },
        backgroundOverlay: HomepageHero_style_defineProperty({
            backgroundColor: "rgba(0,0,0,0.2)",
            height: 826,
            width: "100%"
        }, theme.breakpoints.down("sm"), {
            padding: theme.spacing(20, 2),
            height: "100%"
        }),
        preTitle: {
            backgroundColor: "#1c2834",
            padding: theme.spacing(0.5, 1),
            color: "#fff",
            marginBottom: theme.spacing(-2),
            zIndex: 99,
            textTransform: "uppercase"
        },
        heroTitle: HomepageHero_style_defineProperty({
            backgroundImage: "url('/homepage-title-background.png')",
            backgroundPosition: "center",
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat",
            width: "fit-content",
            padding: "33px 32px 26px 34px",
            color: "#fff",
            textAlign: "center",
            textTransform: "uppercase",
            marginBottom: "-10px"
        }, theme.breakpoints.down("sm"), {
            backgroundSize: "cover",
            padding: theme.spacing(2)
        }),
        heroSubTitle: HomepageHero_style_defineProperty({
            backgroundImage: "url('/homepage-subtitle-background.png')",
            backgroundPosition: "center",
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat",
            width: "fit-content",
            padding: "20px 31px",
            color: "#fff",
            textAlign: "center",
            marginBottom: theme.spacing(4)
        }, theme.breakpoints.down("sm"), {
            backgroundSize: "cover",
            padding: theme.spacing(2)
        }),
        heroButton: HomepageHero_style_defineProperty({
            display: "flex",
            marginTop: theme.spacing(4),
            "& button": {
                margin: theme.spacing(2)
            }
        }, theme.breakpoints.down("sm"), {
            justifyContent: "center",
            flexDirection: "column;",
            alignItems: "center"
        }),
        pointsWrapper: (_obj = {
            display: "flex",
            alignItems: "center"
        }, HomepageHero_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            justifyContent: "center",
            flexDirection: "column;"
        }), HomepageHero_style_defineProperty(_obj, "& h6", {
            fontWeight: 900,
            color: "#fff",
            textTransform: "uppercase"
        }), HomepageHero_style_defineProperty(_obj, "& .bulletPoint", HomepageHero_style_defineProperty({
            width: 5,
            height: 5,
            backgroundColor: "#8bc249",
            borderRadius: 5,
            margin: theme.spacing(0, 2.5)
        }, theme.breakpoints.down("sm"), {
            margin: theme.spacing(1, 0)
        })), _obj)
    };
};
/* harmony default export */ var HomepageHero_style = (HomepageHero_style_styles);

;// CONCATENATED MODULE: ./slices/HomepageHero/index.js












var HomepageHero = function(props) {
    var slice = props.slice, classes = props.classes;
    var primary = slice.primary;
    var ref = (0,react.useState)(false), openModal = ref[0], setOpenModal = ref[1];
    var styles = {};
    if (primary.backgroundImage) {
        styles.backgroundImage = "url(".concat(primary.backgroundImage.url, ")");
    }
    var openVideoDialog = function() {
        setOpenModal(true);
    };
    var closeVideoDialog = function() {
        setOpenModal(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.background,
        style: styles,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.backgroundOverlay,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    direction: "column",
                    justify: "center",
                    alignItems: "center",
                    children: [
                        primary.preTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h6",
                            className: classes.preTitle,
                            children: prismic_reactjs.RichText.asText(primary.preTitle)
                        }),
                        primary.title1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h1",
                            className: classes.heroTitle,
                            children: prismic_reactjs.RichText.asText(primary.title1)
                        }),
                        primary.title2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h1",
                            className: classes.heroSubTitle,
                            children: prismic_reactjs.RichText.asText(primary.title2)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.pointsWrapper,
                            children: [
                                primary.point1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: prismic_reactjs.RichText.asText(primary.point1)
                                }),
                                primary.point2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "bulletPoint"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: prismic_reactjs.RichText.asText(primary.point2)
                                        })
                                    ]
                                }),
                                primary.point3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "bulletPoint"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: prismic_reactjs.RichText.asText(primary.point3)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.heroButton,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                    link: primary.primaryCtaButtonLink,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: "contained",
                                        color: "primary",
                                        children: prismic_reactjs.RichText.asText(primary.primaryCtaButtonText)
                                    })
                                }),
                                primary.secondaryButtonType ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: openVideoDialog,
                                    variant: "outlined",
                                    children: prismic_reactjs.RichText.asText(primary.secondaryCtaButtonText)
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                    link: primary.primaryCtaButtonLink,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: "outlined",
                                        children: prismic_reactjs.RichText.asText(primary.secondaryCtaButtonText)
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModal/* default */.Z, {
                open: openModal,
                handleClose: closeVideoDialog,
                video: primary.vimeoLink
            })
        ]
    });
};
HomepageHero.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            preTitle: utils_prop_types/* structuredTextPropTypes */.h,
            title1: utils_prop_types/* structuredTextPropTypes */.h,
            title2: utils_prop_types/* structuredTextPropTypes */.h,
            point1: utils_prop_types/* structuredTextPropTypes */.h,
            point2: utils_prop_types/* structuredTextPropTypes */.h,
            point3: utils_prop_types/* structuredTextPropTypes */.h,
            backgroundImage: utils_prop_types/* imagePropTypes */.R,
            primaryCtaButtonLink: prop_types_default().objectOf((prop_types_default()).any),
            primaryCtaButtonText: utils_prop_types/* structuredTextPropTypes */.h,
            secondaryCtaButtonText: utils_prop_types/* structuredTextPropTypes */.h,
            secondaryCtaButtonLink: prop_types_default().objectOf((prop_types_default()).any),
            vimeoLink: prop_types_default().objectOf((prop_types_default()).any),
            secondaryButtonType: (prop_types_default()).bool
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_HomepageHero = ((0,withStyles/* default */.Z)(HomepageHero_style)(HomepageHero));

;// CONCATENATED MODULE: ./slices/ImageGallery/style.js
function ImageGallery_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var ImageGallery_style_styles = function(theme) {
    var _obj, _obj1;
    return {
        workDetailsGallery: (_obj1 = {
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, ImageGallery_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), ImageGallery_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), ImageGallery_style_defineProperty(_obj1, "& .galleryContainer", (_obj = {
            marginTop: theme.spacing(10)
        }, ImageGallery_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(9)
        }), ImageGallery_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(8)
        }), ImageGallery_style_defineProperty(_obj, "& img", {
            width: "100%",
            boxShadow: "0 22px 57px 0 rgba(37, 44, 80, 0.5)"
        }), _obj)), _obj1)
    };
};
/* harmony default export */ var ImageGallery_style = (ImageGallery_style_styles);

;// CONCATENATED MODULE: ./slices/ImageGallery/index.js











var WorkDetailsGallery = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary, items = slice.items;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        className: classes.workDetailsGallery,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                title: prismic_reactjs.RichText.asText(primary.sectionTitle),
                subtitle: prismic_reactjs.RichText.asText(primary.sectionSubtitle)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                spacing: 4,
                className: "galleryContainer",
                children: items.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: item.photo.url,
                            alt: item.photo.alt
                        })
                    });
                })
            })
        ]
    });
};
WorkDetailsGallery.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            sectionTitle: utils_prop_types/* structuredTextPropTypes */.h,
            sectionSubtitle: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: prop_types_default().arrayOf(prop_types_default().shape({
            photo: utils_prop_types/* imagePropTypes */.R
        })).isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var ImageGallery = ((0,withStyles/* default */.Z)(ImageGallery_style)(WorkDetailsGallery));

;// CONCATENATED MODULE: ./slices/ImapctStatement/style.js
function ImapctStatement_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var ImapctStatement_style_styles = function(theme) {
    var _obj;
    return {
        impactStatement: (_obj = {
            backgroundImage: "url('/patternSimpleText.svg')",
            backgroundColor: "#397DB7",
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            paddingTop: theme.spacing(20),
            paddingBottom: theme.spacing(20)
        }, ImapctStatement_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(15),
            paddingBottom: theme.spacing(15),
            backgroundPosition: "100%",
            backgroundSize: "cover"
        }), ImapctStatement_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10),
            backgroundPosition: "100%",
            backgroundSize: "cover"
        }), ImapctStatement_style_defineProperty(_obj, "& .impactStatement", {
            color: "#fff",
            fontStyle: "italic",
            textAlign: "center"
        }), _obj)
    };
};
/* harmony default export */ var ImapctStatement_style = (ImapctStatement_style_styles);

;// CONCATENATED MODULE: ./slices/ImapctStatement/index.js










var ImpactStatement = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.impactStatement,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "md",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                direction: "row",
                justify: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h1",
                        component: "h2",
                        className: "impactStatement",
                        children: prismic_reactjs.RichText.asText(primary.impactStatement)
                    })
                })
            })
        })
    });
};
ImpactStatement.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            impact_statement: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var ImapctStatement = ((0,withStyles/* default */.Z)(ImapctStatement_style)(ImpactStatement));

;// CONCATENATED MODULE: ./slices/OurPartners/style.js
function OurPartners_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var OurPartners_style_styles = function(theme) {
    var _obj, _obj1;
    return {
        partners: (_obj1 = {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, OurPartners_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), OurPartners_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), OurPartners_style_defineProperty(_obj1, "& .partnerLogo", (_obj = {
            display: "flex",
            justifyContent: "center",
            width: "100%",
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, OurPartners_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9),
            display: "block",
            textAlign: "center"
        }), OurPartners_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), OurPartners_style_defineProperty(_obj, "& img", OurPartners_style_defineProperty({
            flex: 1,
            margin: theme.spacing(3),
            maxWidth: 350
        }, theme.breakpoints.down("xs"), {
            display: "block",
            margin: "48px auto",
            width: "100%"
        })), _obj)), _obj1)
    };
};
/* harmony default export */ var OurPartners_style = (OurPartners_style_styles);

;// CONCATENATED MODULE: ./slices/OurPartners/index.js












var Partners = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary, items = slice.items;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "lg",
        className: classes.partners,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                title: prismic_reactjs.RichText.asText(primary.title),
                subtitle: prismic_reactjs.RichText.asText(primary.subtitle)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "partnerLogo",
                children: items.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: item.partnerLogo.url,
                        alt: "profile",
                        className: classes.testimonialImg
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                link: primary.ctaButtonLink,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "contained",
                    color: "primary",
                    className: "cta",
                    children: prismic_reactjs.RichText.asText(primary.ctaButtonText)
                })
            })
        ]
    });
};
Partners.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h,
            subtitle: utils_prop_types/* structuredTextPropTypes */.h,
            ctaButtonText: utils_prop_types/* structuredTextPropTypes */.h,
            ctaButtonLink: prop_types_default().objectOf((prop_types_default()).any)
        }).isRequired,
        items: prop_types_default().arrayOf(prop_types_default().shape({
            partnerLogo: utils_prop_types/* imagePropTypes */.R
        })).isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var OurPartners = ((0,withStyles/* default */.Z)(OurPartners_style)(Partners));

;// CONCATENATED MODULE: ./slices/PastEvent/style.js
function PastEvent_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var PastEvent_style_styles = function(theme) {
    var _obj, _obj1;
    return {
        eventListPastEvent: (_obj1 = {
            backgroundColor: "#242440",
            backgroundPosition: "center",
            backgroundSize: "cover",
            marginTop: theme.spacing(10),
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, PastEvent_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(9),
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), PastEvent_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(8),
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), PastEvent_style_defineProperty(_obj1, "& .pastEventBtnWrapper", (_obj = {
            marginTop: theme.spacing(5)
        }, PastEvent_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(4)
        }), PastEvent_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(2)
        }), _obj)), _obj1)
    };
};
/* harmony default export */ var PastEvent_style = (PastEvent_style_styles);

;// CONCATENATED MODULE: ./slices/PastEvent/index.js












var EventListPastEvent = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.eventListPastEvent,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            maxWidth: "md",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                    title: prismic_reactjs.RichText.asText(primary.title),
                    subtitle: prismic_reactjs.RichText.asText(primary.description),
                    showClass: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    container: true,
                    direction: "row",
                    justify: "center",
                    alignItems: "center",
                    className: "pastEventBtnWrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                        link: primary.buttonLink,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "outlined",
                            children: prismic_reactjs.RichText.asText(primary.buttonText)
                        })
                    })
                })
            ]
        })
    });
};
EventListPastEvent.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h,
            description: utils_prop_types/* structuredTextPropTypes */.h,
            button_text: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var PastEvent = ((0,withStyles/* default */.Z)(PastEvent_style)(EventListPastEvent));

;// CONCATENATED MODULE: ./slices/ProjectGallery/style.js
function ProjectGallery_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var ProjectGallery_style_styles = function(theme) {
    var _obj, _obj1;
    return {
        workDetailsGallery: (_obj1 = {
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, ProjectGallery_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), ProjectGallery_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), ProjectGallery_style_defineProperty(_obj1, "& .galleryContainerTitleSub", (_obj = {
            height: 0,
            marginBottom: theme.spacing(10)
        }, ProjectGallery_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            marginBottom: theme.spacing(9)
        }), ProjectGallery_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            marginBottom: theme.spacing(8)
        }), _obj)), ProjectGallery_style_defineProperty(_obj1, "& .galleryContainer", {
            "& img": ProjectGallery_style_defineProperty({
                width: "100%",
                height: 300,
                objectFit: "cover",
                cursor: "pointer",
                boxShadow: "0 22px 57px 0 rgba(37, 44, 80, 0.5)",
                transition: "transform .9s",
                "&:hover": {
                    transform: "scale(1.05)",
                    "-ms-transform": "scale(1.05)",
                    "-webkit-transform": "scale(1.05)"
                }
            }, theme.breakpoints.down("xs"), {
                height: "auto",
                objectFit: "unset"
            })
        }), _obj1)
    };
};
/* harmony default export */ var ProjectGallery_style = (ProjectGallery_style_styles);

// EXTERNAL MODULE: ./node_modules/lightbox-react/dist/main.js
var main = __webpack_require__(4557);
var main_default = /*#__PURE__*/__webpack_require__.n(main);
;// CONCATENATED MODULE: ./slices/ProjectGallery/index.js












var ProjectGallery_WorkDetailsGallery = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary, items = slice.items;
    var ref = (0,react.useState)(0), photoIndex = ref[0], setPhotoIndex = ref[1];
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        className: classes.workDetailsGallery,
        children: [
            primary.sectionTitle && primary.sectionSubtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "galleryContainerTitleSub",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                    title: prismic_reactjs.RichText.asText(primary.sectionTitle),
                    subtitle: prismic_reactjs.RichText.asText(primary.sectionSubtitle)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                spacing: 4,
                className: "galleryContainer",
                children: items.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 4,
                        onClick: function() {
                            setIsOpen(true);
                            setPhotoIndex(index);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: item.image.url,
                            alt: item.image.alt
                        })
                    });
                })
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)((main_default()), {
                mainSrc: items[photoIndex].image.url,
                nextSrc: items[(photoIndex + 1) % items.length].image.url,
                prevSrc: items[(photoIndex + items.length - 1) % items.length].image.url,
                onCloseRequest: function() {
                    return setIsOpen(false);
                },
                onMovePrevRequest: function() {
                    return setPhotoIndex((photoIndex + items.length - 1) % items.length);
                },
                onMoveNextRequest: function() {
                    return setPhotoIndex((photoIndex + 1) % items.length);
                }
            })
        ]
    });
};
ProjectGallery_WorkDetailsGallery.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            sectionTitle: utils_prop_types/* structuredTextPropTypes */.h,
            sectionSubtitle: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: prop_types_default().arrayOf(prop_types_default().shape({
            photo: utils_prop_types/* imagePropTypes */.R
        })).isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var ProjectGallery = ((0,withStyles/* default */.Z)(ProjectGallery_style)(ProjectGallery_WorkDetailsGallery));

;// CONCATENATED MODULE: ./slices/QuoteTestimonials/style.js
function QuoteTestimonials_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var QuoteTestimonials_style_styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5, _obj6, _obj7, _obj8;
    return {
        quoteTestimonialsBg: (_obj5 = {
            backgroundImage: "url('/greenCirclePattner.png')",
            backgroundPosition: "bottom",
            backgroundSize: "128% 70%",
            backgroundRepeat: "no-repeat",
            clipPath: "polygon(0 5%, 100% 0, 100% 100%, 0% 100%)",
            position: "relative",
            backgroundColor: "#8BC249",
            paddingTop: theme.spacing(20),
            paddingBottom: theme.spacing(10)
        }, QuoteTestimonials_style_defineProperty(_obj5, theme.breakpoints.down("sm"), {
            clipPath: "polygon(0 4%, 100% 0, 100% 100%, 0% 100%)",
            paddingTop: theme.spacing(18),
            paddingBottom: theme.spacing(9),
            backgroundSize: "200% 70%"
        }), QuoteTestimonials_style_defineProperty(_obj5, theme.breakpoints.down("xs"), {
            clipPath: "polygon(0 3%, 100% 0, 100% 100%, 0% 100%)",
            paddingTop: theme.spacing(16),
            paddingBottom: theme.spacing(8)
        }), QuoteTestimonials_style_defineProperty(_obj5, "&::after", (_obj = {
            clipPath: "polygon(0 15%, 100% 0, 100% 95%, 0% 100%)",
            background: "linear-gradient(90deg,rgba(140,194,75,1) 10%, rgba(105, 144, 57,1) 60%,  rgba(74,146,207,1) 30%)",
            content: '""',
            position: "absolute",
            left: 0,
            top: "-94.7%",
            right: 0,
            height: "100%",
            display: "block",
            zIndex: 9
        }, QuoteTestimonials_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            top: "-95.7%",
            clipPath: "polygon(0% 0%, 100% 10%, 100% 96%, 0% 100%);"
        }), QuoteTestimonials_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            top: "-96.7%",
            clipPath: "polygon(0% 0%, 100% 10%, 100% 97%, 0% 100%)"
        }), _obj)), QuoteTestimonials_style_defineProperty(_obj5, "& .quoteImg", {
            width: 26,
            marginRight: theme.spacing(1)
        }), QuoteTestimonials_style_defineProperty(_obj5, "& .quoteText", QuoteTestimonials_style_defineProperty({
            fontWeight: 900,
            color: "#ffffff",
            fontStyle: "italic",
            lineHeight: 2.72
        }, theme.breakpoints.down("sm"), {
            lineHeight: 1.72
        })), QuoteTestimonials_style_defineProperty(_obj5, "& .quoteAuthor", QuoteTestimonials_style_defineProperty({
            fontSize: 21,
            fontWeight: 900,
            color: "#fff",
            marginTop: theme.spacing(7.5)
        }, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(3.5)
        })), QuoteTestimonials_style_defineProperty(_obj5, "& .quoteRight", {
            position: "absolute",
            marginTop: theme.spacing(1),
            marginLeft: theme.spacing(1)
        }), QuoteTestimonials_style_defineProperty(_obj5, "& .rightImage", (_obj1 = {
            borderRadius: "67% 40% 53% 60% / 40% 37% 63% 70%",
            height: 469,
            width: 570,
            objectFit: "cover",
            position: "relative",
            zIndex: 99
        }, QuoteTestimonials_style_defineProperty(_obj1, theme.breakpoints.down("md"), {
            width: 500
        }), QuoteTestimonials_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            width: 570
        }), QuoteTestimonials_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            width: "100%",
            height: "100%"
        }), _obj1)), QuoteTestimonials_style_defineProperty(_obj5, "& .rightImageOverlay", (_obj2 = {
            borderRadius: "32% 68% 42% 58% / 36% 71% 29% 64%",
            width: 570,
            height: 469,
            position: "absolute",
            zIndex: 9,
            backgroundColor: "rgba(0, 0, 0, 0.2)"
        }, QuoteTestimonials_style_defineProperty(_obj2, theme.breakpoints.down("md"), {
            width: 500
        }), QuoteTestimonials_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            width: 570
        }), QuoteTestimonials_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
            width: 350,
            height: 232
        }), QuoteTestimonials_style_defineProperty(_obj2, theme.breakpoints.down("400"), {
            width: 250,
            height: 170
        }), _obj2)), QuoteTestimonials_style_defineProperty(_obj5, "& .quoteWrapper", (_obj3 = {
            marginBottom: theme.spacing(10)
        }, QuoteTestimonials_style_defineProperty(_obj3, theme.breakpoints.down("sm"), {
            marginBottom: theme.spacing(9)
        }), QuoteTestimonials_style_defineProperty(_obj3, theme.breakpoints.down("xs"), {
            marginBottom: theme.spacing(8)
        }), _obj3)), QuoteTestimonials_style_defineProperty(_obj5, "& .testimonialWrapper", (_obj4 = {
            marginTop: theme.spacing(15)
        }, QuoteTestimonials_style_defineProperty(_obj4, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(12.5)
        }), QuoteTestimonials_style_defineProperty(_obj4, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(10)
        }), _obj4)), _obj5),
        testimonialCardGrid: QuoteTestimonials_style_defineProperty({
            height: "100%",
            display: "flex",
            justifyContent: "center"
        }, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(4)
        }),
        testimonialCard: (_obj7 = {
            borderRadius: 14,
            boxShadow: "0 20px 30px 0 rgba(0, 0, 0, 0.2)",
            backgroundColor: "#ffffff",
            padding: theme.spacing(9, 5),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center"
        }, QuoteTestimonials_style_defineProperty(_obj7, theme.breakpoints.down("sm"), {
            padding: theme.spacing(9, 2, 2)
        }), QuoteTestimonials_style_defineProperty(_obj7, "& .name", {
            color: "#4c4c78",
            fontFamily: "Raleway,Assistant",
            fontWeight: 900
        }), QuoteTestimonials_style_defineProperty(_obj7, "& .testimonialTitle", (_obj6 = {
            fontSize: 12,
            fontWeight: 700,
            color: "#8bc249",
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(2.5)
        }, QuoteTestimonials_style_defineProperty(_obj6, theme.breakpoints.down("sm"), {
            fontSize: 11,
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(2)
        }), QuoteTestimonials_style_defineProperty(_obj6, theme.breakpoints.down("xs"), {
            fontSize: 10,
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        }), _obj6)), QuoteTestimonials_style_defineProperty(_obj7, "& .testimonial", {
            color: "#4c4c78",
            fontWeight: 700,
            lineHeight: 1.86
        }), _obj7),
        testimonialImg: {
            width: 117,
            height: 117,
            borderRadius: 100,
            boxShadow: "0 38px 66px 0 rgba(80, 82, 138, 0.18)",
            border: "solid 1px #ffffff",
            position: "absolute",
            marginTop: "-60px"
        },
        videoButton: (_obj8 = {
            marginTop: theme.spacing(10)
        }, QuoteTestimonials_style_defineProperty(_obj8, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(9)
        }), QuoteTestimonials_style_defineProperty(_obj8, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(8)
        }), _obj8)
    };
};
/* harmony default export */ var QuoteTestimonials_style = (QuoteTestimonials_style_styles);

;// CONCATENATED MODULE: ./slices/QuoteTestimonials/index.js














var QuoteTestimonials = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary, items = slice.items;
    var ref = (0,react.useState)(false), openModal = ref[0], setOpenModal = ref[1];
    var openVideoDialog = function() {
        setOpenModal(true);
    };
    var closeVideoDialog = function() {
        setOpenModal(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.quoteTestimonialsBg,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                maxWidth: "lg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        spacing: 3,
                        direction: "row",
                        justify: "center",
                        alignItems: "center",
                        className: "quoteWrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                md: 6,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        className: "quoteText",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/quote-left-font-awesome.png",
                                                alt: "quotes",
                                                className: "quoteImg"
                                            }),
                                            prismic_reactjs.RichText.asText(primary.quoteText),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/quote-right-font-awesome.png",
                                                className: "quoteRight quoteImg",
                                                alt: "quotes"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: "quoteAuthor",
                                        children: prismic_reactjs.RichText.asText(primary.quoteAuthor)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                md: 6,
                                container: true,
                                direction: "row",
                                justify: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "rightImageOverlay"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: primary.rightImage.url,
                                        className: "rightImage",
                                        alt: "quotes"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                        title: prismic_reactjs.RichText.asText(primary.title),
                        subtitle: prismic_reactjs.RichText.asText(primary.subtitle),
                        showClass: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        container: true,
                        spacing: 4,
                        className: "testimonialWrapper",
                        children: items.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                md: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.testimonialCardGrid,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: item.profilePicture.url,
                                            alt: "profile",
                                            className: classes.testimonialImg
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classes.testimonialCard,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    className: "name",
                                                    children: prismic_reactjs.RichText.asText(item.name)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "testimonialTitle",
                                                    children: prismic_reactjs.RichText.asText(item.title)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "subtitle2",
                                                    className: "testimonial",
                                                    children: prismic_reactjs.RichText.asText(item.testimonial)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        container: true,
                        direction: "row",
                        justify: "center",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "outlined",
                            className: classes.videoButton,
                            onClick: openVideoDialog,
                            children: prismic_reactjs.RichText.asText(primary.videoButtonText)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModal/* default */.Z, {
                open: openModal,
                handleClose: closeVideoDialog,
                video: primary.vimeoLink
            })
        ]
    });
};
QuoteTestimonials.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            quoteText: utils_prop_types/* structuredTextPropTypes */.h,
            quoteAuthor: utils_prop_types/* structuredTextPropTypes */.h,
            rightImage: utils_prop_types/* imagePropTypes */.R,
            title: utils_prop_types/* structuredTextPropTypes */.h,
            subtitle: utils_prop_types/* structuredTextPropTypes */.h,
            videoButtonText: utils_prop_types/* structuredTextPropTypes */.h,
            vimeoLink: prop_types_default().objectOf((prop_types_default()).any)
        }).isRequired,
        items: prop_types_default().arrayOf(prop_types_default().shape({
            profilePicture: utils_prop_types/* imagePropTypes */.R,
            name: utils_prop_types/* structuredTextPropTypes */.h,
            title: utils_prop_types/* structuredTextPropTypes */.h,
            testimonial: utils_prop_types/* structuredTextPropTypes */.h
        })).isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_QuoteTestimonials = ((0,withStyles/* default */.Z)(QuoteTestimonials_style)(QuoteTestimonials));

;// CONCATENATED MODULE: ./slices/ShortHero/style.js
function ShortHero_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var ShortHero_style_styles = function(theme) {
    var _obj;
    return {
        shortHero: (_obj = {
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10),
            color: "#4c4c78",
            textAlign: "center"
        }, ShortHero_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), ShortHero_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), ShortHero_style_defineProperty(_obj, "& h1", {
            textTransform: "uppercase"
        }), ShortHero_style_defineProperty(_obj, "& p", {
            fontWeight: 700
        }), _obj)
    };
};
/* harmony default export */ var ShortHero_style = (ShortHero_style_styles);

;// CONCATENATED MODULE: ./slices/ShortHero/index.js










var ShortHero = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: "md",
        className: classes.shortHero,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
            container: true,
            spacing: 2,
            justify: "center",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    sm: 11,
                    md: 10,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h1",
                        children: prismic_reactjs.RichText.asText(primary.title)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    sm: 11,
                    md: 10,
                    children: prismic_reactjs.RichText.render(primary.subtitle)
                })
            ]
        })
    });
};
ShortHero.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h,
            subtitle: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_ShortHero = ((0,withStyles/* default */.Z)(ShortHero_style)(ShortHero));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(9895);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputBase/InputBase.js + 1 modules
var InputBase = __webpack_require__(5575);
;// CONCATENATED MODULE: ./slices/SubscribeEbook/style.js
function SubscribeEbook_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var SubscribeEbook_style_styles = function(theme) {
    var _obj, _obj1, _obj2;
    return {
        subscribe: (_obj2 = {
            zIndex: 100,
            backgroundImage: "url('/greenCirclePattner.png')",
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            clipPath: "polygon(0 15%, 100% 0, 100% 100%, 0% 100%)",
            position: "relative",
            backgroundColor: "#8BC249",
            paddingTop: theme.spacing(20),
            paddingBottom: theme.spacing(10),
            marginBottom: "-1px"
        }, SubscribeEbook_style_defineProperty(_obj2, theme.breakpoints.down("sm"), {
            clipPath: "polygon(0 5%, 100% 0, 100% 100%, 0% 100%)",
            paddingTop: theme.spacing(18),
            paddingBottom: theme.spacing(9),
            backgroundSize: "200% 200%"
        }), SubscribeEbook_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(16),
            paddingBottom: theme.spacing(8)
        }), SubscribeEbook_style_defineProperty(_obj2, "&::after", SubscribeEbook_style_defineProperty({
            clipPath: "polygon(0 15%, 100% 0, 100% 85%, 0% 100%)",
            background: "linear-gradient(90deg,rgba(140,194,75,1) 10%, rgba(105, 144, 57,1) 60%,  rgba(74,146,207,1) 30%)",
            content: '""',
            position: "absolute",
            left: 0,
            top: "-84.4%",
            right: 0,
            height: "100%",
            display: "block",
            zIndex: 9
        }, theme.breakpoints.down("sm"), {
            top: "-94.5%",
            clipPath: "polygon(0% 0%, 100% 10%, 100% 94.8%, 0% 100%)"
        })), SubscribeEbook_style_defineProperty(_obj2, "& .resourceImage", (_obj = {
            width: 400
        }, SubscribeEbook_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            width: "100%",
            marginBottom: theme.spacing(9)
        }), SubscribeEbook_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            width: "100%",
            marginBottom: theme.spacing(8)
        }), _obj)), SubscribeEbook_style_defineProperty(_obj2, "& .title", {
            color: "#fff",
            textTransform: "uppercase"
        }), SubscribeEbook_style_defineProperty(_obj2, "& .description", {
            color: "#fff",
            lineHeight: 2.13,
            fontWeight: 700,
            padding: theme.spacing(6, 0, 5, 0)
        }), SubscribeEbook_style_defineProperty(_obj2, "& .subscribeWrapper", (_obj1 = {
            borderRadius: 8,
            padding: theme.direction === "ltr" ? "0px 0px 0px 24px" : "0px 24px 0px 0px",
            display: "flex",
            border: "2px solid #fff",
            "&:hover": {
                borderColor: "#9ad455"
            },
            "&:focus-within": SubscribeEbook_style_defineProperty({
                borderColor: "#9ad455",
                outline: 0
            }, "outline", "none")
        }, SubscribeEbook_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            display: "block",
            padding: theme.spacing(2)
        }), SubscribeEbook_style_defineProperty(_obj1, "& .input", {
            flex: 1,
            fontFamily: "Raleway,Assistant",
            fontSize: 21,
            fontWeight: 900,
            "& input": {
                color: "#4c4c78",
                backgroundColor: "transparent",
                "&::placeholder": {
                    color: "#4c4c78",
                    opacity: 0.38
                }
            }
        }), SubscribeEbook_style_defineProperty(_obj1, "& .subButton", SubscribeEbook_style_defineProperty({}, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(2),
            width: "100%"
        })), _obj1)), SubscribeEbook_style_defineProperty(_obj2, "& .privacyText p", {
            fontSize: 14,
            lineHeight: 2.13,
            fontWeight: 700,
            color: "#fff",
            "& a": {
                color: "#fff"
            }
        }), _obj2),
        snackbarCut: {
            position: "absolute"
        }
    };
};
/* harmony default export */ var SubscribeEbook_style = (SubscribeEbook_style_styles);

;// CONCATENATED MODULE: ./slices/SubscribeEbook/index.js
function SubscribeEbook_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function SubscribeEbook_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                SubscribeEbook_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                SubscribeEbook_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function SubscribeEbook_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SubscribeEbook_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SubscribeEbook_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





















var Subscribe = function(param) {
    var slice = param.slice, classes = param.classes;
    var Alert = function Alert(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, SubscribeEbook_objectSpread({
            elevation: 6,
            variant: "filled"
        }, props));
    };
    var primary = slice.primary;
    console.log("primary", primary);
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    var ref = (0,react.useState)(""), email1 = ref[0], setEmail = ref[1];
    var ref1 = (0,react.useState)(false), emailValid = ref1[0], setEmailValid = ref1[1];
    var ref2 = (0,react.useState)(false), error = ref2[0], setError = ref2[1];
    var ref3 = (0,react.useState)(false), success = ref3[0], setSuccess = ref3[1];
    var ref4 = (0,react.useState)(false), snackbarOpen = ref4[0], setSnackbarOpen = ref4[1];
    var ref5 = (0,react.useState)(false), clearInput = ref5[0], setClearInput = ref5[1];
    var router = (0,next_router.useRouter)();
    var locale = router.locale;
    var send = function() {
        var _ref = SubscribeEbook_asyncToGenerator(runtime_default().mark(function _callee(email) {
            var result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!emailValid) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 3;
                        return fetch("api/contact/mailing-list", {
                            method: "POST",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                email: email,
                                twoLetterLanguageCode: locale
                            })
                        });
                    case 3:
                        result = _ctx.sent;
                        if (result.ok) {
                            setClearInput(!clearInput);
                            setSuccess(true);
                            setError(false);
                            router.push(primary.thankyouPageLink.uid);
                        } else {
                            setSuccess(false);
                            setError(true);
                        }
                        _ctx.next = 8;
                        break;
                    case 7:
                        {
                            setSnackbarOpen(true);
                            setSuccess(false);
                            setError(false);
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function send(email) {
            return _ref.apply(this, arguments);
        };
    }();
    var emailValidation = function(e) {
        setEmailValid(vfi_constants/* default.emailRegex.test */.Z.emailRegex.test(e.target.value));
    };
    var handleClose = function(event, reason) {
        if (reason === "clickaway") {
            return;
        }
        setSuccess(false);
        setSnackbarOpen(false);
        setError(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.subscribe,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    direction: "row",
                    justify: "center",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            sm: 12,
                            md: 6,
                            container: true,
                            justify: "center",
                            alignItems: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: primary.resourceImage.url,
                                alt: "quotes",
                                className: "resourceImage",
                                layout: "fill"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            md: 6,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h3",
                                    className: "title",
                                    children: prismic_reactjs.RichText.asText(primary.title)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "subtitle2",
                                    className: "description",
                                    children: prismic_reactjs.RichText.asText(primary.description)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                    onSubmit: function(formData) {
                                        formData.preventDefault();
                                        send(email1);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
                                        className: "subscribeWrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputBase/* default */.Z, {
                                                className: "input",
                                                placeholder: prismic_reactjs.RichText.asText(primary.emailPlaceholder),
                                                onChange: function(e) {
                                                    setEmail(e.target.value);
                                                    emailValidation(e);
                                                },
                                                type: "email"
                                            }, clearInput),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                color: "secondary",
                                                variant: "contained",
                                                className: "subButton",
                                                size: "large",
                                                "aria-label": "directions",
                                                type: "submit",
                                                children: prismic_reactjs.RichText.asText(primary.subscribeButtonText)
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "privacyText",
                                    children: prismic_reactjs.RichText.render(primary.privacyText)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
                className: classes.snackbarCut,
                open: success,
                autoHideDuration: 6000,
                onClose: handleClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckRounded/* default */.Z, {
                        fontSize: "inherit"
                    }),
                    onClose: handleClose,
                    severity: "success",
                    children: prismic_reactjs.RichText.asText(layout.subscribe_success_message)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
                open: snackbarOpen && !success && !error,
                autoHideDuration: 6000,
                onClose: handleClose,
                className: classes.snackbarCut,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningOutlined/* default */.Z, {
                        fontSize: "inherit"
                    }),
                    onClose: handleClose,
                    severity: "warning",
                    children: prismic_reactjs.RichText.asText(layout.subscribe_email_error_message)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
                open: error,
                autoHideDuration: 6000,
                onClose: handleClose,
                className: classes.snackbarCut,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorRounded/* default */.Z, {
                        fontSize: "inherit"
                    }),
                    onClose: handleClose,
                    severity: "error",
                    children: prismic_reactjs.RichText.asText(layout.subscribe_error_message)
                })
            })
        ]
    });
};
Subscribe.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            resourceImage: utils_prop_types/* imagePropTypes */.R,
            title: utils_prop_types/* structuredTextPropTypes */.h,
            description: utils_prop_types/* structuredTextPropTypes */.h,
            emailPlaceholder: utils_prop_types/* structuredTextPropTypes */.h,
            subscribeButtonText: utils_prop_types/* structuredTextPropTypes */.h,
            privacyText: utils_prop_types/* structuredTextPropTypes */.h,
            thankyouPageLink: prop_types_default().objectOf((prop_types_default()).any)
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var SubscribeEbook = ((0,withStyles/* default */.Z)(SubscribeEbook_style)(Subscribe));

;// CONCATENATED MODULE: ./slices/TestimonialBackgroundImage/style.js
function TestimonialBackgroundImage_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var TestimonialBackgroundImage_style_styles = function(theme) {
    var _obj;
    return {
        workDetailsTestimonials: {
            backgroundSize: "cover",
            backgroundColor: "#000",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            "& .background": (_obj = {
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                display: "flex",
                alignItems: "center",
                paddingTop: theme.spacing(10),
                paddingBottom: theme.spacing(10)
            }, TestimonialBackgroundImage_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
                paddingTop: theme.spacing(9),
                paddingBottom: theme.spacing(9)
            }), TestimonialBackgroundImage_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
                paddingTop: theme.spacing(8),
                paddingBottom: theme.spacing(8)
            }), _obj),
            "& .testimonialText": {
                fontStyle: "italic",
                color: "#ffffff",
                textAlign: "center",
                fontSize: 24,
                maxWidth: 969
            },
            "& .author": {
                color: "#ffffff",
                textAlign: "center",
                lineHeight: 1.42,
                fontSize: 24,
                marginTop: theme.spacing(6.5),
                maxWidth: 969
            }
        }
    };
};
/* harmony default export */ var TestimonialBackgroundImage_style = (TestimonialBackgroundImage_style_styles);

;// CONCATENATED MODULE: ./slices/TestimonialBackgroundImage/index.js










var TestimonialBackgroundImage = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    var styles = {};
    if (primary.backgroundImage) {
        styles.backgroundImage = "url(".concat(primary.backgroundImage.url, ")");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.workDetailsTestimonials,
        style: styles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "background",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "lg",
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    direction: "column",
                    justify: "center",
                    alignItems: "center",
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h4",
                            className: "testimonialText",
                            children: prismic_reactjs.RichText.asText(primary.testimonialText)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "h4",
                            className: "author",
                            children: [
                                "~ ",
                                prismic_reactjs.RichText.asText(primary.author)
                            ]
                        })
                    ]
                })
            })
        })
    });
};
TestimonialBackgroundImage.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            backgroundImage: utils_prop_types/* imagePropTypes */.R,
            testimonialText: utils_prop_types/* structuredTextPropTypes */.h,
            author: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_TestimonialBackgroundImage = ((0,withStyles/* default */.Z)(TestimonialBackgroundImage_style)(TestimonialBackgroundImage));

;// CONCATENATED MODULE: ./slices/TextBlueBackground/style.js
function TextBlueBackground_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var TextBlueBackground_style_styles = function(theme) {
    var _obj, _obj1;
    return {
        transparency: (_obj1 = {
            backgroundColor: "#4A92CF",
            clipPath: "polygon(0% 0%, 0% 100%, 100% 85%, 100% 0%)",
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(20)
        }, TextBlueBackground_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(18),
            paddingRight: theme.spacing(2),
            paddingLeft: theme.spacing(2)
        }), TextBlueBackground_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(16)
        }), TextBlueBackground_style_defineProperty(_obj1, "display", "flex"), TextBlueBackground_style_defineProperty(_obj1, "flexDirection", "column"), TextBlueBackground_style_defineProperty(_obj1, "justifyContent", "center"), TextBlueBackground_style_defineProperty(_obj1, "alignItems", "center"), TextBlueBackground_style_defineProperty(_obj1, "color", "#fff"), TextBlueBackground_style_defineProperty(_obj1, "& h2", (_obj = {
            textTransform: "uppercase",
            textAlign: "center",
            fontFamily: "Raleway,Assistant",
            fontSize: 42,
            fontWeight: 900,
            margin: 0
        }, TextBlueBackground_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            fontSize: 24
        }), TextBlueBackground_style_defineProperty(_obj, "& .label", {
            borderBottom: "3px solid #8dc34c",
            borderRadius: 1.5
        }), TextBlueBackground_style_defineProperty(_obj, "& strong", {
            fontWeight: 900,
            background: "linear-gradient( to left, ".concat(theme.palette.primary[400], " 50%, ").concat(theme.palette.primary[600], " 100% ) left bottom no-repeat"),
            backgroundSize: "100% 3px",
            paddingBottom: "2px"
        }), _obj)), TextBlueBackground_style_defineProperty(_obj1, "& .subtitle", {
            lineHeight: 2.13,
            textAlign: "center",
            fontWeight: 600,
            margin: theme.spacing(1, 0, 4, 0)
        }), TextBlueBackground_style_defineProperty(_obj1, "& .description", {
            textAlign: "center",
            fontWeight: 600,
            lineHeight: 1.88,
            maxWidth: 996
        }), TextBlueBackground_style_defineProperty(_obj1, "& .highlightedText", {
            textAlign: "center",
            fontWeight: 600,
            lineHeight: 1.88,
            maxWidth: 559,
            background: "rgb(255,255,255,0.2)",
            padding: theme.spacing(2),
            margin: theme.spacing(2.5, 0, 4.5, 0)
        }), TextBlueBackground_style_defineProperty(_obj1, "& .cta", {
            backgroundColor: "#282843",
            "&:hover": {
                backgroundColor: "#3a3a5d"
            }
        }), _obj1)
    };
};
/* harmony default export */ var TextBlueBackground_style = (TextBlueBackground_style_styles);

;// CONCATENATED MODULE: ./slices/TextBlueBackground/index.js










var TextBlueBackground = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.transparency,
        children: [
            prismic_reactjs.RichText.render(primary.title),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "subtitle1",
                className: "subtitle",
                children: prismic_reactjs.RichText.asText(primary.subtitle)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "subtitle1",
                className: "description",
                children: prismic_reactjs.RichText.asText(primary.description)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "subtitle1",
                className: "highlightedText",
                children: prismic_reactjs.RichText.asText(primary.highlightedText)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                link: primary.ctaButtonLink,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "contained",
                    color: "primary",
                    className: "cta",
                    children: prismic_reactjs.RichText.asText(primary.ctaButtonText)
                })
            })
        ]
    });
};
TextBlueBackground.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h,
            subtitle: utils_prop_types/* structuredTextPropTypes */.h,
            description: utils_prop_types/* structuredTextPropTypes */.h,
            highlightedText: utils_prop_types/* structuredTextPropTypes */.h,
            ctaButtonText: utils_prop_types/* structuredTextPropTypes */.h,
            ctaButtonLink: prop_types_default().objectOf((prop_types_default()).any)
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_TextBlueBackground = ((0,withStyles/* default */.Z)(TextBlueBackground_style)(TextBlueBackground));

;// CONCATENATED MODULE: ./components/LeftTextImageRight/style.ts
function LeftTextImageRight_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var LeftTextImageRight_style_styles = function(theme) {
    var _obj, _obj1, _obj2;
    return (0,createStyles/* default */.Z)({
        leftTextImageRight: {
            "& .rightImageWrapper": {
                position: "relative"
            },
            "& .rightImage": (_obj = {
                borderRadius: "67% 40% 53% 60% / 40% 37% 63% 70%",
                height: 469,
                width: 570,
                objectFit: "cover",
                position: "relative",
                zIndex: 99
            }, LeftTextImageRight_style_defineProperty(_obj, theme.breakpoints.down("md"), {
                width: 500
            }), LeftTextImageRight_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
                width: 570
            }), LeftTextImageRight_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
                width: "100%",
                height: "100%"
            }), _obj),
            "& .rightImageOverlay": (_obj1 = {
                borderRadius: "32% 68% 42% 58% / 36% 71% 29% 64%",
                width: 570,
                height: 469,
                position: "absolute",
                zIndex: 9,
                backgroundColor: "rgba(0, 0, 0, 0.2)"
            }, LeftTextImageRight_style_defineProperty(_obj1, theme.breakpoints.down("md"), {
                width: 500
            }), LeftTextImageRight_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
                width: 570
            }), LeftTextImageRight_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
                width: 350,
                height: 232
            }), LeftTextImageRight_style_defineProperty(_obj1, theme.breakpoints.down(400), {
                width: 250,
                height: 170
            }), _obj1),
            "& .preTitle": {
                color: "#fff",
                fontWeight: 700,
                marginBottom: theme.spacing(4.5)
            },
            "& .title": {
                color: "#fff"
            },
            "& .description": {
                color: "#fff",
                lineHeight: 1.89,
                fontWeight: 700,
                marginTop: theme.spacing(3.5),
                marginBottom: theme.spacing(6)
            },
            "& .playBtn": (_obj2 = {
                height: 69,
                width: 105,
                border: 0,
                backgroundImage: "url('/playBtnBg.png')",
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                position: "absolute",
                borderRadius: 8,
                zIndex: 99,
                boxShadow: "0px 2px 6px 0px #1f1f1f",
                top: "50%",
                left: "50%",
                right: "50%",
                cursor: "pointer",
                transform: "translateY(-70%) translateX(-50%)"
            }, LeftTextImageRight_style_defineProperty(_obj2, theme.breakpoints.down(844), {
                height: 60,
                width: 90
            }), LeftTextImageRight_style_defineProperty(_obj2, theme.breakpoints.down("xs"), {
                height: 50,
                width: 80,
                borderRadius: 8
            }), _obj2)
        },
        rightBgImageVisibility: {
            objectFit: "contain!important",
            borderRadius: "0 !important"
        }
    });
};
/* harmony default export */ var LeftTextImageRight_style = (LeftTextImageRight_style_styles);

;// CONCATENATED MODULE: ./components/LeftTextImageRight/index.tsx
function LeftTextImageRight_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}












var LeftTextImageRight = function(param) {
    var classes = param.classes, preTitle = param.preTitle, title = param.title, description = param.description, btnLabel = param.btnLabel, rightImageSrc = param.rightImageSrc, rightbannerImageAlt = param.rightbannerImageAlt, btnUrl = param.btnUrl, videoLink = param.videoLink, openVideoDialog = param.openVideoDialog, rightBgImageVisibility = param.rightBgImageVisibility;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: "lg",
        className: classes.leftTextImageRight,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
            container: true,
            spacing: 3,
            direction: "row",
            justify: "center",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    md: 6,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "subtitle2",
                            className: "preTitle",
                            children: preTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h1",
                            component: "h2",
                            className: "title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "subtitle1",
                            className: "description",
                            children: description
                        }),
                        btnUrl && btnLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                            className: "",
                            link: btnUrl,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "contained",
                                color: "primary",
                                children: btnLabel
                            })
                        }, btnLabel)
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    md: 6,
                    className: "rightImageWrapper",
                    container: true,
                    direction: "row",
                    justify: "center",
                    children: [
                        rightBgImageVisibility && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "rightImageOverlay"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: rightImageSrc,
                            className: (0,clsx_m/* default */.Z)("rightImage", LeftTextImageRight_defineProperty({}, classes.rightBgImageVisibility, !rightBgImageVisibility)),
                            alt: rightbannerImageAlt
                        }),
                        videoLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                            onClick: function() {
                                return openVideoDialog();
                            },
                            className: "playBtn"
                        })
                    ]
                })
            ]
        })
    });
};
LeftTextImageRight.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    preTitle: prop_types_default().objectOf((prop_types_default()).string).isRequired,
    title: prop_types_default().objectOf((prop_types_default()).string).isRequired,
    description: prop_types_default().objectOf((prop_types_default()).string).isRequired,
    btnLabel: prop_types_default().objectOf((prop_types_default()).string).isRequired,
    rightImageSrc: prop_types_default().objectOf((prop_types_default()).string).isRequired,
    rightbannerImageAlt: prop_types_default().objectOf((prop_types_default()).string).isRequired,
    rightBgImageVisibility: prop_types_default().objectOf((prop_types_default()).bool).isRequired
};
/* harmony default export */ var components_LeftTextImageRight = ((0,withStyles/* default */.Z)(LeftTextImageRight_style)(LeftTextImageRight));

;// CONCATENATED MODULE: ./slices/TextWithImage/style.js
function TextWithImage_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var TextWithImage_style_styles = function(theme) {
    var _obj;
    return {
        textWithImageBg: (_obj = {
            backgroundColor: "#f4f5f6",
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10),
            position: "relative"
        }, TextWithImage_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9),
            backgroundPosition: "100%",
            backgroundSize: "cover"
        }), TextWithImage_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8),
            backgroundPosition: "100%",
            backgroundSize: "cover"
        }), TextWithImage_style_defineProperty(_obj, "& .element", {
            fontWeight: 900,
            position: "absolute",
            top: 80
        }), TextWithImage_style_defineProperty(_obj, "& .preTitle, .title, .subtitle, .description", {
            color: "#4c4c78 !important"
        }), _obj)
    };
};
/* harmony default export */ var TextWithImage_style = (TextWithImage_style_styles);

;// CONCATENATED MODULE: ./slices/TextWithImage/index.js









var TextWithImage = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.textWithImageBg,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: primary.anchorId,
                className: "element"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LeftTextImageRight, {
                preTitle: prismic_reactjs.RichText.asText(primary.preTitle),
                title: prismic_reactjs.RichText.asText(primary.title),
                description: prismic_reactjs.RichText.asText(primary.description),
                btnLabel: primary.ctaButtonText,
                btnUrl: primary.ctaButtonLink,
                rightImageSrc: primary.rightImage.url,
                rightbannerImageAlt: primary.rightImage.alt,
                rightBgImageVisibility: primary.rightBgImageVisibility
            })
        ]
    });
};
TextWithImage.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            pre_title: utils_prop_types/* structuredTextPropTypes */.h,
            title: utils_prop_types/* structuredTextPropTypes */.h,
            description: utils_prop_types/* structuredTextPropTypes */.h,
            video_thumbnail: utils_prop_types/* imagePropTypes */.R
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_TextWithImage = ((0,withStyles/* default */.Z)(TextWithImage_style)(TextWithImage));

;// CONCATENATED MODULE: ./slices/TextWithVideo/style.js
function TextWithVideo_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var TextWithVideo_style_styles = function(theme) {
    var _obj, _obj1;
    return {
        textWithVideoBg: (_obj1 = {
            clipPath: "polygon(0 0, 100% 15%, 100% 100%, 0 100%)",
            position: "relative",
            background: "#8BC249",
            backgroundImage: 'url("/patternSimpleText.svg")',
            backgroundBlendMode: "exclusion",
            backgroundSize: "123% 134%",
            backgroundPosition: "100%",
            backgroundRepeat: "no-repeat",
            paddingTop: theme.spacing(20),
            paddingBottom: theme.spacing(10)
        }, TextWithVideo_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(18),
            paddingBottom: theme.spacing(9)
        }), TextWithVideo_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(16),
            paddingBottom: theme.spacing(8)
        }), TextWithVideo_style_defineProperty(_obj1, "& .playBtn", (_obj = {
            height: 69,
            width: 105,
            backgroundImage: "url('/playBtnBg.png')",
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            position: "absolute",
            borderRadius: 8,
            boxShadow: "0px 2px 6px 0px #1f1f1f",
            top: "50%",
            left: "50%",
            right: "50%",
            cursor: "pointer",
            transform: theme.direction === "ltr" ? "translateY(-70%) translateX(-50%)" : "translateY(-70%) translateX(50%)"
        }, TextWithVideo_style_defineProperty(_obj, theme.breakpoints.down("844"), {
            height: 60,
            width: 90
        }), TextWithVideo_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            height: 50,
            width: 80,
            borderRadius: 8
        }), _obj)), TextWithVideo_style_defineProperty(_obj1, "&::after", {
            clipPath: "polygon(0 0, 100% 15%, 100% 100%, 0 85%)",
            background: "linear-gradient(90deg, rgba(74,146,207,1) 30%, rgb(105 144 57) 30%,rgba(140,194,75,1) 100% )",
            content: '""',
            position: "absolute",
            left: 0,
            top: "-84.5%",
            right: 0,
            height: "100%",
            display: "block",
            zIndex: 9
        }), TextWithVideo_style_defineProperty(_obj1, "& button", {
            backgroundColor: "transparent",
            border: "1px solid #fff"
        }), _obj1)
    };
};
/* harmony default export */ var TextWithVideo_style = (TextWithVideo_style_styles);

;// CONCATENATED MODULE: ./slices/TextWithVideo/index.js









var TextWithVideo = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    var ref = (0,react.useState)(false), openModal = ref[0], setOpenModal = ref[1];
    var ref1 = (0,react.useState)(false), videoUrl = ref1[0], setVideoUrl = ref1[1];
    var openVideoDialog = function() {
        setOpenModal(true);
    };
    var closeVideoDialog = function() {
        setOpenModal(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.textWithVideoBg,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LeftTextImageRight, {
                preTitle: prismic_reactjs.RichText.asText(primary.preTitle),
                title: prismic_reactjs.RichText.asText(primary.title),
                description: prismic_reactjs.RichText.asText(primary.description),
                btnLabel: prismic_reactjs.RichText.asText(primary.ctaButtonText),
                btnUrl: primary.ctaButtonLink,
                rightImageSrc: primary.videoThumbnail.url,
                rightbannerImageAlt: primary.videoThumbnail.alt,
                videoLink: primary.vimeoLink,
                openVideoDialog: openVideoDialog,
                rightBgImageVisibility: true
            }),
            primary.vimeoLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModal/* default */.Z, {
                open: openModal,
                handleClose: closeVideoDialog,
                video: primary.vimeoLink
            })
        ]
    });
};
TextWithVideo.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            preTitle: utils_prop_types/* structuredTextPropTypes */.h,
            title: utils_prop_types/* structuredTextPropTypes */.h,
            description: utils_prop_types/* structuredTextPropTypes */.h,
            videoThumbnail: utils_prop_types/* imagePropTypes */.R
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_TextWithVideo = ((0,withStyles/* default */.Z)(TextWithVideo_style)(TextWithVideo));

;// CONCATENATED MODULE: ./slices/VideoDetails/style.js
function VideoDetails_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var VideoDetails_style_styles = function(theme) {
    var _obj, _obj1;
    return {
        workDetailsVideo: (_obj1 = {
            clipPath: "polygon(0 10%, 100% 0, 100% 100%, 0% 100%)",
            position: "relative",
            backgroundColor: "#397DB7",
            backgroundRepeat: "no-repeat",
            paddingTop: theme.spacing(20),
            paddingBottom: theme.spacing(10)
        }, VideoDetails_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(18),
            paddingBottom: theme.spacing(9),
            backgroundSize: "200% 70%"
        }), VideoDetails_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(16),
            paddingBottom: theme.spacing(8)
        }), VideoDetails_style_defineProperty(_obj1, "& .thumbnailWrapper", {
            cursor: "pointer",
            "& .playBtn": (_obj = {
                height: 69,
                width: 105,
                backgroundImage: "url('/playBtnBg.png')",
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                position: "absolute",
                borderRadius: 8,
                boxShadow: "0px 2px 6px 0px #1f1f1f",
                top: "55%",
                left: "50%",
                right: "50%",
                cursor: "pointer",
                transform: "translateY(-50%) translateX(-50%)"
            }, VideoDetails_style_defineProperty(_obj, theme.breakpoints.down("844"), {
                top: "60%"
            }), VideoDetails_style_defineProperty(_obj, theme.breakpoints.down("600"), {
                top: "60%",
                height: 35,
                width: 55,
                borderRadius: 8
            }), VideoDetails_style_defineProperty(_obj, theme.breakpoints.down("374"), {
                top: "63%"
            }), _obj)
        }), VideoDetails_style_defineProperty(_obj1, "&::after", {
            clipPath: "polygon(0 15%, 100% 0, 100% 90%, 0% 100%)",
            background: "linear-gradient(90deg, rgba(140,194,75,1) 70%, rgba(74,146,207,1) 30%)",
            content: '""',
            position: "absolute",
            left: 0,
            top: "-89.5%",
            right: 0,
            height: "100%",
            display: "block",
            zIndex: 9
        }), VideoDetails_style_defineProperty(_obj1, "& .container ", {
            height: "100%"
        }), VideoDetails_style_defineProperty(_obj1, "& .imgBg", VideoDetails_style_defineProperty({
            backgroundImage: "url('/videoBg.png')",
            backgroundPosition: "center",
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat",
            maxWidth: 970,
            padding: theme.spacing(2.5, 2.5),
            margin: theme.spacing(8.5, 0, 8.5, 0)
        }, theme.breakpoints.down("sm"), {
            margin: theme.spacing(2, 0)
        })), VideoDetails_style_defineProperty(_obj1, "& img", {
            width: "100%"
        }), _obj1)
    };
};
/* harmony default export */ var VideoDetails_style = (VideoDetails_style_styles);

;// CONCATENATED MODULE: ./slices/VideoDetails/index.js















var VideoDetails = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary;
    var ref = (0,react.useState)(false), openModal = ref[0], setOpenModal = ref[1];
    var openVideoDialog = function() {
        setOpenModal(true);
    };
    var closeVideoDialog = function() {
        setOpenModal(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.workDetailsVideo,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                        title: prismic_reactjs.RichText.asText(primary.sectionTitle),
                        subtitle: prismic_reactjs.RichText.asText(primary.sectionSubtitle),
                        showClass: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        direction: "column",
                        justify: "center",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "thumbnailWrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ThumbnailVideo, {
                                        thumbnailVideoUrl: primary.thumbnail.url,
                                        thumbnailVideoAlt: primary.thumbnail.alt
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                        className: "playBtn",
                                        onClick: openVideoDialog
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                link: primary.ctaButtonLink,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    color: "primary",
                                    children: prismic_reactjs.RichText.asText(primary.ctaButtonText)
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModal/* default */.Z, {
                open: openModal,
                handleClose: closeVideoDialog,
                video: primary.vimeoLink
            })
        ]
    });
};
VideoDetails.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            sectionTitle: utils_prop_types/* structuredTextPropTypes */.h,
            sectionSubtitle: utils_prop_types/* structuredTextPropTypes */.h,
            thumbnail: utils_prop_types/* imagePropTypes */.R,
            ctaButtonText: utils_prop_types/* structuredTextPropTypes */.h,
            ctaButtonLink: prop_types_default().objectOf((prop_types_default()).any)
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_VideoDetails = ((0,withStyles/* default */.Z)(VideoDetails_style)(VideoDetails));

;// CONCATENATED MODULE: ./slices/WhoWeAre/style.js
function WhoWeAre_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var WhoWeAre_style_styles = function(theme) {
    var _obj, _obj1;
    return {
        whoWeAre: (_obj1 = {
            backgroundColor: "#8bc249",
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, WhoWeAre_style_defineProperty(_obj1, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9),
            backgroundPosition: "100%",
            backgroundSize: "cover"
        }), WhoWeAre_style_defineProperty(_obj1, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8),
            backgroundPosition: "100%",
            backgroundSize: "cover"
        }), WhoWeAre_style_defineProperty(_obj1, "& .whoWeAreContainer", (_obj = {
            marginTop: theme.spacing(10)
        }, WhoWeAre_style_defineProperty(_obj, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(9)
        }), WhoWeAre_style_defineProperty(_obj, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(8)
        }), _obj)), WhoWeAre_style_defineProperty(_obj1, "& .testimonialCardGrid", {
            textAlign: "center",
            cursor: "pointer",
            transition: "transform .5s",
            "&:hover": {
                transform: "scale(1.1)"
            }
        }), WhoWeAre_style_defineProperty(_obj1, "& .icon", {
            width: 80,
            height: 80
        }), WhoWeAre_style_defineProperty(_obj1, "& .itemTitle", WhoWeAre_style_defineProperty({
            color: "#fff",
            textAlign: "center",
            margin: theme.spacing(2, 0)
        }, theme.breakpoints.down("sm"), {
            margin: theme.spacing(1, 0)
        })), WhoWeAre_style_defineProperty(_obj1, "& .anchorLinkText", {
            color: "#fff",
            textAlign: "center",
            textDecoration: "underline",
            cursor: "pointer"
        }), _obj1)
    };
};
/* harmony default export */ var WhoWeAre_style = (WhoWeAre_style_styles);

;// CONCATENATED MODULE: ./slices/WhoWeAre/index.js













var WhoWeAre = function(param) {
    var slice = param.slice, classes = param.classes;
    var primary = slice.primary, items = slice.items;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.whoWeAre,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            maxWidth: "lg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                    title: prismic_reactjs.RichText.asText(primary.title),
                    subtitle: prismic_reactjs.RichText.asText(primary.subtitle),
                    showClass: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    container: true,
                    spacing: 4,
                    direction: "row",
                    justify: "center",
                    alignItems: "center",
                    className: "whoWeAreContainer",
                    children: items.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            md: 3,
                            container: true,
                            direction: "column",
                            justify: "center",
                            alignItems: "center",
                            className: "testimonialCardGrid",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(modules/* Link */.rU, {
                                to: item.anchorId,
                                smooth: true,
                                offset: -80,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: item.icon.url,
                                        alt: item.icon.alt,
                                        className: "icon"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h6",
                                        className: "itemTitle",
                                        children: prismic_reactjs.RichText.asText(item.title)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "subtitle2",
                                        className: "anchorLinkText",
                                        children: prismic_reactjs.RichText.asText(item.anchorLinkText)
                                    })
                                ]
                            })
                        });
                    })
                })
            ]
        })
    });
};
WhoWeAre.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h,
            subtitle: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: prop_types_default().arrayOf(prop_types_default().shape({
            icon: utils_prop_types/* imagePropTypes */.R,
            title: (prop_types_default()).string,
            anchor_link_text: (prop_types_default()).string
        })).isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var slices_WhoWeAre = ((0,withStyles/* default */.Z)(WhoWeAre_style)(WhoWeAre));

;// CONCATENATED MODULE: ./slices/index.js
// This file is generated by Slice Machine. Update with care!


















































var components = {
    about_hero: slices_AboutHero,
    about_intro: slices_AboutIntro,
    about_quote: slices_AboutQuote,
    all_blogs: slices_AllBlogs,
    all_endorsements: AllEndorsements,
    all_events: AllEvents,
    all_members: AllMembers,
    all_past_events: AllPastEvents,
    big_image: slices_BigImage,
    blog_post_hero: slices_BlogPostHero,
    blog_post_rich_text: slices_BlogPostRichText,
    blog_post_video: slices_BlogPostVideo,
    blogs_category: BlogsCategory,
    blog_testimonial: BlogTestimonial,
    call_to_action: slices_CallToAction,
    complete_payment: slices_CompletePayment,
    contact_form: slices_ContactForm,
    contact_our_branches: slices_ContactOurBranches,
    donate_now: slices_DonateNow,
    donate_other_modes: slices_DonateOtherModes,
    donate_pay_now: slices_DonatePayNow,
    donation_thankyou: slices_DonationThankyou,
    endorsements_component: EndorsementsComponent,
    event_detail_abpout: EventDetailAbpout,
    event_details_cta: slices_EventDetailsCta,
    event_details_hero: slices_EventDetailsHero,
    event_details_video: slices_EventDetailsVideo,
    events_detail_past_events: EventsDetailPastEvents,
    event_videos: slices_EventVideos,
    featured_blogs: slices_FeaturedBlogs,
    featured_blogs_in_project: FeaturedBlogsInProject,
    featured_members: slices_FeaturedMembers,
    featured_work: slices_FeaturedWork,
    hero_background_image: slices_HeroBackgroundImage,
    homepage_hero: slices_HomepageHero,
    image_gallery: ImageGallery,
    imapct_statement: ImapctStatement,
    our_partners: OurPartners,
    past_event: PastEvent,
    project_gallery: ProjectGallery,
    quote_testimonials: slices_QuoteTestimonials,
    short_hero: slices_ShortHero,
    subscribe_ebook: SubscribeEbook,
    testimonial_background_image: slices_TestimonialBackgroundImage,
    text_blue_background: slices_TextBlueBackground,
    text_with_image: slices_TextWithImage,
    text_with_video: slices_TextWithVideo,
    video_details: slices_VideoDetails,
    who_we_are: slices_WhoWeAre
};

;// CONCATENATED MODULE: ./sm-resolver.js
function sm_resolver_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sm_resolver_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sm_resolver_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var __allSlices = sm_resolver_objectSpread({}, slices_namespaceObject);
var NotFound = function(param) {
    var sliceName = param.sliceName;
    console.log('[sm - resolver] component "'.concat(sliceName, '" not found.'));
    return  false ? /*#__PURE__*/ 0 : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
};
var resolver = function(param) {
    var sliceName = param.sliceName, i = param.i;
    return __allSlices[sliceName] ? __allSlices[sliceName] : function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound, {
            sliceName: sliceName
        });
    };
};
/* harmony default export */ var sm_resolver = (resolver);


/***/ }),

/***/ 1623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YZ": function() { return /* binding */ AdditionalDataProvider; },
/* harmony export */   "eP": function() { return /* binding */ useAdditionalData; }
/* harmony export */ });
/* unused harmony export AdditionalDataConsumer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var AdditionalDataContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
var AdditionalDataProvider = AdditionalDataContext.Provider;
var AdditionalDataConsumer = AdditionalDataContext.Consumer;
var useAdditionalData = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AdditionalDataContext);
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (AdditionalDataContext)));


/***/ }),

/***/ 9725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ imagePropTypes; },
/* harmony export */   "h": function() { return /* binding */ structuredTextPropTypes; }
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

var structuredTextPropTypes = prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
    type: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    text: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    spans: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().array)
}));
var imagePropTypes = prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
    dimensions: prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
        width: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number),
        height: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number)
    }),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    copyright: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    url: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string)
});


/***/ })

}]);